webpackJsonp([1],{

/***/ "+E3e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9iAp");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3926b64f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6cd03679\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6cd03679\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Gu/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.center-container[data-v-896ab43a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "7KbZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7p5c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/invoice-example.796272c.png";

/***/ }),

/***/ "7sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__("gCMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4588f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__("l+T2");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("l+gf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4588f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-timepicker/src/vue-timepicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c4588f32", Component.options)
  } else {
    hotAPI.reload("data-v-c4588f32", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8gwm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("K4Pf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("101a46a2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6428c8d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6428c8d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9fMG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.component-badger-accordion .badger-accordion__panel {\n  max-height: 0;\n}\n.badger-accordion__panel {\n  max-height: 75vh;\n  overflow: hidden;\n}\n.badger-accordion__panel.-ba-is-hidden {\n    max-height: 0 !important;\n}\n.badger-accordion--initialized .badger-accordion__panel {\n  -webkit-transition: max-height ease-in-out 0.2s;\n  transition: max-height ease-in-out 0.2s;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle {\n  width: 100%;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-accordion-title {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 90%;\n            flex: 0 0 90%;\n    cursor: pointer;\n    text-align: left;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-toggle-indicator {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 10%;\n            flex: 0 0 10%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "9iAp":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fitAvailableHeight[data-v-6cd03679]{\n\tmin-height: -webkit-fill-available;\n}\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "AlnM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G0Sz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAAsCAYAAAAgjfcKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA+JJREFUeNrsnFtIFGEYht+Z2VnbrawEKymS1qguKk2E6iZEOmBBZBFRlB3oJsqyopvoou6DDkYEdeGhyyAIzCIqugg6WpZkBRFm50Ts4LSH2Zm+kSLddnXdqAbmfeCDn5m5en8fv///ZxQghBBCMkH5OQge37AMqlLd9xohHsCEae0ydtS3DijID0lOiySbZKgyN+IhPogkIZGkJ/FGogi7pZqlbGZGPESu1NVkN/oJYmyv+4y4VSHDTmZGPLXV8KklwZrKU4N1EBhV9a+k3ZTKMMbciIdQoambZJtR1feiluzJWFPLR33xrOeyH1mW6hkydCzbhq5pmDpqLIpyJsovLRXd0bBct6AoPBtxhSSKslgvL7wfu9Dy7LdNeiLBo+tPyoxuoSR/LkZcJFg1uQgHZ5djSnYuInETWZqOJ93vsL+5EedftsKnqBTFHXTBtsuMbXUtg86GSNIkkiwCT7YyliNsRnBozgrsmbkA0XhUsv91BuJ0EcOMYf+9RtS0XccwVack/x9ngh5IlaXzQ79S6pYz18xt6IRjYawKFaMif6bEHu8nh4NpWRjpD2BNQTHmjQ3hW5xbP1ds2oHZUucGFcTY2WAgam6W4XvmNvTu4URdljcVoTETepdVyYiKFHPHTcH8cQViTJTBuYfStJZNRvWZJyLJRhlGmFn6mNIx8obnYHwgW7pH6gbc21V8OgJSsPkKyl279vQZzbgIBUm2UT+ybjr8vloZZjGy9PGrPrz99B7tX7sk6dRRa4oKK2KgK9Iz4HPEhYIEj67PEzmuyTDAuDLA58flN0/x+EN777Fu0kc0H253tuNOZ4fYojMzd+CsdWu1QeQIQteaZDgN/Mo3IzRVQ1v3O2T7A5ibm48s6SpWn0/dskSOjp4uHGi+iEsdrQjqwxiaG+Sw7QfGtrolAwqilxc2yAwvBN+BZIzzTsNZQt38+EI6xEvkj8jBpBFjJFa190j3yttnqL51Dpdet1EO9yBrYhTHLrREUnaF4LHKffCpB50VAPMinpLDskuN7XWPUu5BRI61lIN4kLjIUf1TDiTbVwRrKmdI/3e+jc9lXsRTcsStw0ZV/d5+S+R+chzfMBKq4vzBVAE35cRDWDCts8aO+tWJNxKXWNcoB/EYzpHiXanNyW72/acNhdI9llOOv4rzoVVIaqnUeKnXUo1S7VJ+xvOfllamVSvdo2NAQci/QV9RMs9fUXLC/hIuUkYFbkcbbmyNXXzYzGTcCd9vEEJBCKEghFAQQigIIRSEEApCCAUhhIIQQkEIIRSEEApCCAUhhIIQQkEIoSCEUBBCKAghFIQQj/NdgAEADVIhwQDuE2MAAAAASUVORK5CYII="

/***/ }),

/***/ "HJqQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("q2xu"), "");

// module
exports.push([module.i, "\n", ""]);

// exports


/***/ }),

/***/ "HXsc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAACmElEQVRoge2Zv2sUQRTHP4kx/sphI4Sk8CoNYhMUbEL6lGJn/gBBbKxFsLIWAyIYxULEQrRII5pUmiKIbQoLQRDiDzSoQWIwyVnsDLesM7tvdufdrbBfeCzHzfvx3Tfzvb230KBB7XAIuA/8ADqRbR2YB1q9IHJPgUDW5ntB5CBwBjiuEPs03c7897BdEWEwMPgIcAv4CnwE7gL7AmP0HUPAK/7dx5eV8gV1JARXcR/I1xrJUCIyAWziJvIpdjKD6EQGcW8pa79jJkshOpFL+El0gLcxk6UQlcg48J18Io9iJcsgqvzeBg4XrHkpTdYvnEf2GDGhlD/K1joCfKaYxLuqiXIwCeytGuQBsm7MVU2kiRnkT6czSjW0gSVgy5N3C1gEjvoCjADvhSR+Aft1eLAkrOGFL8BNYYAOsKBEAmBDWMNPl/MksCMM0AEu6PFgUViDsyOPA0hsA6N6PGibIvPOyHMcZ2TUFCclYn8E22pUAmF/2c8CewL8nprrubjlVMdD5N3YpduJ5ch1FMluoQSvBhB5Y3zGSMQhJqSy6z3w3wIcrxifi+ZzTEhl1yvBIQf9hPGxEhkTUtn1diTE0eKPApEi2fVK8ECKiBRZnwHfwl4idK5VW9SNSGX5LXNGsp9joLL81oVIafmt29ZaqepTl4408mu31kZfq4gAS+RDhRihhzPPrpuYpYcPNwKSaRCwZod9pYcPJ5E/OGoSsVOZ4OGD3VqrJHPe2JgiEQOXTTvWj5urVIad64aRtdRCcsemcoqYdqy/Zr4rPXxIk5kjf5vZ9q8LyYTYZgF5L7IDhx3gGfDEsG6RvE8fTq1ZANaAY8CpMklzMATMktysNbrvZlTRAu4Q9jdZal9IXoMf0CbRoEEB/gL+9Lal9dSHqAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Jif5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.agile {\n\tposition: relative;\n}\n.agile--rtl .agile__track,\n.agile--rtl .agile__slides,\n.agile--rtl .agile__actions,\n.agile--rtl .agile__dots {\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: reverse;\n\t    -ms-flex-direction: row-reverse;\n\t        flex-direction: row-reverse;\n}\n.agile:focus, .agile:active, .agile *:focus, .agile *:active {\n\toutline: none;\n}\n.agile__list {\n\tdisplay: block;\n\toverflow: hidden;\n\tposition: relative;\n\twidth: 100%;\n}\n.agile__track {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-ms-flex-wrap: nowrap;\n\t    flex-wrap: nowrap;\n}\n.agile__actions {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: justify;\n\t    -ms-flex-pack: justify;\n\t        justify-content: space-between;\n}\n.agile__slides {\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-webkit-box-flex: 1;\n\t    -ms-flex-positive: 1;\n\t        flex-grow: 1;\n\t-ms-flex-negative: 0;\n\t    flex-shrink: 0;\n\t-ms-flex-wrap: nowrap;\n\t    flex-wrap: nowrap;\n\t-webkit-box-pack: start;\n\t    -ms-flex-pack: start;\n\t        justify-content: flex-start;\n}\n.agile--disabled .agile__slides {\n\tdisplay: block;\n}\n.agile__slide {\n\tdisplay: block;\n\t-webkit-box-flex: 1;\n\t    -ms-flex-positive: 1;\n\t        flex-grow: 1;\n\t-ms-flex-negative: 0;\n\t    flex-shrink: 0;\n}\n.agile--fade .agile__slide {\n\topacity: 0;\n\tposition: relative;\n\tz-index: 0;\n}\n.agile--fade .agile__slide--active {\n\topacity: 1;\n\tz-index: 2;\n}\n.agile--fade .agile__slide--expiring {\n\topacity: 1;\n\t-webkit-transition-duration: 0s;\n\t        transition-duration: 0s;\n\tz-index: 1;\n}\n.agile__nav-button[disabled] {\n\tcursor: default;\n}\n.agile__dots {\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tlist-style: none;\n\tpadding: 0;\n\twhite-space: nowrap;\n}\n.agile__dot button {\n\tcursor: pointer;\n\tdisplay: block;\n\tfont-size: 0;\n\tline-height: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "K4Pf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n/*  LOADSCREEN  */\n.bg_load[data-v-6428c8d2] {\n\t\n\tposition: fixed;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #00000082;\n\tz-index: 100;\n}\n.imgLoad[data-v-6428c8d2]{\n\tposition: absolute;\n\ttop: 48.5%;\n\tmargin-left: 48.5vw;\n\twidth: 3vw;\n\tbackground: transparent;\n}\n@media (min-width: 767px) and (max-width: 1140px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 47.5%;\n\t\tmargin-left: 47.5vw;\n\t\twidth: 5vw;\n}\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 45%;\n\t\tmargin-left: 45vw;\n\t\twidth: 10vw;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "KSZv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home.5a74717.png";

/***/ }),

/***/ "KwyM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ki2I");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("824e365e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62fe346e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62fe346e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "LUgf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Jif5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("39545326", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-77bc7422\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Agile.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-77bc7422\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Agile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Lz3v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/premi-mob.535ac06.png";

/***/ }),

/***/ "MXkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/polyfill/lib/index.js
var lib = __webpack_require__("u7Vc");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/actions/auth.js
var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_SOCIAL = 'AUTH_SOCIAL';
var AUTH_OK = 'AUTH_OK';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_LOGOUT = 'AUTH_LOGOUT';
var SET_TOKEN = 'SET_TOKEN';
var AUTH_REGISTRATION = 'AUTH_REGISTRATION';
var AUTH_COMPLATE_REGISTRATION = 'AUTH_COMPLATE_REGISTRATION';
var COMPLATE_REGISTRATION_SUCCESS = 'COMPLATE_REGISTRATION_SUCCESS';
var REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
var REGISTRATION_ERROR = 'REGISTRATION_ERROR';
var GET_PROMOTIONS = 'GET_PROMOTIONS';
var GET_PROMOTIONS_SUCCESS = 'GET_PROMOTIONS_SUCCESS';
var SET_PROMOTION = 'SET_PROMOTION';
var ACCEPT_REG = 'ACCEPT_REG';
var DECRYPT = 'DECRYPT';
var ENCRYPT = 'ENCRYPT';
// CONCATENATED MODULE: ./src/store/actions/user.js
var USER_REQUEST = 'USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';
var USER_UPDATE_DATA = 'USER_UPDATE_DATA';
var USER_SET_DEFAULT_SHIP_DATA = 'USER_SET_DEFAULT_SHIP_DATA';
var USER_CHECK_AGE = 'USER_CHECK_AGE';
var ACCEPT_COOKIES = 'ACCEPT_COOKIES';
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/navigation/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var moment = __webpack_require__("PJh5");

/* harmony default export */ var navigation = ({
  name: "navigation",
  components: {},
  data: function data() {
    return {
      moment: __webpack_require__("PJh5"),
      vh: window.innerHeight,
      vw: window.innerWidth,
      scroll: window.pageYOffset,
      directory: "https://ubiqubit.it/staging/pharma",
      consent: "",
      start_intermedio: "2021-09-01 00:00:00",
      now: moment()
    };
  },


  methods: {
    checkSoftwareVersion: function checkSoftwareVersion() {
      console.log("CHECK VERSION SW ************");
      var version = localStorage.getItem("sw_version");

      if (!version) {
        console.log("VERSION NOT SAVED => " + version);
        version = false;
      } else {
        console.log("ACTUAL VERSION => " + version);
      }
      var data = {
        version: version,
        id_platform: "DcJ7J1WfiwucqBl_lierac",
        unique_key_db: "d971ad4ed27c5e76c0ccf95a",
        vector_unique_key_db: "lierac_global"
      };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      axios_default()({
        url: "https://pharma.ubiqubit.it/" + "api/checkSoftwareVersion",
        method: "POST",
        data: { data: data },
        headers: {
          Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        if (resp.data.version) {
          console.log("SERVER VERSION => " + resp.data.version);
          if (version != resp.data.version) {
            localStorage.setItem("sw_version", resp.data.version);
            window.location.reload();
          }
        }
      }).catch(function (error) {});
    },
    doAcceptCookies: function doAcceptCookies(value) {
      this.$store.dispatch(ACCEPT_COOKIES, value).then(function (resp) {});
    },


    logout: function logout() {
      var _this = this;

      this.$store.dispatch(AUTH_LOGOUT).then(function () {
        return _this.$router.push("/login");
      });
    },

    checkConsentPopUp: function checkConsentPopUp() {
      var _this2 = this;

      var _vue = this;
      var text = '<p class="text-center Regular">Per poter continuare é necessario accettare l`informativa</p>';
      //https://www.lierac.it/privacy-cookie-policy.html
      //var text_ =
      //  '<a target="_blank" href="' +
      //  this.directory +
      //  '/privacy"><small class="underline text-center Bold">Se vuoi visualizzare l`informativa clicca <i class="underline">qui</i></small></a>';
      var text_ = '<a target="_blank" href="https://www.lierac.it/privacy-cookie-policy.html"><small class="underline text-center Bold">Se vuoi visualizzare l`informativa clicca <i class="underline">qui</i></small></a>';
      var Swal = this.$swal;
      Swal.fire({
        title: text,
        html: text_,
        showCancelButton: false,
        confirmButtonText: "Accetta",
        allowOutsideClick: false,
        animation: false
      }).then(function (result) {
        _this2.checkConsent();
        /* Read more about isConfirmed, isDenied below */
        if (!result.value) {
          Swal.fire("Non hai accettato l`informativa, per poter parteipare é necessario accettarla", "", "error");
        }
      });
    },
    checkConsent: function checkConsent() {
      var _this3 = this;

      var data = {
        tk: this.profile,
        id_platform: "DcJ7J1WfiwucqBl_lierac",
        unique_key_db: "d971ad4ed27c5e76c0ccf95a",
        vector_unique_key_db: "lierac_global"
      };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      axios_default()({
        url: "https://pharma.ubiqubit.it/" + "api/checkConsent",
        method: "POST",
        data: {
          data: data
        },
        headers: {
          Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        if (resp.data.status == "consent_give") {
          if (_this3.$store.getters.isAuthenticated) {
            _this3.$store.dispatch(USER_REQUEST);
          }
        }
      }).catch(function (error) {});
    },
    scrollToNotActive: function scrollToNotActive() {
      var _vue = this;
      setTimeout(function () {
        _vue.$scrollTo("#notActive", 700, { offset: -85 });
      }, 200);
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.checkSoftwareVersion();
    },

    getProfile: function getProfile(val) {
      this.consent = this.profile.consent;
      if (!this.profile.iban && this.consent == 1) {
        if (this.$route.path != "/iban") {
          if (false) this.$router.push("/iban");
        }
      } else if (this.consent == 0) {
        if (this.$route.path != "/privacy") {
          if (true) this.checkConsentPopUp();
        }
      }
    }
  },
  updated: function updated() {
    this.consent = this.profile.consent;
    if (this.consent) {
      if (!this.profile.iban && this.consent == 1) {
        if (this.$route.path != "/iban") {
          if (false) this.$router.push("/iban");
        }
      } else if (this.consent == 0) {
        if (this.$route.path != "/privacy") {
          if (true) this.checkConsentPopUp();
        }
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies", "promoOpen"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    },
    nome: function nome(state) {
      return "" + state.user.profile.company;
    }
  })),

  mounted: function mounted() {
    var _this4 = this;

    this.now = moment();
    this.consent = this.profile.consent;
    if (!this.profile.iban && this.consent == 1) {
      if (this.$route.path != "/iban") {
        if (false) this.$router.push("/iban");
      }
    } else if (this.consent == 0) {
      if (this.$route.path != "/privacy") {
        if (true) this.checkConsentPopUp();
      }
    }
    window.onresize = function () {
      _this4.vw = window.innerWidth;
      _this4.vh = window.innerHeight;
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eacecb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull" }, [
    _c(
      "nav",
      {
        staticClass:
          "\n        navbar navbar-expand-lg navbar-light\n        custom-toggler\n        align-items-center\n        fixed-top\n      ",
        class: { "fixed-top": _vm.scroll > _vm.vh }
      },
      [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "scroll-to",
                    rawName: "v-scroll-to",
                    value: { el: ".main", offset: -35 },
                    expression: "{ el: '.main', offset: -35 }"
                  }
                ],
                attrs: { to: "/" }
              },
              [
                _vm.vw < 991
                  ? _c("img", {
                      ref: "mainNavLogo",
                      staticClass: "img-fluid logoMob animatedLogo ml-4",
                      attrs: { src: __webpack_require__("iQH9") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.vw > 991 && _vm.$route.path != "/"
                  ? _c("img", {
                      ref: "mainNavLogo",
                      staticClass: "img-fluid logoMob-fix animatedLogo ml-4",
                      attrs: { src: __webpack_require__("iQH9") }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "navbar-collapse collapse align-l",
                attrs: { id: "navbar9" }
              },
              [
                _c(
                  "ul",
                  {
                    staticClass:
                      "navbar-nav nav-fill w-100 lastNavLink mb-5 mb-lg-0"
                  },
                  [
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _vm.$route.path == "/"
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    attrs: { href: "#active" }
                                  },
                                  [_vm._v("Registra richiesta di rimborso")]
                                )
                              : _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    class: {
                                      "theme-1": _vm.$route.name == "Contest"
                                    },
                                    attrs: { to: "/#active" }
                                  },
                                  [_vm._v("Registra richiesta di rimborso")]
                                )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _vm.$route.path == "/"
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    attrs: { href: "#active" }
                                  },
                                  [_vm._v("Promozioni attive")]
                                )
                              : _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    attrs: { to: "/#active" }
                                  },
                                  [_vm._v("Promozioni attive")]
                                )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nav-link menuItem",
                                attrs: {
                                  to: "/",
                                  "data-toggle": "collapse",
                                  "data-target": ".navbar-collapse.show"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "nav-link menuItem",
                                    on: {
                                      click: function($event) {
                                        return _vm.scrollToNotActive()
                                      }
                                    }
                                  },
                                  [_vm._v("Promozioni terminate")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isAuthenticated
                      ? _c(
                          "li",
                          { staticClass: "nav-item" },
                          [
                            _c(
                              "router-link",
                              {
                                directives: [
                                  {
                                    name: "scroll-to",
                                    rawName: "v-scroll-to",
                                    value: ".main",
                                    expression: "'.main'"
                                  }
                                ],
                                staticClass: "nav-link text-right",
                                attrs: {
                                  to: "/login",
                                  "data-toggle": "collapse",
                                  "data-target": ".navbar-collapse.show"
                                }
                              },
                              [
                                _c("strong", { staticClass: "menuItem" }, [
                                  _vm._v("Login")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isProfileLoaded &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") <=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: ".main",
                                  expression: "'.main'"
                                }
                              ],
                              staticClass: "nav-link text-right",
                              attrs: {
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              },
                              on: { click: _vm.logout }
                            },
                            [
                              _c("strong", { staticClass: "menuItem" }, [
                                _vm._v("Esci")
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isProfileLoaded &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          { staticClass: "nav-item dropdown mr-0 pd-0" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "nav-link dropdown-toggle menuItem mr-0 pd-0",
                                attrs: {
                                  href: "#",
                                  id: "navbardrop",
                                  "data-toggle": "dropdown"
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "pointer mr-0 pd-0",
                                  attrs: { icon: "user", size: "1x" }
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.nome) +
                                    "\n              "
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu",
                                attrs: {
                                  "data-toggle": "collapse",
                                  "data-target": ".navbar-collapse.show"
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: ".main",
                                        expression: "'.main'"
                                      }
                                    ],
                                    staticClass: "dropdown-item menuItem",
                                    attrs: {
                                      to: "/account",
                                      "data-toggle": "collapse",
                                      "data-target": ".navbar-collapse.show"
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "menuItem" }, [
                                      _vm._v("Il Mio Profilo")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item pointer menuItem black",
                                    on: { click: _vm.logout }
                                  },
                                  [
                                    _c("span", { staticClass: "menuItem" }, [
                                      _vm._v("Esci")
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    !_vm.acceptCookies
      ? _c(
          "div",
          { staticClass: "container-fluid fixed cookieCont cookieBaner" },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-12 Regular pt-3 pb-3" }, [
                _vm._v(
                  "\n          Questo sito utilizza cookie di profilazione anche di terze parti, per\n          inviare all’Utente pubblicità e servizi in linea con le Sue\n          preferenze. Qualora l’Utente volesse sapere di più o gestire le\n          proprie preferenze sui cookie, premi\n          "
                ),
                _c(
                  "a",
                  {
                    staticClass: "pointer Medium underline",
                    attrs: {
                      href: "https://www.lierac.it/privacy-cookie-policy.html",
                      target: "_blank"
                    }
                  },
                  [_vm._v("\n            qui.")]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v("Cliccando\n          "),
                _c(
                  "i",
                  {
                    staticClass: "pointer Medium underline",
                    on: {
                      click: function($event) {
                        return _vm.doAcceptCookies(1)
                      }
                    }
                  },
                  [_vm._v("accetto")]
                ),
                _vm._v(
                  "\n          - l’Utente acconsente all’uso dei cookie.\n        "
                )
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "ml-3 navbar-toggler",
        staticStyle: { "z-index": "10" },
        attrs: {
          type: "button",
          name: "openNavButton",
          "data-toggle": "collapse",
          "data-target": "#navbar9"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_navigation = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eacecb2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/navigation/index.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  navigation,
  components_navigation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/navigation/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1eacecb2", Component.options)
  } else {
    hotAPI.reload("data-v-1eacecb2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_components_navigation = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/footer/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var footer_moment = __webpack_require__("PJh5");

/* harmony default export */ var footer = ({
  name: "sqreen-footer",
  data: function data() {
    return {
      year: footer_moment().year()
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "loadingState", "isAuthenticated", "isProfileLoaded", "authStatus", "checkAge"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fe346e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
var footer_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var footer_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid footer pt-5 zIndex22" }, [
      _c("div", { staticClass: "row justify-content-center Medium " }, [
        _c("div", { staticClass: "col-lg-12 center" }, [
          _c("p", [
            _vm._v(
              "\n        Laboratoire Native Italia S.p.A. a socio unico - Largo Augusto, 8 - 20122 Milano -\n        Codice Fiscale, Partita IVA e Registro Imprese di Milano n.\n        11618450156 REA n. MI-1481980 – Tutti i diritti sono riservati"
            ),
            _c("br")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Servizio Clienti disponibile dal Lunedì al Venerdì nei seguenti orari:\n        8.00- 12/ 13 - 17 00.\n      "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n        Numero "),
            _c("a", { attrs: { href: "tel:0290390441" } }, [
              _vm._v("0290390441")
            ]),
            _vm._v(" Oppure manda una mail\n        a:\n        "),
            _c("a", { attrs: { href: "mailto:promozioninative@edps.it" } }, [
              _vm._v("promozioninative@edps.it")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3  text-center" }, [
          _c("p", { staticClass: "center" }, [
            _c(
              "a",
              {
                staticClass: "center",
                attrs: {
                  href: "https://it.lierac.com/cms/note-legali",
                  target: "_blank"
                }
              },
              [_vm._v("Privacy e cookie policy")]
            )
          ])
        ])
      ])
    ])
  }
]
footer_render._withStripped = true
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var components_footer = (footer_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62fe346e", footer_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/footer/index.vue
var footer_disposed = false
function injectStyle (ssrContext) {
  if (footer_disposed) return
  __webpack_require__("KwyM")
}
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = injectStyle
/* scopeId */
var footer___vue_scopeId__ = "data-v-62fe346e"
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  components_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)
footer_Component.options.__file = "src/components/footer/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62fe346e", footer_Component.options)
  } else {
    hotAPI.reload("data-v-62fe346e", footer_Component.options)
  }
  module.hot.dispose(function (data) {
    footer_disposed = true
  })
})()}

/* harmony default export */ var src_components_footer = (footer_Component.exports);

// EXTERNAL MODULE: ./src/assets/scss/main.scss
var main = __webpack_require__("MXkr");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var App = ({
  components: {
    SqreenFooter: src_components_footer,
    Navigation: src_components_navigation
    //loading,
  },
  name: 'app',
  data: function data() {
    return {
      moment: __webpack_require__("PJh5"),
      vh: window.innerHeight,
      vw: window.innerWidth
    };
  },

  created: function created() {
    if (this.$store.getters.isAuthenticated) {

      this.$store.dispatch(USER_REQUEST);
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.vw = window.innerWidth;
      _this.vh = window.innerHeight;
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded', 'authStatus', 'checkAge']), Object(vuex_esm["c" /* mapState */])({}))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("vue-headful", {
        attrs: { title: "LABORATOIRE-NATIVE", description: "" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("navigation"),
          _vm._v(" "),
          _c("div", { staticClass: "main-container" }, [_c("router-view")], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c("sqreen-footer", {
        class: {
          absoluteFooter:
            _vm.vw > 990 && _vm.$route.path == "/" && !_vm.isAuthenticated
        }
      })
    ],
    1
  )
}
var App_staticRenderFns = []
App_render._withStripped = true
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", App_esExports)
  }
}
// CONCATENATED MODULE: ./src/App.vue
var App_disposed = false
function App_injectStyle (ssrContext) {
  if (App_disposed) return
  __webpack_require__("x3vu")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-7ba5bd90"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)
App_Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", App_Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", App_Component.options)
  }
  module.hot.dispose(function (data) {
    App_disposed = true
  })
})()}

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vue-parallaxy/dist/vue-parallaxy.min.js
var vue_parallaxy_min = __webpack_require__("kHrF");
var vue_parallaxy_min_default = /*#__PURE__*/__webpack_require__.n(vue_parallaxy_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var components_login = ({
  name: "login",
  components: {
    Parallax: vue_parallaxy_min_default.a
  },
  data: function data() {
    return {
      username: "",
      password: "",
      token: "",
      loading: false,
      tempMail: "",
      socialEmail: false,
      social: "",
      confirmed: true,
      resend_success: false,
      codeLog: "",
      confirm_password_CM: "",
      password_CM: "",
      passwordFieldType: "password",
      codeBeforeLog: false,
      hasEmail: false,
      openlog: false
    };
  },

  methods: {
    switchVisibility: function switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    login: function login() {
      var _this = this;

      var username = this.username,
          password = this.password;


      this.$validator.validate().then(function (valid) {
        if (valid) {
          var data = {
            username: username,
            password: password,
            id_platform: "DcJ7J1WfiwucqBl_lierac",
            unique_key_db: "d971ad4ed27c5e76c0ccf95a",
            vector_unique_key_db: "lierac_global"
          };
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          _this.$store.dispatch(AUTH_REQUEST, { data: data }).then(function (resp) {
            _this.$track({ resp: resp });

            _this.$track(_this.$router);

            _this.$router.push("/account");
            if (false) {
              _this.$track("Gtag", _this.$gtag);
              _this.$gtag.reportConversion({
                send_to: process.env.SENDTO, // the custom tag to be reported
                action: "login",
                status: "success",
                clients: username
              });
            } else if (false) {
              _this.$gtag.event("send", {
                event_category: "success",
                event_label: "login",
                value: username
              });

              _this.$track("Gtag", _this.$gtag);
            }
          });
        }
      });
    },

    resetState: function resetState() {
      this.resend_success = false;
      this.confirmed = true;
    },
    ConfirmPwd: function ConfirmPwd() {
      var _this2 = this;

      this.$validator.validate().then(function (valid) {
        if (valid && _this2.password_CM && _this2.username) {
          _this2.loadingState = true;
          var _vue = _this2;
          var data = {
            password: _this2.password_CM,
            username: _this2.username,
            id_platform: "DcJ7J1WfiwucqBl_lierac",
            unique_key_db: "d971ad4ed27c5e76c0ccf95a",
            vector_unique_key_db: "lierac_global"
          };
          _this2.$callLog("ConfirmPwd", data);
          data = _this2.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://pharma.ubiqubit.it/" + "api/ConfirmPwd",
            method: "POST",
            headers: {
              Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
              "Content-type": "application/json"
            },
            data: { data: data }
          }).then(function (resp) {
            resp.data = _this2.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
            _this2.$track("ConfirmPwd", "SUECCESS");
            _this2.showAlertSuccess("Hai aggiornato correttamente la password, ritorna alla schermata di login per accedere alla piattaforma");
            //this.resend_success = false;
            //this.confirmed = true;
            //_vue.loadingState = false;
          }).catch(function (resp) {
            resp.response.data = _this2.$decryptByAES(resp.response.data, "B%t$AD!YMfnCZnfD");
            _this2.$track("ConfirmPwd", "ERROR");
            _vue.loadingState = false;
            _vue.showError(resp.response.data.description);
          });
        } else {}
      });
    },
    showAlertSuccess: function showAlertSuccess(value) {
      var _this3 = this;

      // Use sweetalret2
      this.$swal({
        type: "success",
        html: value,
        showCancelButton: false,
        animation: false,
        onClose: function onClose() {
          _this3.$router.push("/");
        }
      });
    },

    goForward: function goForward() {
      var _this4 = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this4.loadingState = true;
          var _vue = _this4;
          var data = {
            code: _this4.codeLog,
            id_platform: "DcJ7J1WfiwucqBl_lierac",
            unique_key_db: "d971ad4ed27c5e76c0ccf95a",
            vector_unique_key_db: "lierac_global"
          };
          _this4.$callLog("goForward", data);
          data = _this4.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://pharma.ubiqubit.it/" + "api/goForward",
            method: "POST",
            headers: {
              Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
              "Content-type": "application/json"
            },
            data: { data: data }
          }).then(function (resp) {
            resp.data = _this4.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
            _this4.$track("goForward", "SUECCESS");
            _vue.loadingState = false;
          }).catch(function (resp) {
            resp.response.data = _this4.$decryptByAES(resp.response.data, "B%t$AD!YMfnCZnfD");
            _this4.$track("goForward", "ERROR");
            _vue.loadingState = false;
            _vue.showError(resp.response.data.description);
          });
        } else {}
      });
    },

    checkIfExistEmail: function checkIfExistEmail(value) {
      var _this5 = this;

      var newValue = value.target.value;

      var field = this.$validator.fields.find({ name: "email" });

      if (!this.errors.has("email") && this.tempMail != newValue) {
        this.tempMail = newValue;
        var data = {
          param: newValue,
          table: "utenti",
          fieldName: "email",
          fieldIdPlatform: "idPlatform_utenti",
          id_platform: "DcJ7J1WfiwucqBl_lierac",
          unique_key_db: "d971ad4ed27c5e76c0ccf95a",
          vector_unique_key_db: "lierac_global"
        };
        this.$callLog("checkIfExistEmail", data);
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          method: "POST",
          data: { data: data },
          url: "https://pharma.ubiqubit.it/" + "api/checkIfIsUnique",
          headers: {
            Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this5.socialEmail = false;
          _this5.$respLog("checkIfExistEmail", resp);
        }).catch(function (error) {
          _this5.$respLog("checkIfExistEmail", error.response);
          if (error.response.data.message != "manual") {
            _this5.socialEmail = error.response.data.message;
          }
        });
      }
    },
    checkIfExistCod: function checkIfExistCod(value) {
      var _this6 = this;

      var newValue = value.target.value;

      var field = this.$validator.fields.find({ name: "email" });

      if (!this.errors.has("email") && this.tempMail != newValue) {
        this.tempMail = newValue;
        var data = {
          param: newValue,
          table: "utenti",
          fieldName: "cod",
          fieldIdPlatform: "idPlatform_utenti",
          id_platform: "DcJ7J1WfiwucqBl_lierac",
          unique_key_db: "d971ad4ed27c5e76c0ccf95a",
          vector_unique_key_db: "lierac_global"
        };
        this.$callLog("checkIfExistCod", data);
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          method: "POST",
          data: { data: data },
          url: "https://pharma.ubiqubit.it/" + "api/checkIfIsUnique",
          headers: {
            Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this6.socialEmail = false;
          _this6.$respLog("checkIfExistCod", resp);
        }).catch(function (error) {
          _this6.$respLog("checkIfExistCod", error.response);
          if (error.response.data.message != "manual") {
            _this6.socialEmail = error.response.data.message;
          }
        });
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["loginerror", "loadingState", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    window.onresize = function () {
      _this7.vw = window.innerWidth;
      _this7.vh = window.innerHeight;
    };
    if (!this.codeBeforeLog) this.openlog = true;
    var _vue = this;
    setTimeout(function () {
      _vue.$scrollTo("#firstElem", 0, { offset: -125 });
    }, 100);
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c98a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/index.vue
var login_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pt-5 mt-5 widthFull somatoline",
      attrs: { id: "firstElem" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.codeBeforeLog
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-lg-6 mb-3" }, [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.goForward.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.codeLog,
                            expression: "codeLog"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 56
                            },
                            expression:
                              "{\n                  required: true,\n                  max: 56,\n                }"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("codeLog"),
                          valid: !!_vm.codeLog
                        },
                        attrs: {
                          type: "text",
                          id: "codeLog",
                          name: "codeLog",
                          "data-vv-as": "Codice"
                        },
                        domProps: { value: _vm.codeLog },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.codeLog = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "codeLog" }
                        },
                        [_vm._v("Codice utente")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("codeLog")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.errors.first("codeLog")) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm._m(1)
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.openlog
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _vm.loadingState ? _c("loading") : _vm._e(),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "login",
                  attrs: { id: "login-form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm.confirmed
                    ? _c("div", [
                        _vm.hasEmail
                          ? _c(
                              "div",
                              {
                                staticClass: "form-row justify-content-center"
                              },
                              [
                                _c("div", { staticClass: "col-lg-6 mb-3" }, [
                                  _c("div", { staticClass: "group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.username,
                                          expression: "username"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            email: true,
                                            temporaryEmail: true,
                                            plusIssueEmail: true,
                                            max: 56
                                          },
                                          expression:
                                            "{\n                    required: true,\n                    email: true,\n                    temporaryEmail: true,\n                    plusIssueEmail: true,\n                    max: 56,\n                  }"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "username"
                                        ),
                                        valid: !!_vm.username
                                      },
                                      attrs: {
                                        type: "text",
                                        id: "username",
                                        name: "username",
                                        "data-vv-as": "username"
                                      },
                                      domProps: { value: _vm.username },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.username = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: { for: "username" }
                                      },
                                      [_vm._v("Username")]
                                    ),
                                    _vm._v(" "),
                                    _vm.errors.has("username")
                                      ? _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.errors.first("username")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.socialEmail
                                      ? _c(
                                          "div",
                                          { staticClass: "text-danger mt-3" },
                                          [
                                            _vm._v(
                                              "\n                  Sei registrato con:\n                  "
                                            ),
                                            _c(
                                              "strong",
                                              {
                                                staticClass: "text-capitalize"
                                              },
                                              [_vm._v(_vm._s(_vm.socialEmail))]
                                            ),
                                            _vm._v(
                                              ". Per effetuare accesso clicca sulla apposita icona\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "form-row justify-content-center"
                              },
                              [
                                _c("div", { staticClass: "col-lg-6 mb-3" }, [
                                  _c("div", { staticClass: "group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.username,
                                          expression: "username"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 56
                                          },
                                          expression:
                                            "{\n                    required: true,\n                    max: 56,\n                  }"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "username"
                                        ),
                                        valid: !!_vm.username
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "username",
                                        id: "username",
                                        name: "username",
                                        "data-vv-as": "username"
                                      },
                                      domProps: { value: _vm.username },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.username = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: { for: "username" }
                                      },
                                      [_vm._v("Username")]
                                    ),
                                    _vm._v(" "),
                                    _vm.errors.has("username")
                                      ? _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.errors.first("username")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-lg-6 mb-3" }, [
                              _c("div", { staticClass: "group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        min: 6,
                                        max: 56
                                      },
                                      expression:
                                        "{ required: true, min: 6, max: 56 }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("password"),
                                    valid: !!_vm.password
                                  },
                                  attrs: {
                                    type: "password",
                                    autocomplete: "current-password",
                                    id: "password",
                                    name: "password",
                                    "data-vv-as": "Password"
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.password = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "password" }
                                  },
                                  [_vm._v("Password")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("password")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.errors.first("password")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loginerror
                                  ? _c("div", { staticClass: "mb-3" }, [
                                      _c(
                                        "span",
                                        { staticClass: "formError ml-1" },
                                        [_vm._v("Email o password errati.")]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.hasEmail
                          ? _c(
                              "div",
                              {
                                staticClass: "form-row justify-content-center"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-lg-6 mb-3" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "text-red underline sans-serifBold pl-2 mt-3",
                                        attrs: { to: "/forgot-password" }
                                      },
                                      [_vm._v("Password dimenticata?")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(2)
                      ])
                    : _vm.resend_success
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3 center" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { to: "/login" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.resetState.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Accedi")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : !_vm.resend_success && !_vm.confirmed && _vm.hasEmail
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8 mb-3 center" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary mt-3",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.resendConfirmEmail.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Invia")]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              !_vm.resend_success && !_vm.confirmed && !_vm.hasEmail
                ? _c(
                    "form",
                    { staticClass: "form-row justify-content-center" },
                    [
                      _c("div", { staticClass: "col-md-8" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("div", { key: 10, staticClass: "group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.password_CM,
                                expression: "password_CM"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { passwordCheck: true, min: 8, max: 56 },
                                expression:
                                  "{ passwordCheck: true, min: 8, max: 56 }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("password"),
                              valid: !!_vm.password_CM
                            },
                            attrs: {
                              type: "password",
                              autocomplete: "on",
                              id: "password_CM",
                              name: "password_CM"
                            },
                            domProps: { value: _vm.password_CM },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password_CM = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel label",
                              attrs: { for: "password_CM" }
                            },
                            [_vm._v("Nuova Password")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("password_CM")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.errors.first("password_CM")) +
                                    "\n                    "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { key: 11, staticClass: "group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.confirm_password_CM,
                                expression: "confirm_password_CM"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: !!_vm.password_CM,
                                  confirmed: _vm.password_CM,
                                  passwordCheck: true,
                                  min: 8,
                                  max: 56
                                },
                                expression:
                                  "{\n                        required: !!password_CM,\n                        confirmed: password_CM,\n                        passwordCheck: true,\n                        min: 8,\n                        max: 56,\n                      }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has(
                                "confirm_password_CM"
                              ),
                              valid: !!_vm.confirm_password_CM
                            },
                            attrs: {
                              type: "password",
                              autocomplete: "on",
                              id: "confirm_password_CM",
                              name: "confirm_password_CM",
                              "data-vv-as": "conferma password"
                            },
                            domProps: { value: _vm.confirm_password_CM },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.confirm_password_CM = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel label",
                              attrs: { for: "password" }
                            },
                            [_vm._v("Conferma Nuova Password")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("confirm_password_CM")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.errors.first("confirm_password_CM")
                                    ) +
                                    "\n                    "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "center mt-5 mt-md-3 mb-md-0 mb-5 pb-5"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { tag: "button", type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.ConfirmPwd()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                      CONFERMA\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var login_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid mt-5" }, [
      _c("div", { staticClass: "form-row justify-content-center" }, [
        _c("div", { staticClass: "col-lg-4 mb-1 text-center" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row center mt-5" }, [
        _c("h2", { staticClass: "sans-serifBold center pb-4 widthFull" }, [
          _c("b", [_vm._v("LOGIN")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center" }, [
      _c("button", { staticClass: "btn btn-primary" }, [_vm._v("Procedi")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-6 mb-3 mt-3 text-center" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "submit" } },
          [_vm._v("ACCEDI")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v(
            "L'e-mail di conferma della registrazione è stata inviata alla\n                  tua casella di posta elettronica"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v("Non hai ricevuto l'e-mail "),
          _c("br"),
          _vm._v("di conferma della registrazione?")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4 mt-5" }, [
        _vm._v(
          "Controlla che il tuo gestore di posta elettronica non abbia inserito il messaggio nella cartella di posta indesiderata (spam) o con destinatario sconosciuto."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4" }, [
        _vm._v(
          "Se sono passati diversi minuti da quando hai fatto la richiesta e il messaggio non è ancora arrivato clicca sul bottone qui sotto per chiederne il reinivio."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "h3 darkBlue Bold center pb-3 " }, [
      _c("b", [
        _vm._v("PRIMA DI PROCEDERE AL LOGIN "),
        _c("br"),
        _vm._v("CAMBIA LA TUA PASSWORD")
      ])
    ])
  }
]
login_render._withStripped = true
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_login = (login_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c98a68", login_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/login/index.vue
var login_disposed = false
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = null
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  components_login,
  selectortype_template_index_0_src_components_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)
login_Component.options.__file = "src/components/login/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70c98a68", login_Component.options)
  } else {
    hotAPI.reload("data-v-70c98a68", login_Component.options)
  }
  module.hot.dispose(function (data) {
    login_disposed = true
  })
})()}

/* harmony default export */ var src_components_login = (login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./src/components/agile-slider/mixins/handlers.js
/**
 * Handlers methods for mouse/touch events
 */
var mixin = {
	methods: {
		handleMouseDown: function handleMouseDown(e) {
			if (!e.touches) {
				e.preventDefault();
			}
			this.mouseDown = true;
			this.dragStartX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX;
			this.dragStartY = 'ontouchstart' in window ? e.touches[0].clientY : e.clientY;
		},
		handleMouseMove: function handleMouseMove(e) {
			var positionX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX;
			var positionY = 'ontouchstart' in window ? e.touches[0].clientY : e.clientY;
			var dragDistanceX = Math.abs(positionX - this.dragStartX);
			var dragDistanceY = Math.abs(positionY - this.dragStartY);
			if (dragDistanceX > 3 * dragDistanceY) {
				this.disableScroll();
				this.dragDistance = positionX - this.dragStartX;
			}
		},
		handleMouseUp: function handleMouseUp() {
			this.mouseDown = false;
			this.enableScroll();
		},
		handleMouseOver: function handleMouseOver(element) {
			if (this.settings.autoplay) {
				if (element === 'dot' && this.settings.pauseOnDotsHover || element === 'track' && this.settings.pauseOnHover) {
					this.pauseAutoPlay = true;
				}
			}
		},
		handleMouseOut: function handleMouseOut(element) {
			if (this.settings.autoplay) {
				if (element === 'dot' && this.settings.pauseOnDotsHover || element === 'track' && this.settings.pauseOnHover) {
					this.pauseAutoPlay = false;
				}
			}
		}
	}
};

/* harmony default export */ var handlers = (mixin);
// CONCATENATED MODULE: ./src/components/agile-slider/mixins/helpers.js
/**
 * Helpers methods
 */
var helpers_mixin = {
	methods: {
		/**
   * Convert HTML Collection to JS Array
   */
		htmlCollectionToArray: function htmlCollectionToArray(collection) {
			return Array.prototype.slice.call(collection, 0);
		},


		/**
   * Compare elements for breakpoints sorting
   */
		compare: function compare(a, b) {
			if (a.breakpoint < b.breakpoint) {
				return this.initialSettings.mobileFirst ? -1 : 1;
			} else if (a.breakpoint > b.breakpoint) {
				return this.initialSettings.mobileFirst ? 1 : -1;
			} else {
				return 0;
			}
		},


		/**
   * Set window & container width
   */
		getWidth: function getWidth() {
			this.widthWindow = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			this.widthContainer = this.$refs.list.clientWidth;
		}
	}
};

/* harmony default export */ var helpers = (helpers_mixin);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./src/components/agile-slider/mixins/preparations.js


/**
 * Carousel preparation methods
 */
var preparations_mixin = {
	methods: {
		/**
   * Prepare settings object
   */
		prepareSettings: function prepareSettings() {
			var _this = this;

			if (!this.initialSettings.responsive) {
				this.toggleFade();
				this.toggleAutoPlay();
				return false;
			}

			var newSettings = assign_default()({}, this.initialSettings);
			delete newSettings.responsive;

			this.initialSettings.responsive.forEach(function (option) {
				if (_this.initialSettings.mobileFirst ? option.breakpoint < _this.widthWindow : option.breakpoint > _this.widthWindow) {
					for (var key in option.settings) {
						newSettings[key] = option.settings[key];
					}
				}
			});

			this.settings = assign_default()({}, newSettings);
		},


		/**
   * Prepare slides classes and styles
   */
		prepareSlides: function prepareSlides() {
			this.slides = this.htmlCollectionToArray(this.$refs.slides.children);

			// Probably timeout needed
			if (this.clonedSlides) {
				this.slidesClonedBefore = this.htmlCollectionToArray(this.$refs.slidesClonedBefore.children);
				this.slidesClonedAfter = this.htmlCollectionToArray(this.$refs.slidesClonedAfter.children);
			}

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(this.allSlides), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var slide = _step.value;

					slide.classList.add('agile__slide');
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		},


		/**
   *  Prepare slides active/current classes
   */
		prepareSlidesClasses: function prepareSlidesClasses() {
			if (this.currentSlide === null) {
				return false;
			}

			// Remove active & current classes
			for (var i = 0; i < this.slidesCount; i++) {
				this.slides[i].classList.remove('agile__slide--active');
				this.slides[i].classList.remove('agile__slide--current');
			}

			// Add active & current class for current slide
			this.slides[this.currentSlide].classList.add('agile__slide--active');

			var start = this.clonedSlides ? this.slidesCount + this.currentSlide : this.currentSlide;

			if (this.centerMode) {
				start -= Math.floor(this.settings.slidesToShow / 2) - +(this.settings.slidesToShow % 2 === 0);
			}

			// To account for the combination of infinite = false and centerMode = true, ensure we don't overrun the bounds of the slide count.
			for (var _i = Math.max(start, 0); _i < Math.min(start + this.settings.slidesToShow, this.slidesCount); _i++) {
				this.allSlides[_i].classList.add('agile__slide--current');
			}
		},


		/**
   * Prepare carousel styles
   */
		prepareCarousel: function prepareCarousel() {
			this.widthSlide = !this.settings.unagile ? this.widthContainer / this.settings.slidesToShow : 'auto';

			// Actions on document resize
			for (var i = 0; i < this.allSlidesCount; i++) {
				this.allSlides[i].style.width = this.widthSlide + 'px';
			}

			// Prepare track
			if (this.settings.unagile) {
				this.translateX = 0;
			} else {
				if (this.currentSlide === null && this.slidesCount) {
					this.currentSlide = this.settings.initialSlide;
				}

				this.goTo(this.currentSlide, false, false);
			}
		}
	}
};

/* harmony default export */ var preparations = (preparations_mixin);
// CONCATENATED MODULE: ./src/components/agile-slider/mixins/props.js
/**
 * Component props
 */
var props_mixin = {
	props: {
		// Depreciated
		arrows: {
			type: Boolean,
			default: true
		},

		/**
   * Set the carousel to be the navigation of other carousels
   */
		asNavFor: {
			type: Array,
			default: function _default() {
				return [];
			}
		},

		/**
   * Enable autoplay
   */
		autoplay: {
			type: Boolean,
			default: false
		},

		/**
   * Autoplay interval in milliseconds
   */
		autoplaySpeed: {
			type: Number,
			default: 3000
		},

		/**
   * Enable centered view when slidesToShow > 1
   */
		centerMode: {
			type: Boolean,
			default: false
		},

		/**
   * Slides padding in center mode
   */
		centerPadding: {
			type: String,
			default: '15%'
		},

		/**
   * Enable dot indicators/pagination
   */
		dots: {
			type: Boolean,
			default: true
		},

		/**
   * Enable fade effect
   */
		fade: {
			type: Boolean,
			default: false
		},

		/**
   * Infinite loop sliding
   */
		infinite: {
			type: Boolean,
			default: true
		},

		/**
   * Index of slide to start on
   */
		initialSlide: {
			type: Number,
			default: 0
		},

		/**
   * Enable mobile first calculation for responsive settings
   */
		mobileFirst: {
			type: Boolean,
			default: true
		},

		/**
   * Enable prev/next navigation buttons
   */
		navButtons: {
			type: Boolean,
			default: true
		},

		// Depreciated
		nextArrow: {
			type: String,
			default: null
		},

		/**
   * All settings as one object
   */
		options: {
			type: Object,
			default: function _default() {
				return null;
			}
		},

		/**
   * Pause autoplay when a dot is hovered
   */
		pauseOnDotsHover: {
			type: Boolean,
			default: false
		},

		/**
   * Pause autoplay when a slide is hovered
   */
		pauseOnHover: {
			type: Boolean,
			default: true
		},

		// Depreciated
		prevArrow: {
			type: String,
			default: null
		},

		/**
   * Object containing breakpoints and settings objects
   */
		responsive: {
			type: Array,
			default: function _default() {
				return null;
			}
		},

		/**
   * Enable right-to-left mode
   */
		rtl: {
			type: Boolean,
			default: false
		},

		/**
   * Number of slides to scroll
   */
		slidesToScroll: {
			type: Number,
			default: 1
		},

		/**
   * Number of slides to show
   */
		slidesToShow: {
			type: Number,
			default: 1
		},

		/**
   * Slide animation speed in milliseconds
   */
		speed: {
			type: Number,
			default: 300
		},

		/**
   * Transition timing function
   * Available: ease, linear, ease-in, ease-out, ease-in-out
   */
		timing: {
			type: String,
			default: 'ease'
		},

		/**
   * Disable Agile carousel
   */
		unagile: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			// Initial settings based on props
			initialSettings: {
				asNavFor: this.asNavFor,
				autoplay: this.autoplay,
				autoplaySpeed: this.autoplaySpeed,
				centerMode: this.centerMode,
				centerPadding: this.centerPadding,
				dots: this.dots,
				fade: this.fade,
				infinite: this.infinite,
				initialSlide: this.initialSlide,
				mobileFirst: this.mobileFirst,
				navButtons: this.navButtons,
				pauseOnDotsHover: this.pauseOnDotsHover,
				pauseOnHover: this.pauseOnHover,
				responsive: this.responsive,
				rtl: this.rtl,
				slidesToScroll: this.slidesToScroll,
				slidesToShow: this.slidesToShow,
				speed: this.speed,
				timing: this.timing,
				unagile: this.unagile
			}
		};
	}
};

/* harmony default export */ var props = (props_mixin);
// CONCATENATED MODULE: ./src/components/agile-slider/mixins/watchers.js
/**
 * Component watchers
 */
var watchers_mixin = {
	watch: {
		// Watch window width change
		widthWindow: function widthWindow(newValue, oldValue) {
			if (oldValue) {
				this.prepareCarousel();
				this.toggleFade();
			}
		},


		// Watch current slide change
		currentSlide: function currentSlide() {
			this.prepareSlidesClasses();

			// Set start time of slide
			this.autoplayStart = this.settings.autoplay ? +new Date() : null;

			this.$emit('afterChange', { currentSlide: this.currentSlide });
		},


		// Recalculate settings
		currentBreakpoint: function currentBreakpoint() {
			this.prepareSettings();
			this.$emit('breakpoint', { breakpoint: this.currentBreakpoint });
		},


		// Watch drag distance change
		dragDistance: function dragDistance() {
			if (this.mouseDown) {
				var rtl = this.settings.rtl;

				var dragDistance = this.dragDistance * (rtl ? -1 : 1);

				if (dragDistance > this.swipeDistance && this.canGoToPrev) {
					this.goToPrev();
					this.handleMouseUp();
				}

				if (dragDistance < -1 * this.swipeDistance && this.canGoToNext) {
					this.goToNext();
					this.handleMouseUp();
				}
			}
		},
		'settings.fade': function settingsFade() {
			this.toggleFade();
		},
		'settings.autoplay': function settingsAutoplay() {
			this.toggleAutoPlay();
		},
		pauseAutoPlay: function pauseAutoPlay(nevValue) {
			var _this = this;

			if (nevValue) {
				// Store current slide remaining time and disable auto play mode
				this.remaining = this.settings.autoplaySpeed - (+new Date() - this.autoplayStart);
				this.disableAutoPlay();
				this.clearAutoPlayPause();
			} else {
				// Go to next after remaining time and rerun auto play mode
				this.autoplayTimeout = setTimeout(function () {
					_this.clearAutoPlayPause();
					_this.goToNext();
					_this.toggleAutoPlay();
				}, this.remaining);
			}
		}
	}
};

/* harmony default export */ var watchers = (watchers_mixin);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/agile-slider/Agile.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Agile = ({
	name: 'agile',

	mixins: [handlers, helpers, preparations, props, watchers],

	data: function data() {
		return {
			slides: [],
			slidesClonedBefore: [],
			slidesClonedAfter: [],
			autoplayInterval: null,
			autoplayTimeout: null,
			pauseAutoPlay: false,
			autoplayStart: null,
			autoplayRemaining: null,
			// autoplayStatus: false,
			// autoplayTimeout: null,
			currentSlide: null,
			mouseDown: false,
			dragStartX: 0,
			dragStartY: 0,
			dragDistance: 0,
			swipeDistance: 50,
			translateX: 0,
			transitionDelay: 0,
			widthWindow: 0,
			widthContainer: 0,
			widthSlide: 0,
			settings: {}
		};
	},


	computed: {
		canGoToPrev: function canGoToPrev() {
			return this.settings.infinite || this.currentSlide > 0;
		},

		canGoToNext: function canGoToNext() {
			return this.settings.infinite || this.currentSlide < this.slidesCount - 1;
		},

		clonedSlides: function clonedSlides() {
			return !this.settings.unagile && !this.settings.fade && this.settings.infinite;
		},

		breakpoints: function breakpoints() {
			return !this.initialSettings.responsive ? [] : this.initialSettings.responsive.map(function (item) {
				return item.breakpoint;
			});
		},

		currentBreakpoint: function currentBreakpoint() {
			var _this = this;

			var breakpoints = this.breakpoints.map(function (item) {
				return item;
			}).reverse();
			return this.initialSettings.mobileFirst ? breakpoints.find(function (item) {
				return item < _this.widthWindow;
			}) || 0 : breakpoints.find(function (item) {
				return item > _this.widthWindow;
			}) || null;
		},

		allSlides: function allSlides() {
			return this.clonedSlides ? [].concat(toConsumableArray_default()(this.slidesClonedBefore), toConsumableArray_default()(this.slides), toConsumableArray_default()(this.slidesClonedAfter)) : this.slides;
		},

		slidesCount: function slidesCount() {
			return this.slides.length;
		},

		allSlidesCount: function allSlidesCount() {
			return this.allSlides.length;
		},

		marginX: function marginX() {
			var marginX = this.clonedSlides ? this.slidesCount * this.widthSlide : 0;

			// Center mode margin
			if (this.settings.centerMode) {
				marginX -= (Math.floor(this.settings.slidesToShow / 2) - +(this.settings.slidesToShow % 2 === 0)) * this.widthSlide;
			}

			return this.settings.rtl ? marginX : -1 * marginX;
		}
	},

	created: function created() {
		// Read settings from options object
		if (this.options) {
			for (var key in this.options) {
				this.initialSettings[key] = this.options[key];
			}
		}

		// Sort breakpoints
		if (this.initialSettings.responsive) {
			this.initialSettings.responsive.sort(this.compare);
		}

		// Set first load settings
		assign_default()(this.settings, this.initialSettings);
	},
	mounted: function mounted() {
		// Windows resize listener
		window.addEventListener('resize', this.getWidth);

		// Mouse and touch events
		if ('ontouchstart' in window) {
			this.$refs.track.addEventListener('touchstart', this.handleMouseDown);
			this.$refs.track.addEventListener('touchend', this.handleMouseUp);
			this.$refs.track.addEventListener('touchmove', this.handleMouseMove);
		} else {
			this.$refs.track.addEventListener('mousedown', this.handleMouseDown);
			this.$refs.track.addEventListener('mouseup', this.handleMouseUp);
			this.$refs.track.addEventListener('mousemove', this.handleMouseMove);
		}

		// Init
		this.reload();
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.getWidth);

		this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchstart' : 'mousedown', this.handleMouseDown);
		this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchend' : 'mouseup', this.handleMouseUp);
		this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchmove' : 'mousemove', this.handleMouseMove);

		this.disableAutoPlay();
	},


	methods: {
		// Reload carousel
		reload: function reload() {
			this.getWidth();
			this.prepareSettings();
			this.prepareSlides();
			this.prepareCarousel();
			this.toggleFade();
		},
		toggleFade: function toggleFade() {
			var enabled = !this.settings.unagile && this.settings.fade;

			for (var i = 0; i < this.slidesCount; i++) {
				this.slides[i].style.transition = enabled ? 'opacity ' + this.settings.timing + ' ' + this.settings.speed + 'ms' : 'none';
				this.slides[i].style.transform = enabled ? 'translate(-' + i * this.widthSlide + 'px)' : 'none';
			}
		},
		toggleAutoPlay: function toggleAutoPlay() {
			var _this2 = this;

			var enabled = !this.settings.unagile && this.settings.autoplay;

			if (!this.autoplayInterval && enabled) {
				this.autoplayInterval = setInterval(function () {
					if (!document.hidden) {
						if (!_this2.canGoToNext) {
							_this2.disableAutoPlay();
						} else {
							_this2.goToNext();
						}
					}
				}, this.settings.autoplaySpeed);
			} else {
				this.disableAutoPlay();
			}
		},
		restartAutoPlay: function restartAutoPlay() {
			this.disableAutoPlay();
			this.toggleAutoPlay();
		},
		disableAutoPlay: function disableAutoPlay() {
			clearInterval(this.autoplayInterval);
			this.autoplayInterval = null;
		},
		clearAutoPlayPause: function clearAutoPlayPause() {
			clearTimeout(this.autoplayTimeout);
			this.autoplayRemaining = null;
		},
		disableScroll: function disableScroll() {
			document.ontouchmove = function (e) {
				return e.preventDefault();
			};
		},
		enableScroll: function enableScroll() {
			document.ontouchmove = function () {
				return true;
			};
		},


		// Return current slide index
		getCurrentSlide: function getCurrentSlide() {
			return this.currentSlide;
		},


		// Return current breakpoint
		getCurrentBreakpoint: function getCurrentBreakpoint() {
			return this.currentBreakpoint;
		},


		// Return settings for current breakpoint
		getCurrentSettings: function getCurrentSettings() {
			return this.settings;
		},


		// Return initial settings
		getInitialSettings: function getInitialSettings() {
			return this.initialSettings;
		},


		// Go to next slide
		goToNext: function goToNext() {
			if (this.canGoToNext) {
				this.goTo(this.currentSlide + 1);
			}
		},


		// Go to previous slide
		goToPrev: function goToPrev() {
			if (this.canGoToPrev) {
				this.goTo(this.currentSlide - 1);
			}
		},


		// Go to slide
		goTo: function goTo(n) {
			var _this3 = this;

			var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var asNav = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			// Break goTo() if unagile is active
			if (this.settings.unagile) {
				return false;
			}

			if (!asNav) {
				this.settings.asNavFor.forEach(function (carousel) {
					if (carousel) {
						carousel.goTo(n, transition, true);
					}
				});
			}

			var realNextSlide = n;

			if (transition) {
				if (this.settings.infinite && n < 0) {
					realNextSlide = this.slidesCount - 1;
				} else if (n >= this.slidesCount) {
					realNextSlide = 0;
				}

				this.$emit('beforeChange', { currentSlide: this.currentSlide, nextSlide: realNextSlide });

				this.currentSlide = realNextSlide;

				if (n !== realNextSlide) {
					setTimeout(function () {
						_this3.goTo(realNextSlide, false);
					}, this.settings.speed);
				}
			}

			var translateX = !this.settings.fade ? n * this.widthSlide * this.settings.slidesToScroll : 0;
			this.transitionDelay = transition ? this.speed : 0;
			this.translateX = this.settings.rtl ? translateX : -1 * translateX;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77bc7422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agile-slider/Agile.vue
var Agile_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "agile",
      class: {
        "agile--auto-play": _vm.settings.autoplay,
        "agile--disabled": _vm.settings.unagile,
        "agile--fade": _vm.settings.fade && !_vm.settings.unagile,
        "agile--rtl": _vm.settings.rtl
      }
    },
    [
      _c("div", { ref: "list", staticClass: "agile__list" }, [
        _c(
          "div",
          {
            ref: "track",
            staticClass: "agile__track",
            style: {
              transform: "translate(" + (_vm.translateX + _vm.marginX) + "px)",
              transition:
                "transform " +
                _vm.settings.timing +
                " " +
                _vm.transitionDelay +
                "ms"
            },
            on: {
              mouseover: function($event) {
                return _vm.handleMouseOver("track")
              },
              mouseout: function($event) {
                return _vm.handleMouseOut("track")
              }
            }
          },
          [
            _vm.clonedSlides
              ? _c(
                  "div",
                  {
                    ref: "slidesClonedBefore",
                    staticClass: "agile__slides agile__slides--cloned"
                  },
                  [_vm._t("default")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "slides",
                staticClass: "agile__slides agile__slides--regular"
              },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _vm.clonedSlides
              ? _c(
                  "div",
                  {
                    ref: "slidesClonedAfter",
                    staticClass: "agile__slides agile__slides--cloned"
                  },
                  [_vm._t("default")],
                  2
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.settings.unagile && (_vm.settings.navButtons || _vm.settings.dots)
        ? _c("div", { staticClass: "agile__actions" }, [
            _vm.settings.navButtons && !_vm.settings.unagile
              ? _c(
                  "button",
                  {
                    ref: "prevButton",
                    staticClass: "agile__nav-button agile__nav-button--prev",
                    attrs: { disabled: !_vm.canGoToPrev, type: "button" },
                    on: {
                      click: function($event) {
                        _vm.goToPrev(), _vm.restartAutoPlay()
                      }
                    }
                  },
                  [
                    _vm._t("prevButton", function() {
                      return [_vm._v("←")]
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.dots && !_vm.settings.unagile
              ? _c(
                  "ul",
                  { ref: "dots", staticClass: "agile__dots" },
                  _vm._l(_vm.slidesCount, function(n) {
                    return _c(
                      "li",
                      {
                        key: n,
                        staticClass: "agile__dot",
                        class: {
                          "agile__dot--current": n - 1 === _vm.currentSlide
                        },
                        on: {
                          mouseover: function($event) {
                            return _vm.handleMouseOver("dot")
                          },
                          mouseout: function($event) {
                            return _vm.handleMouseOut("dot")
                          }
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.goTo(n - 1), _vm.restartAutoPlay()
                              }
                            }
                          },
                          [_vm._v(_vm._s(n))]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.navButtons && !_vm.settings.unagile
              ? _c(
                  "button",
                  {
                    ref: "nextButton",
                    staticClass: "agile__nav-button agile__nav-button--next",
                    attrs: { disabled: !_vm.canGoToNext, type: "button" },
                    on: {
                      click: function($event) {
                        _vm.goToNext(), _vm.restartAutoPlay()
                      }
                    }
                  },
                  [
                    _vm._t("nextButton", function() {
                      return [_vm._v("→")]
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var Agile_staticRenderFns = []
Agile_render._withStripped = true
var Agile_esExports = { render: Agile_render, staticRenderFns: Agile_staticRenderFns }
/* harmony default export */ var agile_slider_Agile = (Agile_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77bc7422", Agile_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/agile-slider/Agile.vue
var Agile_disposed = false
function Agile_injectStyle (ssrContext) {
  if (Agile_disposed) return
  __webpack_require__("LUgf")
}
var Agile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Agile___vue_template_functional__ = false
/* styles */
var Agile___vue_styles__ = Agile_injectStyle
/* scopeId */
var Agile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Agile___vue_module_identifier__ = null
var Agile_Component = Agile_normalizeComponent(
  Agile,
  agile_slider_Agile,
  Agile___vue_template_functional__,
  Agile___vue_styles__,
  Agile___vue_scopeId__,
  Agile___vue_module_identifier__
)
Agile_Component.options.__file = "src/components/agile-slider/Agile.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77bc7422", Agile_Component.options)
  } else {
    hotAPI.reload("data-v-77bc7422", Agile_Component.options)
  }
  module.hot.dispose(function (data) {
    Agile_disposed = true
  })
})()}

/* harmony default export */ var components_agile_slider_Agile = (Agile_Component.exports);

// CONCATENATED MODULE: ./src/components/agile-slider/index.js


var agile_slider_install = function install(Vue) {
	Vue.component('agile', components_agile_slider_Agile);
};

/* harmony default export */ var agile_slider = ({
	install: agile_slider_install
});


// EXTERNAL MODULE: ./node_modules/vue-carousel-3d/dist/vue-carousel-3d.min.js
var vue_carousel_3d_min = __webpack_require__("T2eB");
var vue_carousel_3d_min_default = /*#__PURE__*/__webpack_require__.n(vue_carousel_3d_min);

// EXTERNAL MODULE: ./node_modules/vue-slick-carousel/dist/vue-slick-carousel.umd.js
var vue_slick_carousel_umd = __webpack_require__("Xlla");
var vue_slick_carousel_umd_default = /*#__PURE__*/__webpack_require__.n(vue_slick_carousel_umd);

// EXTERNAL MODULE: ./node_modules/vue-slick-carousel/dist/vue-slick-carousel.css
var vue_slick_carousel = __webpack_require__("liEy");
var vue_slick_carousel_default = /*#__PURE__*/__webpack_require__.n(vue_slick_carousel);

// EXTERNAL MODULE: ./node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css
var vue_slick_carousel_theme = __webpack_require__("AlnM");
var vue_slick_carousel_theme_default = /*#__PURE__*/__webpack_require__.n(vue_slick_carousel_theme);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/active.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// optional style for arrows & dots


/* harmony default export */ var active = ({
  name: "active",
  components: {
    agile: components_agile_slider_Agile,
    Carousel3d: vue_carousel_3d_min["Carousel3d"],
    Slide: vue_carousel_3d_min["Slide"],
    VueSlickCarousel: vue_slick_carousel_umd_default.a
  },
  data: function data() {
    return {
      loadingState: "",
      vw: window.innerWidth,
      contests: "",
      key: "",
      piva: "",
      howBack: "white",
      length_: 0,
      view: false,
      cod_client: "",
      active: false,
      //left: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M16.2,21c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L9.6,12L17,4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L6.8,12l8.8,8.7C15.7,20.9,16,21,16.2,21z"/></svg>',
      //right: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M7.8,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.4-7.3L7,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.7l-8.8,8.7C8.3,20.9,8,21,7.8,21z"/></svg>',
      left: __webpack_require__("f/DI"),
      right: __webpack_require__("mNJB")
    };
  },

  methods: {
    mouseOver: function mouseOver(val) {
      this.active = "ACTIVE" + val;
    },
    mouseLeave: function mouseLeave(val) {
      this.active = false;
    },
    getContest: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadingState = true;
                data = {
                  piva: this.profile.piva,
                  cod: this.profile.cod,
                  group: this.profile.groupPh,
                  status: "ACTIVE",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 5;
                return axios_default()({
                  url: "https://pharma.ubiqubit.it/" + "api/getContest",
                  method: "POST",
                  data: {
                    data: data
                  },
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  _this.contests = resp.data;
                  _this.$track("getContest", "SUECCESS");
                  _this.$track("getContest", resp.data);
                  if (resp.data) {
                    _this.length_ = resp.data.length;
                    _this.count = resp.data.length;

                    if (_this.count >= 2 && _this.vw > 990) {
                      _this.length_ = 2;
                    } else {
                      _this.length_ = 1;
                    }
                    if (_this.count == 0) {
                      _this.view = false;
                    } else {
                      _this.view = true;
                    }
                    _this.loadingState = false;
                  } else {
                    _this.loadingState = false;
                  }
                }).catch(function (err) {
                  err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this.$track("getContestActive", "ERROR");
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContest() {
        return _ref.apply(this, arguments);
      }

      return getContest;
    }(),
    goToContest: function goToContest(index) {
      this.$track("goToContest", "promo " + this.contests[index].id);
      this.$track("goToContest", "piva " + this.piva);
      this.$track("goToContest", "codice farmacista " + this.cod_client);
      this.$router.push("/contest/" + this.contests[index].id + "/" + this.piva + "/" + this.cod_client);
    },

    setProfileData: function setProfileData() {
      this.piva = this.profile.piva;
      this.cod_client = this.profile.cod;
    }
  },

  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.getContest();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.getProfile.piva) {
      this.setProfileData();
      this.getContest();
    }

    window.onresize = function () {
      _this2.vw = window.innerWidth;
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04ab7d56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/active.vue
var active_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.view
    ? _c(
        "div",
        { staticClass: "widthFull mt-md-5 mb-md-0", attrs: { id: "active" } },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid blackGradient pt-md-4" }, [
            _c("div", { staticClass: "row back-2 mb-3" }, [
              _c("div", { staticClass: "col-md-8" }, [
                _c(
                  "h1",
                  {
                    staticClass:
                      "uppercase pt-3 pb-2 pt-md-2 pb-md-2 pl-3 mb-3 mt-md-3",
                    class: { h5: _vm.vw < 800 }
                  },
                  [_vm._v("\n          Promozioni attive\n        ")]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.view
              ? _c(
                  "div",
                  { staticClass: "row justify-content-center" },
                  _vm._l(_vm.contests, function(contest, index) {
                    return _c(
                      "router-link",
                      {
                        key: index,
                        staticClass:
                          "\n          col-lg-6 col-md-8 col-10\n          mb-3\n          pl-lg-0\n          pr-lg-0\n          mr-lg-2\n          ml-lg-2\n          box\n        ",
                        class: { "col-lg-7": _vm.vw < 1500 && _vm.vw > 1000 },
                        attrs: {
                          index: index,
                          to: {
                            name: "Contest",
                            params: {
                              id: contest.id,
                              piva: _vm.piva,
                              cod: _vm.cod_client
                            }
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "div first",
                            on: {
                              mouseover: function($event) {
                                return _vm.mouseOver(index)
                              },
                              click: function($event) {
                                return _vm.goToContest(index)
                              }
                            }
                          },
                          [
                            _c(
                              "transition",
                              { attrs: { name: "slide-fade" } },
                              [
                                _vm.active == "ACTIVE" + index
                                  ? _c(
                                      "h4",
                                      {
                                        staticClass: "testo-home center Bold",
                                        style:
                                          "background:rgb(255,255,255);color:" +
                                          contest.config.COLORE_SCURO +
                                          ";background:linear-gradient(328deg, rgba(255,255,255,1) 0%, " +
                                          contest.config.COLORE_CHIARO +
                                          " 15%, " +
                                          contest.config.COLORE_MEDIO_CHIARO +
                                          " 62%, " +
                                          contest.config.COLORE_MEDIO_SCURO +
                                          " 100%, " +
                                          contest.config.COLORE_SCURO +
                                          " 100%);zindex:1000"
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(contest.config.TESTO_HOME) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "img-fluid img",
                              attrs: { src: contest.config.IMMAGINE_HOME }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "row justify-content-center align-self-center pb-5 pt-5 h1 Medium"
                  },
                  [_vm._m(0)]
                )
          ])
        ],
        1
      )
    : _vm._e()
}
var active_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-10" }, [
      _c("h5", { staticClass: "displ uppercase" }, [
        _vm._v(
          "\n          Non sono presenti promozioni attive a cui puoi aderire\n        "
        )
      ])
    ])
  }
]
active_render._withStripped = true
var active_esExports = { render: active_render, staticRenderFns: active_staticRenderFns }
/* harmony default export */ var home_active = (active_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04ab7d56", active_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/home/active.vue
var active_disposed = false
var active_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var active___vue_template_functional__ = false
/* styles */
var active___vue_styles__ = null
/* scopeId */
var active___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var active___vue_module_identifier__ = null
var active_Component = active_normalizeComponent(
  active,
  home_active,
  active___vue_template_functional__,
  active___vue_styles__,
  active___vue_scopeId__,
  active___vue_module_identifier__
)
active_Component.options.__file = "src/components/home/active.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04ab7d56", active_Component.options)
  } else {
    hotAPI.reload("data-v-04ab7d56", active_Component.options)
  }
  module.hot.dispose(function (data) {
    active_disposed = true
  })
})()}

/* harmony default export */ var components_home_active = (active_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/notActive.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// optional style for arrows & dots


/* harmony default export */ var notActive = ({
  name: "active",
  components: {
    agile: components_agile_slider_Agile,
    Carousel3d: vue_carousel_3d_min["Carousel3d"],
    Slide: vue_carousel_3d_min["Slide"],
    VueSlickCarousel: vue_slick_carousel_umd_default.a
  },
  data: function data() {
    return {
      loadingState: "",
      vw: window.innerWidth,
      contests: "",
      key: "",
      piva: "",
      howBack: "white",
      length_: 0,
      view: false,
      active: false,
      cod_client: "",
      //left: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M16.2,21c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L9.6,12L17,4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L6.8,12l8.8,8.7C15.7,20.9,16,21,16.2,21z"/></svg>',
      //right: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M7.8,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.4-7.3L7,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.7l-8.8,8.7C8.3,20.9,8,21,7.8,21z"/></svg>',
      left: __webpack_require__("f/DI"),
      right: __webpack_require__("mNJB")
    };
  },

  methods: {
    mouseOver: function mouseOver(val) {

      this.active = "ACTIVE" + val;
    },
    mouseLeave: function mouseLeave(val) {

      this.active = false;
    },
    getContest: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadingState = true;
                data = {
                  piva: this.profile.piva,
                  cod: this.profile.cod,
                  group: this.profile.groupPh,
                  status: "ENDED",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 5;
                return axios_default()({
                  url: "https://pharma.ubiqubit.it/" + "api/getContest",
                  method: "POST",
                  data: {
                    data: data
                  },
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  _this.contests = resp.data;
                  _this.$track("getContest", "SUECCESS");
                  _this.$track("getContest", resp.data);
                  if (resp.data) {
                    _this.length_ = resp.data.length;
                    _this.count = resp.data.length;

                    if (_this.count >= 2 && _this.vw > 990) {
                      _this.length_ = 2;
                    } else {
                      _this.length_ = 1;
                    }
                    if (_this.count == 0) {
                      _this.view = false;
                    } else {
                      _this.view = true;
                    }
                    _this.loadingState = false;
                  } else {
                    _this.loadingState = false;
                  }
                }).catch(function (err) {
                  err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this.$track("getContestActive", "ERROR");
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContest() {
        return _ref.apply(this, arguments);
      }

      return getContest;
    }(),
    goToContest: function goToContest(index) {
      this.$track("goToContest", "promo " + this.contests[index].id);
      this.$track("goToContest", "piva " + this.piva);
      this.$track("goToContest", "codice farmacista " + this.cod_client);
      this.$router.push("/contest/" + this.contests[index].id + "/" + this.piva + "/" + this.cod_client);
    },

    setProfileData: function setProfileData() {
      this.piva = this.profile.piva;
      this.cod_client = this.profile.cod;
    }
  },

  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.getContest();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.getProfile.piva) {
      this.setProfileData();
      this.getContest();
    }

    window.onresize = function () {
      _this2.vw = window.innerWidth;
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03244019","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/notActive.vue
var notActive_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.view
    ? _c(
        "div",
        { staticClass: "widthFull mt-5 mb-md-0", attrs: { id: "not_active" } },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-fluid blackGradient pt-md-4 pb-5" },
            [
              _c("div", { staticClass: "row back-color-3 mb-3" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "h1",
                    {
                      staticClass:
                        "uppercase pt-3 pb-2 pt-md-2 pb-md-2  pl-3 mb-3 mt-md-3 white ",
                      class: { h5: _vm.vw < 800 }
                    },
                    [_vm._v("\n          Promozioni terminate\n        ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.view
                ? _c(
                    "div",
                    { staticClass: "row justify-content-center pb-5" },
                    _vm._l(_vm.contests, function(contest, index) {
                      return _c(
                        "router-link",
                        {
                          key: index,
                          staticClass:
                            "\n          col-lg-6 col-md-8 col-10\n          mb-3\n          pl-lg-0\n          pr-lg-0\n          mr-lg-2\n          ml-lg-2\n          box\n        ",
                          class: { "col-lg-7": _vm.vw < 1500 && _vm.vw > 1000 },
                          attrs: {
                            index: index,
                            to: {
                              name: "Contest",
                              params: {
                                id: contest.id,
                                piva: _vm.piva,
                                cod: _vm.cod_client
                              }
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                mouseover: function($event) {
                                  return _vm.mouseOver(index)
                                },
                                click: function($event) {
                                  return _vm.goToContest(index)
                                }
                              }
                            },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "slide-fade" } },
                                [
                                  _vm.active == "ACTIVE" + index
                                    ? _c(
                                        "h4",
                                        {
                                          staticClass: "testo-home center Bold",
                                          style:
                                            "background:rgb(255,255,255);color:" +
                                            contest.config.COLORE_SCURO +
                                            ";background:linear-gradient(328deg, rgba(255,255,255,1) 0%, " +
                                            contest.config.COLORE_CHIARO +
                                            " 15%, " +
                                            contest.config.COLORE_MEDIO_CHIARO +
                                            " 62%, " +
                                            contest.config.COLORE_MEDIO_SCURO +
                                            " 100%, " +
                                            contest.config.COLORE_SCURO +
                                            " 100%);zindex:1000"
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                contest.config.TESTO_HOME
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img-fluid img",
                                attrs: {
                                  src: contest.config.IMMAGINE_HOME_TERMINATA
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-center align-self-center pb-5 pt-5 h1 Medium"
                    },
                    [_vm._m(0)]
                  )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var notActive_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-10" }, [
      _c("h5", { staticClass: "displ uppercase" }, [
        _vm._v("\n          Non sono presenti promozioni terminate\n        ")
      ])
    ])
  }
]
notActive_render._withStripped = true
var notActive_esExports = { render: notActive_render, staticRenderFns: notActive_staticRenderFns }
/* harmony default export */ var home_notActive = (notActive_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03244019", notActive_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/home/notActive.vue
var notActive_disposed = false
var notActive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var notActive___vue_template_functional__ = false
/* styles */
var notActive___vue_styles__ = null
/* scopeId */
var notActive___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var notActive___vue_module_identifier__ = null
var notActive_Component = notActive_normalizeComponent(
  notActive,
  home_notActive,
  notActive___vue_template_functional__,
  notActive___vue_styles__,
  notActive___vue_scopeId__,
  notActive___vue_module_identifier__
)
notActive_Component.options.__file = "src/components/home/notActive.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03244019", notActive_Component.options)
  } else {
    hotAPI.reload("data-v-03244019", notActive_Component.options)
  }
  module.hot.dispose(function (data) {
    notActive_disposed = true
  })
})()}

/* harmony default export */ var components_home_notActive = (notActive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/comingSoon.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// optional style for arrows & dots

var comingSoon_moment = __webpack_require__("PJh5");
/* harmony default export */ var comingSoon = ({
  name: "active",
  components: {
    agile: components_agile_slider_Agile,
    Carousel3d: vue_carousel_3d_min["Carousel3d"],
    Slide: vue_carousel_3d_min["Slide"],
    VueSlickCarousel: vue_slick_carousel_umd_default.a
  },
  data: function data() {
    return {
      loadingState: "",
      moment: comingSoon_moment,
      now: comingSoon_moment(),
      start_intermedio: "2021-09-01 00:00:00",
      vw: window.innerWidth,
      contests: "",
      key: "",
      piva: "",
      howBack: "white",
      length_: 0,
      view: false,
      cod_client: "",
      active: '',
      //left: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M16.2,21c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L9.6,12L17,4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L6.8,12l8.8,8.7C15.7,20.9,16,21,16.2,21z"/></svg>',
      //right: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M7.8,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.4-7.3L7,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.7l-8.8,8.7C8.3,20.9,8,21,7.8,21z"/></svg>',
      left: __webpack_require__("f/DI"),
      right: __webpack_require__("mNJB")
    };
  },

  methods: {
    mouseOver: function mouseOver(val) {
      this.active = "ACTIVE" + val;
    },
    mouseLeave: function mouseLeave(val) {

      this.active = false;
    },
    getContest: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadingState = true;
                data = {
                  piva: this.profile.piva,
                  cod: this.profile.cod,
                  group: this.profile.groupPh,
                  status: "COMING",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 5;
                return axios_default()({
                  url: "https://pharma.ubiqubit.it/" + "api/getContest",
                  method: "POST",
                  data: {
                    data: data
                  },
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  _this.contests = resp.data;
                  _this.$track("getContest", "SUECCESS");
                  _this.$track("getContest", resp.data);
                  if (resp.data) {
                    _this.length_ = resp.data.length;
                    _this.count = resp.data.length;

                    if (_this.count >= 2 && _this.vw > 990) {
                      _this.length_ = 2;
                    } else {
                      _this.length_ = 1;
                    }
                    if (_this.count == 0) {
                      _this.view = false;
                    } else {
                      _this.view = true;
                    }
                    _this.loadingState = false;
                  } else {
                    _this.loadingState = false;
                  }
                }).catch(function (err) {
                  err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this.$track("getContestActive", "ERROR");
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContest() {
        return _ref.apply(this, arguments);
      }

      return getContest;
    }(),
    goToContest: function goToContest(index) {},

    setProfileData: function setProfileData() {
      this.piva = this.profile.piva;
      this.cod_client = this.profile.cod;
    }
  },

  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.getContest();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.getProfile.piva) {
      this.setProfileData();
      this.getContest();
    }

    window.onresize = function () {
      _this2.vw = window.innerWidth;
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673ae2ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/comingSoon.vue
var comingSoon_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.view
    ? _c(
        "div",
        { staticClass: "widthFull mb-md-0", attrs: { id: "coming_soon" } },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-fluid blackGradient pt-md-4 pb-5" },
            [
              _c("div", { staticClass: "row back-color-1 mb-3v " }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "h1",
                    {
                      staticClass:
                        "uppercase pt-3 pb-2 pt-md-2 pb-md-2  pl-3 mb-3 mt-md-3 white ",
                      class: { h5: _vm.vw < 800 }
                    },
                    [_vm._v("\n            Promozioni in arrivo\n          ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.view
                ? _c(
                    "div",
                    { staticClass: "row justify-content-center pb-5" },
                    _vm._l(_vm.contests, function(contest, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass:
                            "\n            col-lg-6 col-md-8 col-12\n            mb-3\n            pl-lg-0\n            pr-lg-0\n            mr-lg-2\n            ml-lg-2\n            mt-5\n          ",
                          class: {
                            "col-lg-7": _vm.vw < 1500 && _vm.vw > 1000,
                            box: _vm.vw > 1022
                          },
                          attrs: { index: index }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "div first",
                              on: {
                                mouseover: function($event) {
                                  return _vm.mouseOver(index)
                                }
                              }
                            },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "slide-fade" } },
                                [
                                  _vm.active == "ACTIVE" + index
                                    ? _c(
                                        "h4",
                                        {
                                          staticClass: "testo-home center Bold",
                                          style:
                                            "background:rgb(255,255,255);color:" +
                                            contest.config.COLORE_SCURO +
                                            ";background:linear-gradient(328deg, rgba(255,255,255,1) 0%, " +
                                            contest.config.COLORE_CHIARO +
                                            " 15%, " +
                                            contest.config.COLORE_MEDIO_CHIARO +
                                            " 62%, " +
                                            contest.config.COLORE_MEDIO_SCURO +
                                            " 100%, " +
                                            contest.config.COLORE_SCURO +
                                            " 100%);zindex:1000"
                                        },
                                        [
                                          _vm._v(
                                            "\n               La sezione sará attiva dal " +
                                              _vm._s(
                                                _vm
                                                  .moment(contest.start)
                                                  .format("DD-MM-YYYY")
                                              ) +
                                              " al " +
                                              _vm._s(
                                                _vm
                                                  .moment(contest.end)
                                                  .format("DD-MM-YYYY")
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm.vw < 1022
                                ? _c(
                                    "h5",
                                    { staticClass: "center Bold theme" },
                                    [
                                      _vm._v(
                                        "\n               La sezione sará attiva dal "
                                      ),
                                      _vm.vw > 500 ? _c("br") : _vm._e(),
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .moment(contest.start)
                                            .format("DD-MM-YYYY")
                                        ) +
                                          " al " +
                                          _vm._s(
                                            _vm
                                              .moment(contest.end)
                                              .format("DD-MM-YYYY")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img-fluid img",
                                attrs: {
                                  src: contest.config.IMMAGINE_HOME_IN_ARRIVO
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-center align-self-center pb-5 pt-5 h1 Medium"
                    },
                    [_vm._m(0)]
                  )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var comingSoon_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-10" }, [
      _c("h5", { staticClass: "displ uppercase" }, [
        _vm._v(
          "\n            Non sono presenti promozioni terminate\n          "
        )
      ])
    ])
  }
]
comingSoon_render._withStripped = true
var comingSoon_esExports = { render: comingSoon_render, staticRenderFns: comingSoon_staticRenderFns }
/* harmony default export */ var home_comingSoon = (comingSoon_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-673ae2ec", comingSoon_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/home/comingSoon.vue
var comingSoon_disposed = false
var comingSoon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var comingSoon___vue_template_functional__ = false
/* styles */
var comingSoon___vue_styles__ = null
/* scopeId */
var comingSoon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var comingSoon___vue_module_identifier__ = null
var comingSoon_Component = comingSoon_normalizeComponent(
  comingSoon,
  home_comingSoon,
  comingSoon___vue_template_functional__,
  comingSoon___vue_styles__,
  comingSoon___vue_scopeId__,
  comingSoon___vue_module_identifier__
)
comingSoon_Component.options.__file = "src/components/home/comingSoon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-673ae2ec", comingSoon_Component.options)
  } else {
    hotAPI.reload("data-v-673ae2ec", comingSoon_Component.options)
  }
  module.hot.dispose(function (data) {
    comingSoon_disposed = true
  })
})()}

/* harmony default export */ var components_home_comingSoon = (comingSoon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var home_moment = __webpack_require__("PJh5");
/* harmony default export */ var home = ({
  name: "home",
  components: {
    Login: src_components_login,
    Active: components_home_active,
    NotActive: components_home_notActive,
    ComingSoon: components_home_comingSoon
  },
  data: function data() {
    return {
      loadingState: false,
      moment: __webpack_require__("PJh5"),
      scroll: window.pageYOffset,
      now: home_moment(),
      start_intermedio: "2021-09-01 00:00:00",
      vw: window.innerWidth,
      vh: window.innerHeight
    };
  },

  methods: {
    visibilityActive: function visibilityActive(isVisible, entry) {
      if (isVisible) {
        this.$router.push({ hash: "#active" }).catch(function (err) {});
      }
    },
    visibilityNotActive: function visibilityNotActive(isVisible, entry) {
      if (isVisible) {
        this.$router.push({ hash: "#notActive" }).catch(function (err) {});
      }
    }
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["isAuthenticated", "authStatus", "getPromotions"]), {
    loading: function loading() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    /*var hash = this.$route.hash
    if ( hash && hash != '#home' ){
    this.$scrollTo(hash, 0, {offset: -125})
    }*/
    var _vue = this;
    var hash = _vue.$route.hash;
    if (hash) {
      setTimeout(function () {
        _vue.$scrollTo(hash, 700, { offset: -120 });
      }, 100);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f3a69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
var home_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull back-1 h-100", attrs: { id: "home" } },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid heroHome relative",
          attrs: { id: "top" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-3" }, [
              _vm.vw > 991
                ? _c("img", {
                    ref: "mainNavLogo",
                    staticClass: "img-fluid logoMob animatedLogo ml-4",
                    attrs: { src: __webpack_require__("iQH9") }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row justify-content-center mt-lg-5 pt-lg-5" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-4 mb-5 pb-4 pt-lg-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "Title h0 uppercase headerTitle mt-lg-5 pt-lg-5"
                  },
                  [
                    _c(
                      "h3",
                      {
                        staticClass: "black uppercase Medium pt-lg-4 pb-4",
                        class: { h5: _vm.vw < 600 }
                      },
                      [
                        _vm._v(
                          "\n            SCOPRI TUTTE LE ATTIVITÀ DI\n            "
                        ),
                        _c("b", { staticClass: "Bold" }, [
                          _vm._v("LABORATOIRE NATIVE")
                        ]),
                        _vm._v(
                          " RISERVATE ALLE FARMACIE E\n            AI PUNTI VENDITA ADERENTI\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#active", offset: -85 },
                                expression: "{ el: '#active', offset: -85 }"
                              }
                            ],
                            staticClass: "btn Bold btn-primary"
                          },
                          [_vm._v("Scopri di piú")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") <=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#coming_soon", offset: -85 },
                                expression:
                                  "{ el: '#coming_soon', offset: -85 }"
                              }
                            ],
                            staticClass: "btn Bold btn-primary"
                          },
                          [_vm._v("Scopri di piú")]
                        )
                      : !_vm.isAuthenticated
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn btn-primary Bold",
                            attrs: { to: "/login", href: "#active" }
                          },
                          [_vm._v("Effettua il login")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("Active", {
            staticClass: "zIndex2 relative",
            attrs: { id: "active" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("ComingSoon", {
            staticClass: "zIndex2 relative mb-5",
            attrs: { id: "coming_soon" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("NotActive", {
            staticClass: "zIndex2 relative mb-5",
            attrs: { id: "notActive" }
          })
        : _vm._e()
    ],
    1
  )
}
var home_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-lg-6 mt-5 mt-lg-0 pt-5 pt-lg-0 center " },
      [
        _c("img", {
          staticClass: "img-fluid img mt-4",
          attrs: { src: __webpack_require__("KSZv") }
        })
      ]
    )
  }
]
home_render._withStripped = true
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var components_home = (home_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f3a69c", home_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/home/index.vue
var home_disposed = false
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = null
/* scopeId */
var home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  home,
  components_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)
home_Component.options.__file = "src/components/home/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-67f3a69c", home_Component.options)
  } else {
    hotAPI.reload("data-v-67f3a69c", home_Component.options)
  }
  module.hot.dispose(function (data) {
    home_disposed = true
  })
})()}

/* harmony default export */ var src_components_home = (home_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var account = ({
  name: "account",
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      email: "",
      name: "",
      accHolder: "",
      address: "",
      phone: "",
      password: "",
      confirm_password: "",
      privacy: "",
      cod: "",
      isRequired: false,
      iban: "",
      role: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      tempMail: "",
      existEmail: false,
      existEmailSocial: false,
      addressData: false,
      loadingState: false,
      editStatus: false,
      group: false,
      userToken: "",
      company: "",
      myzip: "",
      provincies: [],
      provinciesState: true,
      cities: [],
      citiesState: false,
      mycity: "",
      zips: []
    }, defineProperty_default()(_ref, "zipsState", false), defineProperty_default()(_ref, "zipError", false), defineProperty_default()(_ref, "province", ""), defineProperty_default()(_ref, "shipData", {}), defineProperty_default()(_ref, "city", ""), defineProperty_default()(_ref, "piva", ""), defineProperty_default()(_ref, "zip", ""), _ref;
  },

  methods: {
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    populateProvincies: function populateProvincies() {
      var _this = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://pharma.ubiqubit.it/" + "api/getProvincies",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this.provincies = resp.data.provincies;
        _this.provinciesState = false;
        _this.province = _this.profile.province;
      }).catch(function (resp) {
        _this.provincies = [];
        _this.provinciesState = false;
      });
    },
    provOk: function provOk(event) {
      this.mycity = "";
      this.myzip = "";
      this.isRequired = true;
    },
    editUser: function editUser(e) {
      var _this2 = this;

      this.$validator.validate().then(function (valid) {
        if (valid && _this2.userToken) {
          _this2.loadingState = true;
          if (!_this2.city) {
            _this2.city = _this2.mycity;
          }
          if (!_this2.zip) {
            _this2.zip = _this2.myzip;
          }
          var data = {
            phone: _this2.phone ? _this2.phone : "",
            accHolder: _this2.accHolder,
            iban: _this2.iban,
            email: _this2.email,
            userToken: _this2.userToken,
            company: _this2.company,
            password: _this2.confirm_password,
            token: _this2.confirm_password,
            address: _this2.address,
            zip: _this2.zip,
            location: _this2.city.city,
            province: _this2.province,
            id_platform: "DcJ7J1WfiwucqBl_lierac",
            unique_key_db: "d971ad4ed27c5e76c0ccf95a",
            vector_unique_key_db: "lierac_global",
            table: "utenti"
          };
          data = _this2.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://pharma.ubiqubit.it/" + "api/editUser",
            data: {
              data: data
            },
            method: "POST",
            headers: {
              Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this2.loadingState = false;
            resp.data = _this2.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
            _this2.$track("editUser", "SUECCESS");
            if (resp.data) {
              if (resp.data == "not_modify") {
                _this2.showAlertInfo("Non hai modificato alcun dato");
              } else {
                _this2.$store.dispatch(USER_REQUEST, _this2.userToken).then(function () {});
                _this2.showAlertSuccess("I tuoi dati sono stati correttamente aggiornati");
              }
            } else {
              _this2.showAlertError(err.response.data.message);
            }
          }).catch(function (err) {
            _this2.loadingState = false;
            err.response.data = _this2.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
            _this2.$track("editUser", "ERROR");
            _this2.showAlertError(err.response.data.message);
          });
        }
      });
    },
    showAlertError: function showAlertError(value) {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: value + " !",
        onClose: function onClose() {}
      });
    },
    showAlertSuccess: function showAlertSuccess(value) {
      var _this3 = this;

      // Use sweetalret2
      this.$swal({
        type: "success",
        title: value,
        showCancelButton: false,
        animation: false,
        onClose: function onClose() {
          _this3.$router.push("/");
        }
      });
    },
    showAlertInfo: function showAlertInfo(value) {
      var _this4 = this;

      // Use sweetalret2
      this.$swal({
        type: "info",
        title: value,
        showCancelButton: false,
        animation: false,
        onClose: function onClose() {
          _this4.$router.push("/");
        }
      });
    },


    setProfileData: function setProfileData() {
      if (this.profile.groupPh) {
        this.group = true;
      }
      this.email = this.profile.email;
      this.zip = this.profile.zip;
      this.accHolder = this.profile.accHolder;
      this.userToken = this.profile.userToken;
      this.piva = this.profile.piva;
      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.province = this.profile.province;
      this.mycity = this.profile.location;
      this.myzip = this.profile.zip;
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    province: function province(newProvince) {
      var _this5 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://pharma.ubiqubit.it/" + "api/getComuni",
          method: "POST",
          data: {
            sigla: newProvince
          },
          headers: {
            Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this5.cities = resp.data.cities;

          _this5.citiesState = false;
        }).catch(function (resp) {
          _this5.cities = [];
          _this5.citiesState = false;
        });
      }
    },
    city: function city(newCity) {
      var _this6 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";
      this.isRequired = true;
      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://pharma.ubiqubit.it/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this6.zips = resp.data.cap;
          _this6.zipsState = false;
        }).catch(function (resp) {
          _this6.zips = [];
          _this6.zipsState = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.setProfileData();
    this.populateProvincies();
  },
  created: function created() {
    this.$validator.extend("notZeros", {
      getMessage: function getMessage(field) {
        return " Il campo Numero di cellulare non ha un formato valido.";
      },
      validate: function validate(value) {
        // value must be > zero
        if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
        return false;
      }
    });
  },


  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcfb22e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/index.vue
var account_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull mainBackground h-100 back-1" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container dataContainer" }, [
        _c(
          "form",
          {
            staticClass: "pb-5",
            attrs: { id: "editUser" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.editUser.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center mt-5 pb-5" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { key: 0, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.company,
                        expression: "company"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 128, min: 2 },
                        expression: "{ required: true, max: 128, min: 2 }"
                      }
                    ],
                    staticClass: "form-control dis",
                    class: {
                      "is-invalid": _vm.errors.has("company"),
                      valid: !!_vm.company
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "company",
                      name: "company",
                      "data-vv-as": "Ragione sociale"
                    },
                    domProps: { value: _vm.company },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.company = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "company" }
                    },
                    [_vm._v("Ragione sociale\n            ")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("company")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("company")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 1, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.piva,
                        expression: "piva"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 11, min: 11 },
                        expression: "{ required: true, max: 11, min: 11 }"
                      }
                    ],
                    staticClass: "dis form-control",
                    class: {
                      "is-invalid": _vm.errors.has("piva"),
                      valid: !!_vm.piva
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "piva",
                      name: "piva",
                      "data-vv-as": "Partita IVA"
                    },
                    domProps: { value: _vm.piva },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.piva = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "piva" } },
                    [_vm._v("Partita IVA ")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("piva")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("piva")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { key: 2, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cod,
                        expression: "cod"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 11, min: 5 },
                        expression: "{ required: true, max: 11, min: 5 }"
                      }
                    ],
                    staticClass: "form-control dis",
                    class: {
                      "is-invalid": _vm.errors.has("cod"),
                      valid: !!_vm.cod
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "cod",
                      name: "cod",
                      "data-vv-as": "Codice Utente"
                    },
                    domProps: { value: _vm.cod },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.cod = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "piva" } },
                    [_vm._v("Codice utente ")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("cod")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("cod")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 3, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          email: true,
                          temporaryEmail: true,
                          plusIssueEmail: true,
                          max: 56
                        },
                        expression:
                          "{\n                required: true,\n                email: true,\n                temporaryEmail: true,\n                plusIssueEmail: true,\n                max: 56,\n              }"
                      }
                    ],
                    ref: "email",
                    staticClass: "form-control dis",
                    class: {
                      "is-invalid": _vm.errors.has("email") || _vm.existEmail,
                      valid: !!_vm.email
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "email",
                      name: "email",
                      "data-vv-as": "Email"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "email" } },
                    [_vm._v("Email ")]
                  ),
                  _vm._v(" "),
                  _vm.existEmail
                    ? _c(
                        "div",
                        {
                          staticClass: "invalid-feedback",
                          staticStyle: { display: "block" }
                        },
                        [
                          _vm.existEmailSocial
                            ? _c("span", [
                                _vm._v(
                                  "Email digitato già presente. Sei registrato con:\n                "
                                ),
                                _c(
                                  "strong",
                                  { staticClass: "text-capitalize" },
                                  [_vm._v(_vm._s(_vm.existEmailSocial))]
                                )
                              ])
                            : _c("span", [
                                _vm._v("Email digitato già presente")
                              ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("email")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("email")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.province,
                          expression: "province"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {},
                          expression: "{}"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.errors.has("province"),
                        valid: !!_vm.province
                      },
                      attrs: {
                        autocomplete: "randomy",
                        id: "province",
                        name: "province",
                        "data-vv-as": "Provincia"
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.province = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.provOk($event)
                          }
                        ]
                      }
                    },
                    [
                      !_vm.shipData.province
                        ? _c("option", {
                            attrs: {
                              disabled: "",
                              value: "",
                              selected: "selected"
                            }
                          })
                        : _c(
                            "option",
                            {
                              attrs: { selected: "selected" },
                              domProps: { value: _vm.shipData.province }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.shipData.province) +
                                  "\n              "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _vm._l(_vm.provincies, function(province) {
                        return _c(
                          "option",
                          {
                            key: province.sigla,
                            domProps: {
                              value: province.sigla,
                              selected: province.sigla == _vm.shipData.province
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(province.sigla) +
                                " - " +
                                _vm._s(province.provincia) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "province" }
                    },
                    [_vm._v("Provincia ")]
                  ),
                  _vm._v(" "),
                  _vm.provinciesState
                    ? _c(
                        "div",
                        [
                          _c("font-awesome-icon", {
                            staticClass: "loadSpinner",
                            attrs: {
                              id: "loadProvince",
                              icon: "spinner",
                              size: "1x",
                              pulse: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("province")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("province")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "group" }, [
                  !_vm.zip && !_vm.city
                    ? _c("div", { staticClass: "fix-2" }, [
                        _vm._v(_vm._s(_vm.myzip))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.zip,
                          expression: "zip"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {},
                          expression: "{}"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.errors.has("zip"),
                        valid: !!_vm.zip
                      },
                      attrs: {
                        autocomplete: "randomi",
                        id: "zip",
                        name: "zip",
                        "data-vv-as": "Cap",
                        disabled: _vm.zipsState
                      },
                      on: {
                        click: _vm.checkZip,
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.zip = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      !_vm.shipData.zip
                        ? _c("option", {
                            attrs: { value: "", disabled: "" },
                            domProps: { selected: true }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.zips, function(zip) {
                        return _c(
                          "option",
                          {
                            key: zip.cap,
                            domProps: {
                              value: zip.cap,
                              selected: zip.cap == _vm.shipData.zip
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(zip.cap) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "zip" } },
                    [
                      _vm._v("Codice postale\n              "),
                      _vm.zipError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli il comune")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.zipsState
                    ? _c(
                        "div",
                        [
                          _c("font-awesome-icon", {
                            staticClass: "loadSpinner",
                            attrs: {
                              id: "loadZips",
                              icon: "spinner",
                              size: "1x",
                              pulse: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("zip")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("zip")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "group" }, [
                  !_vm.city
                    ? _c("div", { staticClass: "fix-2" }, [
                        _vm._v(_vm._s(_vm.mycity))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.city,
                          expression: "city"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {},
                          expression: "{}"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.errors.has("city"),
                        valid: !!_vm.city
                      },
                      attrs: {
                        autocomplete: "randomu",
                        id: "city",
                        name: "city",
                        "data-vv-as": "Comune",
                        disabled: _vm.citiesState
                      },
                      on: {
                        click: _vm.checkProvince,
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.city = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      !_vm.shipData.city
                        ? _c("option", {
                            attrs: {
                              disabled: "",
                              value: "mycity",
                              selected: "selected"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: { else: "", selected: "selected" },
                          domProps: { value: { city: _vm.shipData.city } }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.shipData.city) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.cities, function(city) {
                        return _c(
                          "option",
                          {
                            key: city.comune,
                            domProps: {
                              value: {
                                cityistat: city.istat,
                                city: city.comune
                              },
                              selected: city.comune == _vm.shipData.city
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(city.comune) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "city" } },
                    [
                      _vm._v("Comune\n              "),
                      _vm.cityError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli la provincia")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.citiesState
                    ? _c(
                        "div",
                        [
                          _c("font-awesome-icon", {
                            staticClass: "loadSpinner",
                            attrs: {
                              id: "loadCity",
                              icon: "spinner",
                              size: "1x",
                              pulse: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("city")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("city")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 4, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.address,
                        expression: "address"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { min: 5 },
                        expression: "{ min: 5 }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("address"),
                      valid: !!_vm.address
                    },
                    attrs: {
                      type: "text",
                      id: "address",
                      name: "address",
                      "data-vv-as": "Indirizzo"
                    },
                    domProps: { value: _vm.address },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.address = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "address" }
                    },
                    [_vm._v("Indirizzo")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("address")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("address")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { key: 10, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { passwordCheck: true, min: 8, max: 56 },
                        expression: "{ passwordCheck: true, min: 8, max: 56 }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("password"),
                      valid: !!_vm.password
                    },
                    attrs: {
                      type: "password",
                      autocomplete: "on",
                      id: "password",
                      name: "password"
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel label",
                      attrs: { for: "password" }
                    },
                    [_vm._v("Nuova Password")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("password")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("password")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 11, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirm_password,
                        expression: "confirm_password"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: !!_vm.password,
                          confirmed: _vm.password,
                          passwordCheck: true,
                          min: 8,
                          max: 56
                        },
                        expression:
                          "{\n                required: !!password,\n                confirmed: password,\n                passwordCheck: true,\n                min: 8,\n                max: 56,\n              }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("confirm_password"),
                      valid: !!_vm.confirm_password
                    },
                    attrs: {
                      type: "password",
                      autocomplete: "on",
                      id: "confirm_password",
                      name: "confirm_password",
                      "data-vv-as": "conferma password"
                    },
                    domProps: { value: _vm.confirm_password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.confirm_password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel label",
                      attrs: { for: "password" }
                    },
                    [_vm._v("Conferma Nuova Password")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("confirm_password")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("confirm_password")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _vm.phone
                  ? _c("div", { key: 8, staticClass: "group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phone,
                            expression: "phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              max: 11,
                              min: 8,
                              notZeros: true,
                              regex: /^[3]+/
                            },
                            expression:
                              "{\n                max: 11,\n                min: 8,\n                notZeros: true,\n                regex: /^[3]+/,\n              }"
                          }
                        ],
                        staticClass: "form-control dis",
                        class: {
                          "is-invalid": _vm.errors.has("phone"),
                          valid: !!_vm.phone,
                          dis: _vm.phone
                        },
                        attrs: {
                          type: "text",
                          placeholder:
                            "Inserisci il tuo numero di telefono nella pagina di caricamento",
                          disabled: "",
                          id: "phone",
                          name: "phone",
                          "data-vv-as": "Telefono"
                        },
                        domProps: { value: _vm.phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.phone = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "phone" }
                        },
                        [_vm._v("Telefono ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("phone")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("phone")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-10 mb-5 mb-md-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group back-white",
                    staticStyle: { "border-radius": "10px" }
                  },
                  [
                    _c("div", { staticClass: "form-check pl-0" }, [
                      _c("div", { staticClass: "group" }, [
                        _vm.privacy == 1
                          ? _c(
                              "div",
                              {
                                staticClass: "form-check form-check-inline mt-2"
                              },
                              [
                                _c("label", { staticClass: "Bold black" }, [
                                  _vm._v(
                                    "\n                    Informativa accettata\n                    "
                                  ),
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "24",
                                        height: "24",
                                        fill: "#173f53"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M17.818 5.693a.35.35 0 0 1 .27-.11.47.47 0 0 1 .305.11l.946 1.057c.09.073.135.17.135.292a.47.47 0 0 1-.135.328L9.203 18.307a.35.35 0 0 1-.27.11.47.47 0 0 1-.304-.11l-4.494-4.885A.356.356 0 0 1 4 13.13a.47.47 0 0 1 .135-.328l.946-1.02a.407.407 0 0 1 .304-.147c.113 0 .203.049.27.146l3.278 3.537 8.885-9.625z"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("privacy"),
                                expression: "errors.has('privacy')"
                              }
                            ],
                            staticClass: "errorMes"
                          },
                          [
                            _vm._v(
                              "\n                  Il consenso deve essere accettato oppure rifiutato\n                "
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(1)
                  ]
                ),
                _vm._v(" "),
                _vm._m(2)
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var account_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c(
        "h1",
        { staticClass: "h1 darkBlue center mb-5 pt-5 mt-5 uppercase Bold" },
        [_c("b", [_vm._v("Il tuo profilo")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-check pl-0" }, [
      _c("div", { staticClass: "group" }, [
        _c("label", { staticClass: "form-check-label mb-3 Medium" }, [
          _vm._v(
            "\n                  Puoi consultare la normativa sulla privacy cliccando qui:\n                  "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.lierac.it/privacy-cookie-policy.html",
                target: "_blank"
              }
            },
            [_vm._v("\n                    Privacy Policy ")]
          ),
          _vm._v(".\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center mt-5 mt-md-3 mb-md-0 mb-5 pb-5" }, [
      _c(
        "button",
        { staticClass: "btn btn-primary mr-md-5", attrs: { tag: "button" } },
        [_vm._v("\n              CONFERMA MODIFICHE\n            ")]
      )
    ])
  }
]
account_render._withStripped = true
var account_esExports = { render: account_render, staticRenderFns: account_staticRenderFns }
/* harmony default export */ var components_account = (account_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcfb22e0", account_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/account/index.vue
var account_disposed = false
var account_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var account___vue_template_functional__ = false
/* styles */
var account___vue_styles__ = null
/* scopeId */
var account___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var account___vue_module_identifier__ = null
var account_Component = account_normalizeComponent(
  account,
  components_account,
  account___vue_template_functional__,
  account___vue_styles__,
  account___vue_scopeId__,
  account___vue_module_identifier__
)
account_Component.options.__file = "src/components/account/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bcfb22e0", account_Component.options)
  } else {
    hotAPI.reload("data-v-bcfb22e0", account_Component.options)
  }
  module.hot.dispose(function (data) {
    account_disposed = true
  })
})()}

/* harmony default export */ var src_components_account = (account_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_confirm = ({
  name: "confirm",
  data: function data() {
    return {
      result: "Verifica Token",
      status: false,
      loading: false
    };
  },

  methods: {
    checkConsent: function checkConsent() {
      axios_default()({
        url: "https://pharma.ubiqubit.it/" + "fapi/checkConsent",
        method: "POST",
        data: {
          tk: this.profile
        },
        headers: {
          Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
          "Content-type": "application/json"
        }
      }).then(function (resp) {}).catch(function (error) {});
    }
  },
  beforeMount: function beforeMount() {
    this.confirm();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0a1213a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirm/index.vue
var confirm_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container verticalCentred" },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.consent
        ? _c("div", [
            _c("div", { staticClass: "form-row justify-content-center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 mb-3 center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.checkConsent()
                      }
                    }
                  },
                  [_vm._v("\n          accetta\n        ")]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var confirm_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v(
            "Per poter proseguire é necessario prendere visione\n            dell'informativa"
          )
        ])
      ])
    ])
  }
]
confirm_render._withStripped = true
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_confirm = (confirm_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0a1213a", confirm_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/confirm/index.vue
var confirm_disposed = false
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = null
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  components_confirm,
  selectortype_template_index_0_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)
confirm_Component.options.__file = "src/components/confirm/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0a1213a", confirm_Component.options)
  } else {
    hotAPI.reload("data-v-c0a1213a", confirm_Component.options)
  }
  module.hot.dispose(function (data) {
    confirm_disposed = true
  })
})()}

/* harmony default export */ var src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forgotpassword/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var forgotpassword = ({
  name: "forgotpassword",
  data: function data() {
    return {
      username: "",
      state: false,
      error: "",
      loading: false
    };
  },

  methods: {
    forgot: function forgot() {
      var _this = this;

      var username = this.username;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loading = true;
          var data = {
            email: username,
            table: "utenti",
            id_platform: "DcJ7J1WfiwucqBl_lierac",
            unique_key_db: "d971ad4ed27c5e76c0ccf95a",
            vector_unique_key_db: "lierac_global"
          };
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            data: {
              data: data
            },
            url: "https://pharma.ubiqubit.it/" + "api/sendForgotPassEmail",
            method: "POST",
            headers: {
              Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            if (resp.data.error == "") {
              _this.state = true;
            }
            if (resp.data.error == "email_not_present") {
              _this.state = false;
              _this.error = "L`ndirizzo e-mail non è presente nel nostro sistema";
            }

            if (resp.data.error == "account_not_confirmed") {
              _this.state = false;
              _this.error = "Attenzione! Non hai ancora effettuato il primo login. Esegui l`accesso con le credenziali fornite per accettare l`informativa, dopodiché potrai aggiornare la tua passswword";
            }
            _this.loading = false;
          }).catch(function (resp) {
            _this.state = false;
            _this.error = "L`ndirizzo e-mail non è presente nel nostro sistema";
            _this.loading = false;
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded"]), Object(vuex_esm["c" /* mapState */])({
    //login_error: state => `${state.login_error}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea681d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forgotpassword/index.vue
var forgotpassword_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "container-fluid fitAvailableHeight pt-5 somatoline mt-5 pt-5"
    },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "forgot-password mt-3",
          attrs: { id: "forgot-form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.forgot.apply(null, arguments)
            }
          }
        },
        [
          !_vm.state
            ? _c("div", [
                _c("div", { staticClass: "form-row justify-content-center" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              email: true,
                              temporaryEmail: true,
                              plusIssueEmail: true,
                              max: 56
                            },
                            expression:
                              "{\n                required: true,\n                email: true,\n                temporaryEmail: true,\n                plusIssueEmail: true,\n                max: 56,\n              }"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("username"),
                          valid: !!_vm.username
                        },
                        attrs: {
                          type: "text",
                          id: "username",
                          name: "username",
                          "data-vv-as": "Email"
                        },
                        domProps: { value: _vm.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "username" }
                        },
                        [_vm._v("La tua mail")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("username")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("username")) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.error
                        ? _c("div", { staticClass: "mb-3" }, [
                            _c("span", { staticClass: "formError ml-1" }, [
                              _vm._v(_vm._s(_vm.error))
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(2)
              ])
            : _c("div", [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-row justify-content-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6 mb-3 text-center" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary mt-4",
                          attrs: { to: "/" }
                        },
                        [_vm._v("Continua")]
                      )
                    ],
                    1
                  )
                ])
              ])
        ]
      )
    ],
    1
  )
}
var forgotpassword_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row center mt-5 mb-5" }, [
      _c("h2", { staticClass: "text-red Bold widthFull" }, [
        _c("strong", [_vm._v("Recupera password")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 mb-3" }, [
      _c(
        "label",
        {
          staticClass: "widthFull text-center back-white",
          attrs: { for: "email" }
        },
        [
          _c("h4", { staticClass: "Medium widthFull text-center" }, [
            _vm._v(
              "\n              Ti manderemo una mail con le istruzioni\n            "
            )
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "Medium widthFull text-center" }, [
            _vm._v(
              "\n              per ripristinare la tua password\n            "
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-6 mb-3 mt-3 text-center" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary mt-3", attrs: { type: "submit" } },
          [_vm._v("\n            Recupera password\n          ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-6 mb-3 mt-3 back-white" }, [
        _c(
          "h4",
          {
            staticClass: "center Medium pt-3 pb-3 pl-3 pr-3",
            attrs: { for: "email", role: "alert" }
          },
          [
            _c("p", [
              _vm._v(
                "\n              Ti è stata inviata una mail con il link per reimpostare la tua\n              password di accesso,controlla nella tua posta in arrivo.\n            "
              )
            ]),
            _vm._v(" "),
            _c("b", [
              _vm._v(
                "Se non dovessi trovarla controlla anche nella casella spam."
              )
            ])
          ]
        )
      ])
    ])
  }
]
forgotpassword_render._withStripped = true
var forgotpassword_esExports = { render: forgotpassword_render, staticRenderFns: forgotpassword_staticRenderFns }
/* harmony default export */ var components_forgotpassword = (forgotpassword_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea681d1", forgotpassword_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/forgotpassword/index.vue
var forgotpassword_disposed = false
var forgotpassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var forgotpassword___vue_template_functional__ = false
/* styles */
var forgotpassword___vue_styles__ = null
/* scopeId */
var forgotpassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var forgotpassword___vue_module_identifier__ = null
var forgotpassword_Component = forgotpassword_normalizeComponent(
  forgotpassword,
  components_forgotpassword,
  forgotpassword___vue_template_functional__,
  forgotpassword___vue_styles__,
  forgotpassword___vue_scopeId__,
  forgotpassword___vue_module_identifier__
)
forgotpassword_Component.options.__file = "src/components/forgotpassword/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ea681d1", forgotpassword_Component.options)
  } else {
    hotAPI.reload("data-v-5ea681d1", forgotpassword_Component.options)
  }
  module.hot.dispose(function (data) {
    forgotpassword_disposed = true
  })
})()}

/* harmony default export */ var src_components_forgotpassword = (forgotpassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/recoverypassword/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var recoverypassword = ({
  name: "recoverypassword",
  data: function data() {
    return {
      password: "",
      confirm_password: "",
      state: false,
      error: "",
      loading: false
    };
  },

  methods: {
    recovery: function recovery() {
      var _this = this;

      var password = this.password,
          confirm_password = this.confirm_password;

      var token = this.$route.query.token;

      this.$validator.validate().then(function (valid) {
        if (valid && token) {
          _this.loading = true;
          var data = {
            password: password,
            token: token,
            id_platform: "DcJ7J1WfiwucqBl_lierac",
            unique_key_db: "d971ad4ed27c5e76c0ccf95a",
            vector_unique_key_db: "lierac_global"
          };
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://pharma.ubiqubit.it/" + "api/changePassword",
            data: {
              data: data
            },
            method: "POST",
            headers: {
              Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this.state = true;
            _this.loading = false;
          }).catch(function (resp) {
            _this.state = false;
            _this.error = "Il token è scaduto o non è presente";
            _this.loading = false;
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "loadingState", "isAuthenticated", "isProfileLoaded"]), Object(vuex_esm["c" /* mapState */])({
    //login_error: state => `${state.login_error}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264227c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recoverypassword/index.vue
var recoverypassword_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull fitAvailableHeight somatoline" },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid mt-5 pt-5" }, [
        _c("div", { staticClass: "row mt-0 mt-lg-5 pt-5 center" }, [
          !_vm.state
            ? _c("h1", { staticClass: "text-red Medium widthFull" }, [
                _c("span", [_vm._v("Crea nuova password")])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "form",
          {
            staticClass: "recovery-password",
            attrs: { id: "recovery-form" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.recovery.apply(null, arguments)
              }
            }
          },
          [
            !_vm.state
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-row justify-content-center" },
                    [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("label", {
                          staticClass: "widthFull text-center",
                          attrs: { for: "password" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "group mt-5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.password,
                                expression: "password"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  passwordCheck: true,
                                  min: 8,
                                  max: 56
                                },
                                expression:
                                  "{\n                  required: true,\n                  passwordCheck: true,\n                  min: 8,\n                  max: 56,\n                }"
                              }
                            ],
                            staticClass: "form-control mt-1",
                            class: {
                              "is-invalid": _vm.errors.has("password"),
                              valid: !!_vm.password
                            },
                            attrs: {
                              type: "password",
                              id: "password",
                              name: "password"
                            },
                            domProps: { value: _vm.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "password" }
                            },
                            [_vm._v("Nuova Password")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("password")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("password")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "group mt-5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.confirm_password,
                                expression: "confirm_password"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: !!_vm.password,
                                  confirmed: _vm.password,
                                  passwordCheck: true,
                                  min: 8,
                                  max: 56
                                },
                                expression:
                                  "{\n                  required: !!password,\n                confirmed: password,\n                passwordCheck: true,\n                  min: 8,\n                  max: 56,\n                }"
                              }
                            ],
                            staticClass: "form-control mt-3",
                            class: {
                              "is-invalid": _vm.errors.has("confirm_password"),
                              valid: !!_vm.confirm_password
                            },
                            attrs: {
                              type: "password",
                              id: "confirm_password",
                              name: "confirm_password",
                              "data-vv-as": "conferma password"
                            },
                            domProps: { value: _vm.confirm_password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.confirm_password = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "password" }
                            },
                            [_vm._v("Conferma Nuova Password")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("confirm_password")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.errors.first("confirm_password")
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.error
                            ? _c("div", { staticClass: "mt-3" }, [
                                _c("span", { staticClass: "formError ml-1" }, [
                                  _vm._v(_vm._s(_vm.error))
                                ])
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              : _c("div", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row justify-content-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-md-6 mb-3 text-center" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { to: "/login" }
                            },
                            [_vm._v("Accedi")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
          ]
        )
      ])
    ],
    1
  )
}
var recoverypassword_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-6 mb-3 mt-5 text-center" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "submit" } },
          [_vm._v("CONFERMA")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-6 mb-5 mt-5 back-white" }, [
        _c(
          "h4",
          {
            staticClass: "center widthFull Medium",
            attrs: { for: "email", role: "alert" }
          },
          [
            _c("p", [_vm._v("La password è stata aggiornata correttamente,")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("adesso puoi accedere utilizzando la tua nuova password..")
            ])
          ]
        )
      ])
    ])
  }
]
recoverypassword_render._withStripped = true
var recoverypassword_esExports = { render: recoverypassword_render, staticRenderFns: recoverypassword_staticRenderFns }
/* harmony default export */ var components_recoverypassword = (recoverypassword_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264227c3", recoverypassword_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/recoverypassword/index.vue
var recoverypassword_disposed = false
var recoverypassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recoverypassword___vue_template_functional__ = false
/* styles */
var recoverypassword___vue_styles__ = null
/* scopeId */
var recoverypassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var recoverypassword___vue_module_identifier__ = null
var recoverypassword_Component = recoverypassword_normalizeComponent(
  recoverypassword,
  components_recoverypassword,
  recoverypassword___vue_template_functional__,
  recoverypassword___vue_styles__,
  recoverypassword___vue_scopeId__,
  recoverypassword___vue_module_identifier__
)
recoverypassword_Component.options.__file = "src/components/recoverypassword/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-264227c3", recoverypassword_Component.options)
  } else {
    hotAPI.reload("data-v-264227c3", recoverypassword_Component.options)
  }
  module.hot.dispose(function (data) {
    recoverypassword_disposed = true
  })
})()}

/* harmony default export */ var src_components_recoverypassword = (recoverypassword_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/vuejs-datepicker.esm.js
var vuejs_datepicker_esm = __webpack_require__("IC97");

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/locale/index.js
var locale = __webpack_require__("D52M");
var locale_default = /*#__PURE__*/__webpack_require__.n(locale);

// EXTERNAL MODULE: ./node_modules/vue2-timepicker/index.js
var vue2_timepicker = __webpack_require__("SVjV");
var vue2_timepicker_default = /*#__PURE__*/__webpack_require__.n(vue2_timepicker);

// EXTERNAL MODULE: ./node_modules/viewerjs/dist/viewer.css
var viewer = __webpack_require__("N1kN");
var viewer_default = /*#__PURE__*/__webpack_require__.n(viewer);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.css
var vue_select = __webpack_require__("R870");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/play/step_2_prodotti.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var step_2_prodotti_moment = __webpack_require__("PJh5");

/* harmony default export */ var step_2_prodotti = ({
  name: "Play",
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a
  },
  props: {
    date_sc: String,
    time_sc: Object,
    price_sc: String,
    priceCent_sc: String,
    number_sc: String,
    immagine_sc: String,
    ocrContent: Array,
    erroriOcr: Object
  },
  data: function data() {
    var _ref;

    return _ref = {
      loadingState: "",
      id: "",
      title: ""
    }, defineProperty_default()(_ref, "title", ""), defineProperty_default()(_ref, "main_image", ""), defineProperty_default()(_ref, "main_text", ""), defineProperty_default()(_ref, "regulation", ""), defineProperty_default()(_ref, "$viewer", ""), defineProperty_default()(_ref, "faq", ""), defineProperty_default()(_ref, "maxRegistration", 0), defineProperty_default()(_ref, "products_contest", []), defineProperty_default()(_ref, "disabledDates", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "step1Text", ""), defineProperty_default()(_ref, "step2Text", ""), defineProperty_default()(_ref, "step3Text", ""), defineProperty_default()(_ref, "step4Text", ""), defineProperty_default()(_ref, "call_support", ""), defineProperty_default()(_ref, "email_support", ""), defineProperty_default()(_ref, "award_name", ""), defineProperty_default()(_ref, "award_description", ""), defineProperty_default()(_ref, "numMaxQnt_prod", false), defineProperty_default()(_ref, "numMax_prod", false), defineProperty_default()(_ref, "numMaxAttempts_prod", false), defineProperty_default()(_ref, "showProdError", false), defineProperty_default()(_ref, "start", ""), defineProperty_default()(_ref, "discount", ""), defineProperty_default()(_ref, "end", ""), defineProperty_default()(_ref, "start_", ""), defineProperty_default()(_ref, "numberOcr", false), defineProperty_default()(_ref, "amountOcr", false), defineProperty_default()(_ref, "end_", ""), defineProperty_default()(_ref, "products", [{
      index: "product" + 0,
      indexCount: "quantity" + 0,
      product: "",
      quantity: 1,
      points: 0,
      countable: 1,
      price: 0.0
    }]), defineProperty_default()(_ref, "token", ""), defineProperty_default()(_ref, "quantity", ""), defineProperty_default()(_ref, "wrongErr", false), defineProperty_default()(_ref, "priceError", false), defineProperty_default()(_ref, "totPrice", ""), defineProperty_default()(_ref, "priceCent", ""), defineProperty_default()(_ref, "price", ""), defineProperty_default()(_ref, "priceFocused", false), defineProperty_default()(_ref, "invoiceFrontBucket", ""), defineProperty_default()(_ref, "message", ""), defineProperty_default()(_ref, "invoiceFront", ""), defineProperty_default()(_ref, "it", locale["it"]), defineProperty_default()(_ref, "uploadFrontPercentage", 0), defineProperty_default()(_ref, "award_image", ""), defineProperty_default()(_ref, "loadingState", false), defineProperty_default()(_ref, "empty", false), defineProperty_default()(_ref, "notRegister", false), defineProperty_default()(_ref, "specific", ""), defineProperty_default()(_ref, "statusOCR", ""), defineProperty_default()(_ref, "change", false), defineProperty_default()(_ref, "mobileUpl", false), defineProperty_default()(_ref, "changeSecond", 0), defineProperty_default()(_ref, "award_type_", ""), defineProperty_default()(_ref, "award_type", ""), defineProperty_default()(_ref, "rebate", ""), defineProperty_default()(_ref, "sale_time", ""), defineProperty_default()(_ref, "amount", ""), defineProperty_default()(_ref, "priceEur", ""), defineProperty_default()(_ref, "number", ""), defineProperty_default()(_ref, "piva_shop", ""), defineProperty_default()(_ref, "shop", ""), defineProperty_default()(_ref, "id_image", ""), defineProperty_default()(_ref, "zip", ""), defineProperty_default()(_ref, "city", ""), defineProperty_default()(_ref, "modify", false), defineProperty_default()(_ref, "province", ""), defineProperty_default()(_ref, "ocrData", {}), defineProperty_default()(_ref, "type", ""), defineProperty_default()(_ref, "showProdError", false), defineProperty_default()(_ref, "maxSelOk", false), defineProperty_default()(_ref, "minPrice", ""), defineProperty_default()(_ref, "regex", ""), defineProperty_default()(_ref, "minPrice_products", false), defineProperty_default()(_ref, "maxPrice_products", false), defineProperty_default()(_ref, "my_registration_in_promo", ""), defineProperty_default()(_ref, "discountClients", ""), defineProperty_default()(_ref, "pricenew", ""), defineProperty_default()(_ref, "errProd", false), defineProperty_default()(_ref, "canCon", false), defineProperty_default()(_ref, "INF", ""), defineProperty_default()(_ref, "productIndex", 0), defineProperty_default()(_ref, "reload", false), defineProperty_default()(_ref, "vw", window.innerWidth), defineProperty_default()(_ref, "imageData", {}), defineProperty_default()(_ref, "contests", {}), defineProperty_default()(_ref, "time", {
      HH: "",
      mm: ""
    }), defineProperty_default()(_ref, "priceMod1", false), _ref;
  },

  methods: {
    play: function play() {
      var _this = this;

      this.checkAccess();
      var _vue = this;
      this.errProd_check = true;
      this.errProd_check_N = false;
      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i]["product"]) {
          this.errProd_check = false;
        } else this.errProd_check_N = true;
      }
      if (!this.errProd_check_N) {
        this.errProd = false;

        this.loadingState = true;
        this.$track("createMyProd", "START");
        var data = {
          product: this.products,
          promo: this.contests,
          utente: this.profile,
          id_platform: "DcJ7J1WfiwucqBl_lierac",
          unique_key_db: "d971ad4ed27c5e76c0ccf95a",
          vector_unique_key_db: "lierac_global"
        };
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          method: "POST",
          data: { data: data },
          url: "https://pharma.ubiqubit.it/" + "api/createMyProd",
          headers: {
            Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this.$track("createMyProd", "SUCCESS");
          _this.$track("createMyProd", resp.data);
          resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
          _this.products1 = resp.data;
          _this.$validator.validate().then(function (valid) {
            if (valid && !_this.numMaxQnt_prod && !_this.numMaxAttempts_prod && _this.date_sc && _this.price_sc && _this.priceCent_sc && _this.number_sc && _this.immagine_sc && _this.ocrContent) {
              var _vue = _this;
              var sale_time = _this.time_sc.HH + ":" + _this.time_sc.mm + ":00";
              var errors = "";
              for (var i in _vue.erroriOcr) {
                if (_vue.erroriOcr[i].status == "KO") {
                  errors += '<h4 class="smallText">' + _vue.erroriOcr[i].description + "</h4>";
                }
              }
              var value = parseInt(_this.price) + "" + _this.priceCent;
              if (_this.softCheck) {
                errors += '<h4 class="smallText">' + _this.softCheck + "</h4>";
              }
              if (valid && !_this.countError && !_this.showProdError && !_this.minPrice_products && !_this.maxPrice_products && !_this.errProd) {
                var timestamp = step_2_prodotti_moment().valueOf();
                var data = {
                  profile: _this.profile,
                  promo: _this.contests,
                  email: _this.email,
                  channel: 'web',
                  sdate_submit: step_2_prodotti_moment().format("YYYY-MM-DD hh:mm:ss"),
                  ttdate: step_2_prodotti_moment(_this.date_sc).format("YYYY-MM-DD"),
                  ttime: sale_time,
                  tvalue: parseInt(_this.price_sc) + "." + _this.priceCent_sc,
                  tnumber: _this.number_sc,
                  rebate: _this.discount,
                  piva: _this.piva,
                  iban: _this.iban,
                  ntk: "a47a065bee221a88306bafcd0c9b866cefb738ec",
                  uid: timestamp + "$" + value,
                  products: _this.products1,
                  receipts_uploads: [{ url1: _this.immagine_sc }],
                  ocrData: _this.ocrContent,
                  INF: _this.INF,
                  code: 200,
                  description: errors,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };
                _this.$track("Play", data);
                data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _this.loadingState = true;
                _this.$track("Play", "START");

                axios_default()({
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/play",
                  method: "POST",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  },
                  withCredentials: false
                }).then(function (resp) {
                  _this.$track("Play", "SUCCESS");
                  _this.$track("Play", resp.data);
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  if (resp.data.status_code == 200) {
                    _this.showPlay();
                    _this.resetForm();
                  } else {
                    if (resp.data.status_code == 112) {
                      _this.showError("Lo scontrino risulta essere giá caricato");
                    } else {
                      _this.showError("Errore. Riprova piú tardi");
                    }
                  }
                }).catch(function (err) {
                  _this.loadingState = false;
                  _this.$track("Play", "ERROR");
                  err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this.showError("Errore. Riprova piú tardi");
                });
              } else {
                var _vue = _this;
                if (_this.showProdError) {
                  _vue.$scrollTo("#quantity", 700, { offset: -170 });
                }
                if (_this.minPrice_products) {
                  _vue.$scrollTo("#quantity", 700, { offset: -170 });
                }
                _vue.$scrollTo("#" + _this.errors.items[0].field, 700, {
                  offset: -170
                });
              }
            } else {
              var _vue = _this;
              setTimeout(function () {
                _vue.$scrollTo("#top-error", 100, { offset: -800 });
              }, 100);
              _this.loadingState = false;
            }
          });
        }).catch(function (err) {
          _this.loadingState = false;
          _this.$track("createMyProd", "ERROR");
          _this.message = '<b class="Bold">I/Il prodotto/i inseriti non sono piu` attivi</b>';
          _this.UploadError("", _this.message);
          err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
        });
      } else {
        this.errProd = true;
      }
    },
    loadProducts: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this2 = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadingState = true;
                this.$track("loadProducts", "START");
                data = {
                  id: this.$route.params.id,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/loadProducts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this2.$track("loadProducts", "SUECCESS");
                  _this2.$track("loadProducts", [resp.data]);
                  var prod = [];
                  for (var x in resp.data) {
                    var y = [];
                    y["key"] = x;
                    y["label"] = resp.data[x];
                    y["value"] = resp.data[x];
                    prod.push(y);
                  }
                  _this2.products_contest = resp.data;
                  _this2.loadingState = false;
                }).catch(function (resp) {
                  _this2.loadingState = false;
                  _this2.$track("loadProducts", "ERROR");
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadProducts() {
        return _ref2.apply(this, arguments);
      }

      return loadProducts;
    }(),
    logout: function logout() {
      var _this3 = this;

      this.$store.dispatch(AUTH_LOGOUT).then(function () {
        return _this3.$router.push("/login");
      });
    },
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show() {
      var el = this.$refs.inv;
      var viewer = el.$viewer;
      viewer.show();
      viewer.zoomTo(2);
      viewer.move(-1, 0);
    },
    showError: function showError(text) {
      var _this4 = this;

      this.$swal({
        type: "error",
        title: '<strong class="Bold">Oops...</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: function onClose() {
          _this4.loadingState = false;
          _this4.$router.push("/contest/" + _this4.$route.params.id + "/" + _this4.$route.params.piva + "/" + _this4.$route.params.cod);
        }
      });
    },
    resetForm: function resetForm() {
      var _this5 = this;

      var _vue = this;
      this.$validator.pause();
      this.mail = "";
      this.sdate_submit = "";
      this.ttdate = "";
      this.ttime = "";
      this.tvalue = "";
      this.tnumber = "";
      this.user_token = "";
      this.name = "";
      this.company = "";
      this.sname = "";
      this.piva = "";
      this.iban = "";
      this.address = "";
      this.tel = "";
      this.ntk = "";
      this.uid = "";
      this.receipts = "";
      this.ocrData = "";
      this.products = "";
      this.loadingState = false;
      setTimeout(function () {
        _vue.checkProducts(1);
      }, 200);

      // CLEAR VALIDATOR AFTER REMOVE ALL VALUES
      this.$nextTick(function () {
        _this5.$validator.reset();
        _this5.$validator.errors.clear();
        _this5.$validator.resume();
      });
    },
    addProduct: function addProduct() {
      this.productIndex = this.productIndex + 1;
      this.$track("addProduct", "Siamo al prodotto: " + this.productIndex);
      this.$track("addProduct", "Il massimo dei prodotti per questa promo è: " + this.contests.config.PRODOTTI_MASSIMO);
      if (this.productIndex >= this.contests.config.PRODOTTI_MASSIMO - 1) {
        this.numMax_prod = true;
      } else {
        this.numMax_prod = false;
      }
      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        product: "",
        quantity: 1,
        points: 0,
        countable: 1,
        price: 0
      });
    },
    removeProduct: function removeProduct(elem) {
      var _vue = this;
      this.productIndex = this.productIndex - 1;
      if (this.productIndex >= this.contests.config.PRODOTTI_MASSIMO - 1) {
        this.numMax_prod = true;
      } else {
        this.numMax_prod = false;
      }
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      _vue.calcTotPrice();
    },

    checkProducts: function checkProducts(param) {
      var products = this.products;
      var count = 0;
      this.$track("checkProducts", products);
      this.$track("checkProducts", "IL PREZZO MINIMO : " + this.contests.config.PREZZO_MINIMO);
      this.$track("checkProducts", "LA QUANTITA MINIMA DI PRODOTTI : " + this.contests.config.PRODOTTI_MINIMO);
      this.$track("checkProducts", this.contests.config);
      if (this.contests.config.PREZZO_MINIMO > 0) {
        this.showProdError = false;
      } else if (this.contests.config.PRODOTTI_MINIMO) {
        if (param) {
          this.showProdError = false;
          this.$track("checkProducts", "Non è da considerarsi un prezzo minimo");
        } else {
          for (var i in products) {
            this.$track("checkProducts", "ciclo su tutti i prodotti");
            var prod = products[i].product;

            if (products[i].quantity) {
              count = count + 1 * parseInt(products[i].quantity);
            }
            this.$track("checkProducts", "i prodotti inseriti sono : " + count);
          }

          if (count >= parseFloat(this.contests.config.PRODOTTI_MINIMO)) {
            this.$track("checkProducts", "ha inserito : " + count + " su un minimo di " + this.contests.config.PRODOTTI_MINIMO);
            this.showProdError = false;
          } else {
            this.$track("checkProducts", "Non è ancora arrivato al minimo");
            this.showProdError = true;
          }
        }
      }
    },
    calcTotPrice: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var prod, count, qnt, x;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.takeMyAttempts();

              case 2:
                prod = this.products;
                count = 0;
                qnt = 0;

                for (x in prod) {
                  if (prod[x].price && prod[x].quantity) {
                    qnt = qnt + parseFloat(prod[x].quantity);
                    count = count + parseFloat(prod[x].price).toFixed(2) * parseInt(prod[x].quantity);
                    this.$track("calcTotPrice", "Il prezzo del prodotto selezionato è : " + prod[x].price);
                    this.$track("calcTotPrice", "La quantitá del prodotto selezionato è : " + prod[x].quantity);
                    this.$track("calcTotPrice", "QNT TOT: " + qnt);
                    this.$track("calcTotPrice", "PRICE : " + count);
                  }
                  if (prod[x].points && prod[x].quantity) {
                    qnt = qnt + parseFloat(prod[x].quantity);
                    count = count + parseFloat(prod[x].points) * parseInt(prod[x].quantity);
                    this.$track("calcTotPrice", "Il punteggio del prodotto selezionato è : " + prod[x].points);
                    this.$track("calcTotPrice", "La quantitá del prodotto selezionato è : " + prod[x].quantity);
                    this.$track("calcTotPrice", "QNT TOT: " + qnt);
                    this.$track("calcTotPrice", "PUNTEGGIO : " + count);
                  }
                }
                if (qnt > this.contests.config.PRODOTTI_MASSIMO) {
                  this.numMaxQnt_prod = true;
                } else {
                  this.numMaxQnt_prod = false;
                }
                if (this.contests.config.DESTINAZIONE_SCONTO == 'PRODOTTO') {
                  if (qnt + this.my_registration_in_promo > this.maxRegistration) {
                    this.numMaxAttempts_prod = true;
                  } else {
                    this.numMaxAttempts_prod = false;
                  }
                }

                if (this.contests.config.RIMBORSO_SECONDO_PRODOTTO) {
                  if (qnt == 1) this.discount = this.contests.config.RIMBORSO_PRIMO_PRODOTTO;
                  if (qnt == 2) this.discount = this.contests.config.RIMBORSO_SCONTO_PRODOTTO;
                } else if (this.contests.config.RIMBORSO_COMPLESSIVO) {
                  this.discount = this.contests.config.RIMBORSO;
                }
                this.$track("calcTotPrice", "Lo sconto che deve essere applicato è : " + parseFloat(this.discount));
                if (isNaN(count)) {
                  count = 0;
                }
                this.totPrice = parseFloat(count).toFixed(2);
                //CHECK TOTAL OF RECEIPT
                if (this.contests.config.PREZZO_MINIMO > 0) {
                  if (this.totPrice < parseFloat(this.contests.config.PREZZO_MINIMO)) {
                    this.minPrice_products = true;
                  } else {
                    this.minPrice_products = false;
                  }
                }
                if (this.contests.config.PREZZO_MASSIMO > 0) {
                  if (this.totPrice > parseFloat(this.contests.config.PREZZO_MASSIMO)) {
                    this.maxPrice_products = true;
                  } else {
                    this.maxPrice_products = false;
                  }
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function calcTotPrice() {
        return _ref3.apply(this, arguments);
      }

      return calcTotPrice;
    }(),
    takeMyAttempts: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this6 = this;

        var data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loadingState = true;
                this.$track("takeMyAttempts", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  desc: this.contests.config.DESTINAZIONE_SCONTO,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context3.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/takeMyAttempts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this6.loadingState = false;
                  _this6.$track("takeMyAttempts", "SUCCESS");
                  resp.data = _this6.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this6.$track("takeMyAttempts -> MY", resp.data);
                  _this6.$track("takeMyAttempts -> MAX", _this6.maxRegistration);
                  _this6.my_registration_in_promo = resp.data.countMyAttempts;
                  if (_this6.my_registration_in_promo >= _this6.maxRegistration) {
                    _this6.$track("takeMyAttempts -> RAGGIUNTO MASSIMO", _this6.my_registration_in_promo + " >= " + _this6.maxRegistration);
                    _this6.notRegister = true;
                    var _vue = _this6;
                    var text;
                    var text = '<h5 class="text-center uppercase red">Hai raggiunto il numero massimo di richieste di rimborso disponibili per questa promozione</h5> ';
                    text += '<p class="text-center Bold mt-1 pt-5 red">Il numero massimo di richieste di rimborso per questa promozione é <h3 class="bordered back-color-1 white">' + _this6.maxRegistration + "</h3></p>";
                    var mySwal = _this6.$swal;
                    mySwal({
                      html: text,
                      showCloseButton: true,
                      width: 555,
                      color: "red",
                      showConfirmButton: false,
                      confirmButton: "closeProductsModal",
                      confirmButtonClass: "btn btn-secondary",
                      onClose: function onClose() {
                        _this6.$router.push("/contest/" + _this6.$route.params.id + "/" + _this6.$route.params.piva + "/" + _this6.$route.params.cod);
                      }
                    });
                  }
                }).catch(function (err) {
                  _this6.loadingState = false;
                  _this6.$track("takeMyAttempts", "ERROR");
                  err.response.data = _this6.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function takeMyAttempts() {
        return _ref4.apply(this, arguments);
      }

      return takeMyAttempts;
    }(),
    showPlay: function showPlay() {
      var _this7 = this;

      var _vue = this;
      var text = '<h5 class="text-center uppercase">L`inserimento della richiesta di rimborso é andata a buon fine.</h5> ';
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';
      var mySwal = this.$swal;
      mySwal({
        title: '<div class="col-12 center d-flex justify-content-center" style="width:700px"><div class="w-25 px-2 px-md-3 line-h4"><hr /></div><h4 class="text-center Bold">ESITO</h4><div class="w-25 px-2 px-md-3 line-h4"><hr /></div></div>',
        html: text,
        showCloseButton: true,
        width: 1000,
        showConfirmButton: false,
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: function onClose() {
          if (_this7.mobileUpl) {
            window.location.reload();
          } else {
            _this7.$router.push("/contest/" + _this7.$route.params.id + "/" + _this7.$route.params.piva + "/" + _this7.$route.params.cod);
          }
        }
      });
    },
    doAcceptReg: function doAcceptReg(value) {
      this.$store.dispatch(ACCEPT_REG, value).then(function (resp) {});
    },
    UploadError: function UploadError(desc, specific) {
      var _this8 = this;

      this.$swal({
        type: "error",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          _this8.$router.push("/");
        }
      });
    },

    getThisContest: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _this9 = this;

        var data;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContest", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ACTIVE",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context4.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this9.loadingState = false;
                  resp.data = _this9.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this9.$track("getThisContest", "SUCCESS");
                  if (resp.data) {
                    _this9.empty = false;
                  }
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  _this9.contests = resp.data[0];

                  _this9.type = _this9.contests.config.TIPOLOGIA_RIEPILOGO;
                  _this9.start_ = _this9.contests.start;
                  _this9.start = step_2_prodotti_moment(_this9.start_).format("DD-MM-YYYY");
                  _this9.end_ = _this9.contests.end;
                  _this9.end = step_2_prodotti_moment(_this9.end_).format("DD-MM-YYYY");
                  _this9.theseProducts();
                  _this9.now = step_2_prodotti_moment();
                  var then = step_2_prodotti_moment(_this9.end_);

                  var dif = then.diff(_this9.now);
                  if (dif <= 0) {
                    _this9.finish = true;
                    _this9.countdown = 0 - dif;
                  } else {
                    _this9.countdown = dif;
                  }
                  _this9.$track("getThisContest", _this9.contests);
                }).catch(function (err) {
                  _this9.loadingState = false;
                  err.response.data = _this9.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this9.$track("getThisContest", "ERROR");
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getThisContest() {
        return _ref5.apply(this, arguments);
      }

      return getThisContest;
    }(),
    theseProducts: function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _this10 = this;

        var data;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.loadingState = true;
                this.$track("theseProducts", "START");
                data = {
                  id: this.$route.params.id,
                  profile: this.profile,
                  desc: this.contests.config.DESTINAZIONE_SCONTO,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context5.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/theseProducts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this10.loadingState = false;
                  _this10.$track("theseProducts", "SUCCESS");
                  resp.data = _this10.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this10.$track("theseProducts", resp.data);

                  _this10.productList = resp.data;
                }).catch(function (err) {
                  _this10.$track("theseProducts", "ERROR");
                  err.response.data = _this10.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function theseProducts() {
        return _ref6.apply(this, arguments);
      }

      return theseProducts;
    }(),

    setProfileData: function setProfileData() {
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.id;
      this.token = this.profile.token;
      this.piva = this.profile.piva;
      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.group = this.profile.groupPh;
      this.cod_client = this.profile.cod;
      this.profileId = this.profile.id;
    },
    showConfirmReg: function showConfirmReg() {
      var _this11 = this;

      var reg = this.accepted_regulations;

      if (reg[this.id]) {} else {
        this.$swal({
          type: "info",
          title: "Consenso necessario",
          html: '<p class="black">cliccando su conferma si accettano il <a class="link underline" target="_blank" href="' + this.regulation + '" style="color: blue;"> termini e le condizioni di questa promozione </a>',
          confirmButtonText: "CONFERMA",
          confirmButton: "closeProductsModal",
          onClose: function onClose() {
            _this11.$store.dispatch(ACCEPT_REG, _this11.id);
          }
        });
      }
    },

    activateMod: function activateMod(param) {
      this.modify = true;
      this.change = false;
      this.pricenew = param;
    },
    deactivateMod: function deactivateMod() {
      var _vue = this;
      this.pricenew = "";
      setTimeout(function () {
        _vue.modify = false;
      }, 100);
    },
    selectChange: function selectChange(param) {
      this.change = true;
      this.errProd = false;
    },
    priceMod: function priceMod(param) {
      var _vue = this;
      this.changeSecond = param;
    },

    myRegistration: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _this12 = this;

        var data;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this.piva != this.$route.params.piva)) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 8;
                break;

              case 3:
                this.$track("myRegistration", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context6.next = 8;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/myRegistration",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this12.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this12.$track("myRegistration", "SUCCESS");
                  _this12.$track("myRegistration", resp.data);
                  if (resp.data) {
                    _this12.maxRegistration = parseInt(resp.data[0].bonus) + parseInt(resp.data[0].extra_bonus);
                    _this12.maxRegistrationOr = parseInt(resp.data[0].bonus);
                  }
                }).catch(function (err) {
                  _this12.$track("myRegistration", "ERROR");
                  err.response.data = _this12.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function myRegistration() {
        return _ref7.apply(this, arguments);
      }

      return myRegistration;
    }(),
    calcToDate: function calcToDate() {
      var _vue = this;
      var startRecDate = {
        year: step_2_prodotti_moment(_vue.startRec_).year(),
        month: step_2_prodotti_moment(_vue.startRec_).month(),
        day: step_2_prodotti_moment(_vue.startRec_).day()
      };
      var start = startRecDate;
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = startDate;
      }
      return finalTo;
    },
    calcFromDate: function calcFromDate() {
      var _vue = this;
      var endRecDate = {
        year: step_2_prodotti_moment(_vue.endRec_).year(),
        month: step_2_prodotti_moment(_vue.endRec_).month(),
        day: step_2_prodotti_moment(_vue.endRec_).day()
      };
      var stopObj = endRecDate;
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },

    checkAccess: function () {
      var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var _this13 = this;

        var data;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.piva == this.$route.params.piva)) {
                  _context7.next = 8;
                  break;
                }

                this.$track("checkAccess", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context7.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/checkAccess",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this13.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this13.loadingState = false;
                  _this13.checkAccessOk = true;
                  _this13.$track("checkAccess", "SUCCESS");
                  _this13.$track("checkAccess", resp.data);
                  if (resp.data == "access_denied") {
                    _this13.message = '<b class="Bold">Non hai accesso a questa promozione</b>';
                    _this13.UploadError("", _this13.message);
                  } else {}
                }).catch(function (err) {
                  _this13.loadingState = false;
                  _this13.$track("checkAccess", "ERROR");
                  err.response.data = _this13.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
                _context7.next = 9;
                break;

              case 8:
                this.$router.push("/");

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function checkAccess() {
        return _ref8.apply(this, arguments);
      }

      return checkAccess;
    }()
  },
  /********************************************************************************************* */
  watch: {
    "$route.params.id": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.piva": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.phone": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    products: {
      handler: function handler(val) {
        var _vue = this;
        switch (this.contests.config.DESTINAZIONE_SCONTO) {
          case "PUNTI":
            setTimeout(function () {
              if (_vue.productList[0]) {
                if (_vue.change) {
                  _vue.products[_vue.changeSecond].points = "";
                }
                if (_vue.products[_vue.changeSecond].product && !_vue.products[_vue.changeSecond].points && !_vue.modify && _vue.pricenew == "") {
                  _vue.products[_vue.changeSecond].points = "" + _vue.productList[0][_vue.products[_vue.changeSecond].product];
                  _vue.change = false;
                }
              }
              _vue.products[_vue.changeSecond].points = val[_vue.changeSecond].points.replace(",", ".");
              _vue.products[_vue.changeSecond].points = val[_vue.changeSecond].points.replace(/[`~!@#$£%^&*()_|+\-=?;:",<>\{\}\[\]\\\/]/gi, "");
            }, 100);
            this.checkProducts();
            this.calcTotPrice();
            break;

          default:
            setTimeout(function () {
              if (_vue.productList[0]) {
                if (_vue.change) {
                  _vue.products[_vue.changeSecond].price = "";
                }
                if (_vue.products[_vue.changeSecond].product && !_vue.products[_vue.changeSecond].price && !_vue.modify && _vue.pricenew == "") {
                  _vue.products[_vue.changeSecond].price = "" + _vue.productList[0][_vue.products[_vue.changeSecond].product];
                  _vue.change = false;
                }
              }
              _vue.products[_vue.changeSecond].price = val[_vue.changeSecond].price.replace(",", ".");
              _vue.products[_vue.changeSecond].price = val[_vue.changeSecond].price.replace(/[`~!@#$£%^&*()_|+\-=?;:",<>\{\}\[\]\\\/]/gi, "");
            }, 100);
            this.checkProducts();
            this.calcTotPrice();
            break;
        }
      },

      deep: true
    },
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.checkAccess();
      this.myRegistration();
      this.loadProducts();
    }
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.id = id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    this.loadProducts();
    if (!piva || !cod) {
      this.$router.push("/");
    }
    this.setProfileData();
    if (this.getProfile.piva) {
      this.setProfileData();
      this.myRegistration();

      var _vue = this;
    }
    if (this.$route.params.phone == 1) {
      this.mobileUpl = true;
    }

    //this.getThisContest()
    var _vue = this;
    //_vue.setProfileData()
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);
  },
  created: function () {
    var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.getThisContest();

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function created() {
      return _ref9.apply(this, arguments);
    }

    return created;
  }(),
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies", "accepted_regulations"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eda55834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/play/step_2_prodotti.vue
var step_2_prodotti_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top-error" } },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.contests.config
        ? _c(
            "form",
            { attrs: { id: "edit-user-form", autocomplete: "qwerqrt" } },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 col-lg-12 mb-0" },
                [
                  _vm._l(_vm.products, function(elem, num) {
                    return _c(
                      "div",
                      {
                        key: num,
                        staticClass: "row",
                        on: {
                          click: function($event) {
                            return _vm.priceMod(num)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "group ml-0 mr-0" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "lable-style",
                                  attrs: { for: "product" }
                                },
                                [_vm._v("Prodotto")]
                              ),
                              _vm._v(" "),
                              _c("v-select", {
                                key: elem.product,
                                attrs: {
                                  options: _vm.products_contest,
                                  clearable: false
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectChange(_vm.products)
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "search",
                                      fn: function(ref) {
                                        var attributes = ref.attributes
                                        var events = ref.events
                                        return [
                                          _c(
                                            "input",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "vs__search",
                                                  attrs: {
                                                    required: !elem.product
                                                  }
                                                },
                                                "input",
                                                attributes,
                                                false
                                              ),
                                              events
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: elem.product,
                                  callback: function($$v) {
                                    _vm.$set(elem, "product", $$v)
                                  },
                                  expression: "elem.product"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _vm.errProd
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-1" },
                                    [
                                      _vm._v(
                                        "\n                Devi inserire almeno un prodotto tra quelli in elenco\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "group ml-0 mr-0" }, [
                            _c(
                              "label",
                              {
                                staticClass: "lable-style",
                                attrs: { for: elem.indexCount }
                              },
                              [_vm._v("Quantità")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: elem.quantity,
                                  expression: "elem.quantity"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    is_not: "0",
                                    min_value: 1,
                                    max_value:
                                      _vm.contests.config.PRODOTTI_MASSIMO,
                                    max: 2
                                  },
                                  expression:
                                    "{\n                  required: true,\n                  is_not: '0',\n                  min_value: 1,\n                  max_value: contests.config.PRODOTTI_MASSIMO,\n                  max: 2,\n                }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(elem.indexCount),
                                valid: !!elem.quantity,
                                dis: !_vm.contests.config.QNT_MODIFICABILE
                              },
                              attrs: {
                                type: "number",
                                disabled: !_vm.contests.config.QNT_MODIFICABILE,
                                id: elem.indexCount,
                                name: elem.indexCount,
                                "data-vv-as": "Quantità"
                              },
                              domProps: { value: elem.quantity },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    elem,
                                    "quantity",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _vm.errors.has(elem.indexCount)
                              ? _c(
                                  "div",
                                  { staticClass: "invalid-feedback-1" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.errors.first(elem.indexCount)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _vm.contests.config.DESTINAZIONE_SCONTO != "PUNTI"
                            ? _c("div", { staticClass: "group ml-0 mr-0" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "lable-style",
                                    attrs: { for: elem.indexCount }
                                  },
                                  [_vm._v("Importo unitario")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: elem.price,
                                      expression: "elem.price"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        is_not: "0",
                                        decimal: 2
                                      },
                                      expression:
                                        "{ required: true, is_not: '0', decimal: 2 }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      elem.indexCount + "p"
                                    ),
                                    valid: !!elem.price,
                                    dis: !_vm.priceMod1
                                  },
                                  attrs: {
                                    type: "text",
                                    disabled: !_vm.priceMod1,
                                    id: elem.indexCount + "p",
                                    name: elem.indexCount + "p",
                                    "data-vv-as": "importo unitario"
                                  },
                                  domProps: { value: elem.price },
                                  on: {
                                    focus: function($event) {
                                      return _vm.activateMod(elem.price)
                                    },
                                    blur: function($event) {
                                      return _vm.deactivateMod(elem.price)
                                    },
                                    keyup: function($event) {
                                      elem.price = elem.price.replace(",", ".")
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        elem,
                                        "price",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.errors.has(elem.indexCount + "p")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback-1" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                elem.indexCount + "p"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.DESTINAZIONE_SCONTO == "PUNTI"
                            ? _c("div", { staticClass: "group ml-0 mr-0" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "lable-style",
                                    attrs: { for: elem.indexCount }
                                  },
                                  [_vm._v("Punteggio unitario")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: elem.points,
                                      expression: "elem.points"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        is_not: "0",
                                        decimal: 2
                                      },
                                      expression:
                                        "{ required: true, is_not: '0', decimal: 2 }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      elem.indexCount + "p"
                                    ),
                                    valid: !!elem.points,
                                    dis: !_vm.priceMod1
                                  },
                                  attrs: {
                                    type: "text",
                                    disabled: !_vm.priceMod1,
                                    id: elem.indexCount + "p",
                                    name: elem.indexCount + "p",
                                    "data-vv-as": "importo unitario"
                                  },
                                  domProps: { value: elem.points },
                                  on: {
                                    focus: function($event) {
                                      return _vm.activateMod(elem.points)
                                    },
                                    blur: function($event) {
                                      return _vm.deactivateMod(elem.points)
                                    },
                                    keyup: function($event) {
                                      elem.points = elem.points.replace(
                                        ",",
                                        "."
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        elem,
                                        "points",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.errors.has(elem.indexCount + "p")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback-1" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                elem.indexCount + "p"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          num
                            ? _c(
                                "span",
                                {
                                  staticClass: "removeProduct pointer",
                                  class: elem.index
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticStyle: {
                                      background: "white",
                                      "margin-right": "11px",
                                      "margin-top": "25px"
                                    },
                                    attrs: { icon: "trash-alt", size: "lg" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeProduct(num)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row justify-content-center pb-5" },
                    [
                      _vm.contests.config
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-md-6 col-lg-6 mb-3 text-left vcenter mt-md-0 mt-3"
                            },
                            [
                              !_vm.numMaxQnt_prod &&
                              !_vm.numMax_prod &&
                              !_vm.numMaxAttempts_prod
                                ? _c("img", {
                                    staticClass:
                                      "addProduct imageIcons pointer",
                                    on: { click: _vm.addProduct }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.numMaxQnt_prod &&
                              !_vm.numMax_prod &&
                              !_vm.maxSelOk &&
                              !_vm.numMaxAttempts_prod
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "fixPointer white",
                                      on: { click: _vm.addProduct }
                                    },
                                    [
                                      _c("b", [_vm._v("+")]),
                                      _vm._v(" Aggiungi prodotto")
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showProdError &&
                              _vm.contests.config.PRODOTTI_MINIMO
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare l'inserimento é necessario aver acquistato\n              in un unico atto d’acquisto almeno\n              " +
                                        _vm._s(
                                          _vm.contests.config.PRODOTTI_MINIMO
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.contests.config.PRODOTTI_MINIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showProdError &&
                              _vm.contests.config.PREZZO_MINIMO > 0
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare l'inserimento é necessario aver acquistato\n              in un unico atto d’acquisto almeno\n              " +
                                        _vm._s(
                                          _vm.contests.config.PREZZO_MINIMO
                                        ) +
                                        " € di\n              "
                                    ),
                                    _vm.contests.config.PREZZO_MINIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.numMaxQnt_prod
                                ? _c("small", { staticClass: "red Bold h5" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per poter registrare la richiesta per questa promozione\n              puoi inserire massimo " +
                                        _vm._s(
                                          _vm.contests.config.PRODOTTI_MASSIMO
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.contests.config.PRODOTTI_MASSIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.numMax_prod && !_vm.numMaxQnt_prod
                                ? _c("small", { staticClass: "black" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per poter registrare la richiesta per questa promozione\n              puoi inserire massimo " +
                                        _vm._s(
                                          _vm.contests.config.PRODOTTI_MASSIMO
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.contests.config.PRODOTTI_MASSIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.numMaxAttempts_prod
                                ? _c("small", { staticClass: "red Bold" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per questa promozione hai diritto a massimo\n              " +
                                        _vm._s(_vm.maxRegistration) +
                                        " buoni, attualmente hai usufruito di\n              " +
                                        _vm._s(_vm.my_registration_in_promo) +
                                        " buoni, ne hai a disposizione ancora\n              " +
                                        _vm._s(
                                          _vm.maxRegistration -
                                            _vm.my_registration_in_promo
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.maxSelOk
                        ? _c("div", {
                            staticClass:
                              "col-md-6 col-lg-6 mb-3 text-left vcenter mt-md-0 mt-3"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.contests.config
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-md-6 col-lg-6 mb-3 text-right pt-2"
                            },
                            [
                              _vm.totPrice &&
                              _vm.contests.config.DESTINAZIONE_SCONTO != "PUNTI"
                                ? _c(
                                    "h5",
                                    {
                                      staticClass: "Bold",
                                      class: {
                                        "invalid-feedback-1": _vm.priceError
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Totale prodotti: " +
                                          _vm._s(_vm.totPrice) +
                                          "€\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.totPrice &&
                              _vm.contests.config.DESTINAZIONE_SCONTO == "PUNTI"
                                ? _c(
                                    "h5",
                                    {
                                      staticClass: "Bold",
                                      class: {
                                        "invalid-feedback-1": _vm.priceError
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Punteggio richiesto: " +
                                          _vm._s(_vm.totPrice) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.minPrice_products &&
                              _vm.contests.config.PREZZO_MINIMO
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare la richiesta di rimborso é necessario che la\n              somma dei prodotti sia almeno " +
                                        _vm._s(
                                          _vm.contests.config.PREZZO_MINIMO
                                        ) +
                                        "€\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.maxPrice_products &&
                              _vm.contests.config.PREZZO_MASSIMO
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare la richiesta di rimborso é necessario che la\n              somma dei prodotti non superi la soglia massima di\n              " +
                                        _vm._s(
                                          _vm.contests.config.PREZZO_MASSIMO
                                        ) +
                                        "€\n            "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6 center" }, [
                        _vm.uploadFrontPercentage == 0
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary-1 uppercase pl-3 mb-0",
                                style:
                                  "background: " +
                                  _vm.contests.config.COLORE_MEDIO_SCURO +
                                  "!important",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.play()
                                  }
                                }
                              },
                              [
                                _c("a", [
                                  _vm._v("Registra richiesta di rimborso")
                                ])
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.mobileUpl
                        ? _c(
                            "div",
                            { staticClass: "col-md-6 center mt-2 pt-1 center" },
                            [
                              _vm.uploadFrontPercentage == 0
                                ? _c(
                                    "b",
                                    {
                                      staticClass:
                                        "hover underline color uppercase pl-3 mb-0",
                                      on: { click: _vm.logout }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Termina ed esegui il logout\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var step_2_prodotti_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center mb-1 pt-2 pt-5" }, [
      _c("h5", { staticClass: "uppercase" }, [
        _vm._v(
          "\n          Inserisci i/il prodotti/o presenti/e nello scontrino :\n        "
        )
      ])
    ])
  }
]
step_2_prodotti_render._withStripped = true
var step_2_prodotti_esExports = { render: step_2_prodotti_render, staticRenderFns: step_2_prodotti_staticRenderFns }
/* harmony default export */ var play_step_2_prodotti = (step_2_prodotti_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eda55834", step_2_prodotti_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/play/step_2_prodotti.vue
var step_2_prodotti_disposed = false
var step_2_prodotti_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var step_2_prodotti___vue_template_functional__ = false
/* styles */
var step_2_prodotti___vue_styles__ = null
/* scopeId */
var step_2_prodotti___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var step_2_prodotti___vue_module_identifier__ = null
var step_2_prodotti_Component = step_2_prodotti_normalizeComponent(
  step_2_prodotti,
  play_step_2_prodotti,
  step_2_prodotti___vue_template_functional__,
  step_2_prodotti___vue_styles__,
  step_2_prodotti___vue_scopeId__,
  step_2_prodotti___vue_module_identifier__
)
step_2_prodotti_Component.options.__file = "src/components/play/step_2_prodotti.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eda55834", step_2_prodotti_Component.options)
  } else {
    hotAPI.reload("data-v-eda55834", step_2_prodotti_Component.options)
  }
  module.hot.dispose(function (data) {
    step_2_prodotti_disposed = true
  })
})()}

/* harmony default export */ var components_play_step_2_prodotti = (step_2_prodotti_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/play/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var play_moment = __webpack_require__("PJh5");

/* harmony default export */ var components_play = ({
  name: "Play",
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a,
    STEP2PRODOTTI: components_play_step_2_prodotti
  },
  data: function data() {
    var _ref;

    return _ref = {
      loadingState: "",
      id: "",
      title: ""
    }, defineProperty_default()(_ref, "title", ""), defineProperty_default()(_ref, "main_image", ""), defineProperty_default()(_ref, "main_text", ""), defineProperty_default()(_ref, "regulation", ""), defineProperty_default()(_ref, "$viewer", ""), defineProperty_default()(_ref, "faq", ""), defineProperty_default()(_ref, "maxRegistration", 0), defineProperty_default()(_ref, "products_contest", []), defineProperty_default()(_ref, "contests", {}), defineProperty_default()(_ref, "disabledDates", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "step1Text", ""), defineProperty_default()(_ref, "step2Text", ""), defineProperty_default()(_ref, "step3Text", ""), defineProperty_default()(_ref, "step4Text", ""), defineProperty_default()(_ref, "call_support", ""), defineProperty_default()(_ref, "email_support", ""), defineProperty_default()(_ref, "award_name", ""), defineProperty_default()(_ref, "award_description", ""), defineProperty_default()(_ref, "qntErr", false), defineProperty_default()(_ref, "qntErr1", false), defineProperty_default()(_ref, "qntErrAtt", false), defineProperty_default()(_ref, "showProdError", false), defineProperty_default()(_ref, "start", ""), defineProperty_default()(_ref, "discount", ""), defineProperty_default()(_ref, "end", ""), defineProperty_default()(_ref, "start_", ""), defineProperty_default()(_ref, "numberOcr", false), defineProperty_default()(_ref, "amountOcr", false), defineProperty_default()(_ref, "end_", ""), defineProperty_default()(_ref, "products", [{
      index: "product" + 0,
      indexCount: "quantity" + 0,
      product: "",
      quantity: "",
      price: ""
    }]), defineProperty_default()(_ref, "token", ""), defineProperty_default()(_ref, "quantity", ""), defineProperty_default()(_ref, "wrongErr", false), defineProperty_default()(_ref, "priceError", false), defineProperty_default()(_ref, "totPrice", ""), defineProperty_default()(_ref, "priceCent", ""), defineProperty_default()(_ref, "price", ""), defineProperty_default()(_ref, "priceFocused", false), defineProperty_default()(_ref, "invoiceFrontBucket", ""), defineProperty_default()(_ref, "message", ""), defineProperty_default()(_ref, "invoiceFront", ""), defineProperty_default()(_ref, "it", locale["it"]), defineProperty_default()(_ref, "uploadFrontPercentage", 0), defineProperty_default()(_ref, "award_image", ""), defineProperty_default()(_ref, "loadingState", false), defineProperty_default()(_ref, "empty", false), defineProperty_default()(_ref, "notRegister", false), defineProperty_default()(_ref, "specific", ""), defineProperty_default()(_ref, "statusOCR", ""), defineProperty_default()(_ref, "change", false), defineProperty_default()(_ref, "mobileUpl", false), defineProperty_default()(_ref, "changeSecond", 0), defineProperty_default()(_ref, "award_type_", ""), defineProperty_default()(_ref, "award_type", ""), defineProperty_default()(_ref, "rebate", ""), defineProperty_default()(_ref, "sale_date", ""), defineProperty_default()(_ref, "sale_time", ""), defineProperty_default()(_ref, "amount", ""), defineProperty_default()(_ref, "priceEur", ""), defineProperty_default()(_ref, "number", ""), defineProperty_default()(_ref, "piva_shop", ""), defineProperty_default()(_ref, "shop", ""), defineProperty_default()(_ref, "id_image", ""), defineProperty_default()(_ref, "zip", ""), defineProperty_default()(_ref, "city", ""), defineProperty_default()(_ref, "modify", false), defineProperty_default()(_ref, "province", ""), defineProperty_default()(_ref, "ocrData", {}), defineProperty_default()(_ref, "type", ""), defineProperty_default()(_ref, "showProdError", false), defineProperty_default()(_ref, "minProduct", ""), defineProperty_default()(_ref, "maxSelOk", false), defineProperty_default()(_ref, "minPrice", ""), defineProperty_default()(_ref, "regex", ""), defineProperty_default()(_ref, "minErr", false), defineProperty_default()(_ref, "myAttempts", ""), defineProperty_default()(_ref, "discountClients", ""), defineProperty_default()(_ref, "pricenew", ""), defineProperty_default()(_ref, "errProd", false), defineProperty_default()(_ref, "canCon", false), defineProperty_default()(_ref, "INF", ""), defineProperty_default()(_ref, "reload", false), defineProperty_default()(_ref, "vw", window.innerWidth), defineProperty_default()(_ref, "imageData", {}), defineProperty_default()(_ref, "date", ""), defineProperty_default()(_ref, "time", {
      HH: "",
      mm: ""
    }), defineProperty_default()(_ref, "priceMod1", false), _ref;
  },

  methods: {
    loadProducts: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadingState = true;
                this.$track("loadProducts", "START");
                data = {
                  id: this.$route.params.id,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/loadProducts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this.$track("loadProducts", "SUECCESS");
                  _this.$track("loadProducts", [resp.data]);
                  var prod = [];
                  for (var x in resp.data) {
                    var y = [];
                    y["key"] = x;
                    y["label"] = resp.data[x];
                    y["value"] = resp.data[x];
                    prod.push(y);
                  }
                  _this.products_contest = resp.data;
                  _this.loadingState = false;
                }).catch(function (resp) {
                  _this.loadingState = false;
                  _this.$track("loadProducts", "ERROR");
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadProducts() {
        return _ref2.apply(this, arguments);
      }

      return loadProducts;
    }(),
    checkAccess: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _this2 = this;

        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.piva == this.$route.params.piva)) {
                  _context2.next = 8;
                  break;
                }

                this.$track("checkAccess", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  case: "PLAY",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context2.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/checkAccess",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this2.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this2.loadingState = false;
                  _this2.checkAccessOk = true;
                  _this2.$track("checkAccess", "SUCCESS");
                  _this2.$track("checkAccess", resp.data);
                  if (resp.data == "access_denied") {
                    _this2.message = '<b class="Bold">Non hai accesso a questa promozione</b>';
                    _this2.UploadError("", _this2.message);
                  } else if (resp.data == "no_promo_active") {
                    _this2.message = '<b class="Bold">La promozione a cui si sta cercando di accedere non è piú attiva</b>';
                    _this2.UploadError("", _this2.message);
                  }
                }).catch(function (err) {
                  _this2.loadingState = false;
                  _this2.$track("checkAccess", "ERROR");
                  err.response.data = _this2.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
                _context2.next = 9;
                break;

              case 8:
                this.$router.push("/");

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function checkAccess() {
        return _ref3.apply(this, arguments);
      }

      return checkAccess;
    }(),
    QRcode: function QRcode(token, userToken, piva) {
      var _this3 = this;

      this.loadingState = true;
      var text;
      var params;
      this.steps = token.replaceAll("/", "2TGRS2");
      this.steps1 = this.steps.replaceAll(".", "3MULTI3");
      this.idPass = "WERgt4r2sfr" + this.$route.params.id + "REWrfs2r4tg";
      var tkPssaggio = this.$encryptByAES(stringify_default()(this.userToken), "B%t$AD!YMfnCZnfD");
      this.tokenPass = "TOKhgsfddte" + tkPssaggio + "KOTnaskdue";
      params = this.idPass + "" + this.steps1 + "" + this.tokenPass;
      text = encodeURI("https://ubiqubit.it/staging/pharma" + "/uploadphone/" + params);
      this.$track("QRcode", "START");
      this.$track("QRcode", text);
      console.log("For QRCode: " + text);
      var data = {
        text: text,
        id_platform: "DcJ7J1WfiwucqBl_lierac",
        unique_key_db: "d971ad4ed27c5e76c0ccf95a",
        vector_unique_key_db: "lierac_global"
      };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      axios_default()({
        method: "POST",
        data: {
          data: data
        },
        url: "https://pharma.ubiqubit.it/" + "api/Qrcode",
        headers: {
          Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this3.loadingState = false;
        _this3.$track("QRcode", "SUCCESS");
        _this3.$track("QRcode", resp.data);
        _this3.$swal({
          html: '<h5 class="Bold black">Scannerizza il QRcode per caricare le immagini dal tuo telefono</h5>',
          width: 555,
          imageUrl: resp.data,
          allowOutsideClick: false,
          confirmButtonText: "CHIUDI",
          confirmButton: "closeProductsModal",
          confirmButtonClass: "btn btn-secondary",
          onClose: function onClose() {
            _this3.$router.push("/contest/" + _this3.$route.params.id + "/" + _this3.$route.params.piva + "/" + _this3.$route.params.cod);
          }
        });
      }).catch(function (resp) {});
    },
    waLog: function waLog(token, userToken, config) {
      if (this.getProfile.phone) {
        var newline = "%0a";
        var newlineD = "%0a%0a";
        var text = newline;
        text += "Benvenuto nella chat della piattaforma Laboratoire Native: Il suo codice farmacista è: " + this.getProfile.cod + '. In questa chat potrá effettuare i caricamenti per la promozione ' + config.title;
        if (config.config.AGGREGATE_PROMO) text += "Questa chat potrá essere utilizzata anche per il caricamento della promozione: " + config.config.AGGREGATE_PROMO_TITLE;
        var url = "https://wa.me/39" + config.config.WA_NUMBER + "?text=" + text;
        window.open(url, "_blank").focus();
      } else {
        this.$router.push("/phone/" + config.id + '/' + this.$encryptByAES(stringify_default()(play_moment()), "B%t$AD!YMfnCZnfD"));
      }
    },
    checkIfDuplicated: function checkIfDuplicated(content) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var data, res;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.$track("checkIfDuplicated", "START");
                data = {
                  content: content,
                  promoid: _this4.contests.id,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = _this4.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context3.next = 5;
                return axios_default()({
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/checkIfDuplicated",
                  method: "POST",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this4.$track("checkIfDuplicated", "SUCCESS");
                  resp.data = _this4.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  return true;
                }).catch(function (err) {
                  _this4.$track("checkIfDuplicated", "ERROR");
                  err.response.data = _this4.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  return false;
                });

              case 5:
                res = _context3.sent;
                return _context3.abrupt("return", res);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    saveOcrError: function saveOcrError(ocrErrors, type) {
      var _this5 = this;

      // OCR ERRORS DESCRIPTION
      var html = "";
      var _vue = this;

      this.calcInvoiceStatusOcr(ocrErrors);

      if (type == "afterOcr") {
        // AFTER OCR
        for (var i in ocrErrors) {
          if (ocrErrors[i].status == "KO") {
            if (ocrErrors[i].description) {
              html += '<h4 class="smallText">' + ocrErrors[i].description + "</h4>";
            }
            if (this.invoiceStatusOcr == 217) {
              html += "<br />Letta : [" + _vue.piva_shop + "]<br />Farmacia: [" + this.piva + "]";
            }
          }
        }

        var imageUrl = _vue.ocrData["invoiceFrontBucket"];
        var res = _vue.ocrData;
        var invData = res.data;
        var invImporto = res.importo;
        var invNumero = res.numero;
        var invOra = res.ora;
        var award = "";
        var action = "ocr_error";
      } else {
        // BEFORE OCR => dublicate
        this.$track(909);
        this.$track(ocrErrors);

        html += "Duplicato immagine con ID: " + ocrErrors.duplicated.duplicated_list[0].id + ' <a class="link" href="' + ocrErrors.duplicated.duplicated_list[0].url + '" target="_blank" style="color:red">FOTO</a>';
        this.invoiceStatusOcr = "250";
        var imageUrl = ocrErrors.duplicated.duplicated_list[0].url;
        var invData = "";
        var invImporto = "";
        var invNumero = "";
        var invOra = "";
        var award = "";
        var action = "duplicate_image";
      }

      // AWARD
      if (_vue.podium1Selected) {
        award = "x ";
      } else {
        award = "x ";
      }

      _vue.dataForError = {
        profile: this.profile,
        promo: this.contests,
        sdate_submit: play_moment().format("YYYY-MM-DD hh:mm:ss"),
        ttdate: invData,
        ttime: invOra,
        tvalue: invImporto,
        tnumber: "",
        rebate: "",
        ntk: "a47a065bee221a88306bafcd0c9b866cefb738ec",
        uid: "",
        products: "",
        receipts_uploads: [{ url1: imageUrl }],
        award: "",
        discountSpec: "",
        rebateSpec: "",
        ocrData: this.saveDataOcr,
        status: "error",
        INF: this.INF,
        code: _vue.invoiceStatusOcr,
        description: html,
        id_platform: "DcJ7J1WfiwucqBl_lierac",
        unique_key_db: "d971ad4ed27c5e76c0ccf95a",
        vector_unique_key_db: "lierac_global"
      };
      var data = _vue.dataForError;
      this.$track("saveOcrError", "START");
      this.$track("saveOcrError", data);
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      axios_default()({
        data: { data: data },
        url: "https://pharma.ubiqubit.it/" + "api/saveOcrError",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this5.$track("saveOcrError", "SUCCESS");
        resp.data = _this5.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
        _vue.invoiceFront = "";
        _vue.invoiceFrontName = "";
        _vue.invoiceFrontBucket = "";
        _vue.uploadFrontPercentage = 0;
        _vue.invoiceRear = "";
        _vue.invoiceRearName = "";
        _vue.invoiceRearBucket = "";
        _vue.ocrErrors = {};
        _vue.haveError = false;
      }).catch(function (err) {
        _this5.$track("saveOcrError", "ERROR");
        err.response.data = _this5.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
      });
    },
    checkSoftwareVersion: function checkSoftwareVersion() {
      console.log("CHECK VERSION SW ************");
      var version = localStorage.getItem("sw_version");

      if (!version) {
        console.log("VERSION NOT SAVED => " + version);
        version = false;
      } else {
        console.log("ACTUAL VERSION => " + version);
      }
      var data = {
        version: version,
        id_platform: "DcJ7J1WfiwucqBl_lierac",
        unique_key_db: "d971ad4ed27c5e76c0ccf95a",
        vector_unique_key_db: "lierac_global"
      };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      axios_default()({
        url: "https://pharma.ubiqubit.it/" + "api/checkSoftwareVersion",
        method: "POST",
        data: { data: data },
        headers: {
          Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        if (resp.data.version) {
          console.log("SERVER VERSION => " + resp.data.version);
          if (version != resp.data.version) {
            localStorage.setItem("sw_version", resp.data.version);
            window.location.reload();
          }
        }
      }).catch(function (error) {});
    },

    uploadFile: function uploadFile(input) {
      this.$track("uploadFile", "START");
      this.$track("uploadFile", input);
      this.inputFile = input;
      var file = input.target.files[0].name;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;
      this.filename1 = file;
      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("file", input.target.files[0]);
        var keyP = {
          unique_key_db: "d971ad4ed27c5e76c0ccf95a",
          vector_unique_key_db: "lierac_global",
          id_platform: "DcJ7J1WfiwucqBl_lierac"
        };
        if (true) keyP = this.$encryptByAES(stringify_default()(keyP), "B%t$AD!YMfnCZnfD");else keyP = _JSON$stringify(keyP);
        formData.append("key", keyP);
        axios_default.a.post("https://pharma.ubiqubit.it/" + "api/uploadImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.url)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.url;
            _vue.callOCR(e.data);
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = "";
          _vue.invoiceFrontBucket = "";
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },

    logout: function logout() {
      var _this6 = this;

      this.$store.dispatch(AUTH_LOGOUT).then(function () {
        return _this6.$router.push("/login");
      });
    },
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show() {
      var el = this.$refs.inv;
      var viewer = el.$viewer;
      viewer.show();
      viewer.zoomTo(2);
      viewer.move(-1, 0);
    },
    showError: function showError(text) {
      var _this7 = this;

      this.$swal({
        type: "error",
        title: '<strong class="Bold">Oops...</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: function onClose() {
          _this7.$router.push("/contest/" + _this7.$route.params.id + "/" + _this7.$route.params.piva + "/" + _this7.$route.params.cod);
        }
      });
    },
    resetForm: function resetForm() {
      var _this8 = this;

      var _vue = this;
      this.$validator.pause();
      this.mail = "";
      this.sdate_submit = "";
      this.ttdate = "";
      this.ttime = "";
      this.tvalue = "";
      this.tnumber = "";
      this.user_token = "";
      this.name = "";
      this.company = "";
      this.sname = "";
      this.piva = "";
      this.iban = "";
      this.address = "";
      this.tel = "";
      this.ntk = "";
      this.uid = "";
      this.receipts = "";
      this.ocrData = "";
      this.products = "";
      setTimeout(function () {
        _vue.checkProducts(1);
      }, 200);
      // CLEAR VALIDATOR AFTER REMOVE ALL VALUES
      this.$nextTick(function () {
        _this8.$validator.reset();
        _this8.$validator.errors.clear();
        _this8.$validator.resume();
      });
    },
    showPlay: function showPlay() {
      var _this9 = this;

      var _vue = this;
      var text = '<h5 class="text-center uppercase">L`inserimento della richiesta di rapi/pimborso é andata a buon fine.</h5> ';
      //text += '<p class="text-center Bold mt-1 pt-5">Ti verrá comunicato tramite mail l`esito della giocata e le istruzioni per ricevere il premio</p>'
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';

      var mySwal = this.$swal;
      mySwal({
        title: '<div class="col-12 center d-flex justify-content-center" style="width:700px"><div class="w-25 px-2 px-md-3 line-h4"><hr /></div><h4 class="text-center Bold">ESITO</h4><div class="w-25 px-2 px-md-3 line-h4"><hr /></div></div>',
        html: text,
        showCloseButton: true,
        width: 1000,
        //background: 'linear-gradient(180deg, black 0%, black 13%, #ed1b34 14%, #ed1b34 100%)',
        showConfirmButton: false,
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: function onClose() {
          if (_this9.mobileUpl) {
            window.location.reload();
          } else {
            _this9.$router.push("/contest/" + _this9.$route.params.id + "/" + _this9.$route.params.piva + "/" + _this9.$route.params.cod);
          }
        }
      });
    },
    doAcceptReg: function doAcceptReg(value) {
      this.$store.dispatch(ACCEPT_REG, value).then(function (resp) {});
    },
    UploadError: function UploadError(desc, specific) {
      var _this10 = this;

      this.$swal({
        type: "error",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          _this10.$router.push("/");
        }
      });
    },
    callOCR: function callOCR() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this11.getThisContest();

              case 2:
                //this.empty = true;
                if (!_this11.empty) {
                  _this11.$validator.validate().then(function (valid) {
                    if (valid && !_this11.countError) {
                      _this11.loadingState = true;
                      var img = _this11.invoiceFrontBucket;
                      var _vue = _this11;

                      axios_default()({
                        url: "https://api.ocrtag.com/receipt",
                        method: "POST",
                        data: {
                          icode: "lierac_global",
                          front: img
                        },
                        headers: {
                          Authorization: "Bearer " + "21a25071eaf6c5ef584ee179ea49b904f71dbc12a2f0",
                          "Content-type": "application/json"
                        }
                      }).then(function () {
                        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(resp) {
                          var _vue, newOCRResponce, notInvoice, x, y, z, c, responce, check, _check, ocrErrors, date, m, d, start, end, now, then, dif, duration, days, time, hour, minute, num, amount;

                          return regenerator_default.a.wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  _this11.$track("callOCR", "000");
                                  _vue = _this11;
                                  newOCRResponce = resp.data;
                                  notInvoice = false;

                                  _this11.$track("callOCR", resp.data);
                                  ///////////////////////////////////////////////////
                                  if (!newOCRResponce.hasOwnProperty("receipt")) {
                                    _this11.$track("callOCR", "OCR => RECEIPT NOT HAVE ANY DATA");
                                    x = {};

                                    x.date = "";
                                    x.time = "";
                                    x.number = "";
                                    x.amount = "";
                                    x.vatnum = "";
                                    x.shop = "";
                                    y = {};

                                    y.location;
                                    y.zip = "";
                                    y.province = "";
                                    x.address = y;
                                    newOCRResponce.content = "";
                                    z = {};

                                    z.status = "no";
                                    newOCRResponce.duplicated = z;
                                    c = {};

                                    c.status = "no";
                                    newOCRResponce.manipulated = c;
                                    newOCRResponce.receipt = x;
                                    notInvoice = true;
                                  }
                                  ////////////////////////////////////////////////
                                  _this11.$track("callOCR", "111");
                                  // REMOVE ALL EX RESULT
                                  _vue.price = "";
                                  _vue.priceCent = "";
                                  _vue.date = "";
                                  _vue.time.HH = "";
                                  _vue.time.mm = "";
                                  _vue.number = "";
                                  _vue.ocrResp = resp.data;
                                  _vue.haveError = false;
                                  _this11.$track("callOCR", "222");
                                  responce = {};

                                  responce.data = newOCRResponce.receipt.date;
                                  responce.ora = newOCRResponce.receipt.time;
                                  responce.numero = newOCRResponce.receipt.number;
                                  responce.importo = newOCRResponce.receipt.amount;
                                  responce.city = newOCRResponce.receipt.address.location;
                                  responce.zip = newOCRResponce.receipt.address.zip;
                                  responce.province = newOCRResponce.receipt.address.province;
                                  responce.products = {};
                                  responce.iva = newOCRResponce.receipt.vatnum;
                                  responce.issetProducts = true;
                                  responce.insegna = newOCRResponce.receipt.shop;
                                  responce.rows = newOCRResponce.content;
                                  responce.duplicated = newOCRResponce.duplicated;
                                  _vue.saveDataOcr = newOCRResponce.content;
                                  _vue.ocrData = responce;
                                  //////////////////////////////////////////////
                                  // CONVERT DUPLICATED AND MANIPULATED
                                  _vue.imageData.exif = {};
                                  _vue.imageData.exif.all_exif_data = {};
                                  _vue.imageData.custom_keys = "";
                                  check = true;

                                  if (!(newOCRResponce.duplicated.status == "yes")) {
                                    _context4.next = 42;
                                    break;
                                  }

                                  _context4.next = 39;
                                  return _vue.checkIfDuplicated(newOCRResponce.content);

                                case 39:
                                  _check = _context4.sent;

                                  _this11.$track("callOCR", "check if duplicated => " + _check);
                                  if (!_check) {
                                    _vue.statusOCR = "KO";
                                    _vue.showDublicateImage(_vue.filename1);
                                    // SAVE PLAY
                                    _vue.saveOcrError(responce, "beforeOcr");
                                    _vue.uploadFrontPercentage = 0;
                                    _vue.invoiceFront = "";
                                    _vue.invoiceFrontBucket = "";
                                    //_vue.input = input;
                                    _vue.filename1 = "";
                                    //input.value = null;
                                    _vue.loadingState = false;
                                    _vue.ocrResult = "KO";
                                    if (_vue.invoiceRearBucket) {
                                      _vue.uploadRearPercentage = 0;
                                      _vue.invoiceRear = "";
                                      _vue.invoiceRearBucket = "";
                                      _vue.input2 = null;
                                      _vue.filename2 = "";
                                    }
                                  }

                                case 42:
                                  _this11.$track("callOCR", "223");
                                  if (check) {
                                    _vue.softCheck = "";
                                    // CHECK SOFT AND Tags
                                    if (newOCRResponce.manipulated.status == "yes") {
                                      _vue.softCheck += newOCRResponce.manipulated.type;
                                      _vue.invoiceStatus = "601";
                                    }
                                    ocrErrors = {
                                      date: {
                                        status: "KO",
                                        error: false,
                                        description: false
                                      },
                                      time: {
                                        status: "KO",
                                        error: false,
                                        description: false
                                      },
                                      number: {
                                        status: "KO",
                                        error: false,
                                        description: false
                                      },
                                      amount: {
                                        status: "KO",
                                        error: false,
                                        description: false
                                      },
                                      iva: {
                                        status: "KO",
                                        error: false,
                                        description: false
                                      },
                                      count: 0
                                    };
                                    // **********************************************************************************************
                                    ////////////////////////////////////////
                                    ////////////////////////////////////////
                                    // DATE CONTROL
                                    ////////////////////////////////////////

                                    if (responce.data) {
                                      date = play_moment(responce.data, "DD/MM/YYYY");
                                      // check if date is valid

                                      if (date.isValid()) {
                                        y = date.format("YYYY");
                                        m = date.format("MM");
                                        d = date.format("DD");


                                        if (y > 2301) {
                                          ocrErrors.date.error = "invalid_date";
                                          _vue.ocrData.data = "";
                                          ocrErrors.count = ocrErrors.count + 1;
                                          ocrErrors.date.description = "La data dello scontrino non valida";
                                          _vue.haveError = true;
                                        } else if (m > 12) {
                                          ocrErrors.date.error = "invalid_date";
                                          _vue.ocrData.data = "";
                                          ocrErrors.count = ocrErrors.count + 1;
                                          ocrErrors.date.description = "La data dello scontrino non valida";
                                          _vue.haveError = true;
                                        } else if (d > 31) {
                                          ocrErrors.date.error = "invalid_date";
                                          _vue.ocrData.data = "";
                                          ocrErrors.count = ocrErrors.count + 1;
                                          ocrErrors.date.description = "La data dello scontrino non valida";
                                          _vue.haveError = true;
                                        } else {
                                          // check if date in period of promo
                                          start = play_moment(_vue.start_rec, "DD/MM/YYYY");
                                          end = play_moment(_vue.end_rec, "DD/MM/YYYY");
                                          now = play_moment();
                                          then = play_moment(date);
                                          dif = then.diff(now);
                                          duration = play_moment.duration(dif, "milliseconds");
                                          days = duration.asDays();

                                          if (date >= start && date <= end) {
                                            ocrErrors.date.status = "OK";
                                            _vue.date = date.format("YYYY-MM-DD");
                                            _this11.$track("callOCR", "Data: " + _vue.date);
                                            /*if (days < -6) {
                                            ocrErrors.date.error = "not_play_period";
                                            ocrErrors.count = ocrErrors.count + 1;
                                            ocrErrors.date.description =
                                              "Sono passati piú di 5 giorni compreso oggi dalla data di acquisto riportata sul documento di vendita";
                                            ocrErrors.date.status = "KO";
                                            }*/
                                          } else {
                                            ocrErrors.date.error = "not_play_period";
                                            ocrErrors.count = ocrErrors.count + 1;
                                            ocrErrors.date.description = "La data dello scontrino non rientra nel periodo del concorso";
                                            _vue.haveError = true;
                                            ocrErrors.date.status = "KO";
                                          }
                                        }
                                      } else {
                                        ocrErrors.date.error = "invalid_date";
                                        _vue.ocrData.data = "";
                                        ocrErrors.count = ocrErrors.count + 1;
                                        ocrErrors.date.description = "La data dello scontrino non valida";
                                        _vue.haveError = true;
                                      }
                                    } else {
                                      ocrErrors.count = ocrErrors.count + 1;
                                      ocrErrors.date.error = "missing_date";
                                      ocrErrors.date.description = "La data dello scontrino mancante";
                                      _vue.haveError = true;
                                      ocrErrors.date.status = "KO";
                                    }
                                    ////////////////////////////////////////
                                    ////////////////////////////////////////
                                    // TIME CONTROL
                                    ////////////////////////////////////////
                                    if (newOCRResponce.receipt.type != "ddc") {
                                      if (responce.ora) {
                                        time = responce.ora;
                                        hour = time.substring(0, 2);
                                        minute = time.substring(3, 5);

                                        if (parseInt(hour) >= 0 && parseInt(hour) <= 24 && minute >= 0 && minute <= 60) {
                                          //_vue.time.HH = hour
                                          //_vue.time.mm = minute
                                          _vue.time = { HH: hour, mm: minute };
                                          ocrErrors.time.status = "OK";
                                          _vue.ocrData.ora = 200;
                                        } else {
                                          ocrErrors.time.error = "invalid_time";
                                          ocrErrors.count = ocrErrors.count + 1;
                                          ocrErrors.time.description = "L`ora dello scontrino non valida";
                                          _vue.haveError = true;
                                          _vue.time = {};
                                          _vue.ocrData.ora = "";
                                        }
                                      } else {
                                        ocrErrors.count = ocrErrors.count + 1;
                                        ocrErrors.time.error = "missing_time";
                                        ocrErrors.time.description = "L`ora dello scontrino mancante";
                                        _vue.haveError = true;
                                      }
                                    } else {
                                      ocrErrors.time.status = "OK";
                                      _vue.time = { HH: "00", mm: "00" };
                                    }
                                    _this11.$track("callOCR", "Ora: " + hour + ":" + minute);
                                    ////////////////////////////////////////
                                    /////////////////////////////////////////
                                    // NUMBER CONTROL
                                    ///////////////////////////////////////
                                    if (responce.numero) {
                                      num = responce.numero;

                                      num = num.toString();
                                      num = num.replace("-", "");
                                      _vue.number = num;
                                      ocrErrors.number.status = "OK";
                                    } else {
                                      ocrErrors.count = ocrErrors.count + 1;
                                      ocrErrors.number.error = "missing_number";
                                      ocrErrors.number.description = "Numero dello scontrino mancante";
                                      _vue.haveError = true;
                                    }
                                    _this11.$track("callOCR", "Numero: " + _vue.number);
                                    ////////////////////////////////////////
                                    ///////////////////////////////////////
                                    // AMMOUNT CONTROL
                                    ///////////////////////////////////////
                                    if (responce.importo) {
                                      amount = responce.importo.split(",");

                                      ocrErrors.amount.status = "OK";
                                      _vue.price = amount[0];
                                      _vue.priceCent = amount[1];

                                      if (parseInt(_vue.price) < Object({"NODE_ENV":"production","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"55H$yGS8e8$PSY","ID_PLATFORM":"DcJ7J1WfiwucqBl_lierac","HAS_CONFIRM_POPUP":true,"HAS_IBAN_BEFORE_LOG":false,"LOGIN_WITH_EMAIL":false,"CODE_BEFORE_LOG":false,"HAS_OCR":true,"AUTH_TOKEN":"a47a065bee221a88306bafcd0c9b866cefb738ec","GTAGEVENT":"off","SENDTO":"G-3J0H2NL5XM/9newCKCi0osCELns6LoC","GTMSTATUS":"off","GTM":"GTM-P789JK4","GTAGAWSTATUS":"off","GTAGAW":"AW-660223545","GTAGSTATUS":"off","GTAG":"G-3J0H2NL5XM","COOKIEBOT":false,"COOKIEBOTKEY":"ddc9d39a-ca3b-4fe0-be69-f7b35d841e20","ROOT_API":"https://pharma.ubiqubit.it/","API_TOKEN":"21a25071eaf6c5ef584ee179ea49b904f71dbc12a2f0","ICODE":"lierac_global","UNIQUE_KEY_DB":"d971ad4ed27c5e76c0ccf95a","CRYPT":"ON","DIRECTORY":"https://ubiqubit.it/staging/pharma","MSG_ACCOUNT_CONFIRMED":"Il tuo account è stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"L`ndirizzo e-mail non è presente nel nostro sistema","TOKEN_NOT_EXIST":"Il token è scaduto o non è presente","START":"2021-07-01 00:00:00","START_INTERMEDIO":"2021-09-01 00:00:00","FINISH":"2029-09-18 00:00:00"}).OCR_MIN_AMOUNT) {
                                        ocrErrors.amount.status = "KO";
                                        ocrErrors.amount.error = "price_less";
                                        ocrErrors.amount.description = "Importo dello scontrino è inferiore a " + Object({"NODE_ENV":"production","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"55H$yGS8e8$PSY","ID_PLATFORM":"DcJ7J1WfiwucqBl_lierac","HAS_CONFIRM_POPUP":true,"HAS_IBAN_BEFORE_LOG":false,"LOGIN_WITH_EMAIL":false,"CODE_BEFORE_LOG":false,"HAS_OCR":true,"AUTH_TOKEN":"a47a065bee221a88306bafcd0c9b866cefb738ec","GTAGEVENT":"off","SENDTO":"G-3J0H2NL5XM/9newCKCi0osCELns6LoC","GTMSTATUS":"off","GTM":"GTM-P789JK4","GTAGAWSTATUS":"off","GTAGAW":"AW-660223545","GTAGSTATUS":"off","GTAG":"G-3J0H2NL5XM","COOKIEBOT":false,"COOKIEBOTKEY":"ddc9d39a-ca3b-4fe0-be69-f7b35d841e20","ROOT_API":"https://pharma.ubiqubit.it/","API_TOKEN":"21a25071eaf6c5ef584ee179ea49b904f71dbc12a2f0","ICODE":"lierac_global","UNIQUE_KEY_DB":"d971ad4ed27c5e76c0ccf95a","CRYPT":"ON","DIRECTORY":"https://ubiqubit.it/staging/pharma","MSG_ACCOUNT_CONFIRMED":"Il tuo account è stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"L`ndirizzo e-mail non è presente nel nostro sistema","TOKEN_NOT_EXIST":"Il token è scaduto o non è presente","START":"2021-07-01 00:00:00","START_INTERMEDIO":"2021-09-01 00:00:00","FINISH":"2029-09-18 00:00:00"}).OCR_MIN_AMOUNT + " Euro";
                                        ocrErrors.count = ocrErrors.count + 1;
                                        _vue.haveError = true;
                                      }
                                    } else {
                                      ocrErrors.count = ocrErrors.count + 1;
                                      ocrErrors.amount.error = "missing_amount";
                                      ocrErrors.amount.description = "Importo dello scontrino mancante";
                                      _vue.haveError = true;
                                    }
                                    _this11.$track("callOCR", "Prezzo: " + _vue.price);
                                    ///////////////////////////////////////
                                    //////////////////////////////////////
                                    //P.IVA
                                    ///////////////////////////////////////
                                    if (_this11.group != 1) {
                                      if (responce.iva) {
                                        if (responce.iva != _this11.piva) {
                                          ocrErrors.count = ocrErrors.count + 1;
                                          ocrErrors.iva.error = "piva_not_correspond";
                                          ocrErrors.iva.description = "La partita iva dello scontrino caricato non corrisponde con la partita iva del tuo negozio";
                                          _vue.haveError = true;
                                        } else {
                                          _this11.$track("callOCR", "Il Negozio: " + _this11.piva);
                                          ocrErrors.iva.status = "OK";
                                        }
                                      } else {
                                        ocrErrors.count = ocrErrors.count + 1;
                                        ocrErrors.iva.error = "piva_not_correspond";
                                        ocrErrors.iva.description = "Purtroppo questa prova d'acquisto non sembra includere alcun punto vendita aderente all'iniziativa";
                                        _vue.haveError = true;
                                      }
                                    } else {
                                      _this11.$track("callOCR", "Gruppo di Piva :" + _this11.piva + " gruppo : " + _this11.group);
                                      ocrErrors.iva.status = "OK";
                                      if (responce.iva) {
                                        _vue.softCheck += "Farmacia associata ad un gruppo<br /><br />Letta : [" + responce.iva + "]<br />Farmacia: [" + _this11.piva + "]";
                                      } else {
                                        _vue.softCheck += "Farmacia associata ad un gruppo<br /><br />Non rilevata <br />Farmacia: [" + _this11.piva + "]";
                                      }
                                    }
                                    _this11.$track("callOCR", "Partita iva letta: " + responce.piva);
                                    _this11.$track("callOCR", "Partita iva mia: " + _vue.piva);
                                    ////////////////////////////////////////
                                    ////////////////////////////////////////
                                    console.error(ocrErrors);
                                    // **********************************************************************************************
                                    if (ocrErrors.amount.error != "price_less" && ocrErrors.count <= 2 && ocrErrors.date.error != "not_play_period" && ocrErrors.iva.error != "piva_not_correspond" && (ocrErrors.date.status == "OK" && ocrErrors.time.status == "OK" || ocrErrors.date.error == "invalid_date" && ocrErrors.time.status == "OK" || ocrErrors.time.error == "invalid_time" && ocrErrors.date.status == "OK" || ocrErrors.date.status == "OK" && ocrErrors.time.status == "KO")) {
                                      if (ocrErrors.amount.status == "KO" && ocrErrors.number.status == "KO") {
                                        _vue.invoiceStatus = "605";
                                      }
                                      if (ocrErrors.amount.status == "OK" && ocrErrors.number.status == "KO") {
                                        _vue.invoiceStatus = "604";
                                      }
                                      if (ocrErrors.amount.status == "KO" && ocrErrors.number.status == "OK") {
                                        _vue.invoiceStatus = "603";
                                      }

                                      _vue.ocrErrors = ocrErrors;
                                      _vue.ocrResult = "OK";
                                      _vue.statusOCR = "OK";
                                      _vue.uploadFrontPercentage = 0;
                                      _vue.uploadRearPercentage = 0;
                                      _vue.invoiceFrontBucket = img;
                                      _vue.loadingState = false;
                                      setTimeout(function () {
                                        _vue.$validator.validate();
                                      }, 2000);
                                    } else {
                                      if (notInvoice) {
                                        _vue.invoiceStatusOcr = "606";
                                      }
                                      // rewrite data to variable
                                      _vue.ocrData["invoiceFrontBucket"] = _vue.invoiceFrontBucket;
                                      _vue.loadingState = false;
                                      _vue.ocrResult = "KO";
                                      _vue.ocrErrors = ocrErrors;
                                      _vue.uploadFrontPercentage = 0;
                                      _vue.invoiceFront = "";
                                      _vue.invoiceFrontBucket = "";
                                      _vue.input = null;
                                      _vue.filename1 = "";
                                      if (_vue.invoiceRearBucket) {
                                        _vue.uploadRearPercentage = 0;
                                        _vue.invoiceRear = "";
                                        _vue.invoiceRearBucket = "";
                                        _vue.input2 = null;
                                        _vue.filename2 = "";
                                      }
                                      _vue.saveOcrError(_vue.ocrErrors, "afterOcr");
                                      _vue.showErrorOCR(_vue.ocrErrors);
                                    }
                                  }

                                  //}

                                case 44:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4, _this11);
                        }));

                        return function (_x) {
                          return _ref4.apply(this, arguments);
                        };
                      }()).catch(function (resp) {
                        //_vue.UploadError(resp.response.data.description);
                        _vue.loadingState = false;
                      });
                    } else {
                      //this.$scrollTo('#' + this.errors.items[0].field, 700, {offset: -170})
                    }
                  });
                }

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    showDublicateImage: function showDublicateImage(img) {
      this.$swal({
        type: "error",
        title: "Ops!",
        html: '<p class="center smallText">Lo scontrino</p> <p class="center smallText"></p><p class="center smallText"> risulta essere già caricato</p>',
        confirmButtonText: "CHIUDI",
        onClose: function onClose() {
          window.location.reload();
        }
      });
    },
    showErrorOCR: function showErrorOCR(text) {
      var _this12 = this;

      var html = '<p class="smallText text-left">Nell`immagine caricata:</p><ul>';
      var x = 0;
      var z = 0;
      for (var i in text) {
        if (text[i].status == "KO") {
          if (text[i].description) {
            html += '<li class="smallText text-left">' + text[i].description + "</li>";
          }

          x++;
        }
      }
      html += "</ul>";
      if (x >= 4) {
        html = '<p class="smallText text-left">Purtroppo l`immagine caricata non sembra essere quella di un scontrino.</p>';
        html += '<ul><li class="smallText text-left">I dati sullo scontrino devono essere ben visibili.</li>';
        html += '<li class=" smallText text-left mt-2">Se lo scontrino è troppo lungo, piegalo a fisarmonica per mostrare solo i dati necessari</li></ul> ';
        html += '<li class=" smallText text-left mt-2">La foto caricata deve avere un peso compreso fra 12KB e 10MB</li></ul> ';
        html += '<p class="smallText text-left mt-3">Prova a rifare la foto e ricarica lo scontrino</p> ';
        z = 4;
      } else if (x <= 3) {
        html += '<p class="smallText text-left">Attenzione!</p>';
        if (x == 1 && text.date.error == "not_play_period") {
          // IF ONLY DATE OUT OF PERIOD
          // html += '<ul><li class="smallText text-left">Sono passati piú di 5 giorni compreso oggi dalla data di acquisto riportata sul documento di vendita.</li></ul>'
        } else {
          // IF MANY ERRORS
          html += '<ul><li class="smallText text-left">I dati sullo scontrino devono essere ben visibili.</li>';
          html += '<li class=" smallText text-left mt-2">Se lo scontrino è troppo lungo piegalo a fisarmonica per mostrare solo i dati necessari</li>';
          html += '<li class=" smallText text-left mt-2">La foto caricata deve avere un peso compreso fra 12KB e 10MB</li></ul> ';
          html += '<p class="smallText text-left mt-3">Prova a rifare la foto e ricarica lo scontrino</p> ';
        }
      }
      this.$swal({
        type: "error",
        title: '<strong class="">Ops!</strong>',
        html: html,
        confirmButtonText: "Esempio scontrino",
        confirmButtonColor: "#15267",
        showCancelButton: true,
        cancelButtonText: "Chiudi",
        cancelButtonColor: "black"
      }).then(function (okay) {
        if (okay.dismiss) {
          window.location.reload();
        }
        if (okay.value) {
          _this12.$swal.fire({
            imageUrl: __webpack_require__("7p5c"),
            imageAlt: "A tall image",
            width: "70%",
            imageClass: "image-margin0",
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "Chiudi",
            cancelButtonColor: "black",
            onClose: function onClose() {
              window.location.reload();
            }
          });
        }
      }).catch(function (resp) {
        window.location.reload();
      });
    },
    calcInvoiceStatusOcr: function calcInvoiceStatusOcr(ocrErrors) {
      var errors = ocrErrors;

      if (errors.count) {
        if (errors.count == 4) {
          this.invoiceStatusOcr = "606";
        } else if (errors.count == 3) {
          // OK DATA
          if (errors.date.status == "OK") {
            this.invoiceStatusOcr = "611";
          }
          // OK ORA
          if (errors.time.status == "OK") {
            this.invoiceStatusOcr = "612";
          }
          // OK IMPORTO
          if (errors.amount.status == "OK") {
            this.invoiceStatusOcr = "608";
          }
          // OK NUMERO
          if (errors.number.status == "OK") {
            this.invoiceStatusOcr = "607";
          }
        } else if (errors.count == 2) {
          // IF I AM HERE => ONLY DATA ORA MISSING
          this.invoiceStatusOcr = "609";
        }

        if (errors.date.error == "not_play_period") {
          this.invoiceStatusOcr = "610";
        }
        if (errors.iva.error == "piva_not_correspond") {
          this.invoiceStatusOcr = "617";
        }
      }
    },

    getThisContest: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _this13 = this;

        var data;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContest", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ACTIVE",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context6.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this13.loadingState = false;
                  resp.data = _this13.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this13.$track("getThisContest", "SUCCESS");
                  if (resp.data) {
                    _this13.empty = false;
                  }
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  _this13.contests = resp.data[0];

                  _this13.type = _this13.contests.config.TIPOLOGIA_RIEPILOGO;
                  _this13.start_ = _this13.contests.start;
                  _this13.start = play_moment(_this13.start_).format("DD-MM-YYYY");
                  _this13.end_ = _this13.contests.end;
                  _this13.end = play_moment(_this13.end_).format("DD-MM-YYYY");
                  _this13.startRec_ = _this13.contests.startRec;
                  _this13.start_rec = play_moment(_this13.startRec_).format("DD/MM/YYYY");
                  _this13.endRec_ = _this13.contests.endRec;
                  _this13.end_rec = play_moment(_this13.endRec_).format("DD/MM/YYYY");

                  _this13.now = play_moment();
                  var then = play_moment(_this13.end_);

                  var dif = then.diff(_this13.now);
                  if (dif <= 0) {
                    _this13.finish = true;
                    _this13.countdown = 0 - dif;
                  } else {
                    _this13.countdown = dif;
                  }
                  _this13.$track("getThisContest", _this13.contests);
                }).catch(function (err) {
                  _this13.loadingState = false;
                  err.response.data = _this13.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this13.$track("getThisContest", "ERROR");
                });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getThisContest() {
        return _ref5.apply(this, arguments);
      }

      return getThisContest;
    }(),
    takeMyAttempts: function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var _this14 = this;

        var data;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.loadingState = true;
                this.$track("takeMyAttempts", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  promo: this.contests,
                  desc: this.contests.config.DESTINAZIONE_SCONTO,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context7.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/takeMyAttempts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this14.loadingState = false;
                  _this14.$track("takeMyAttempts", "SUCCESS");
                  resp.data = _this14.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this14.$track("takeMyAttempts -> MY", resp.data);
                  _this14.$track("takeMyAttempts -> MAX", _this14.maxRegistration);
                  _this14.my_registration_in_promo = resp.data.countMyAttempts;
                  if (_this14.my_registration_in_promo >= _this14.maxRegistration) {
                    _this14.$track("takeMyAttempts -> RAGGIUNTO MASSIMO", _this14.my_registration_in_promo + " >= " + _this14.maxRegistration);
                    _this14.notRegister = true;
                    var _vue = _this14;
                    var text;
                    var text = '<h5 class="text-center uppercase red">Hai raggiunto il numero massimo di richieste di rimborso disponibili per questa promozione</h5> ';
                    text += '<p class="text-center Bold mt-1 pt-5 red">Il numero massimo di richieste di rimborso per questa promozione é <h3 class="bordered back-color-1 white">' + _this14.maxRegistration + "</h3></p>";
                    var mySwal = _this14.$swal;
                    mySwal({
                      html: text,
                      showCloseButton: true,
                      width: 555,
                      color: "red",
                      showConfirmButton: false,
                      confirmButton: "closeProductsModal",
                      confirmButtonClass: "btn btn-secondary",
                      onClose: function onClose() {
                        _this14.$router.push("/contest/" + _this14.$route.params.id + "/" + _this14.$route.params.piva + "/" + _this14.$route.params.cod);
                      }
                    });
                  }
                }).catch(function (err) {
                  _this14.loadingState = false;
                  _this14.$track("takeMyAttempts", "ERROR");
                  err.response.data = _this14.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function takeMyAttempts() {
        return _ref6.apply(this, arguments);
      }

      return takeMyAttempts;
    }(),

    setProfileData: function setProfileData() {
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.userToken;
      this.token = this.profile.password;
      this.piva = this.profile.piva;
      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.group = this.profile.groupPh;
      this.cod_client = this.profile.cod;
      this.profileId = this.profile.id;
    },
    showConfirmReg: function showConfirmReg() {
      var _this15 = this;

      var reg = this.accepted_regulations;

      if (reg[this.id]) {} else {
        this.$swal({
          type: "info",
          title: "Consenso necessario",
          html: '<p class="black">cliccando su conferma si accettano il <a class="link underline" target="_blank" href="' + this.contests.config.REGOLAMENTO + '" style="color: blue;"> termini e le condizioni di questa promozione </a>',
          confirmButtonText: "CONFERMA",
          confirmButton: "closeProductsModal",
          onClose: function onClose() {
            _this15.$store.dispatch(ACCEPT_REG, _this15.id);
          }
        });
      }
    },

    activateMod: function activateMod(param) {
      this.modify = true;
      this.change = false;
      this.pricenew = param;
    },
    deactivateMod: function deactivateMod() {
      var _vue = this;
      this.pricenew = "";
      setTimeout(function () {
        _vue.modify = false;
      }, 100);
    },
    selectChange: function selectChange(param) {
      this.change = true;
      this.errProd = false;
    },
    priceMod: function priceMod(param) {
      var _vue = this;
      this.changeSecond = param;
    },

    myRegistration: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var _this16 = this;

        var data;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.piva != this.$route.params.piva)) {
                  _context8.next = 3;
                  break;
                }

                _context8.next = 8;
                break;

              case 3:
                this.$track("myRegistration", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  promo: this.contests,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context8.next = 8;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/myRegistration",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this16.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this16.$track("myRegistration", "SUCCESS");
                  _this16.$track("myRegistration", resp.data);
                  if (resp.data) {
                    _this16.maxRegistration = parseInt(resp.data[0].bonus) + parseInt(resp.data[0].extra_bonus);
                    _this16.maxRegistrationOr = parseInt(resp.data[0].bonus);
                  }
                }).catch(function (err) {
                  _this16.$track("myRegistration", "ERROR");
                  err.response.data = _this16.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function myRegistration() {
        return _ref7.apply(this, arguments);
      }

      return myRegistration;
    }(),
    calcToDate: function calcToDate() {
      var _vue = this;
      var startRecDate = {
        year: play_moment(_vue.startRec_).year(),
        month: play_moment(_vue.startRec_).month(),
        day: play_moment(_vue.startRec_).day()
      };
      var start = startRecDate;
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = startDate;
      }
      return finalTo;
    },
    calcFromDate: function calcFromDate() {
      var _vue = this;
      var endRecDate = {
        year: play_moment(_vue.endRec_).year(),
        month: play_moment(_vue.endRec_).month(),
        day: play_moment(_vue.endRec_).day()
      };
      var stopObj = endRecDate;
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    }
  },
  /********************************************************************************************* */
  watch: {
    "$route.params.id": {
      handler: function handler(id) {
        if (this.loaded) {
          //window.location.reload()
        }
      },
      deep: true,
      immediate: true
    },
    "$route.params.piva": {
      handler: function handler(id) {
        if (this.loaded) {
          //window.location.reload()
        }
      },
      deep: true,
      immediate: true
    },
    "$route.params.phone": {
      handler: function handler(id) {
        if (this.loaded) {
          //window.location.reload()
        }
      },
      deep: true,
      immediate: true
    },
    products: {
      handler: function handler(val) {
        var _vue = this;
        setTimeout(function () {
          //for ( var x in val ){
          if (_vue.productList[0]) {
            if (_vue.change) {
              _vue.products[_vue.changeSecond].price = "";
            }
            if (_vue.products[_vue.changeSecond].product && !_vue.products[_vue.changeSecond].price && !_vue.modify && _vue.pricenew == "") {
              _vue.products[_vue.changeSecond].price = "" + _vue.productList[0][_vue.products[_vue.changeSecond].product];
              _vue.change = false;
            }
          }
          _vue.products[_vue.changeSecond].price = val[_vue.changeSecond].price.replace(",", ".");
          _vue.products[_vue.changeSecond].price = val[_vue.changeSecond].price.replace(/[`~!@#$£%^&*()_|+\-=?;:",<>\{\}\[\]\\\/]/gi, "");
          //}
        }, 100);
        this.checkProducts();
        this.calcTotPrice();
      },

      deep: true
    },
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.checkAccess();
      this.myRegistration();
      this.loadProducts();
    }
  },
  mounted: function mounted() {
    this.checkSoftwareVersion();
    var id = this.$route.params.id;

    this.id = id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    this.loadProducts();
    if (!piva || !cod) {
      this.$router.push("/");
    }
    this.setProfileData();
    if (this.getProfile.piva) {
      this.setProfileData();
      this.checkAccess();
      this.myRegistration();

      var _vue = this;
    }
    if (this.$route.params.phone == 1) {
      this.mobileUpl = true;
    }

    //this.getThisContest()
    var _vue = this;
    //_vue.setProfileData()
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);

    //this.takeMyAttempts()
    setTimeout(function () {
      _vue.disabledDates = {
        to: _vue.calcToDate(), // Disable all dates up to specific date
        from: _vue.calcFromDate() // Disable all dates after specific date
      };

      _vue.scrollFinished = true;
    }, 1500);
  },
  created: function () {
    var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.getThisContest();

            case 2:
              _context9.next = 4;
              return this.setProfileData();

            case 4:
              this.takeMyAttempts();
              this.showConfirmReg();

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function created() {
      return _ref8.apply(this, arguments);
    }

    return created;
  }(),
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies", "accepted_regulations"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f59cc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/play/index.vue
var play_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widthFull h-100 somatoline pb-5 back-1",
      attrs: { id: "top" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-5 pt-5" }, [
        _vm.contests.config
          ? _c("div", { staticClass: "col-12 center" }, [
              _c("img", {
                staticClass: "img img-fluid",
                attrs: { src: _vm.contests.config.LOGO_INTERNO }
              })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.empty && !_vm.notRegister
        ? _c(
            "div",
            { staticClass: "container", class: { "mt-5": _vm.vw > 700 } },
            [
              _c(
                "div",
                { staticClass: "back-white row justify-content-center mt-5" },
                [
                  _vm.vw > 700
                    ? _c("div", { staticClass: "col-10 Bold mb-3" }, [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "back-white color uppercase center padd"
                          },
                          [
                            _c("h5", [_vm._v("Promozione:")]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.contests.title) +
                                "\n        "
                            )
                          ]
                        )
                      ])
                    : _c("div", { staticClass: "col-12 Bold mb-3" }, [
                        _c("small", { staticClass: "color uppercase Bold" }, [
                          _vm._v("Promozione: ")
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "back-white black" }, [
                          _vm._v(_vm._s(_vm.contests.title))
                        ])
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-5 center",
                      class: { "pt-5": _vm.vw > 700 }
                    },
                    [
                      _c(
                        "form",
                        {
                          class: { "mt-2": _vm.vw > 700 },
                          attrs: {
                            id: "edit-user-form",
                            autocomplete: "qwerqrt"
                          },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.callOCR.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm.statusOCR != "OK"
                            ? _c(
                                "label",
                                {
                                  staticClass:
                                    "lable-style-custom h4 Bold uppercase",
                                  attrs: { for: "tappa" }
                                },
                                [_vm._v("Carica la foto dello scontrino:")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statusOCR == "OK"
                            ? _c(
                                "label",
                                {
                                  staticClass:
                                    "lable-style-custom h4 Bold uppercase",
                                  attrs: { for: "tappa" }
                                },
                                [_vm._v("Premi sulla foto per ingrandirla")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row justify-content-center mb-5" },
                            [
                              _c(
                                "div",
                                {
                                  class: {
                                    "group front-image center mt-3 ": !_vm.invoiceFrontBucket,
                                    "group front-image-1 center mt-5":
                                      _vm.invoiceFrontBucket
                                  }
                                },
                                [
                                  !_vm.invoiceFrontBucket
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              size: 10240,
                                              ext: [
                                                "jpeg",
                                                "jpg",
                                                "png",
                                                "pdf"
                                              ],
                                              mimes: [
                                                "image/jpeg",
                                                "image/jpg",
                                                "image/png",
                                                "application/pdf"
                                              ]
                                            },
                                            expression:
                                              "{\n                  required: true,\n                  size: 10240,\n                  ext: ['jpeg', 'jpg', 'png', 'pdf'],\n                  mimes: [\n                    'image/jpeg',\n                    'image/jpg',\n                    'image/png',\n                    'application/pdf',\n                  ],\n                }"
                                          }
                                        ],
                                        ref: "invoice",
                                        staticClass: "fileInput",
                                        class: {
                                          "is-invalid": _vm.errors.has(
                                            "invoice"
                                          ),
                                          valid: !!_vm.invoiceFront,
                                          helper: !!_vm.invoiceFrontBucket
                                        },
                                        attrs: {
                                          type: "file",
                                          name: "invoice",
                                          id: "invoice",
                                          "data-vv-as": "Scontrino"
                                        },
                                        on: { change: _vm.uploadFile }
                                      })
                                    : _c("input", {
                                        attrs: { type: "file", disabled: "" }
                                      }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoice" }
                                    },
                                    [
                                      !_vm.invoiceFrontBucket
                                        ? _c("span", [_vm._v("Scegli")])
                                        : _vm.invoiceFrontBucket &&
                                          !_vm.invoiceFrontBucket
                                            .toUpperCase()
                                            .includes(".PDF")
                                        ? _c(
                                            "viewer",
                                            {
                                              staticClass:
                                                "images clearfix widthFull",
                                              on: { inited: _vm.inited }
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "img-fluid img-mod",
                                                staticStyle: {
                                                  "border-radius": "10px"
                                                },
                                                attrs: {
                                                  src: _vm.invoiceFrontBucket
                                                }
                                              })
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              ref: "inv",
                                              staticClass:
                                                "images clearfix widthFull"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "underline theme",
                                                  attrs: {
                                                    href:
                                                      _vm.invoiceFrontBucket,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Clicca qui per vedere il pdf"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.invoiceFrontBucket
                                        ? _c(
                                            "span",
                                            { staticClass: "Bold" },
                                            [
                                              _c("br"),
                                              _c("font-awesome-icon", {
                                                staticClass: "helper mr-1",
                                                attrs: {
                                                  icon: "check-circle",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v("Scontrino caricato")
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoice")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback-1" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.errors.first("invoice")
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.mobileUpl && _vm.statusOCR != "OK" && _vm.contests.config
                    ? _c("div", { staticClass: "col-md-5 center pt-5 mt-5" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-center" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _vm.vw > 600
                              ? _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "mt-1 uppercase",
                                      on: {
                                        click: function($event) {
                                          return _vm.QRcode(
                                            _vm.token,
                                            _vm.userToken,
                                            _vm.piva
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img img-fluid",
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          src: __webpack_require__("HXsc")
                                        }
                                      }),
                                      _c("br"),
                                      _c(
                                        "small",
                                        { staticClass: "black Medium" },
                                        [_vm._v("Carica la foto da cellulare")]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contests.config.HAS_WA
                              ? _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pt-1 uppercase",
                                      on: {
                                        click: function($event) {
                                          return _vm.waLog(
                                            _vm.token,
                                            _vm.userToken,
                                            _vm.contests
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img img-fluid mt-3 pt-1",
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          src: __webpack_require__("7KbZ")
                                        }
                                      }),
                                      _c("br"),
                                      _c(
                                        "small",
                                        { staticClass: "black Medium" },
                                        [_vm._v("Carica tramite whatsapp")]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.statusOCR == "OK"
                    ? _c(
                        "div",
                        {
                          staticClass: "col-md-6 mb-5 mt-md-5 pt-md-3 mb-lg-0"
                        },
                        [
                          _c(
                            "div",
                            {
                              style:
                                "background:" +
                                _vm.contests.config.COLORE_CHIARO +
                                "!important;border-radius:10px;padding:9px",
                              attrs: { id: "top" }
                            },
                            [
                              _c("h5", { staticClass: "uppercase mb-lg-3" }, [
                                _vm._v("Riepilogo scontrino caricato:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-lg-6 col-12 mb-4",
                                      class: {
                                        "closedBlock ": !!_vm.ocrData.numero
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "group" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.number,
                                              expression: "number"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                integer: true,
                                                is_not: 0
                                              },
                                              expression:
                                                "{\n                    required: true,\n                    integer: true,\n                    is_not: 0,\n                  }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "number"
                                            ),
                                            valid: !!_vm.number,
                                            "form-control-dis": !!_vm.ocrData
                                              .numero
                                          },
                                          attrs: {
                                            type: "number",
                                            disabled: !!_vm.ocrData.numero,
                                            id: "number",
                                            name: "number",
                                            "data-vv-as": "Numero"
                                          },
                                          domProps: { value: _vm.number },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.number = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "lable-style",
                                            attrs: { for: "number" }
                                          },
                                          [
                                            _vm._v(
                                              "Numero scontrino\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("number")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.errors.first("number")
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-12 mb-5 mb-md-0",
                                      class: {
                                        "closedBlock ": !!_vm.ocrData.importo
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "group priceVal pr-0 mr-0"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.price,
                                                expression: "price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  regex: /^([0-9][0-9]*)$/,
                                                  max: 4
                                                },
                                                expression:
                                                  "{\n                    required: true,\n                    regex: /^([0-9][0-9]*)$/,\n                    max: 4,\n                  }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "price"
                                              ),
                                              valid: !!_vm.price,
                                              "form-control-dis": !!_vm.ocrData
                                                .importo
                                            },
                                            attrs: {
                                              type: "text",
                                              disabled: !!_vm.ocrData.importo,
                                              id: "price",
                                              name: "price",
                                              "data-vv-as": "Importo Euro"
                                            },
                                            domProps: { value: _vm.price },
                                            on: {
                                              focus: function($event) {
                                                _vm.priceFocused = true
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.price = $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.priceFocused ||
                                          _vm.priceCent ||
                                          _vm.price
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pseudoEuro theme"
                                                },
                                                [_vm._v("€")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "highlight"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "bar" }),
                                          _vm._v(" "),
                                          !_vm.priceCent ||
                                          (_vm.priceCent && _vm.price)
                                            ? _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "lable-style newPriceLabel doubleRow",
                                                  attrs: { for: "price" }
                                                },
                                                [_vm._v("Importo tot*")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.errors.has("price")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invalid-feedback",
                                                  staticStyle: {
                                                    width: "200%",
                                                    display: "block",
                                                    position: "absolute"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "price"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "theme" }, [
                                        _vm._v(",")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "group priceCent pl-0 ml-0"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.priceCent,
                                                expression: "priceCent"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  min: 2,
                                                  max: 2,
                                                  regex: /^([0-9]+)$/
                                                },
                                                expression:
                                                  "{\n                    required: true,\n                    min: 2,\n                    max: 2,\n                    regex: /^([0-9]+)$/,\n                  }"
                                              }
                                            ],
                                            staticClass:
                                              "form-control text-left centInput",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "priceCent"
                                              ),
                                              valid: !!_vm.priceCent,
                                              "form-control-dis": !!_vm.ocrData
                                                .importo
                                            },
                                            attrs: {
                                              type: "text",
                                              disabled: !!_vm.ocrData.importo,
                                              id: "priceCent",
                                              name: "priceCent",
                                              "data-vv-as": "Centesimi"
                                            },
                                            domProps: { value: _vm.priceCent },
                                            on: {
                                              focus: function($event) {
                                                _vm.priceFocused = true
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.priceCent =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.priceFocused ||
                                          _vm.priceCent ||
                                          _vm.price
                                            ? _c(
                                                "span",
                                                { staticClass: "pseudoCent" },
                                                [_vm._v("Cent.")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "highlight"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "bar" }),
                                          _vm._v(" "),
                                          !_vm.price && _vm.priceCent
                                            ? _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "niceInputLabel newPriceLabel",
                                                  staticStyle: {
                                                    "margin-left": "-115%"
                                                  },
                                                  attrs: { for: "price" }
                                                },
                                                [_vm._v("Importo")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.errors.has("priceCent") &&
                                          !_vm.errors.has("price")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invalid-feedback",
                                                  staticStyle: {
                                                    width: "200%",
                                                    display: "block",
                                                    position: "absolute",
                                                    "margin-left": "-100%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "priceCent"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-12 mb-3 mb-md-0",
                                      class: {
                                        "closedBlock ": !!_vm.ocrData.ora
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "group" },
                                        [
                                          _c("vue-timepicker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  emptyTime: true
                                                },
                                                expression:
                                                  "{ required: true, emptyTime: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              disabledTime:
                                                !!_vm.time.HH && !!_vm.time.mm,
                                              "is-invalid": _vm.errors.has(
                                                "time"
                                              ),
                                              valid: !!_vm.time.HH != "",
                                              "time-picker-dis ": !!_vm.ocrData
                                                .ora
                                            },
                                            attrs: {
                                              disabled: !!_vm.ocrData.ora,
                                              hideClearButton: true,
                                              "data-vv-validate-on": "none",
                                              id: "time",
                                              name: "time",
                                              "data-vv-as": "Ora Scontrino"
                                            },
                                            model: {
                                              value: _vm.time,
                                              callback: function($$v) {
                                                _vm.time = $$v
                                              },
                                              expression: "time"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "highlight"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "bar" }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "lable-style labelTime",
                                              attrs: { for: "time" }
                                            },
                                            [_vm._v("Ora scontrino")]
                                          ),
                                          _vm._v(" "),
                                          _vm.errors.has("time")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invalid-feedback"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.errors.first("time")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-lg-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mb-3 mb-md-0",
                                        class: {
                                          "closedBlock ": !!_vm.ocrData.data
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "group" },
                                          [
                                            _c("datepicker", {
                                              attrs: {
                                                language: _vm.it,
                                                disabled: !!_vm.ocrData.data,
                                                "full-month-name": true,
                                                initialView: "month",
                                                format: "dd MMMM yyyy",
                                                "monday-first": true,
                                                disabledDates:
                                                  _vm.disabledDates,
                                                id: "date",
                                                name: "date",
                                                "input-class": "form-control "
                                              },
                                              model: {
                                                value: _vm.date,
                                                callback: function($$v) {
                                                  _vm.date = $$v
                                                },
                                                expression: "date"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: false,
                                                  expression: "false"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.date,
                                                  expression: "date"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: { required: true },
                                                  expression:
                                                    "{ required: true }"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "is-invalid": _vm.errors.has(
                                                  "date"
                                                ),
                                                valid: !!_vm.date,
                                                "form-control-dis": !!_vm
                                                  .ocrData.data
                                              },
                                              attrs: {
                                                type: "text",
                                                id: "date",
                                                name: "date",
                                                "data-vv-as": "Data scontrino"
                                              },
                                              domProps: { value: _vm.date },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.date = $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "lable-style",
                                                attrs: { for: "date" }
                                              },
                                              [_vm._v("Data scontrino")]
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.has("date")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "date"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm.empty
        ? _c("div", { staticClass: "container-fluid mt-5 pt-5" }, [_vm._m(1)])
        : _vm.notRegister
        ? _c("div", { staticClass: "container-fluid mt-5 pt-5" }, [_vm._m(2)])
        : _vm._e(),
      _vm._v(" "),
      _vm.statusOCR == "OK"
        ? _c(
            "div",
            { staticClass: "container back-white" },
            [
              _c("STEP2PRODOTTI", {
                attrs: {
                  date_sc: _vm.date,
                  time_sc: _vm.time,
                  price_sc: _vm.price,
                  priceCent_sc: _vm.priceCent,
                  number_sc: _vm.number,
                  immagine_sc: _vm.invoiceFrontBucket,
                  ocrContent: _vm.saveDataOcr,
                  erroriOcr: _vm.ocrErrors
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var play_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "mt-4 color Medium h2" }, [_vm._v("Oppure:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "row justify-content-center mt-5 pt-5 back-white" },
      [
        _c("div", { staticClass: "col-md-10 center mt-5 pt-5 pb-5 mb-5" }, [
          _c("h1", [
            _vm._v(
              "\n          LA PROMOZIONE CHE STAI CERCANDO NON É ANCORA ATTIVA OPPURE É GIÁ\n          TERMINATA\n        "
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "row justify-content-center mt-5 pt-5 back-white" },
      [
        _c("div", { staticClass: "col-md-10 center mt-5 pt-5 pb-5 mb-5" }, [
          _c("h1")
        ])
      ]
    )
  }
]
play_render._withStripped = true
var play_esExports = { render: play_render, staticRenderFns: play_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_play = (play_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f59cc7", play_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/play/index.vue
var play_disposed = false
var play_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var play___vue_template_functional__ = false
/* styles */
var play___vue_styles__ = null
/* scopeId */
var play___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var play___vue_module_identifier__ = null
var play_Component = play_normalizeComponent(
  components_play,
  selectortype_template_index_0_src_components_play,
  play___vue_template_functional__,
  play___vue_styles__,
  play___vue_scopeId__,
  play___vue_module_identifier__
)
play_Component.options.__file = "src/components/play/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-54f59cc7", play_Component.options)
  } else {
    hotAPI.reload("data-v-54f59cc7", play_Component.options)
  }
  module.hot.dispose(function (data) {
    play_disposed = true
  })
})()}

/* harmony default export */ var src_components_play = (play_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uploadphone/index.vue




//
//
//
//
//
//
//






var uploadphone_moment = __webpack_require__("PJh5");

/* harmony default export */ var uploadphone = ({
  name: "Play",

  data: function data() {
    return {
      loadingState: false,
      piva: "",
      phone: "",
      promo: "",
      cod: ""
    };
  },

  methods: {
    logFromUrl: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(param, idUser, promo, phone) {
        var _this = this;

        var _vue, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadingState = true;
                _vue = this;

                this.$track("QRcode", "START");
                this.$track("QRcode -> userToken", idUser);
                this.$track("QRcode -> promo", promo);
                this.$track("QRcode -> phone", phone);
                this.$track("QRcode -> param", param);
                data = {
                  userToken: idUser,
                  id_promo: promo,
                  phone: phone,
                  password: param,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 11;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/logFromUrl",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this.$track("QRcode", "SUCCESS");
                  _this.$track("QRcode", resp.data);
                  _this.piva = resp.data[0].piva;
                  _this.cod = resp.data[0].cod;
                  _this.phone = phone;
                  _this.promo = promo;
                  if (resp.data == "access_denied") {
                    _this.message = '<b class="Bold">Non hai accesso a questa promozione</b>';
                    _this.UploadError("", _this.message);
                  }
                  var data = {
                    username:  false ? resp.data[0].email : resp.data[0].cod,
                    password: resp.data[0].password,
                    case: "login_from_url",
                    id_platform: "DcJ7J1WfiwucqBl_lierac",
                    unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                    vector_unique_key_db: "lierac_global"
                  };
                  data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                  _this.$store.dispatch(AUTH_REQUEST, { data: data }).then(function (resp) {
                    _this.$store.dispatch(ACCEPT_REG, promo);
                    _this.$store.dispatch(ACCEPT_COOKIES, true);
                    _this.$store.dispatch(USER_REQUEST);
                    _this.$track("AUTH_REQUEST", "SUCCESS");

                    setTimeout(function () {
                      _vue.$router.push("/play/" + _vue.promo + "/" + _vue.piva + "/" + _vue.cod);
                    }, 200);
                    _this.loadingState = false;
                  });
                }).catch(function (resp) {
                  _this.$store.dispatch(AUTH_LOGOUT).then(function () {
                    return _this.$router.push("/login");
                  });
                  _this.loadingState = false;
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function logFromUrl(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return logFromUrl;
    }(),
    UploadError: function UploadError(desc, specific) {
      var _this2 = this;

      this.$swal({
        type: "error",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          _this2.$router.push("/");
        }
      });
    }
  },
  /********************************************************************************************* */
  watch: {
    getProfile: function getProfile() {
      var _vue = this;
    }
  },
  mounted: function mounted() {
    if (this.$route.params.token) {
      this.link = this.$route.params.token;

      var idPromo = this.link.substring(this.link.lastIndexOf("WERgt4r2sfr") + 11, this.link.lastIndexOf("REWrfs2r4tg"));

      var idSearch = this.link.substring(this.link.lastIndexOf("TOKhgsfddte") + 11, this.link.lastIndexOf("KOTnaskdue"));

      var str = this.link.substring(this.link.lastIndexOf("REWrfs2r4tg") + 11, this.link.lastIndexOf("TOKhgsfddte"));

      this.phone = 1;
      idSearch = this.$decryptByAES(idSearch, "B%t$AD!YMfnCZnfD");
      this.steps = str.replaceAll("2TGRS2", "/");
      this.steps1 = this.steps.replaceAll("3MULTI3", ".");
      this.logFromUrl(this.steps1, idSearch, idPromo, this.phone);
    } else {
      this.$router.push("/");
    }
  },
  created: function () {
    var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _ref2.apply(this, arguments);
    }

    return created;
  }(),
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies", "accepted_regulations"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0113d070","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadphone/index.vue
var uploadphone_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull h-100 somatoline pb-5", attrs: { id: "top" } },
    [_vm.loadingState ? _c("loading") : _vm._e()],
    1
  )
}
var uploadphone_staticRenderFns = []
uploadphone_render._withStripped = true
var uploadphone_esExports = { render: uploadphone_render, staticRenderFns: uploadphone_staticRenderFns }
/* harmony default export */ var components_uploadphone = (uploadphone_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0113d070", uploadphone_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/uploadphone/index.vue
var uploadphone_disposed = false
var uploadphone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var uploadphone___vue_template_functional__ = false
/* styles */
var uploadphone___vue_styles__ = null
/* scopeId */
var uploadphone___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploadphone___vue_module_identifier__ = null
var uploadphone_Component = uploadphone_normalizeComponent(
  uploadphone,
  components_uploadphone,
  uploadphone___vue_template_functional__,
  uploadphone___vue_styles__,
  uploadphone___vue_scopeId__,
  uploadphone___vue_module_identifier__
)
uploadphone_Component.options.__file = "src/components/uploadphone/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0113d070", uploadphone_Component.options)
  } else {
    hotAPI.reload("data-v-0113d070", uploadphone_Component.options)
  }
  module.hot.dispose(function (data) {
    uploadphone_disposed = true
  })
})()}

/* harmony default export */ var src_components_uploadphone = (uploadphone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page_not_found/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var page_not_found = ({
		name: 'PageNotFound',
		components: {},
		data: function data() {
				return {
						loadingState: '',
						userToken: ''
				};
		},

		methods: {},
		watch: {},
		mounted: function mounted() {
				var _vue = this;
		},
		computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded', 'acceptCookies', 'checkAge', 'acceptSalesForce', 'acceptRelay42']), Object(vuex_esm["c" /* mapState */])({ profile: function profile(state) {
						return state.user.profile;
				} }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd03679","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_not_found/index.vue
var page_not_found_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull fitAvailableHeight mt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container center pb-5 mb-5" },
        [
          _c("h3", { staticClass: " center" }, [
            _vm._v("PAGINA NON TROVATA! ")
          ]),
          _vm._v(" "),
          _c("h5", { staticClass: " center mt-5 pb-5" }, [
            _vm._v("LA PAGINA CHE STAI CERCANDO NON È DISPONIBILE.")
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            { staticClass: "btn btn-primary btn-lg mb-5", attrs: { to: "/" } },
            [_vm._v("Home")]
          )
        ],
        1
      )
    ],
    1
  )
}
var page_not_found_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid mt-5" }, [
      _c("div", { staticClass: "row pt-5 mt-5 mt-lg-5 pb-3 center" }, [
        _c("h1", { staticClass: "text-red widthFull center uppercase pt-5" }, [
          _c("b", [_vm._v("OPS!")])
        ])
      ])
    ])
  }
]
page_not_found_render._withStripped = true
var page_not_found_esExports = { render: page_not_found_render, staticRenderFns: page_not_found_staticRenderFns }
/* harmony default export */ var components_page_not_found = (page_not_found_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cd03679", page_not_found_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/page_not_found/index.vue
var page_not_found_disposed = false
function page_not_found_injectStyle (ssrContext) {
  if (page_not_found_disposed) return
  __webpack_require__("+E3e")
}
var page_not_found_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var page_not_found___vue_template_functional__ = false
/* styles */
var page_not_found___vue_styles__ = page_not_found_injectStyle
/* scopeId */
var page_not_found___vue_scopeId__ = "data-v-6cd03679"
/* moduleIdentifier (server only) */
var page_not_found___vue_module_identifier__ = null
var page_not_found_Component = page_not_found_normalizeComponent(
  page_not_found,
  components_page_not_found,
  page_not_found___vue_template_functional__,
  page_not_found___vue_styles__,
  page_not_found___vue_scopeId__,
  page_not_found___vue_module_identifier__
)
page_not_found_Component.options.__file = "src/components/page_not_found/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6cd03679", page_not_found_Component.options)
  } else {
    hotAPI.reload("data-v-6cd03679", page_not_found_Component.options)
  }
  module.hot.dispose(function (data) {
    page_not_found_disposed = true
  })
})()}

/* harmony default export */ var src_components_page_not_found = (page_not_found_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-badger-accordion/index.js
var vue_badger_accordion = __webpack_require__("paJE");

// EXTERNAL MODULE: ./node_modules/vue-svg-gauge/dist/vue-svg-gauge.js
var vue_svg_gauge = __webpack_require__("o39/");
var vue_svg_gauge_default = /*#__PURE__*/__webpack_require__.n(vue_svg_gauge);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contest/template_contatore.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var template_contatore_moment = __webpack_require__("PJh5");

/* harmony default export */ var template_contatore = ({
  name: "contest",
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"]
  },
  props: {
    pageTitle: {
      type: String,
      default: "Dashboard"
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      loadingState: "",
      moment: template_contatore_moment,
      statusPlay: {},
      contests: {},
      id: "",
      piva: "",
      title: ""
    }, defineProperty_default()(_ref, "title", ""), defineProperty_default()(_ref, "contest", true), defineProperty_default()(_ref, "end_rec", ""), defineProperty_default()(_ref, "info", false), defineProperty_default()(_ref, "checkAccessOk", false), defineProperty_default()(_ref, "main_image", ""), defineProperty_default()(_ref, "main_text", ""), defineProperty_default()(_ref, "regulation", ""), defineProperty_default()(_ref, "time", false), defineProperty_default()(_ref, "$viewer", ""), defineProperty_default()(_ref, "vw", window.innerWidth), defineProperty_default()(_ref, "countdown", 0), defineProperty_default()(_ref, "datenow", ""), defineProperty_default()(_ref, "finish", false), defineProperty_default()(_ref, "cod_client", ""), defineProperty_default()(_ref, "products", []), defineProperty_default()(_ref, "products_registered", 0), defineProperty_default()(_ref, "total_product_value", 0), defineProperty_default()(_ref, "start", ""), defineProperty_default()(_ref, "end", ""), defineProperty_default()(_ref, "start_", ""), defineProperty_default()(_ref, "end_", ""), defineProperty_default()(_ref, "award_spec", ""), defineProperty_default()(_ref, "id", ""), defineProperty_default()(_ref, "award_image", ""), defineProperty_default()(_ref, "empty", true), defineProperty_default()(_ref, "minProduct", ""), defineProperty_default()(_ref, "minPrice", ""), defineProperty_default()(_ref, "regex", ""), defineProperty_default()(_ref, "playContest", ""), defineProperty_default()(_ref, "selectedPlay", {}), defineProperty_default()(_ref, "my_registration_in_promo", 0), defineProperty_default()(_ref, "maxRegistration", 0), defineProperty_default()(_ref, "playConsens", true), defineProperty_default()(_ref, "maxRegistrationOr", 0), defineProperty_default()(_ref, "now", template_contatore_moment()), defineProperty_default()(_ref, "maxRegistration_", 0), defineProperty_default()(_ref, "step", __webpack_require__("G0Sz")), defineProperty_default()(_ref, "doc", __webpack_require__("YAyH")), _ref;
  },

  methods: {
    setProfileData: function setProfileData() {
      this.piva = this.profile.piva;
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.id;

      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.cod_client = this.profile.cod;

      this.group = this.profile.groupPh;
      this.profileId = this.profile.id;
    },
    checkAccess: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.piva == this.$route.params.piva)) {
                  _context.next = 8;
                  break;
                }

                this.$track("checkAccess", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/checkAccess",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this.loadingState = false;
                  _this.checkAccessOk = true;
                  _this.$track("checkAccess", "SUCCESS");
                  _this.$track("checkAccess", resp.data);
                  if (resp.data == "access_denied") {
                    _this.message = '<b class="Bold">Non hai accesso a questa promozione</b>';
                    _this.UploadError("ATTENZIONE!", _this.message);
                  } else {
                    _this.myRegistration();
                    _this.loadProducts();
                    _this.thisPlay();
                  }
                }).catch(function (err) {
                  _this.loadingState = false;
                  _this.$track("checkAccess", "ERROR");
                  err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
                _context.next = 9;
                break;

              case 8:
                this.$router.push("/");

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkAccess() {
        return _ref2.apply(this, arguments);
      }

      return checkAccess;
    }(),
    myRegistration: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _this2 = this;

        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.piva != this.$route.params.piva)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 8;
                break;

              case 3:
                this.$track("myRegistration", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context2.next = 8;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/myRegistration",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this2.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this2.$track("myRegistration", "SUCCESS");
                  _this2.$track("myRegistration", resp.data);
                  if (resp.data) {
                    _this2.maxRegistration = parseInt(resp.data[0].bonus) + parseInt(resp.data[0].extra_bonus);
                    _this2.maxRegistrationOr = parseInt(resp.data[0].bonus);
                  }
                }).catch(function (err) {
                  _this2.$track("myRegistration", "ERROR");
                  err.response.data = _this2.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function myRegistration() {
        return _ref3.apply(this, arguments);
      }

      return myRegistration;
    }(),
    thisPlay: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this3 = this;

        var data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.$route.params.cod) {
                  _context3.next = 9;
                  break;
                }

                this.loadingState = true;
                this.$track("thisPlay", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context3.next = 7;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/thisPlay",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this3.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this3.$track("thisPlay", "SUCCESS");
                  _this3.$track("thisPlay", resp.data);
                  _this3.loadingState = false;
                  if (resp.data.summary[0]) _this3.statusPlay = resp.data.summary[0];else {
                    _this3.statusPlay = {
                      TOTAL: 0,
                      TO_ELABORATE: 0,
                      ELABORATE_OK: 0,
                      ELABORATE_KO: 0,
                      ELABORATE_KO_CONFIRMED: 0,
                      ELABORATE_OK_CONFIRMED: 0,
                      CASHBACK_START: 0,
                      CASHBACK_GONE: 0,
                      CASHBACK_ERROR: 0,
                      CASHBACK_SENT: 0,
                      ASKED_REBATE: 0,
                      RECEIVED_REBATE: 0,
                      ASKED: 0,
                      RECEIVED: 0
                    };
                  }

                  _this3.products_registered = resp.data.products_registered;
                  _this3.total_product_value = resp.data.total_product_value;
                }).catch(function (err) {
                  _this3.loadingState = false;
                  _this3.$track("thisPlay", "ERROR");
                  err.response.data = _this3.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 7:
                _context3.next = 10;
                break;

              case 9:
                this.setProfileData();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function thisPlay() {
        return _ref4.apply(this, arguments);
      }

      return thisPlay;
    }(),

    takeMyAttempts: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _this4 = this;

        var data;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.loadingState = true;

                if (!this.contests.config) {
                  _context4.next = 10;
                  break;
                }

                this.$track("takeMyAttempts", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  desc: this.contests.config.DESTINAZIONE_SCONTO,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };


                this.$track("takeMyAttempts", data);
                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context4.next = 8;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/takeMyAttempts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this4.loadingState = false;
                  _this4.$track("takeMyAttempts", "SUCCESS");
                  resp.data = _this4.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this4.$track("takeMyAttempts", resp.data);
                  _this4.my_registration_in_promo = resp.data.countMyAttempts;
                  _this4.playContest = resp.data.allPlayForPromo;
                }).catch(function (err) {
                  _this4.loadingState = false;
                  _this4.$track("takeMyAttempts", "ERROR");
                  err.response.data = _this4.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 8:
                _context4.next = 12;
                break;

              case 10:
                _context4.next = 12;
                return this.getThisContest();

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function takeMyAttempts() {
        return _ref5.apply(this, arguments);
      }

      return takeMyAttempts;
    }(),
    disablePlay: function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(idDis) {
        var _this5 = this;

        var data;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.loadingState = true;
                this.$track("disablePlay", "START");
                data = {
                  id: idDis,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context5.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/disablePlay",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this5.loadingState = false;
                  _this5.$track("disablePlay", "SUCCESS");
                  resp.data = _this5.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this5.$track("disablePlay", resp.data);
                  if (resp.data) _this5.shoSuccess("Pratica eliminata correttamente", "La pratica " + idDis + " è stata eliminata correttamente");else _this5.UploadError("Errore", "Riprova piú tardi");
                }).catch(function (resp) {
                  _this5.$track("disablePlay", "ERROR");
                  err.response.data = _this5.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function disablePlay(_x) {
        return _ref6.apply(this, arguments);
      }

      return disablePlay;
    }(),
    loadProducts: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _this6 = this;

        var data;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.loadingState = true;
                this.$track("loadProducts", "START");
                data = {
                  id: this.$route.params.id,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context6.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/loadProducts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this6.$track("loadProducts", "SUECCESS");
                  var prod = [];
                  for (var x in resp.data) {
                    var y = [];
                    y["key"] = x;
                    y["label"] = resp.data[x];
                    prod.push(y);
                  }
                  _this6.products = prod;
                  _this6.loadingState = false;
                }).catch(function (resp) {
                  _this6.loadingState = false;
                  _this6.$track("loadProducts", "ERROR");
                });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function loadProducts() {
        return _ref7.apply(this, arguments);
      }

      return loadProducts;
    }(),

    getThisContest: function () {
      var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var _this7 = this;

        var data;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContest", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ACTIVE",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context7.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this7.loadingState = false;
                  resp.data = _this7.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this7.$track("getThisContest", "SUCCESS");
                  if (resp.data) _this7.empty = false;else _this7.getThisContestNOTACTIVE();
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  if (resp.data) {
                    _this7.contests = resp.data[0];
                    _this7.type = _this7.contests.config.TIPOLOGIA_RIEPILOGO;
                    _this7.start_ = _this7.contests.start;
                    _this7.startRec_ = _this7.contests.startRec;
                    _this7.start_rec = template_contatore_moment(_this7.startRec_).format("DD/MM/YYYY");
                    _this7.endRec_ = _this7.contests.endRec;
                    _this7.end_rec = template_contatore_moment(_this7.endRec_).format("DD-MM-YYYY");
                    _this7.start = template_contatore_moment(_this7.start_).format("DD-MM-YYYY");
                    _this7.end_ = _this7.contests.end;
                    _this7.end = template_contatore_moment(_this7.end_).format("DD-MM-YYYY");

                    _this7.now = template_contatore_moment();
                    var then = template_contatore_moment(_this7.end_);

                    var dif = then.diff(_this7.now);
                    if (dif <= 0) {
                      _this7.finish = true;
                      _this7.countdown = 0 - dif;
                    } else {
                      _this7.countdown = dif;
                    }
                    _this7.$track("getThisContest", _this7.contests);
                  }
                }).catch(function (err) {
                  _this7.loadingState = false;
                  err.response.data = _this7.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this7.$track("getThisContest", "ERROR");
                });

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getThisContest() {
        return _ref8.apply(this, arguments);
      }

      return getThisContest;
    }(),
    getThisContestNOTACTIVE: function () {
      var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var _this8 = this;

        var data;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContestNOTACTIVE", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ENDED",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context8.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this8.loadingState = false;

                  resp.data = _this8.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this8.$track("getThisContestNOTACTIVE", "SUCCESS");
                  if (!resp.data) {}
                  if (resp.data) {
                    _this8.empty = false;
                  }
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }

                  _this8.contests = resp.data[0];
                  _this8.type = _this8.contests.config.TIPOLOGIA_RIEPILOGO;
                  _this8.start_ = _this8.contests.start;
                  _this8.start = template_contatore_moment(_this8.start_).format("DD-MM-YYYY");
                  _this8.end_ = _this8.contests.end;
                  _this8.end = template_contatore_moment(_this8.end_).format("DD-MM-YYYY");
                  _this8.startRec_ = _this8.contests.startRec;
                  _this8.start_rec = template_contatore_moment(_this8.startRec_).format("DD/MM/YYYY");
                  _this8.endRec_ = _this8.contests.endRec;
                  _this8.end_rec = template_contatore_moment(_this8.endRec_).format("DD-MM-YYYY");

                  _this8.now = template_contatore_moment();
                  var then = template_contatore_moment(_this8.end_);

                  var dif = then.diff(_this8.now);
                  if (dif <= 0) {
                    _this8.finish = true;
                    _this8.countdown = 0 - dif;
                  } else {
                    _this8.countdown = dif;
                  }
                  _this8.$track("getThisContestNOTACTIVE", _this8.contests);
                  _this8.takeMyAttempts();
                }).catch(function (err) {
                  _this8.loadingState = false;
                  err.response.data = _this8.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this8.$track("getThisContestNOTACTIVE", "ERROR");
                });

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getThisContestNOTACTIVE() {
        return _ref9.apply(this, arguments);
      }

      return getThisContestNOTACTIVE;
    }(),
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show() {
      var el = this.$refs.inv;
      var viewer = el.$viewer;
      viewer.show();
      viewer.zoomTo(2);
      viewer.move(-1, 0);
    },
    print: function print(value) {},
    secondClick: function secondClick(id) {
      var _vue = this;
      if (_vue.activeId != "no") {
        _vue.$track("pre ID: " + id + " Active:" + _vue.activeId);

        if (id == _vue.activeId) {
          _vue.$track("same");
          var _vue = this;
          setTimeout(function () {
            _vue.$scrollTo("#centerEl", 0, { offset: -125 });
          }, 0);
          _vue.selectedPlay = {};
          _vue.activeId = "no";
        } else {
          _vue.$track("newOpen Exisrt one");
          _vue.activeId = id;
        }
      } else {
        _vue.$track("new not exist");
        _vue.activeId = id;
      }
    },
    UploadError: function UploadError(desc, specific) {
      var _this9 = this;

      this.$swal({
        type: "info",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          _this9.$router.push("/");
        }
      });
    },
    shoSuccess: function shoSuccess(desc, specific) {
      this.$swal({
        type: "info",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          window.location.reload();
        }
      });
    },

    /************************* */
    changeView: function changeView(val) {
      if (val == 1) {
        this.contest = true;
        this.info = false;
      } else {
        this.contest = false;
        this.info = true;
      }
    },
    toContest: function toContest() {
      this.contest = true;
      this.info = false;
    }
  },
  /********************************************************************************************* */
  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.checkAccess();
    },
    "$route.params.id": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.piva": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.cod": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    /**************** */
    selectedPlay: function selectedPlay(array) {
      this.imageLoaded = true;
    },
    info: function info() {
      if (this.info) {
        var _vue = this;
        setTimeout(function () {
          _vue.$refs.activeAccordion.open(0);
        }, 100);
      }
    }
    /**************** */
  },

  mounted: function mounted() {
    var _this10 = this;

    this.id = this.$route.params.id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    if (!cod) {
      this.$router.push("/");
    }
    if (!piva) {
      this.$router.push("/");
    }

    if (this.getProfile.piva) {
      this.setProfileData();
      this.checkAccess();
      this.now = template_contatore_moment().format("DD-MM-YYYY");
    }

    window.onresize = function () {
      _this10.vw = window.innerWidth;
      _this10.vh = window.innerHeight;
    };
    var _vue = this;
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);
  },
  created: function () {
    var _ref10 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.getThisContest();

            case 2:
              this.takeMyAttempts();

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function created() {
      return _ref10.apply(this, arguments);
    }

    return created;
  }(),
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b231c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contest/template_contatore.vue
var template_contatore_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.contests.config
    ? _c(
        "div",
        { attrs: { id: "top" } },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row mt-5 pt-5" }, [
              _vm.contests.config
                ? _c("div", { staticClass: "col-12 center" }, [
                    _c("img", {
                      staticClass: "img img-fluid",
                      attrs: { src: _vm.contests.config.LOGO_INTERNO }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("nav", {}, [
              _c(
                "div",
                {
                  staticClass: "nav nav-tabs mt-3",
                  attrs: { id: "nav-tab", role: "tablist" }
                },
                [
                  _vm.contest
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link active",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-home-tab",
                            "data-toggle": "tab",
                            href: "#nav-home",
                            role: "tab",
                            "aria-controls": "nav-home",
                            "aria-selected": "true"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(1)
                            }
                          }
                        },
                        [_vm._v("Promozione")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link active",
                          attrs: {
                            id: "nav-home-tab",
                            "data-toggle": "tab",
                            href: "#nav-home",
                            role: "tab",
                            "aria-controls": "nav-home",
                            "aria-selected": "true"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(1)
                            }
                          }
                        },
                        [_vm._v("Promozione")]
                      ),
                  _vm._v(" "),
                  _vm.info
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(2)
                            }
                          }
                        },
                        [_vm._v("richieste di rimborso inserite")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(2)
                            }
                          }
                        },
                        [_vm._v("richieste di rimborso inserite")]
                      )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.info && _vm.contest
            ? _c(
                "div",
                {
                  staticClass: "container padd pt-2 pb-5",
                  attrs: { id: "nav-home" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-center pb-5 pt-3 back-white"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-9 mt-3 center",
                          class: { "back-color-3": _vm.empty },
                          on: {
                            click: function($event) {
                              return _vm.toContest()
                            }
                          }
                        },
                        [
                          _vm.my_registration_in_promo <= _vm.maxRegistration &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD HH:mm:ss")
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Play",
                                      params: {
                                        id: _vm.id,
                                        piva: _vm.piva,
                                        cod: _vm.cod_client
                                      }
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "center padd",
                                      class: {
                                        "back-color-2 white":
                                          _vm.my_registration_in_promo >
                                          _vm.maxRegistration,
                                        "back-white color uppercase ":
                                          _vm.my_registration_in_promo <=
                                            _vm.maxRegistration && !_vm.empty,
                                        "back-color-3 white uppercase":
                                          _vm.my_registration_in_promo <
                                            _vm.maxRegistration && _vm.empty
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.title) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.empty
                                    ? _c(
                                        "small",
                                        { staticClass: "color underline" },
                                        [
                                          _vm._v(
                                            "Premi qui per andare direttamente al caricamento dello\n            scontrino"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _vm.my_registration_in_promo < _vm.maxRegistration &&
                          !_vm.empty &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD HH:mm:ss")
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Play",
                                      params: {
                                        id: _vm.id,
                                        piva: _vm.piva,
                                        cod: _vm.cod_client
                                      }
                                    }
                                  }
                                },
                                [
                                  _c("countdown", {
                                    attrs: { time: _vm.countdown },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(props) {
                                            return [
                                              _vm.vw <= 770 && !_vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                Ti rimangono:\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.vw <= 770 && _vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                Mancano:\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row center justify-content-center pb-2 pt-3 text-right"
                                                },
                                                [
                                                  _vm.vw > 770 && !_vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-3 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Ti rimangono:\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.vw > 770 && _vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-3 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Mancano:\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(props.days)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.days == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    giorno\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("giorni")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(props.hours)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.hours == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic darkBlue Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    ora\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("ore")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.minutes
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.minutes == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    minuto\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("minuti")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.seconds
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.seconds == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    secondo\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("secondi")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.vw >= 770 && !_vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-1 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  per registrare "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "uno scontrino\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.vw >= 770 && _vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-1 text-left activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  al termine"
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "della promozione\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.vw < 770 && !_vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                per registrare uno scontrino\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.vw < 770 && _vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                al termine della promozione\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3705344063
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "center black Bold mr-lg-5 mb-md-5 mt-lg-0 mt-3"
                            },
                            [
                              _vm._v("\n          Validitá promozione: dal "),
                              _c("b", { staticClass: "underline" }, [
                                _vm._v(_vm._s(_vm.start))
                              ]),
                              _vm._v(" al\n          "),
                              _c("b", { staticClass: "underline" }, [
                                _vm._v(_vm._s(_vm.end_rec)),
                                _c("br")
                              ]),
                              _vm._v(
                                "con possibilità di\n          caricare gli scontrini fino al "
                              ),
                              _c("b", [_vm._v(_vm._s(_vm.end))])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.empty
                        ? _c("div", { staticClass: "col-md-10 center" }, [
                            _vm.finish
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "bordered-1 Black Bold h3 mt-3"
                                  },
                                  [
                                    _vm._v(
                                      "\n          Promozione terminata\n        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v("\n        Validitá promozione: dal "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(_vm.start))
                            ]),
                            _vm._v(" al\n        "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(_vm.end_rec)),
                              _c("br")
                            ]),
                            _vm._v(
                              " con possibilità di\n        caricare gli scontrini fino al "
                            ),
                            _c("b", [_vm._v(_vm._s(_vm.end))])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.contests.config
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-4 col-md-4 pt-5 mt-lg-0 mt-md-4 center mb-3 mb-md-0"
                            },
                            [
                              !!_vm.contests.config.REGOLAMENTO
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.contests.config.REGOLAMENTO,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "\n              center\n              uppercase\n              white\n              bordered\n              back-color-1\n              btn btn-primary-4\n              mb-2\n            ",
                                          style:
                                            "background: " +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "!important"
                                        },
                                        [
                                          _vm._v("\n            Regolamento "),
                                          _c("img", { attrs: { src: _vm.doc } })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              !!_vm.contests.config.FAQ
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.contests.config.FAQ,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "\n              center\n              uppercase\n              back-color-1\n              white\n              bordered\n              btn btn-primary-4\n            ",
                                          style:
                                            "background: " +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "!important"
                                        },
                                        [
                                          _vm._v("\n            Faq "),
                                          _c("img", { attrs: { src: _vm.doc } })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.finish
                        ? _c(
                            "div",
                            { staticClass: "col-md-4 col-8" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-4 col-8 absolute center numberReg",
                                  class: {
                                    "numberReg-1":
                                      _vm.my_registration_in_promo ==
                                        _vm.maxRegistration &&
                                      _vm.vw < 800 &&
                                      _vm.vw > 700
                                  }
                                },
                                [
                                  _c(
                                    "h1",
                                    {
                                      staticClass: "bordered-2 quadNum",
                                      style:
                                        "background: linear-gradient(87deg,rgba(255,255,255,1) 0%," +
                                        _vm.contests.config.COLORE_CHIARO +
                                        " 15%," +
                                        _vm.contests.config
                                          .COLORE_MEDIO_CHIARO +
                                        " 62%," +
                                        _vm.contests.config.COLORE_MEDIO_SCURO +
                                        " 100%," +
                                        _vm.contests.config.COLORE_SCURO +
                                        " 100%)"
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.my_registration_in_promo)
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "smallList-2" },
                                        [
                                          _vm._v(
                                            "su " +
                                              _vm._s(_vm.maxRegistration) +
                                              " disponibili"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("VueSvgGauge", {
                                attrs: {
                                  "start-angle": -90,
                                  "end-angle": 90,
                                  value: _vm.my_registration_in_promo,
                                  "separator-step": 10,
                                  min: 0,
                                  innerRadius: 70,
                                  separatorThickness: 1,
                                  max: _vm.maxRegistration,
                                  "gauge-color": [
                                    {
                                      offset: 0,
                                      color:
                                        _vm.contests.config.COLORE_MEDIO_CHIARO
                                    },
                                    {
                                      offset: 100,
                                      color:
                                        _vm.contests.config.COLORE_PRINCIPALE
                                    }
                                  ],
                                  "scale-interval": 1
                                }
                              }),
                              _vm._v(" "),
                              _vm.my_registration_in_promo < _vm.maxRegistration
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "inner-text Bold h5 text-center"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Richieste di rimborso effettuate"
                                        )
                                      ])
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "inner-text Bold h5 text-center"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Richieste di rimborso esaurite")
                                      ])
                                    ]
                                  )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.empty && !_vm.finish
                        ? _c(
                            "div",
                            { staticClass: "col-lg-4 col-md-4 mt-5 pt-4" },
                            [
                              _c(
                                "p",
                                { staticClass: "customHowTo pull-left" },
                                [
                                  _vm._v(
                                    "\n          CONTATORE DEGLI ATTI DI SCONTO EFFETTUATI E RIMANENTI\n        "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.empty && !_vm.finish
                    ? _c(
                        "div",
                        {
                          staticClass: "row justify-content-center pt-md-5",
                          class: {
                            "back-white": !_vm.empty && _vm.contest && !_vm.info
                          }
                        },
                        [
                          _vm.contests.config.STEP_1
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_1)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_2
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_2)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_3
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_3)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_4
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_4)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.empty && _vm.finish
                    ? _c(
                        "div",
                        {
                          staticClass: "row justify-content-center",
                          class: {
                            "back-white": !_vm.empty && _vm.contest && !_vm.info
                          }
                        },
                        [
                          _c("div", { staticClass: "col-10" }, [
                            _c("img", {
                              staticClass: "img-fluid img",
                              attrs: { src: _vm.contests.config.IMMAGINE_HOME }
                            })
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row pt-5 pb-5 back-white",
                      class: {
                        "back-white justify-content-center":
                          !_vm.empty && _vm.contest && !_vm.info
                      }
                    },
                    [
                      !_vm.empty &&
                      _vm.contest &&
                      !_vm.info &&
                      _vm.moment(_vm.now) <=
                        _vm.moment(_vm.end_, "YYYY-MM-DD HH:mm:ss")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-5 col-md-5 center mt-md-4 mt-5 pt-lg-0 pt-md-4"
                            },
                            [
                              _vm.my_registration_in_promo < _vm.maxRegistration
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important",
                                      attrs: {
                                        to: {
                                          name: "Play",
                                          params: {
                                            id: _vm.id,
                                            piva: _vm.piva,
                                            cod: _vm.cod_client
                                          }
                                        }
                                      }
                                    },
                                    [_vm._v("Registra uno scontrino")]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color white Medium h5",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Numero massimo di richieste di rimborso raggiunto\n        "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        : !_vm.empty && _vm.contest && !_vm.info
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "center mt-md-4 mt-5 pt-lg-0 pt-md-4",
                              class: {
                                "col-12":
                                  _vm.moment(_vm.now) >
                                  _vm.moment(_vm.end_, "YYYY-MM-DD"),
                                "col-lg-5 col-md-5":
                                  _vm.moment(_vm.now) <=
                                  _vm.moment(_vm.end_, "YYYY-MM-DD HH:mm:ss")
                              }
                            },
                            [
                              _vm.moment(_vm.now) <
                              _vm.moment(_vm.start, "YYYY-MM-DD HH:mm:ss")
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color black Bold uppercase",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important;color: " +
                                        _vm.contests.config.COLORE_CHIARO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Promozione non ancora iniziata\n        "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.moment(_vm.now) >
                              _vm.moment(_vm.end_, "YYYY-MM-DD")
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color black Bold uppercase",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important;color: " +
                                        _vm.contests.config.COLORE_CHIARO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Promozione terminata\n        "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _c("div", { attrs: { id: "nav-profile " } }, [
                _c(
                  "div",
                  { staticClass: "container mt-5 pb-5 mb-5 back-white" },
                  [
                    _vm.playContest != ""
                      ? _c(
                          "div",
                          {
                            staticClass: "row justify-content-center pl-3 pr-3"
                          },
                          [
                            _c(
                              "badger-accordion",
                              { ref: "activeAccordion" },
                              [
                                _c(
                                  "badger-accordion-item",
                                  {
                                    on: {
                                      close: function($event) {
                                        _vm.selectedPlay = {}
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      {
                                        staticClass: "center black",
                                        slot: "header"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row justify-content-center mb-5 pb-5"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 col-md-10 mt-3 center"
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass: "uppercase",
                                                    class: {
                                                      "back-white color": !_vm.empty,
                                                      "back-color-3 white":
                                                        _vm.empty
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(_vm.title) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "color underline"
                                                  },
                                                  [
                                                    _c("br"),
                                                    _vm._v(
                                                      "Premi qui per vedere tutte le tue richieste di\n                    rimborso"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("br")
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-6 col-10 mb-md-0 mb-5"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-6 col-8 absolute center numberReg-2",
                                                    class: {
                                                      "numberReg-1":
                                                        _vm.my_registration_in_promo ==
                                                          _vm.maxRegistration &&
                                                        _vm.vw < 800 &&
                                                        _vm.vw > 700
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "h1",
                                                      {
                                                        staticClass:
                                                          "bordered-3 quadNum",
                                                        style:
                                                          "background: linear-gradient(87deg,rgba(255,255,255,1) 0%," +
                                                          _vm.contests.config
                                                            .COLORE_CHIARO +
                                                          " 15%," +
                                                          _vm.contests.config
                                                            .COLORE_MEDIO_CHIARO +
                                                          " 62%," +
                                                          _vm.contests.config
                                                            .COLORE_MEDIO_SCURO +
                                                          " 100%," +
                                                          _vm.contests.config
                                                            .COLORE_SCURO +
                                                          " 100%)"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.my_registration_in_promo
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "smallList-2"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "su " +
                                                                _vm._s(
                                                                  _vm.maxRegistration
                                                                ) +
                                                                " disponibili"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("VueSvgGauge", {
                                                  attrs: {
                                                    "start-angle": -90,
                                                    "end-angle": 90,
                                                    value:
                                                      _vm.my_registration_in_promo,
                                                    "separator-step": 10,
                                                    min: 0,
                                                    innerRadius: 70,
                                                    separatorThickness: 1,
                                                    max: _vm.maxRegistration,
                                                    "gauge-color": [
                                                      {
                                                        offset: 0,
                                                        color:
                                                          _vm.contests.config
                                                            .COLORE_MEDIO_CHIARO
                                                      },
                                                      {
                                                        offset: 100,
                                                        color:
                                                          _vm.contests.config
                                                            .COLORE_PRINCIPALE
                                                      }
                                                    ],
                                                    "scale-interval": 1
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.my_registration_in_promo <
                                                _vm.maxRegistration
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "inner-text Bold h5 text-center"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Richieste di rimborso effettuate"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "inner-text Bold h5 text-center"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Richieste di rimborso esaurite"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-10 mt-5" },
                                              [
                                                _c("a", [
                                                  _vm._v(
                                                    "Prodotti registrati: "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.products_registered
                                                      )
                                                    )
                                                  ])
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.playContest, function(
                                      some,
                                      cod
                                    ) {
                                      return _c(
                                        "template",
                                        {
                                          staticClass: "mb-4",
                                          slot: "content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              key: cod,
                                              staticClass:
                                                "row justify-content-center",
                                              attrs: { id: "centerEl" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "scroll-to",
                                                          rawName:
                                                            "v-scroll-to",
                                                          value: {
                                                            el: ".itemReview",
                                                            offset: -155,
                                                            duration: 900,
                                                            force: false
                                                          },
                                                          expression:
                                                            "{\n                      el: '.itemReview',\n                      offset: -155,\n                      duration: 900,\n                      force: false,\n                    }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "\n                      widthFull\n                      center\n                      text-left\n                      mini\n                      pointer\n                      cusCol\n                      mb-2\n                      mt-2\n                      font\n                      Bold\n                    ",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.selectedPlay = {}
                                                          _vm.selectedPlay[
                                                            cod
                                                          ] = some
                                                          _vm.secondClick(cod)
                                                          _vm.print(
                                                            _vm.selectedPlay
                                                          )
                                                          _vm.showShipForm = false
                                                        }
                                                      }
                                                    },
                                                    [
                                                      some.status == 0 ||
                                                      some.status == 2 ||
                                                      some.status == 1
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "color"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "info-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "( In corso di validazione )"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      some.status == 20 ||
                                                      some.status == 102
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass: "red"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "times-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status == 20
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Non valido )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 102
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Non rimborsato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      some.status == 10 ||
                                                      some.status == 100 ||
                                                      some.status == 101 ||
                                                      some.status == 110
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "green"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "check-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status == 10
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Validato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 100
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( In fase di rimborso )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 101
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Rimborso in corso )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 110
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Rimborsato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "container-fluid"
                                                },
                                                [
                                                  !!_vm.selectedPlay[cod]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: !!_vm
                                                                .selectedPlay[
                                                                cod
                                                              ],
                                                              expression:
                                                                "!!selectedPlay[cod]"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "row mb-5 itemReview justify-content-center"
                                                        },
                                                        [
                                                          _vm.selectedPlay[cod]
                                                            .status == 20
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-12 center mt-2 mb-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "h5",
                                                                    {
                                                                      staticClass:
                                                                        "Bold red"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        Motivazione di invalidazione: "
                                                                      ),
                                                                      _c("br"),
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .motivation
                                                                          ) +
                                                                          "\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-6 mt-5 colSxRiepilogo",
                                                              style:
                                                                "background: " +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_CHIARO +
                                                                "!important"
                                                            },
                                                            [
                                                              _c("h5", [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black customHowTo",
                                                                    style:
                                                                      "padding:10px;border-radius:10px;background: " +
                                                                      _vm
                                                                        .contests
                                                                        .config
                                                                        .COLORE_SCURO +
                                                                      "!important"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          Riepilogo dati inseriti:\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Totale scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .selectedPlay[
                                                                            cod
                                                                          ]
                                                                            .recVal
                                                                        ) +
                                                                        "€\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Data emissione scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .moment(
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .recDate
                                                                            )
                                                                            .format(
                                                                              "DD-MM-YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Ora emissione scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .selectedPlay[
                                                                            cod
                                                                          ]
                                                                            .recTime
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Data inserimento dati:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .moment(
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .playDate
                                                                            )
                                                                            .format(
                                                                              "DD-MM-YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                !_vm
                                                                  .selectedPlay[
                                                                  cod
                                                                ].iban &&
                                                                _vm.iban
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "black Medium"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "b",
                                                                          [
                                                                            _vm._v(
                                                                              "Il tuo iban:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.iban
                                                                            ) +
                                                                            "\n                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm.iban &&
                                                                    _vm
                                                                      .selectedPlay[
                                                                      cod
                                                                    ].iban
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "black Medium"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "b",
                                                                          [
                                                                            _vm._v(
                                                                              "L'iban su cui riceverai il rimborso:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "\n                          " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .iban
                                                                            ) +
                                                                            "\n                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium mb-2"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Prodotti registrati:"
                                                                      )
                                                                    ])
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "table",
                                                                  {
                                                                    staticClass:
                                                                      "mt-3"
                                                                  },
                                                                  [
                                                                    _c("thead"),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "tbody",
                                                                      [
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Prodotto\n                              "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Prezzo unitario\n                              "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Quantitá\n                              "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          JSON.parse(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .products
                                                                          ),
                                                                          function(
                                                                            prod,
                                                                            index
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "tr",
                                                                                {
                                                                                  key: index
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.product
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.price
                                                                                          ) +
                                                                                          " €\n                                "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.quantity
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "\n                        col-md-5\n                        center\n                        ml-md-5\n                        mt-md-5 mt-2 mt-md-0\n                        colDxRiepilogo\n                      ",
                                                              style:
                                                                "background: linear-gradient(87deg,rgba(255,255,255,1) 0%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_CHIARO +
                                                                " 15%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_MEDIO_CHIARO +
                                                                " 62%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_MEDIO_SCURO +
                                                                " 100%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_SCURO +
                                                                " 100%)"
                                                            },
                                                            [
                                                              _vm.selectedPlay[
                                                                cod
                                                              ].receipt &&
                                                              !_vm.selectedPlay[
                                                                cod
                                                              ].receipt
                                                                .toUpperCase()
                                                                .includes(
                                                                  ".PDF"
                                                                )
                                                                ? _c(
                                                                    "viewer",
                                                                    {
                                                                      staticClass:
                                                                        "images clearfix widthFull",
                                                                      on: {
                                                                        inited:
                                                                          _vm.inited
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "img-fluid img-mod mb-5",
                                                                          staticStyle: {
                                                                            "border-radius":
                                                                              "5px !important"
                                                                          },
                                                                          attrs: {
                                                                            src:
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .receipt
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      ref:
                                                                        "inv",
                                                                      refInFor: true,
                                                                      staticClass:
                                                                        "mt-5 mb-5"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "uppercase white btn-primary mb-5 mt-5 small",
                                                                          staticStyle: {
                                                                            padding:
                                                                              "7px",
                                                                            "font-size":
                                                                              "14px !important",
                                                                            "border-radius":
                                                                              "5px !important"
                                                                          },
                                                                          style:
                                                                            "background: " +
                                                                            _vm
                                                                              .contests
                                                                              .config
                                                                              .COLORE_SCURO +
                                                                            "!important",
                                                                          attrs: {
                                                                            href:
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .receipt,
                                                                            target:
                                                                              "_blank"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Clicca qui per vedere il pdf"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "h4",
                                                                {
                                                                  staticClass:
                                                                    "Bold pt-3 pb-3 black",
                                                                  style:
                                                                    "border-radius:10px;background: " +
                                                                    _vm.contests
                                                                      .config
                                                                      .COLORE_CHIARO +
                                                                    "!important"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        ID PRATICA : " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .selectedPlay[
                                                                          cod
                                                                        ]
                                                                          .codicePratica
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status ==
                                                                0 && !_vm.empty
                                                                ? _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "\n                          btn btn-primary\n                          uppercase\n                          btn-small\n                          mt-3 mt-lg-0\n                        ",
                                                                      style:
                                                                        "background: " +
                                                                        _vm
                                                                          .contests
                                                                          .config
                                                                          .COLORE_MEDIO_SCURO +
                                                                        "!important",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.disablePlay(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .codicePratica
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        Cancella registrazione\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "col-md-12 mt-5"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.playContest != ""
                      ? _c("div", {
                          staticClass:
                            "row mb-5 itemReview justify-content-center"
                        })
                      : _vm.playContest == "" && _vm.loadingState
                      ? _c("div", { staticClass: "row" }, [_vm._m(4)])
                      : _c("div", { staticClass: "row mt-5 pt-5 back-white" }, [
                          !_vm.empty &&
                          !_vm.contest &&
                          _vm.info &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD HH:mm:ss")
                            ? _c("div", { staticClass: "col center mt-5" }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass:
                                      "tizaFont bbaRed Bold uppercase center widthFull mt-5 mb-5"
                                  },
                                  [
                                    _vm._v(
                                      "\n            Non hai ancora inserito richieste di rimborso\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h3", { staticClass: "mt-5" }),
                                _vm._v(" "),
                                !_vm.contest
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-primary-1 mt-5 uppercase",
                                        style:
                                          "background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeView(1)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Registra subito il primo scontrino"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : !_vm.empty && !_vm.contest && _vm.info
                            ? _c("div", { staticClass: "col center mt-5" }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass:
                                      "tizaFont bbaRed center Bold uppercase widthFull mt-5 mb-5"
                                  },
                                  [
                                    _vm._v(
                                      "\n            Non hai inserito richieste di rimborso\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h3", { staticClass: "mt-5" }),
                                _vm._v(" "),
                                _vm.moment(_vm.now) <
                                _vm.moment(_vm.start, "YYYY-MM-DD HH:mm:ss")
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "btn btn-primary-1 pt-1 mt-5 uppercase",
                                        style:
                                          "background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important;color: " +
                                          _vm.contests.config.COLORE_CHIARO +
                                          "!important"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Promozione non ancora iniziata\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.moment(_vm.now) >
                                _vm.moment(_vm.end_, "YYYY-MM-DD")
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "black mt-5 h2 pt-1 pb-1 uppercase",
                                        style:
                                          "border-radius:10px;background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important;color: " +
                                          _vm.contests.config.COLORE_CHIARO +
                                          "!important"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Promozione terminata\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                  ]
                )
              ])
        ],
        1
      )
    : _vm._e()
}
var template_contatore_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("1"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("2"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("3"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("4"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col center" }, [
      _c("h3", [_vm._v("Carico ....")])
    ])
  }
]
template_contatore_render._withStripped = true
var template_contatore_esExports = { render: template_contatore_render, staticRenderFns: template_contatore_staticRenderFns }
/* harmony default export */ var contest_template_contatore = (template_contatore_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51b231c3", template_contatore_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/contest/template_contatore.vue
var template_contatore_disposed = false
var template_contatore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var template_contatore___vue_template_functional__ = false
/* styles */
var template_contatore___vue_styles__ = null
/* scopeId */
var template_contatore___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var template_contatore___vue_module_identifier__ = null
var template_contatore_Component = template_contatore_normalizeComponent(
  template_contatore,
  contest_template_contatore,
  template_contatore___vue_template_functional__,
  template_contatore___vue_styles__,
  template_contatore___vue_scopeId__,
  template_contatore___vue_module_identifier__
)
template_contatore_Component.options.__file = "src/components/contest/template_contatore.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51b231c3", template_contatore_Component.options)
  } else {
    hotAPI.reload("data-v-51b231c3", template_contatore_Component.options)
  }
  module.hot.dispose(function (data) {
    template_contatore_disposed = true
  })
})()}

/* harmony default export */ var components_contest_template_contatore = (template_contatore_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-gauge/index.vue

//
//
//
//
//
//


var GaugeChart = __webpack_require__("CBQm");

/* harmony default export */ var vue_gauge = ({
    name: 'vue-gauge',
    props: ['refid', 'options'],
    mounted: function mounted() {
        this.initPlugin(this.options);
    },

    methods: {
        initPlugin: function initPlugin() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this.gaugeId) {
                var config = {
                    hasNeedle: true,
                    needleColor: '#f76c57',
                    needleUpdateSpeed: 1000,
                    arcColors: ['#85a3ca', '#d3d3d3'],
                    arcDelimiters: [70],
                    rangeLabel: ['0', '100'],
                    chartWidth: 250,
                    needleValue: 70
                };
                config = extends_default()({}, config, options);

                // Element inside which you want to see the chart
                var element = document.querySelector("#" + this.gaugeId);

                // Drawing and updating the chart
                GaugeChart.gaugeChart(element, config.chartWidth, config).updateNeedle(config.needleValue);
            }
        }
    },
    computed: {
        gaugeId: function gaugeId() {
            if (typeof this.refid != 'undefined') {
                return this.refid;
            }
            return "vue-gauge";
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25baf33e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-gauge/index.vue
var vue_gauge_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "vue-gauge-item",
    attrs: { id: this.gaugeId }
  })
}
var vue_gauge_staticRenderFns = []
vue_gauge_render._withStripped = true
var vue_gauge_esExports = { render: vue_gauge_render, staticRenderFns: vue_gauge_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_node_modules_vue_gauge = (vue_gauge_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25baf33e", vue_gauge_esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-gauge/index.vue
var vue_gauge_disposed = false
var vue_gauge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var vue_gauge___vue_template_functional__ = false
/* styles */
var vue_gauge___vue_styles__ = null
/* scopeId */
var vue_gauge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vue_gauge___vue_module_identifier__ = null
var vue_gauge_Component = vue_gauge_normalizeComponent(
  vue_gauge,
  selectortype_template_index_0_node_modules_vue_gauge,
  vue_gauge___vue_template_functional__,
  vue_gauge___vue_styles__,
  vue_gauge___vue_scopeId__,
  vue_gauge___vue_module_identifier__
)
vue_gauge_Component.options.__file = "node_modules/vue-gauge/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25baf33e", vue_gauge_Component.options)
  } else {
    hotAPI.reload("data-v-25baf33e", vue_gauge_Component.options)
  }
  module.hot.dispose(function (data) {
    vue_gauge_disposed = true
  })
})()}

/* harmony default export */ var node_modules_vue_gauge = (vue_gauge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contest/template_soglia_premiofisico.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var template_soglia_premiofisico_moment = __webpack_require__("PJh5");

/* harmony default export */ var template_soglia_premiofisico = ({
  name: "contest",
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"],
    VueGauge: node_modules_vue_gauge
  },
  props: {
    pageTitle: {
      type: String,
      default: "Dashboard"
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      loadingState: "",
      moment: template_soglia_premiofisico_moment,
      statusPlay: {},
      contests: {},
      id: "",
      piva: "",
      title: ""
    }, defineProperty_default()(_ref, "title", ""), defineProperty_default()(_ref, "contest", true), defineProperty_default()(_ref, "premi", false), defineProperty_default()(_ref, "end_rec", ""), defineProperty_default()(_ref, "info", false), defineProperty_default()(_ref, "checkAccessOk", false), defineProperty_default()(_ref, "main_image", ""), defineProperty_default()(_ref, "main_text", ""), defineProperty_default()(_ref, "regulation", ""), defineProperty_default()(_ref, "time", false), defineProperty_default()(_ref, "$viewer", ""), defineProperty_default()(_ref, "vw", window.innerWidth), defineProperty_default()(_ref, "countdown", 0), defineProperty_default()(_ref, "datenow", ""), defineProperty_default()(_ref, "finish", false), defineProperty_default()(_ref, "cod_client", ""), defineProperty_default()(_ref, "products", []), defineProperty_default()(_ref, "products_registered", 0), defineProperty_default()(_ref, "total_product_value", 0), defineProperty_default()(_ref, "start", ""), defineProperty_default()(_ref, "end", ""), defineProperty_default()(_ref, "start_", ""), defineProperty_default()(_ref, "end_", ""), defineProperty_default()(_ref, "award_spec", ""), defineProperty_default()(_ref, "id", ""), defineProperty_default()(_ref, "award_image", ""), defineProperty_default()(_ref, "empty", true), defineProperty_default()(_ref, "minProduct", ""), defineProperty_default()(_ref, "minPrice", ""), defineProperty_default()(_ref, "regex", ""), defineProperty_default()(_ref, "playContest", ""), defineProperty_default()(_ref, "selectedPlay", {}), defineProperty_default()(_ref, "my_registration_in_promo", 0), defineProperty_default()(_ref, "my_registration_in_promo_done", 0), defineProperty_default()(_ref, "maxRegistration", 0), defineProperty_default()(_ref, "playConsens", true), defineProperty_default()(_ref, "maxRegistrationOr", 0), defineProperty_default()(_ref, "now", template_soglia_premiofisico_moment()), defineProperty_default()(_ref, "maxRegistration_", 0), defineProperty_default()(_ref, "step", __webpack_require__("G0Sz")), defineProperty_default()(_ref, "doc", __webpack_require__("YAyH")), _ref;
  },

  methods: {
    setProfileData: function setProfileData() {
      this.piva = this.profile.piva;
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.id;

      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.cod_client = this.profile.cod;

      this.group = this.profile.groupPh;
      this.profileId = this.profile.id;
    },
    checkAccess: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.piva == this.$route.params.piva)) {
                  _context.next = 8;
                  break;
                }

                this.$track("checkAccess", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/checkAccess",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this.loadingState = false;
                  _this.checkAccessOk = true;
                  _this.$track("checkAccess", "SUCCESS");
                  _this.$track("checkAccess", resp.data);
                  if (resp.data == "access_denied") {
                    _this.message = '<b class="Bold">Non hai accesso a questa promozione</b>';
                    _this.UploadError("ATTENZIONE!", _this.message);
                  } else {
                    _this.loadProducts();
                    _this.thisPlay();
                  }
                }).catch(function (err) {
                  _this.loadingState = false;
                  _this.$track("checkAccess", "ERROR");
                  err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
                _context.next = 9;
                break;

              case 8:
                this.$router.push("/");

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkAccess() {
        return _ref2.apply(this, arguments);
      }

      return checkAccess;
    }(),
    myRegistration: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _this2 = this;

        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.piva != this.$route.params.piva)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 8;
                break;

              case 3:
                this.$track("myRegistration", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  promo: this.contests,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context2.next = 8;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/myRegistration",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this2.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this2.$track("myRegistration", "SUCCESS");
                  _this2.$track("myRegistration", resp.data);
                  if (resp.data) {
                    _this2.maxRegistration = parseInt(resp.data[0].bonus) + parseInt(resp.data[0].extra_bonus);
                    _this2.maxRegistrationOr = parseInt(resp.data[0].bonus);
                  }
                }).catch(function (err) {
                  _this2.$track("myRegistration", "ERROR");
                  err.response.data = _this2.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function myRegistration() {
        return _ref3.apply(this, arguments);
      }

      return myRegistration;
    }(),
    thisPlay: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this3 = this;

        var data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.$route.params.cod) {
                  _context3.next = 9;
                  break;
                }

                this.loadingState = true;
                this.$track("thisPlay", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context3.next = 7;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/thisPlay",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this3.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this3.$track("thisPlay", "SUCCESS");
                  _this3.$track("thisPlay", resp.data);
                  _this3.loadingState = false;
                  if (resp.data.summary[0]) _this3.statusPlay = resp.data.summary[0];else {
                    _this3.statusPlay = {
                      TOTAL: 0,
                      TO_ELABORATE: 0,
                      ELABORATE_OK: 0,
                      ELABORATE_KO: 0,
                      ELABORATE_KO_CONFIRMED: 0,
                      ELABORATE_OK_CONFIRMED: 0,
                      CASHBACK_START: 0,
                      CASHBACK_GONE: 0,
                      CASHBACK_ERROR: 0,
                      CASHBACK_SENT: 0,
                      ASKED_REBATE: 0,
                      RECEIVED_REBATE: 0,
                      ASKED: 0,
                      RECEIVED: 0
                    };
                  }

                  _this3.products_registered = resp.data.products_registered;
                  _this3.total_product_value = resp.data.total_product_value;
                }).catch(function (err) {
                  _this3.loadingState = false;
                  _this3.$track("thisPlay", "ERROR");
                  err.response.data = _this3.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 7:
                _context3.next = 10;
                break;

              case 9:
                this.setProfileData();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function thisPlay() {
        return _ref4.apply(this, arguments);
      }

      return thisPlay;
    }(),

    takeMyAttempts: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _this4 = this;

        var data;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.loadingState = true;

                if (!this.contests.config) {
                  _context4.next = 10;
                  break;
                }

                this.$track("takeMyAttempts", "START");

                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  desc: this.contests.config.DESTINAZIONE_SCONTO,
                  profile: this.profile,
                  promo: this.contests,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };


                this.$track("takeMyAttempts", data);
                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context4.next = 8;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/takeMyAttempts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this4.loadingState = false;
                  _this4.$track("takeMyAttempts", "SUCCESS");
                  resp.data = _this4.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this4.$track("takeMyAttempts", resp.data);
                  _this4.my_registration_in_promo = resp.data.OTTENUTI_PUNTI;
                  _this4.my_registration_in_promo_done = resp.data.TOTALI_RICHIESTI_PUNTI;
                  _this4.playContest = resp.data.allPlayForPromo_punti;
                }).catch(function (err) {
                  _this4.loadingState = false;
                  _this4.$track("takeMyAttempts", "ERROR");
                  err.response.data = _this4.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 8:
                _context4.next = 12;
                break;

              case 10:
                _context4.next = 12;
                return this.getThisContest();

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function takeMyAttempts() {
        return _ref5.apply(this, arguments);
      }

      return takeMyAttempts;
    }(),
    disablePlay: function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(idDis) {
        var _this5 = this;

        var data;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.loadingState = true;
                this.$track("disablePlay", "START");
                data = {
                  id: idDis,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context5.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/disablePlay",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this5.loadingState = false;
                  _this5.$track("disablePlay", "SUCCESS");
                  resp.data = _this5.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this5.$track("disablePlay", resp.data);
                  if (resp.data) _this5.shoSuccess("Pratica eliminata correttamente", "La pratica " + idDis + " è stata eliminata correttamente");else _this5.UploadError("Errore", "Riprova piú tardi");
                }).catch(function (resp) {
                  _this5.$track("disablePlay", "ERROR");
                  err.response.data = _this5.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function disablePlay(_x) {
        return _ref6.apply(this, arguments);
      }

      return disablePlay;
    }(),
    loadProducts: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _this6 = this;

        var data;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.loadingState = true;
                this.$track("loadProducts", "START");
                data = {
                  id: this.$route.params.id,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context6.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/loadProducts",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this6.$track("loadProducts", "SUECCESS");
                  var prod = [];
                  for (var x in resp.data) {
                    var y = [];
                    y["key"] = x;
                    y["label"] = resp.data[x];
                    prod.push(y);
                  }
                  _this6.products = prod;
                  _this6.loadingState = false;
                }).catch(function (resp) {
                  _this6.loadingState = false;
                  _this6.$track("loadProducts", "ERROR");
                });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function loadProducts() {
        return _ref7.apply(this, arguments);
      }

      return loadProducts;
    }(),

    getThisContest: function () {
      var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var _this7 = this;

        var data;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContest", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ACTIVE",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context7.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this7.loadingState = false;
                  resp.data = _this7.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this7.$track("getThisContest", "SUCCESS");

                  if (resp.data) _this7.empty = false;else _this7.getThisContestNOTACTIVE();
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  if (resp.data) {
                    _this7.contests = resp.data[0];
                    _this7.myRegistration();
                    _this7.takeMyAttempts();
                    _this7.type = _this7.contests.config.TIPOLOGIA_RIEPILOGO;
                    _this7.start_ = _this7.contests.start;
                    _this7.startRec_ = _this7.contests.startRec;
                    _this7.start_rec = template_soglia_premiofisico_moment(_this7.startRec_).format("DD/MM/YYYY");
                    _this7.endRec_ = _this7.contests.endRec;
                    _this7.end_rec = template_soglia_premiofisico_moment(_this7.endRec_).format("DD-MM-YYYY");
                    _this7.start = template_soglia_premiofisico_moment(_this7.start_).format("DD-MM-YYYY");
                    _this7.end_ = _this7.contests.end;
                    _this7.end = template_soglia_premiofisico_moment(_this7.end_).format("DD-MM-YYYY");

                    _this7.now = template_soglia_premiofisico_moment();
                    var then = template_soglia_premiofisico_moment(_this7.end_);

                    var dif = then.diff(_this7.now);
                    if (dif <= 0) {
                      _this7.finish = true;
                      _this7.countdown = 0 - dif;
                    } else {
                      _this7.countdown = dif;
                    }
                    _this7.$track("getThisContest", _this7.contests);
                  }
                }).catch(function (err) {
                  _this7.loadingState = false;
                  err.response.data = _this7.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this7.$track("getThisContest", "ERROR");
                });

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getThisContest() {
        return _ref8.apply(this, arguments);
      }

      return getThisContest;
    }(),
    getThisContestNOTACTIVE: function () {
      var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var _this8 = this;

        var data;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContestNOTACTIVE", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ENDED",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context8.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this8.loadingState = false;
                  resp.data = _this8.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this8.$track("getThisContestNOTACTIVE", "SUCCESS");
                  if (!resp.data) {}
                  if (resp.data) {
                    _this8.empty = false;
                  }
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }

                  _this8.contests = resp.data[0];
                  _this8.type = _this8.contests.config.TIPOLOGIA_RIEPILOGO;
                  _this8.start_ = _this8.contests.start;
                  _this8.start = template_soglia_premiofisico_moment(_this8.start_).format("DD-MM-YYYY");
                  _this8.end_ = _this8.contests.end;
                  _this8.end = template_soglia_premiofisico_moment(_this8.end_).format("DD-MM-YYYY");
                  _this8.startRec_ = _this8.contests.startRec;
                  _this8.start_rec = template_soglia_premiofisico_moment(_this8.startRec_).format("DD/MM/YYYY");
                  _this8.endRec_ = _this8.contests.endRec;
                  _this8.end_rec = template_soglia_premiofisico_moment(_this8.endRec_).format("DD-MM-YYYY");

                  _this8.now = template_soglia_premiofisico_moment();
                  var then = template_soglia_premiofisico_moment(_this8.end_);

                  var dif = then.diff(_this8.now);
                  if (dif <= 0) {
                    _this8.finish = true;
                    _this8.countdown = 0 - dif;
                  } else {
                    _this8.countdown = dif;
                  }
                  _this8.$track("getThisContestNOTACTIVE", _this8.contests);
                  _this8.takeMyAttempts();
                }).catch(function (err) {
                  _this8.loadingState = false;
                  err.response.data = _this8.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this8.$track("getThisContestNOTACTIVE", "ERROR");
                });

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getThisContestNOTACTIVE() {
        return _ref9.apply(this, arguments);
      }

      return getThisContestNOTACTIVE;
    }(),
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show() {
      var el = this.$refs.inv;
      var viewer = el.$viewer;
      viewer.show();
      viewer.zoomTo(2);
      viewer.move(-1, 0);
    },
    print: function print(value) {},
    secondClick: function secondClick(id) {
      var _vue = this;
      if (_vue.activeId != "no") {
        _vue.$track("pre ID: " + id + " Active:" + _vue.activeId);

        if (id == _vue.activeId) {
          _vue.$track("same");
          var _vue = this;
          setTimeout(function () {
            _vue.$scrollTo("#centerEl", 0, { offset: -125 });
          }, 0);
          _vue.selectedPlay = {};
          _vue.activeId = "no";
        } else {
          _vue.$track("newOpen Exisrt one");
          _vue.activeId = id;
        }
      } else {
        _vue.$track("new not exist");
        _vue.activeId = id;
      }
    },
    UploadError: function UploadError(desc, specific) {
      var _this9 = this;

      this.$swal({
        type: "info",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          _this9.$router.push("/");
        }
      });
    },
    shoSuccess: function shoSuccess(desc, specific) {
      this.$swal({
        type: "info",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          window.location.reload();
        }
      });
    },

    /************************* */
    changeView: function changeView(val) {
      if (val == 1) {
        this.contest = true;
        this.info = false;
        this.premi = false;
      } else if (val == 2) {
        this.contest = false;
        this.info = true;
        this.premi = false;
      } else if (val == 3) {
        this.premi = true;
        this.contest = false;
        this.info = false;
      }
    },
    toContest: function toContest() {
      this.contest = true;
      this.info = false;
    }
  },
  /********************************************************************************************* */
  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.checkAccess();
    },
    "$route.params.id": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.piva": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.cod": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    /**************** */
    selectedPlay: function selectedPlay(array) {
      this.imageLoaded = true;
    },
    info: function info() {
      if (this.info) {
        var _vue = this;
        setTimeout(function () {
          _vue.$refs.activeAccordion.open(0);
        }, 100);
      }
    }
    /**************** */
  },

  mounted: function mounted() {
    var _this10 = this;

    this.id = this.$route.params.id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    if (!cod) {
      this.$router.push("/");
    }
    if (!piva) {
      this.$router.push("/");
    }

    if (this.getProfile.piva) {
      this.setProfileData();
      this.checkAccess();
      this.now = template_soglia_premiofisico_moment().format("DD-MM-YYYY");
    }

    window.onresize = function () {
      _this10.vw = window.innerWidth;
      _this10.vh = window.innerHeight;
    };
    var _vue = this;
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);
  },
  created: function () {
    var _ref10 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.getThisContest();

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function created() {
      return _ref10.apply(this, arguments);
    }

    return created;
  }(),
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e343be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contest/template_soglia_premiofisico.vue
var template_soglia_premiofisico_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.contests.config
    ? _c(
        "div",
        { attrs: { id: "top" } },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row mt-5 pt-5" }, [
              _vm.contests.config
                ? _c("div", { staticClass: "col-12 center" }, [
                    _c("img", {
                      staticClass: "img img-fluid",
                      attrs: { src: _vm.contests.config.LOGO_INTERNO }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("nav", {}, [
              _c(
                "div",
                {
                  staticClass: "nav nav-tabs mt-3",
                  attrs: { id: "nav-tab", role: "tablist" }
                },
                [
                  _vm.contest
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link active",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-home-tab",
                            "data-toggle": "tab",
                            href: "#nav-home",
                            role: "tab",
                            "aria-controls": "nav-home",
                            "aria-selected": "true"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(1)
                            }
                          }
                        },
                        [_vm._v("Promozione")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link active",
                          attrs: {
                            id: "nav-home-tab",
                            "data-toggle": "tab",
                            href: "#nav-home",
                            role: "tab",
                            "aria-controls": "nav-home",
                            "aria-selected": "true"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(1)
                            }
                          }
                        },
                        [_vm._v("Promozione")]
                      ),
                  _vm._v(" "),
                  _vm.info
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(2)
                            }
                          }
                        },
                        [_vm._v("dettaglio caricamenti")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(2)
                            }
                          }
                        },
                        [_vm._v("dettaglio caricamenti")]
                      ),
                  _vm._v(" "),
                  _vm.premi
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(3)
                            }
                          }
                        },
                        [_vm._v("catalogo premi")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(3)
                            }
                          }
                        },
                        [_vm._v("catalogo premi")]
                      )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.info && _vm.contest && !_vm.premi
            ? _c(
                "div",
                {
                  staticClass: "container padd pt-2 pb-5",
                  attrs: { id: "nav-home" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-center pb-5 pt-3 back-white"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-9 mt-3 center",
                          class: { "back-color-3": _vm.empty },
                          on: {
                            click: function($event) {
                              return _vm.toContest()
                            }
                          }
                        },
                        [
                          _vm.my_registration_in_promo <= _vm.maxRegistration &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD")
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Play",
                                      params: {
                                        id: _vm.id,
                                        piva: _vm.piva,
                                        cod: _vm.cod_client
                                      }
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "center padd",
                                      class: {
                                        "back-color-2 white":
                                          _vm.my_registration_in_promo >
                                          _vm.maxRegistration,
                                        "back-white color uppercase ":
                                          _vm.my_registration_in_promo <=
                                            _vm.maxRegistration && !_vm.empty,
                                        "back-color-3 white uppercase":
                                          _vm.my_registration_in_promo <
                                            _vm.maxRegistration && _vm.empty
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.title) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.empty
                                    ? _c(
                                        "small",
                                        { staticClass: "color underline" },
                                        [
                                          _vm._v(
                                            "Premi qui per andare direttamente al caricamento dello\n            scontrino"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _vm.my_registration_in_promo < _vm.maxRegistration &&
                          !_vm.empty &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD")
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Play",
                                      params: {
                                        id: _vm.id,
                                        piva: _vm.piva,
                                        cod: _vm.cod_client
                                      }
                                    }
                                  }
                                },
                                [
                                  _c("countdown", {
                                    attrs: { time: _vm.countdown },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(props) {
                                            return [
                                              _vm.vw <= 770 && !_vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                Ti rimangono:\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.vw <= 770 && _vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                Mancano:\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row center justify-content-center pb-2 pt-3 text-right"
                                                },
                                                [
                                                  _vm.vw > 770 && !_vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-3 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Ti rimangono:\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.vw > 770 && _vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-3 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Mancano:\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(props.days)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.days == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    giorno\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("giorni")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(props.hours)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.hours == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic darkBlue Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    ora\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("ore")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.minutes
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.minutes == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    minuto\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("minuti")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.seconds
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.seconds == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    secondo\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("secondi")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.vw >= 770 && !_vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-1 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  per registrare "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "uno scontrino\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.vw >= 770 && _vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-1 text-left activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  al termine"
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "della promozione\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.vw < 770 && !_vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                per registrare uno scontrino\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.vw < 770 && _vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                al termine della promozione\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3705344063
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "center black Bold mr-lg-5 mb-md-5 mt-lg-0 mt-3"
                            },
                            [
                              _vm._v("\n          Validitá promozione: dal "),
                              _c("b", { staticClass: "underline" }, [
                                _vm._v(_vm._s(_vm.start))
                              ]),
                              _vm._v(" al\n          "),
                              _c("b", { staticClass: "underline" }, [
                                _vm._v(_vm._s(_vm.end_rec)),
                                _c("br")
                              ]),
                              _vm._v(
                                "con possibilità di\n          caricare gli scontrini fino al "
                              ),
                              _c("b", [_vm._v(_vm._s(_vm.end))])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.empty
                        ? _c("div", { staticClass: "col-md-10 center" }, [
                            _vm.finish
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "bordered-1 Black Bold h3 mt-3"
                                  },
                                  [
                                    _vm._v(
                                      "\n          Promozione terminata\n        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v("\n        Validitá promozione: dal "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(_vm.start))
                            ]),
                            _vm._v(" al\n        "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(_vm.end_rec)),
                              _c("br")
                            ]),
                            _vm._v(
                              " con possibilità di\n        caricare gli scontrini fino al "
                            ),
                            _c("b", [_vm._v(_vm._s(_vm.end))])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.contests.config
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-4 col-md-4 pt-5 mt-lg-0 mt-md-4 center mb-3 mb-md-0"
                            },
                            [
                              !!_vm.contests.config.REGOLAMENTO
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.contests.config.REGOLAMENTO,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "\n              center\n              uppercase\n              white\n              bordered\n              back-color-1\n              btn btn-primary-4\n              mb-2\n            ",
                                          style:
                                            "background: " +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "!important"
                                        },
                                        [
                                          _vm._v("\n            Regolamento "),
                                          _c("img", { attrs: { src: _vm.doc } })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              !!_vm.contests.config.FAQ
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.contests.config.FAQ,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "\n              center\n              uppercase\n              back-color-1\n              white\n              bordered\n              btn btn-primary-4\n            ",
                                          style:
                                            "background: " +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "!important"
                                        },
                                        [
                                          _vm._v("\n            Faq "),
                                          _c("img", { attrs: { src: _vm.doc } })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.finish
                        ? _c(
                            "div",
                            { staticClass: "col-md-4 col-8 text-left" },
                            [
                              _vm.vw > 1000
                                ? _c("vue-gauge", {
                                    attrs: {
                                      refid: "type-unique-id",
                                      options: {
                                        needleValue:
                                          _vm.my_registration_in_promo,
                                        chartWidth: [_vm.vw * 0.2],
                                        centralLabel: [""],
                                        arcColors: [
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "",
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_CHIARO +
                                            "",
                                          "" +
                                            _vm.contests.config.COLORE_SCURO +
                                            ""
                                        ],
                                        arcLabels: [55, 80, 100],
                                        arcDelimiters: [55, 80, 99],
                                        hasNeedle: [true],
                                        arcOverEffect: [true],
                                        needleColor: ["#f29daf"]
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vw > 600 && _vm.vw < 1000
                                ? _c("vue-gauge", {
                                    attrs: {
                                      refid: "type-unique-id",
                                      options: {
                                        needleValue:
                                          _vm.my_registration_in_promo,
                                        chartWidth: [_vm.vw * 0.3],
                                        centralLabel: [""],
                                        arcColors: [
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "",
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_CHIARO +
                                            "",
                                          "" +
                                            _vm.contests.config.COLORE_SCURO +
                                            ""
                                        ],
                                        arcLabels: [55, 80, 100],
                                        arcDelimiters: [55, 80, 99],
                                        hasNeedle: [true],
                                        arcOverEffect: [true],
                                        needleColor: ["#f29daf"]
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vw < 600
                                ? _c("vue-gauge", {
                                    attrs: {
                                      refid: "type-unique-id",
                                      options: {
                                        needleValue:
                                          _vm.my_registration_in_promo,
                                        chartWidth: [_vm.vw * 0.6],
                                        centralLabel: [""],
                                        arcColors: [
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "",
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_CHIARO +
                                            "",
                                          "" +
                                            _vm.contests.config.COLORE_SCURO +
                                            ""
                                        ],
                                        arcLabels: [55, 80, 100],
                                        arcDelimiters: [55, 80, 99],
                                        hasNeedle: [true],
                                        arcOverEffect: [true],
                                        needleColor: ["#f29daf"]
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "punti Bold h5 text-center" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.my_registration_in_promo) +
                                        " punti ottenuti"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n            su " +
                                        _vm._s(
                                          _vm.my_registration_in_promo_done
                                        ) +
                                        " richiesti"
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.empty && !_vm.finish
                        ? _c(
                            "div",
                            { staticClass: "col-lg-4 col-md-4 mt-5 pt-4" },
                            [_vm._m(0)]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.empty && !_vm.finish
                    ? _c(
                        "div",
                        {
                          staticClass: "row justify-content-center pt-md-5",
                          class: {
                            "back-white": !_vm.empty && _vm.contest && !_vm.info
                          }
                        },
                        [
                          _vm.contests.config.STEP_1
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_1)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_2
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_2)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_3
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_3)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_4
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_4)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.empty && _vm.finish
                    ? _c(
                        "div",
                        {
                          staticClass: "row justify-content-center",
                          class: {
                            "back-white": !_vm.empty && _vm.contest && !_vm.info
                          }
                        },
                        [
                          _c("div", { staticClass: "col-10" }, [
                            _c("img", {
                              staticClass: "img-fluid img",
                              attrs: { src: _vm.contests.config.IMMAGINE_HOME }
                            })
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row pt-5 pb-5 back-white",
                      class: {
                        "back-white justify-content-center":
                          !_vm.empty && _vm.contest && !_vm.info
                      }
                    },
                    [
                      !_vm.empty &&
                      _vm.contest &&
                      !_vm.info &&
                      _vm.moment(_vm.now) <= _vm.moment(_vm.end_, "YYYY-MM-DD")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-5 center mt-md-4 mt-5 pt-lg-0 pt-md-4"
                            },
                            [
                              _vm.my_registration_in_promo < _vm.maxRegistration
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important",
                                      attrs: {
                                        to: {
                                          name: "Play",
                                          params: {
                                            id: _vm.id,
                                            piva: _vm.piva,
                                            cod: _vm.cod_client
                                          }
                                        }
                                      }
                                    },
                                    [_vm._v("Registra uno scontrino")]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color white Medium h5",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Numero massimo di richieste di rimborso raggiunto\n        "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.empty && _vm.contest && !_vm.info
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "center mt-md-4 mt-5 pt-lg-0 pt-md-4",
                              class: {
                                "col-12":
                                  _vm.moment(_vm.now) >=
                                  _vm.moment(_vm.end, "DD-MM-YYYY"),
                                "col-lg-5 col-md-5":
                                  _vm.moment(_vm.now) <=
                                  _vm.moment(_vm.end_, "YYYY-MM-DD")
                              }
                            },
                            [
                              _vm.moment(_vm.now) <
                              _vm.moment(_vm.start, "YYYY-MM-DD HH:mm:ss")
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color black Bold uppercase",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important;color: " +
                                        _vm.contests.config.COLORE_CHIARO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Promozione non ancora iniziata\n        "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.moment(_vm.now) >=
                              _vm.moment(_vm.end, "DD-MM-YYYY")
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color black Bold uppercase",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important;color: " +
                                        _vm.contests.config.COLORE_CHIARO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Promozione terminata\n        "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm.info && !_vm.contest && !_vm.premi
            ? _c("div", { attrs: { id: "nav-profile " } }, [
                _c(
                  "div",
                  { staticClass: "container mt-5 pb-5 mb-5 back-white" },
                  [
                    _vm.playContest != ""
                      ? _c(
                          "div",
                          {
                            staticClass: "row justify-content-center pl-3 pr-3"
                          },
                          [
                            _c(
                              "badger-accordion",
                              { ref: "activeAccordion" },
                              [
                                _c(
                                  "badger-accordion-item",
                                  {
                                    on: {
                                      close: function($event) {
                                        _vm.selectedPlay = {}
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      {
                                        staticClass: "center black",
                                        slot: "header"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row justify-content-center mb-5 pb-5"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 col-md-10 mt-3 center"
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass: "uppercase",
                                                    class: {
                                                      "back-white color": !_vm.empty,
                                                      "back-color-3 white":
                                                        _vm.empty
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(_vm.title) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "color underline"
                                                  },
                                                  [
                                                    _c("br"),
                                                    _vm._v(
                                                      "Premi qui per vedere tutte le tue richieste\n                    punti"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("br")
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-6 col-10 mb-md-0 mb-5"
                                              },
                                              [
                                                _vm.vw > 600
                                                  ? _c("vue-gauge", {
                                                      attrs: {
                                                        refid: "type-unique-id",
                                                        options: {
                                                          needleValue:
                                                            _vm.my_registration_in_promo,
                                                          chartWidth: [500],
                                                          centralLabel: [""],
                                                          arcColors: [
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_SCURO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_CHIARO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_SCURO +
                                                              ""
                                                          ],
                                                          arcLabels: [
                                                            55,
                                                            80,
                                                            100
                                                          ],
                                                          arcDelimiters: [
                                                            55,
                                                            80,
                                                            99
                                                          ],
                                                          hasNeedle: [true],
                                                          arcOverEffect: [true],
                                                          needleColor: [
                                                            "#f29daf"
                                                          ]
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.vw < 600
                                                  ? _c("vue-gauge", {
                                                      attrs: {
                                                        refid: "type-unique-id",
                                                        options: {
                                                          needleValue:
                                                            _vm.my_registration_in_promo,
                                                          chartWidth: [300],
                                                          centralLabel: [""],
                                                          arcColors: [
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_SCURO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_CHIARO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_SCURO +
                                                              ""
                                                          ],
                                                          arcLabels: [
                                                            55,
                                                            80,
                                                            100
                                                          ],
                                                          arcDelimiters: [
                                                            55,
                                                            80,
                                                            99
                                                          ],
                                                          hasNeedle: [true],
                                                          arcOverEffect: [true],
                                                          needleColor: [
                                                            "#f29daf"
                                                          ]
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "punti Bold h5 text-center"
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.my_registration_in_promo
                                                        ) + " punti ottenuti"
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      su " +
                                                          _vm._s(
                                                            _vm.my_registration_in_promo_done
                                                          ) +
                                                          " richiesti"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.playContest, function(
                                      some,
                                      cod
                                    ) {
                                      return _c(
                                        "template",
                                        {
                                          staticClass: "mb-4",
                                          slot: "content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              key: cod,
                                              staticClass:
                                                "row justify-content-center",
                                              attrs: { id: "centerEl" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "scroll-to",
                                                          rawName:
                                                            "v-scroll-to",
                                                          value: {
                                                            el: ".itemReview",
                                                            offset: -155,
                                                            duration: 900,
                                                            force: false
                                                          },
                                                          expression:
                                                            "{\n                      el: '.itemReview',\n                      offset: -155,\n                      duration: 900,\n                      force: false,\n                    }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "\n                      widthFull\n                      center\n                      text-left\n                      mini\n                      pointer\n                      cusCol\n                      mb-2\n                      mt-2\n                      font\n                      Bold\n                    ",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.selectedPlay = {}
                                                          _vm.selectedPlay[
                                                            cod
                                                          ] = some
                                                          _vm.secondClick(cod)
                                                          _vm.print(
                                                            _vm.selectedPlay
                                                          )
                                                          _vm.showShipForm = false
                                                        }
                                                      }
                                                    },
                                                    [
                                                      some.status == 0 ||
                                                      some.status == 2 ||
                                                      some.status == 1
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "color"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "info-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "( In corso di validazione )"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      some.status == 20 ||
                                                      some.status == 102
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass: "red"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "times-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status == 20
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Non valido )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 102
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Non rimborsato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      some.status == 10 ||
                                                      some.status == 100 ||
                                                      some.status == 101 ||
                                                      some.status == 110
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "green"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "check-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status == 10
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Validato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 100
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( In fase di assegnazione punti )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 101
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Punti assegnati )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 110
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Rimborsato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "container-fluid"
                                                },
                                                [
                                                  !!_vm.selectedPlay[cod]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: !!_vm
                                                                .selectedPlay[
                                                                cod
                                                              ],
                                                              expression:
                                                                "!!selectedPlay[cod]"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "row mb-5 itemReview justify-content-center"
                                                        },
                                                        [
                                                          _vm.selectedPlay[cod]
                                                            .status == 20
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-12 center mt-2 mb-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "h5",
                                                                    {
                                                                      staticClass:
                                                                        "Bold red"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        Motivazione di invalidazione: "
                                                                      ),
                                                                      _c("br"),
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .motivation
                                                                          ) +
                                                                          "\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-6 mt-5 colSxRiepilogo",
                                                              style:
                                                                "background: " +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_CHIARO +
                                                                "!important"
                                                            },
                                                            [
                                                              _c("h5", [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black customHowTo",
                                                                    style:
                                                                      "padding:10px;border-radius:10px;background: " +
                                                                      _vm
                                                                        .contests
                                                                        .config
                                                                        .COLORE_SCURO +
                                                                      "!important"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          Riepilogo dati inseriti:\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Totale scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .selectedPlay[
                                                                            cod
                                                                          ]
                                                                            .recVal
                                                                        ) +
                                                                        "€\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Data emissione scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .moment(
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .recDate
                                                                            )
                                                                            .format(
                                                                              "DD-MM-YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Ora emissione scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .selectedPlay[
                                                                            cod
                                                                          ]
                                                                            .recTime
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Data inserimento dati:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .moment(
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .playDate
                                                                            )
                                                                            .format(
                                                                              "DD-MM-YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium mb-2"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Prodotti registrati:"
                                                                      )
                                                                    ])
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "table",
                                                                  {
                                                                    staticClass:
                                                                      "mt-3"
                                                                  },
                                                                  [
                                                                    _c("thead"),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "tbody",
                                                                      [
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Prodotto\n                              "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Punteggio\n                              "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Quantitá\n                              "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          JSON.parse(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .products
                                                                          ),
                                                                          function(
                                                                            prod,
                                                                            index
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "tr",
                                                                                {
                                                                                  key: index
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.product
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.points
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.quantity
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "\n                        col-md-5\n                        center\n                        ml-md-5\n                        mt-md-5 mt-2 mt-md-0\n                        colDxRiepilogo\n                      ",
                                                              style:
                                                                "background: linear-gradient(87deg,rgba(255,255,255,1) 0%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_CHIARO +
                                                                " 15%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_MEDIO_CHIARO +
                                                                " 62%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_MEDIO_SCURO +
                                                                " 100%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_SCURO +
                                                                " 100%)"
                                                            },
                                                            [
                                                              _vm.selectedPlay[
                                                                cod
                                                              ].receipt &&
                                                              !_vm.selectedPlay[
                                                                cod
                                                              ].receipt
                                                                .toUpperCase()
                                                                .includes(
                                                                  ".PDF"
                                                                )
                                                                ? _c(
                                                                    "viewer",
                                                                    {
                                                                      staticClass:
                                                                        "images clearfix widthFull",
                                                                      on: {
                                                                        inited:
                                                                          _vm.inited
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "img-fluid img-mod mb-5",
                                                                          staticStyle: {
                                                                            "border-radius":
                                                                              "5px !important"
                                                                          },
                                                                          attrs: {
                                                                            src:
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .receipt
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      ref:
                                                                        "inv",
                                                                      refInFor: true,
                                                                      staticClass:
                                                                        "mt-5 mb-5"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "uppercase white btn-primary mb-5 mt-5 small",
                                                                          staticStyle: {
                                                                            padding:
                                                                              "7px",
                                                                            "font-size":
                                                                              "14px !important",
                                                                            "border-radius":
                                                                              "5px !important"
                                                                          },
                                                                          style:
                                                                            "background: " +
                                                                            _vm
                                                                              .contests
                                                                              .config
                                                                              .COLORE_SCURO +
                                                                            "!important",
                                                                          attrs: {
                                                                            href:
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .receipt,
                                                                            target:
                                                                              "_blank"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Clicca qui per vedere il pdf"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "h4",
                                                                {
                                                                  staticClass:
                                                                    "Bold pt-3 pb-3 black",
                                                                  style:
                                                                    "border-radius:10px;background: " +
                                                                    _vm.contests
                                                                      .config
                                                                      .COLORE_CHIARO +
                                                                    "!important"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        ID PRATICA : " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .selectedPlay[
                                                                          cod
                                                                        ]
                                                                          .codicePratica
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status ==
                                                                0 && !_vm.empty
                                                                ? _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "\n                          btn btn-primary\n                          uppercase\n                          btn-small\n                          mt-3 mt-lg-0\n                        ",
                                                                      style:
                                                                        "background: " +
                                                                        _vm
                                                                          .contests
                                                                          .config
                                                                          .COLORE_MEDIO_SCURO +
                                                                        "!important",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.disablePlay(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .codicePratica
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        Cancella registrazione\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "col-md-12 mt-5"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.playContest != ""
                      ? _c("div", {
                          staticClass:
                            "row mb-5 itemReview justify-content-center"
                        })
                      : _vm.playContest == "" && _vm.loadingState
                      ? _c("div", { staticClass: "row" }, [_vm._m(5)])
                      : _c("div", { staticClass: "row mt-5 pt-5 back-white" }, [
                          !_vm.empty &&
                          !_vm.contest &&
                          _vm.info &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD")
                            ? _c("div", { staticClass: "col center mt-5" }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass:
                                      "tizaFont bbaRed Bold uppercase center widthFull mt-5 mb-5"
                                  },
                                  [
                                    _vm._v(
                                      "\n            Non hai ancora inserito richieste punti\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h3", { staticClass: "mt-5" }),
                                _vm._v(" "),
                                !_vm.contest
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-primary-1 mt-5 uppercase",
                                        style:
                                          "background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeView(1)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Registra subito il primo scontrino"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : !_vm.empty && !_vm.contest && _vm.info
                            ? _c("div", { staticClass: "col center mt-5" }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass:
                                      "tizaFont bbaRed center Bold uppercase widthFull mt-5 mb-5"
                                  },
                                  [
                                    _vm._v(
                                      "\n            Non hai caricato richieste punti\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h3", { staticClass: "mt-5" }),
                                _vm._v(" "),
                                _vm.moment(_vm.now) <
                                _vm.moment(_vm.start, "YYYY-MM-DD HH:mm:ss")
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "btn btn-primary-1 pt-1 mt-5 uppercase",
                                        style:
                                          "background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important;color: " +
                                          _vm.contests.config.COLORE_CHIARO +
                                          "!important"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Promozione non ancora iniziata\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.moment(_vm.now) >=
                                _vm.moment(_vm.end, "DD-MM-YYYY")
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "black mt-5 h2 pt-1 pb-1 uppercase",
                                        style:
                                          "border-radius:10px;background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important;color: " +
                                          _vm.contests.config.COLORE_CHIARO +
                                          "!important"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Promozione terminata\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.info && !_vm.contest && _vm.premi
            ? _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  { staticClass: "row justify-content-center back-white" },
                  [
                    _c("div", { staticClass: "col-10 pt-5 mt-2 mb-5 center" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 center mb-5" }, [
                      _c("h5", [
                        _vm._v(
                          "\n          “ Al termine dell’attività, in base alla soglia punti raggiunta,\n          avrai diritto a un credito da spendere sul sito Mygiftcardsquare.\n          Potrai scegliere tra tantissimi brand disponibili!”\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn-primary-4 btn white",
                          style:
                            "background: " +
                            _vm.contests.config.COLORE_MEDIO_SCURO +
                            "!important;color: " +
                            _vm.contests.config.COLORE_CHIARO +
                            "!important",
                          attrs: {
                            href: "https://www.mygiftcardsquare.it/home",
                            target: "_blank"
                          }
                        },
                        [
                          _c("b", { staticClass: "white Bold" }, [
                            _vm._v("Vai al sito MygiftcardSquare")
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm.vw > 800
                      ? _c("img", {
                          staticClass: "img img-fluid",
                          attrs: {
                            src: __webpack_require__("pFZQ")
                          }
                        })
                      : _c("img", {
                          staticClass: "img img-fluid",
                          attrs: {
                            src: __webpack_require__("Lz3v")
                          }
                        })
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var template_soglia_premiofisico_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "customHowTo pull-left" }, [
      _c("img", {
        staticClass: "img img-fluid",
        attrs: { src: __webpack_require__("PyBu") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("1"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("2"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("3"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("4"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col center" }, [
      _c("h3", [_vm._v("Carico ....")])
    ])
  }
]
template_soglia_premiofisico_render._withStripped = true
var template_soglia_premiofisico_esExports = { render: template_soglia_premiofisico_render, staticRenderFns: template_soglia_premiofisico_staticRenderFns }
/* harmony default export */ var contest_template_soglia_premiofisico = (template_soglia_premiofisico_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e343be", template_soglia_premiofisico_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/contest/template_soglia_premiofisico.vue
var template_soglia_premiofisico_disposed = false
var template_soglia_premiofisico_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var template_soglia_premiofisico___vue_template_functional__ = false
/* styles */
var template_soglia_premiofisico___vue_styles__ = null
/* scopeId */
var template_soglia_premiofisico___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var template_soglia_premiofisico___vue_module_identifier__ = null
var template_soglia_premiofisico_Component = template_soglia_premiofisico_normalizeComponent(
  template_soglia_premiofisico,
  contest_template_soglia_premiofisico,
  template_soglia_premiofisico___vue_template_functional__,
  template_soglia_premiofisico___vue_styles__,
  template_soglia_premiofisico___vue_scopeId__,
  template_soglia_premiofisico___vue_module_identifier__
)
template_soglia_premiofisico_Component.options.__file = "src/components/contest/template_soglia_premiofisico.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07e343be", template_soglia_premiofisico_Component.options)
  } else {
    hotAPI.reload("data-v-07e343be", template_soglia_premiofisico_Component.options)
  }
  module.hot.dispose(function (data) {
    template_soglia_premiofisico_disposed = true
  })
})()}

/* harmony default export */ var components_contest_template_soglia_premiofisico = (template_soglia_premiofisico_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contest/index.vue





//
//
//
//
//
//
//
//
//












var contest_moment = __webpack_require__("PJh5");

/* harmony default export */ var contest = ({
  name: "contest",
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"],
    CONTATORE: components_contest_template_contatore,
    SOGLIAPREMIOFISICO: components_contest_template_soglia_premiofisico

  },
  props: {
    pageTitle: {
      type: String,
      default: "Contest"
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      loadingState: "",
      moment: contest_moment,
      statusPlay: {},
      contests: {},
      type: '',
      id: "",
      piva: "",
      title: ""
    }, defineProperty_default()(_ref, "title", ""), defineProperty_default()(_ref, "contest", true), defineProperty_default()(_ref, "endRec", ""), defineProperty_default()(_ref, "info", false), defineProperty_default()(_ref, "checkAccessOk", false), defineProperty_default()(_ref, "main_image", ""), defineProperty_default()(_ref, "main_text", ""), defineProperty_default()(_ref, "regulation", ""), defineProperty_default()(_ref, "time", false), defineProperty_default()(_ref, "$viewer", ""), defineProperty_default()(_ref, "vw", window.innerWidth), defineProperty_default()(_ref, "countdown", 0), defineProperty_default()(_ref, "datenow", ""), defineProperty_default()(_ref, "finish", false), defineProperty_default()(_ref, "cod_client", ""), defineProperty_default()(_ref, "products", []), defineProperty_default()(_ref, "start", ""), defineProperty_default()(_ref, "end", ""), defineProperty_default()(_ref, "start_", ""), defineProperty_default()(_ref, "end_", ""), defineProperty_default()(_ref, "award_spec", ""), defineProperty_default()(_ref, "id", ""), defineProperty_default()(_ref, "award_image", ""), defineProperty_default()(_ref, "empty", true), defineProperty_default()(_ref, "minProduct", ""), defineProperty_default()(_ref, "minPrice", ""), defineProperty_default()(_ref, "regex", ""), defineProperty_default()(_ref, "playContest", ""), defineProperty_default()(_ref, "selectedPlay", {}), defineProperty_default()(_ref, "my_registration_in_promo", 0), defineProperty_default()(_ref, "maxRegistration", 0), defineProperty_default()(_ref, "playConsens", true), defineProperty_default()(_ref, "maxRegistrationOr", 0), defineProperty_default()(_ref, "now", contest_moment()), defineProperty_default()(_ref, "maxRegistration_", 0), defineProperty_default()(_ref, "step", __webpack_require__("G0Sz")), defineProperty_default()(_ref, "doc", __webpack_require__("YAyH")), _ref;
  },

  methods: {
    setProfileData: function setProfileData() {
      this.piva = this.profile.piva;
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.id;

      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.cod_client = this.profile.cod;

      this.group = this.profile.groupPh;
      this.profileId = this.profile.id;
    },
    checkAccess: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.piva == this.$route.params.piva)) {
                  _context.next = 8;
                  break;
                }

                this.$track("checkAccess", "START");
                data = {
                  id: this.$route.params.id,
                  piva: this.$route.params.piva,
                  cod: this.$route.params.cod,
                  group: this.group,
                  profile: this.profile,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/checkAccess",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this.loadingState = false;
                  _this.checkAccessOk = true;
                  _this.$track("checkAccess", "SUCCESS");
                  _this.$track("checkAccess", resp.data);
                  if (resp.data == "access_denied") {
                    _this.message = '<b class="Bold">Non hai accesso a questa promozione</b>';
                    _this.UploadError("", _this.message);
                  } else {}
                }).catch(function (err) {
                  _this.loadingState = false;
                  _this.$track("checkAccess", "ERROR");
                  err.response.data = _this.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                });

              case 6:
                _context.next = 9;
                break;

              case 8:
                this.$router.push("/");

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkAccess() {
        return _ref2.apply(this, arguments);
      }

      return checkAccess;
    }(),
    trackAccess: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _this2 = this;

        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loadingState = true;
                this.$track("trackAccess", "START");
                data = {
                  promotion_id_track: this.$route.params.id,
                  client_piva_track: this.$route.params.piva,
                  client_cod_track: this.$route.params.cod,
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context2.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/trackAccess",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this2.$track("trackAccess", "SUECCESS");
                  var prod = [];
                  for (var x in resp.data) {
                    var y = [];
                    y["key"] = x;
                    y["label"] = resp.data[x];
                    prod.push(y);
                  }
                  _this2.products = prod;
                  _this2.loadingState = false;
                }).catch(function (resp) {
                  _this2.loadingState = false;
                  _this2.$track("trackAccess", "ERROR");
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function trackAccess() {
        return _ref3.apply(this, arguments);
      }

      return trackAccess;
    }(),
    getThisContest: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this3 = this;

        var data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContest", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ACTIVE",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context3.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this3.loadingState = false;
                  resp.data = _this3.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this3.$track("getThisContest", "SUCCESS");
                  if (resp.data) _this3.empty = false;else _this3.getThisContestNOTACTIVE();
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  if (resp.data) {
                    _this3.trackAccess();
                    _this3.contests = resp.data[0];
                    _this3.type = _this3.contests.config.TIPOLOGIA_RIEPILOGO;
                    _this3.start_ = _this3.contests.start;
                    _this3.start = contest_moment(_this3.start_).format("DD-MM-YYYY");
                    _this3.end_ = _this3.contests.end;
                    _this3.end = contest_moment(_this3.end_).format("DD-MM-YYYY");

                    _this3.now = contest_moment();
                    var then = contest_moment(_this3.end_);

                    var dif = then.diff(_this3.now);
                    if (dif <= 0) {
                      _this3.finish = true;
                      _this3.countdown = 0 - dif;
                    } else {
                      _this3.countdown = dif;
                    }
                    _this3.$track("getThisContest", _this3.contests);
                  }
                }).catch(function (err) {
                  _this3.loadingState = false;
                  err.response.data = _this3.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this3.$track("getThisContest", "ERROR");
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getThisContest() {
        return _ref4.apply(this, arguments);
      }

      return getThisContest;
    }(),
    getThisContestNOTACTIVE: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _this4 = this;

        var data;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.loadingState = true;
                this.$track("getThisContestNOTACTIVE", "START");
                data = {
                  id: this.$route.params.id,
                  status: "ENDED",
                  id_platform: "DcJ7J1WfiwucqBl_lierac",
                  unique_key_db: "d971ad4ed27c5e76c0ccf95a",
                  vector_unique_key_db: "lierac_global"
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context4.next = 6;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://pharma.ubiqubit.it/" + "api/getThisContest",
                  headers: {
                    Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this4.loadingState = false;
                  resp.data = _this4.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this4.$track("getThisContestNOTACTIVE", "SUCCESS");
                  _this4.trackAccess();
                  if (!resp.data) {}
                  if (resp.data) {
                    _this4.empty = false;
                  }
                  for (var i in resp.data) {
                    var pass = JSON.parse(resp.data[i].config);
                    resp.data[i].config = pass;
                  }
                  _this4.contests = resp.data[0];
                  _this4.type = _this4.contests.config.TIPOLOGIA_RIEPILOGO;
                  _this4.start_ = _this4.contests.start;
                  _this4.start = contest_moment(_this4.start_).format("DD-MM-YYYY");
                  _this4.end_ = _this4.contests.end;
                  _this4.end = contest_moment(_this4.end_).format("DD-MM-YYYY");

                  _this4.now = contest_moment();
                  var then = contest_moment(_this4.end_);

                  var dif = then.diff(_this4.now);
                  if (dif <= 0) {
                    _this4.finish = true;
                    _this4.countdown = 0 - dif;
                  } else {
                    _this4.countdown = dif;
                  }
                  _this4.$track("getThisContestNOTACTIVE", _this4.contests);
                }).catch(function (err) {
                  _this4.loadingState = false;
                  err.response.data = _this4.$decryptByAES(err.response.data, "B%t$AD!YMfnCZnfD");
                  _this4.$track("getThisContestNOTACTIVE", "ERROR");
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getThisContestNOTACTIVE() {
        return _ref5.apply(this, arguments);
      }

      return getThisContestNOTACTIVE;
    }()

  },
  /********************************************************************************************* */
  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
      this.checkAccess();
    },
    "$route.params.id": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.piva": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    "$route.params.cod": {
      handler: function handler(id) {
        if (this.loaded) {}
      },
      deep: true,
      immediate: true
    },
    /**************** */
    selectedPlay: function selectedPlay(array) {
      this.imageLoaded = true;
    },
    info: function info() {
      if (this.info) {
        var _vue = this;
        setTimeout(function () {
          _vue.$refs.activeAccordion.open(0);
        }, 100);
      }
    }
    /**************** */
  },

  mounted: function mounted() {
    var _this5 = this;

    this.id = this.$route.params.id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    if (!cod) {
      this.$router.push("/");
    }
    if (!piva) {
      this.$router.push("/");
    }

    if (this.getProfile.piva) {
      this.setProfileData();
      this.getThisContest();
      this.checkAccess();
      this.now = contest_moment().format("DD-MM-YYYY");
    }

    window.onresize = function () {
      _this5.vw = window.innerWidth;
      _this5.vh = window.innerHeight;
    };
    var _vue = this;
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);
  },
  created: function () {
    var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.getThisContest();

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function created() {
      return _ref6.apply(this, arguments);
    }

    return created;
  }(),
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b6e4b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contest/index.vue
var contest_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull h-100 back-1" },
    [
      _vm.checkAccessOk && _vm.type == "CONTATORE" ? _c("CONTATORE") : _vm._e(),
      _vm._v(" "),
      _vm.checkAccessOk && _vm.type == "SOGLIA_PREMIOFISICO"
        ? _c("SOGLIAPREMIOFISICO")
        : _vm._e()
    ],
    1
  )
}
var contest_staticRenderFns = []
contest_render._withStripped = true
var contest_esExports = { render: contest_render, staticRenderFns: contest_staticRenderFns }
/* harmony default export */ var components_contest = (contest_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59b6e4b7", contest_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/contest/index.vue
var contest_disposed = false
var contest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contest___vue_template_functional__ = false
/* styles */
var contest___vue_styles__ = null
/* scopeId */
var contest___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var contest___vue_module_identifier__ = null
var contest_Component = contest_normalizeComponent(
  contest,
  components_contest,
  contest___vue_template_functional__,
  contest___vue_styles__,
  contest___vue_scopeId__,
  contest___vue_module_identifier__
)
contest_Component.options.__file = "src/components/contest/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59b6e4b7", contest_Component.options)
  } else {
    hotAPI.reload("data-v-59b6e4b7", contest_Component.options)
  }
  module.hot.dispose(function (data) {
    contest_disposed = true
  })
})()}

/* harmony default export */ var src_components_contest = (contest_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/iban/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var iban = ({
  name: "account",
  components: {},
  data: function data() {
    return {
      iban: "",
      accHolder: "",
      loadingState: false
    };
  },

  methods: {
    ibanInsert: function ibanInsert(e) {
      var _this = this;

      var data = {
        iban: this.iban,
        accHolder: this.accHolder,
        userToken: this.userToken,
        id_platform: "DcJ7J1WfiwucqBl_lierac",
        unique_key_db: "d971ad4ed27c5e76c0ccf95a",
        vector_unique_key_db: "lierac_global"
      };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      this.$validator.validate().then(function (valid) {
        if (valid && _this.userToken) {
          _this.loadingState = true;
          axios_default()({
            url: "https://pharma.ubiqubit.it/" + "api/insertField",
            data: { data: data },
            method: "POST",
            headers: {
              Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this.loadingState = false;
            resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
            _this.$track("ibanInsert", "ALL OK");
            if (resp.data) {
              _this.$store.dispatch(USER_REQUEST, _this.userToken).then(function () {});
              _this.showAlertSuccess("Hai correttamente inserito i dati relativi al tuo iban");
            } else {
              _this.showAlertError(err.response.data.message);
            }
          }).catch(function (err) {
            resp.response.data = _this.$decryptByAES(resp.response.data, "B%t$AD!YMfnCZnfD");
            _this.$track("ibanInsert", "ERROR");
            _this.showAlertError(err.response.data.message);
          });
        }
      });
    },
    showAlertError: function showAlertError(value) {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: value + " !",
        onClose: function onClose() {
          window.location.reload();
        }
      });
    },
    showAlertSuccess: function showAlertSuccess(value) {
      var _this2 = this;

      // Use sweetalret2
      this.$swal({
        type: "success",
        html: value,
        showCancelButton: false,
        animation: false,
        onClose: function onClose() {
          _this2.$router.push("/");
        }
      });
    },


    setProfileData: function setProfileData() {
      this.company = this.profile.company;
      this.email = this.profile.email;
      this.userToken = this.profile.userToken;
      this.piva = this.profile.piva;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      if (this.profile.iban) {
        this.$router.push("/");
      }
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    }
  },
  mounted: function mounted() {
    this.setProfileData();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f32a19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/iban/index.vue
var iban_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull mainBackground h-100 somatoline" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container dataContainer" }, [
        _c(
          "form",
          {
            staticClass: "pb-5",
            attrs: { id: "ibanInsert" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.ibanInsert.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center mt-5 pb-5" }, [
              _c("div", { staticClass: "col-md-6 mt-5 pt-5" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v(
                    "I dati inseriti serviranno per poter ricevere gli eventuali rimborsi a cui si ha accesso tramite le promozioni in piattaforma."
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v(
                    "Successivamente non sará possibile modificare i dati che si\n            stanno inserendo in questo form."
                  )
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v("Operazione richiesta solo al primo login.")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "group mt-5" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.accHolder,
                        expression: "accHolder"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, min: 5 },
                        expression: "{ required: true, min: 5 }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("accHolder"),
                      valid: !!_vm.accHolder
                    },
                    attrs: {
                      type: "text",
                      id: "accHolder",
                      name: "accHolder",
                      "data-vv-as": "Intestatario"
                    },
                    domProps: { value: _vm.accHolder },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.accHolder = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "accHolder" }
                    },
                    [_vm._v("Intestatario Iban")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("accHolder")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("accHolder")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.iban,
                        expression: "iban"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          ibanItalian: true,
                          ibanControl: true,
                          min: 5
                        },
                        expression:
                          "{\n                required: true,\n                ibanItalian: true,\n                ibanControl: true,\n                min: 5,\n              }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("iban"),
                      valid: !!_vm.iban
                    },
                    attrs: {
                      type: "text",
                      id: "iban",
                      name: "iban",
                      "data-vv-as": "Iban"
                    },
                    domProps: { value: _vm.iban },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.iban = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "iban" } },
                    [_vm._v("Iban")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("iban")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("iban")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._m(1)
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var iban_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "uppercase darkBlue  mt-5" }, [
      _c("b", [_vm._v("Prima di poter procedere é necessario inserire l'iban")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center mt-5 mt-md-3 mb-md-0 mb-5 pb-5" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary btn-lg mr-md-5",
          attrs: { tag: "button" }
        },
        [_vm._v("\n              CONFERMA\n            ")]
      )
    ])
  }
]
iban_render._withStripped = true
var iban_esExports = { render: iban_render, staticRenderFns: iban_staticRenderFns }
/* harmony default export */ var components_iban = (iban_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70f32a19", iban_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/iban/index.vue
var iban_disposed = false
var iban_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var iban___vue_template_functional__ = false
/* styles */
var iban___vue_styles__ = null
/* scopeId */
var iban___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var iban___vue_module_identifier__ = null
var iban_Component = iban_normalizeComponent(
  iban,
  components_iban,
  iban___vue_template_functional__,
  iban___vue_styles__,
  iban___vue_scopeId__,
  iban___vue_module_identifier__
)
iban_Component.options.__file = "src/components/iban/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70f32a19", iban_Component.options)
  } else {
    hotAPI.reload("data-v-70f32a19", iban_Component.options)
  }
  module.hot.dispose(function (data) {
    iban_disposed = true
  })
})()}

/* harmony default export */ var src_components_iban = (iban_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/phone/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_phone = ({
  name: "account",
  components: {},
  data: function data() {
    return {
      iban: "",
      phone: "",
      loadingState: false
    };
  },

  methods: {
    insertField: function insertField(e) {
      var _this = this;

      var data = {
        phone: '+39' + this.phone,
        userToken: this.userToken,
        id_platform: "DcJ7J1WfiwucqBl_lierac",
        unique_key_db: "d971ad4ed27c5e76c0ccf95a",
        vector_unique_key_db: "lierac_global"
      };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      this.$validator.validate().then(function (valid) {
        if (valid && _this.userToken) {
          _this.loadingState = true;
          axios_default()({
            url: "https://pharma.ubiqubit.it/" + "api/insertField",
            data: { data: data },
            method: "POST",
            headers: {
              Authorization: "Bearer " + "a47a065bee221a88306bafcd0c9b866cefb738ec",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this.loadingState = false;
            resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
            _this.$track("insertField", "ALL OK");
            if (resp.data) {
              _this.$store.dispatch(USER_REQUEST, _this.userToken).then(function () {});
              _this.showAlertSuccess("<small class='Medium'>Hai correttamente inserito i dati relativi al tuo numero di telefono</small>");
            } else {
              _this.showAlertError(err.response.data.message);
            }
          }).catch(function (err) {
            resp.response.data = _this.$decryptByAES(resp.response.data, "B%t$AD!YMfnCZnfD");
            _this.$track("insertField", "ERROR");
            _this.showAlertError(err.response.data.message);
          });
        }
      });
    },
    showAlertError: function showAlertError(value) {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: value + " !",
        onClose: function onClose() {
          window.location.reload();
        }
      });
    },
    showAlertSuccess: function showAlertSuccess(value) {
      var _this2 = this;

      // Use sweetalret2
      this.$swal({
        type: "success",
        html: value,
        showCancelButton: false,
        animation: false,
        onClose: function onClose() {
          _this2.$router.push("/play/" + _this2.$route.params.id + '/' + _this2.piva + '/' + _this2.cod);
        }
      });
    },


    setProfileData: function setProfileData() {
      this.company = this.profile.company;
      this.email = this.profile.email;
      this.userToken = this.profile.userToken;
      this.piva = this.profile.piva;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      if (this.profile.iban) {
        this.$router.push("/");
      }
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      this.setProfileData();
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    }
  },
  mounted: function mounted() {
    this.setProfileData();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607e8691","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/phone/index.vue
var phone_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull mainBackground h-100 somatoline" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container dataContainer" }, [
        _c(
          "form",
          {
            staticClass: "pb-5",
            attrs: { id: "insertField" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.insertField.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center mt-5 pb-5" }, [
              _c("div", { staticClass: "col-md-6 mt-5 pt-5" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v(
                    "Prima di poter caricare gli scontrini dal tuo cellulare tramite whatsapp dovrai indicare il numero di telefono da cui effettuerai i caricamenti"
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v(
                    "Successivamente non sará possibile modificare i dati che si\n            stanno inserendo in questo form."
                  )
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v("Operazione richiesta solo una volta.")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c("div", { staticClass: "col-1 mt-3 pt-1 " }, [
                    _vm._v("+39")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-11" }, [
                    _c("div", { key: 8, staticClass: "group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phone,
                            expression: "phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              max: 11,
                              min: 8,
                              regex: /^[3]+/
                            },
                            expression:
                              "{\n                max: 11,\n                min: 8,\n                regex: /^[3]+/,\n              }"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("phone"),
                          valid: !!_vm.phone
                        },
                        attrs: {
                          type: "text",
                          id: "phone",
                          name: "phone",
                          "data-vv-as": "Telefono"
                        },
                        domProps: { value: _vm.phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.phone = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "phone" }
                        },
                        [_vm._v("Telefono ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("phone")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("phone")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(1)
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var phone_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "uppercase darkBlue  mt-5" }, [
      _c("b", [
        _vm._v("Inserisci il numero whatsapp da cui effettuerai i caricamenti"),
        _c("img", {
          staticClass: "img img-fluid",
          attrs: { src: __webpack_require__("7KbZ") }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center mt-5 mt-md-3 mb-md-0 mb-5 pb-5" }, [
      _c(
        "button",
        { staticClass: "btn btn-primary mr-md-5", attrs: { tag: "button" } },
        [_vm._v("\n              CONFERMA\n            ")]
      )
    ])
  }
]
phone_render._withStripped = true
var phone_esExports = { render: phone_render, staticRenderFns: phone_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_phone = (phone_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-607e8691", phone_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/phone/index.vue
var phone_disposed = false
var phone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var phone___vue_template_functional__ = false
/* styles */
var phone___vue_styles__ = null
/* scopeId */
var phone___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var phone___vue_module_identifier__ = null
var phone_Component = phone_normalizeComponent(
  components_phone,
  selectortype_template_index_0_src_components_phone,
  phone___vue_template_functional__,
  phone___vue_styles__,
  phone___vue_scopeId__,
  phone___vue_module_identifier__
)
phone_Component.options.__file = "src/components/phone/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-607e8691", phone_Component.options)
  } else {
    hotAPI.reload("data-v-607e8691", phone_Component.options)
  }
  module.hot.dispose(function (data) {
    phone_disposed = true
  })
})()}

/* harmony default export */ var src_components_phone = (phone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/not_active/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var not_active_moment = __webpack_require__("PJh5");
/* harmony default export */ var not_active = ({
  name: "NotActive",
  data: function data() {
    return {
      time: false,
      countdown: 0,
      datenow: "",
      moment: not_active_moment
    };
  },

  methods: {
    timeReactive: function timeReactive() {
      var self = this;
      this.datenow = not_active_moment();

      if (not_active_moment() >= not_active_moment("2021-07-01 00:00:00")) {
        window.location.replace("/");
      }
    }
  },
  created: function created() {
    //// COUNDOWN
    //var data = '2019-09-09 00:00:00'

    setInterval(this.timeReactive, 1000);

    var now = not_active_moment();

    var then = not_active_moment("2021-07-01 00:00:00");
    var dif = then.diff(now);

    //moment.utc(moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
    this.countdown = dif;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375d5ff6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/not_active/index.vue
var not_active_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widthFull somatoline h-100",
      staticStyle: { "min-height": "85vh" },
      attrs: { id: "firstElem" }
    },
    [
      _c("div", { staticClass: "track" }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass:
                "Bold uppercase uppercase center theme widthFull mt-5"
            },
            [_vm._v("\n        La piattaforma sará attiva tra:\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-7 pb-2 mb-5 pt-5 center custForm" },
            [
              _c("countdown", {
                attrs: { time: _vm.countdown },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row center justify-content-center pb-5 pt-1"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.days) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.days == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  giorno\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  giorni\n                "
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.hours) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.hours == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  ora\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  ore\n                "
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.minutes) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.minutes == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  minuto\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  minuti\n                "
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.seconds) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.seconds == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  secondo\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  secondi\n                "
                                        )
                                      ]
                                    )
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var not_active_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid pt-5 pb-5" }, [
      _c("div", { staticClass: "row pt-5 pb-3 center" })
    ])
  }
]
not_active_render._withStripped = true
var not_active_esExports = { render: not_active_render, staticRenderFns: not_active_staticRenderFns }
/* harmony default export */ var components_not_active = (not_active_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-375d5ff6", not_active_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/not_active/index.vue
var not_active_disposed = false
function not_active_injectStyle (ssrContext) {
  if (not_active_disposed) return
  __webpack_require__("u2z1")
}
var not_active_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var not_active___vue_template_functional__ = false
/* styles */
var not_active___vue_styles__ = not_active_injectStyle
/* scopeId */
var not_active___vue_scopeId__ = "data-v-375d5ff6"
/* moduleIdentifier (server only) */
var not_active___vue_module_identifier__ = null
var not_active_Component = not_active_normalizeComponent(
  not_active,
  components_not_active,
  not_active___vue_template_functional__,
  not_active___vue_styles__,
  not_active___vue_scopeId__,
  not_active___vue_module_identifier__
)
not_active_Component.options.__file = "src/components/not_active/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-375d5ff6", not_active_Component.options)
  } else {
    hotAPI.reload("data-v-375d5ff6", not_active_Component.options)
  }
  module.hot.dispose(function (data) {
    not_active_disposed = true
  })
})()}

/* harmony default export */ var src_components_not_active = (not_active_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("Av7u");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// CONCATENATED MODULE: ./src/store/modules/auth.js




var _state, _actions, _mutations;

/* eslint-disable promise/param-names */





var auth_moment = __webpack_require__("PJh5");
var auth_state = (_state = { token: localStorage.getItem("55H$yGS8e8$PSY" + "lierac_global") || '', status: '', tempEncrypt: '', tempCrypt: '' }, defineProperty_default()(_state, 'status', ''), defineProperty_default()(_state, 'login_error', ''), defineProperty_default()(_state, 'loadingState', ''), defineProperty_default()(_state, 'hasLoadedOnce', false), defineProperty_default()(_state, 'promotions', {}), defineProperty_default()(_state, 'promo', 'no'), defineProperty_default()(_state, 'regulations', JSON.parse(localStorage.getItem('accept_reg')) || {}), _state);

var getters = {
  promoOpen: function promoOpen(state) {
    return state.promo;
  },
  accepted_regulations: function accepted_regulations(state) {
    return state.regulations;
  },
  getPromotions: function getPromotions(state) {
    return state.promotions;
  },
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token;
  },
  authStatus: function authStatus(state) {
    return state.status;
  },
  loginerror: function loginerror(state) {
    return state.login_error;
  },
  loadingState: function loadingState(state) {
    return state.loadingState;
  }
};

var actions = (_actions = {}, defineProperty_default()(_actions, AUTH_REQUEST, function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(AUTH_REQUEST);
    axios_default()({ url: "https://pharma.ubiqubit.it/" + 'api/login', data: user, method: 'POST', crossDomain: true, headers: { 'Authorization': 'Bearer ' + "a47a065bee221a88306bafcd0c9b866cefb738ec", 'Content-type': 'application/json' } }).then(function (resp) {
      commit(DECRYPT, resp.data);
      resp.data = auth_state.tempCrypt;
      var token = resp.data.usertoken;
      localStorage.setItem('55a5s1dffe$fswe' + "lierac_global", '$234' + token.split("").reverse().join("") + '2324234');
      localStorage.setItem('66a5s2dtte$fsw' + "lierac_global", '$vr4' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + '3453455');
      localStorage.setItem('99a3s2dgfe$fsw' + "lierac_global", '$34f' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'wer345f');
      localStorage.setItem('01a5s2dhge$fsw' + "lierac_global", '$fwe' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'werweqe');
      localStorage.setItem('98a0s2ddee$fsw' + "lierac_global", '$5fs' + token + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'fertfdw');
      localStorage.setItem('75a9s2dsse$fsw' + "lierac_global", '$4ff' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'werfsfd');
      localStorage.setItem("55H$yGS8e8$PSY" + "lierac_global", token);
      localStorage.setItem('96a3s2djje$fsw' + "lierac_global", '$45f' + token + '435wefs');
      localStorage.setItem('81a4s2dyye$fsw' + "lierac_global", '$4fe' + token + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'sdtrrdf');
      localStorage.setItem('72a5s2diie$fsw' + "lierac_global", '$5fs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'dswe443');
      localStorage.setItem('97a6s2dkke$fsw' + "lierac_global", '$ng4' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'cvrt433');
      localStorage.setItem('00a7s2dwde$fsw' + "lierac_global", '$8hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'gfdgerg');
      sessionStorage.setItem('token', '$2th#eto#ket$h%a6tyo^ua@ret$ryi%ng^tof&5in$di^snota)9vaiable');
      localStorage.removeItem('55a5s1dfflo$fswe' + "lierac_global");
      localStorage.removeItem('66a5s2dttlo$fsw' + "lierac_global");
      localStorage.removeItem('99a3s2dgflo$fsw' + "lierac_global");
      localStorage.removeItem('01a5s2dhglo$fsw' + "lierac_global");
      localStorage.removeItem('98a0s2ddelo$fsw' + "lierac_global");
      localStorage.removeItem('75a9s2dsslo$fsw' + "lierac_global");
      localStorage.removeItem('96a3s2djjlo$fsw' + "lierac_global");
      localStorage.removeItem('81a4s2dyylo$fsw' + "lierac_global");
      localStorage.removeItem('72a5s2diilo$fsw' + "lierac_global");
      localStorage.removeItem('97a6s2dkklo$fsw' + "lierac_global");
      localStorage.removeItem('55a7s2dwdlo$fswe' + "lierac_global");
      localStorage.removeItem('00a7s2dwdlo$fswe' + "lierac_global");
      localStorage.removeItem('11a7s2dwdlo$fswe' + "lierac_global");
      localStorage.removeItem('44a7s2dwdlo$fsw' + "lierac_global");
      localStorage.removeItem('77a7s2dwdlo$fswe' + "lierac_global");
      localStorage.removeItem('88a7s2dwdlo$fswe' + "lierac_global");
      localStorage.removeItem('99a7s2dwdlo$fswe' + "lierac_global");
      localStorage.removeItem('10a7s2dwdlo$fswe' + "lierac_global");

      commit(AUTH_SUCCESS, token);
      // you have your token, now log in your user :)
      dispatch(USER_REQUEST, token);
      resolve(resp.data);
    }).catch(function (err) {
      commit(DECRYPT, err.response.data);
      err.response.data = auth_state.tempCrypt;
      commit(AUTH_ERROR, err.response.data.message);
      localStorage.removeItem("55H$yGS8e8$PSY" + "lierac_global"); // if the request fails, remove any possible user token if possible
      reject(err);
    });
  });
}), defineProperty_default()(_actions, SET_TOKEN, function (_ref2, token) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login 

    localStorage.setItem(Object({"NODE_ENV":"production","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"55H$yGS8e8$PSY","ID_PLATFORM":"DcJ7J1WfiwucqBl_lierac","HAS_CONFIRM_POPUP":true,"HAS_IBAN_BEFORE_LOG":false,"LOGIN_WITH_EMAIL":false,"CODE_BEFORE_LOG":false,"HAS_OCR":true,"AUTH_TOKEN":"a47a065bee221a88306bafcd0c9b866cefb738ec","GTAGEVENT":"off","SENDTO":"G-3J0H2NL5XM/9newCKCi0osCELns6LoC","GTMSTATUS":"off","GTM":"GTM-P789JK4","GTAGAWSTATUS":"off","GTAGAW":"AW-660223545","GTAGSTATUS":"off","GTAG":"G-3J0H2NL5XM","COOKIEBOT":false,"COOKIEBOTKEY":"ddc9d39a-ca3b-4fe0-be69-f7b35d841e20","ROOT_API":"https://pharma.ubiqubit.it/","API_TOKEN":"21a25071eaf6c5ef584ee179ea49b904f71dbc12a2f0","ICODE":"lierac_global","UNIQUE_KEY_DB":"d971ad4ed27c5e76c0ccf95a","CRYPT":"ON","DIRECTORY":"https://ubiqubit.it/staging/pharma","MSG_ACCOUNT_CONFIRMED":"Il tuo account è stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"L`ndirizzo e-mail non è presente nel nostro sistema","TOKEN_NOT_EXIST":"Il token è scaduto o non è presente","START":"2021-07-01 00:00:00","START_INTERMEDIO":"2021-09-01 00:00:00","FINISH":"2029-09-18 00:00:00"}).LOG_VAR, token); // store the token in localstorage

    commit(AUTH_SUCCESS, token);
    // you have your token, now log in your user :)

    resolve(token);
  });
}), defineProperty_default()(_actions, AUTH_SOCIAL, function (_ref3, token) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login 
    commit(AUTH_SOCIAL);
    localStorage.setItem(Object({"NODE_ENV":"production","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"55H$yGS8e8$PSY","ID_PLATFORM":"DcJ7J1WfiwucqBl_lierac","HAS_CONFIRM_POPUP":true,"HAS_IBAN_BEFORE_LOG":false,"LOGIN_WITH_EMAIL":false,"CODE_BEFORE_LOG":false,"HAS_OCR":true,"AUTH_TOKEN":"a47a065bee221a88306bafcd0c9b866cefb738ec","GTAGEVENT":"off","SENDTO":"G-3J0H2NL5XM/9newCKCi0osCELns6LoC","GTMSTATUS":"off","GTM":"GTM-P789JK4","GTAGAWSTATUS":"off","GTAGAW":"AW-660223545","GTAGSTATUS":"off","GTAG":"G-3J0H2NL5XM","COOKIEBOT":false,"COOKIEBOTKEY":"ddc9d39a-ca3b-4fe0-be69-f7b35d841e20","ROOT_API":"https://pharma.ubiqubit.it/","API_TOKEN":"21a25071eaf6c5ef584ee179ea49b904f71dbc12a2f0","ICODE":"lierac_global","UNIQUE_KEY_DB":"d971ad4ed27c5e76c0ccf95a","CRYPT":"ON","DIRECTORY":"https://ubiqubit.it/staging/pharma","MSG_ACCOUNT_CONFIRMED":"Il tuo account è stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"L`ndirizzo e-mail non è presente nel nostro sistema","TOKEN_NOT_EXIST":"Il token è scaduto o non è presente","START":"2021-07-01 00:00:00","START_INTERMEDIO":"2021-09-01 00:00:00","FINISH":"2029-09-18 00:00:00"}).LOG_VAR, token); // store the token in localstorage
    commit(AUTH_SUCCESS, token);
    // you have your token, now log in your user :)
    dispatch(USER_REQUEST, token);
    resolve(token);
  });
}), defineProperty_default()(_actions, AUTH_REGISTRATION, function (_ref4, user) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(AUTH_REGISTRATION);
    axios_default()({
      url: "https://pharma.ubiqubit.it/" + 'api/addNewUser',
      data: { data: user },
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + "a47a065bee221a88306bafcd0c9b866cefb738ec", 'Content-type': 'application/json' }
    }).then(function (resp) {
      commit(DECRYPT, resp.data);
      resp.data = auth_state.tempCrypt;
      commit(REGISTRATION_SUCCESS, resp.data);
      resolve(resp.data);
    }).catch(function (err) {
      commit(DECRYPT, err.response.data);
      err.response.data = auth_state.tempCrypt;
      commit(REGISTRATION_ERROR);
      reject(err);
    });
  });
}), defineProperty_default()(_actions, AUTH_COMPLATE_REGISTRATION, function (_ref5, user) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(AUTH_COMPLATE_REGISTRATION);
    axios_default()({
      url: "https://pharma.ubiqubit.it/" + 'api/editUser',
      data: user,
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + "a47a065bee221a88306bafcd0c9b866cefb738ec", 'Content-type': 'application/json' }
    }).then(function (resp) {
      commit(DECRYPT, resp.data);
      resp.data = auth_state.tempCrypt;
      commit(COMPLATE_REGISTRATION_SUCCESS, resp.data);
      dispatch(USER_UPDATE_DATA, resp.data);
      resolve(resp.data);
    }).catch(function (err) {
      commit(DECRYPT, err.response.data);
      err.response.data = auth_state.tempCrypt;
      commit(REGISTRATION_ERROR);
      reject(err);
    });
  });
}), defineProperty_default()(_actions, AUTH_LOGOUT, function (_ref6) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(AUTH_LOGOUT);
    localStorage.removeItem("55H$yGS8e8$PSY" + "lierac_global");
    localStorage.removeItem('55a5s1dffe$fswe' + "lierac_global");
    localStorage.removeItem('66a5s2dtte$fsw' + "lierac_global");
    localStorage.removeItem('99a3s2dgfe$fsw' + "lierac_global");
    localStorage.removeItem('01a5s2dhge$fsw' + "lierac_global");
    localStorage.removeItem('98a0s2ddee$fsw' + "lierac_global");
    localStorage.removeItem('75a9s2dsse$fsw' + "lierac_global");
    localStorage.removeItem('96a3s2djje$fsw' + "lierac_global");
    localStorage.removeItem('81a4s2dyye$fsw' + "lierac_global");
    localStorage.removeItem('72a5s2diie$fsw' + "lierac_global");
    localStorage.removeItem('97a6s2dkke$fsw' + "lierac_global");
    localStorage.removeItem('00a7s2dwde$fsw' + "lierac_global");
    localStorage.removeItem('11a5s2dffe$fswe' + "lierac_global");
    sessionStorage.removeItem('token');
    sessionStorage.setItem('token', '$2n@3ow5$thet^ok&en8^th86atyo7uar8etr&yi(ng)to)_findisava$#iabl3efo%%rc$$hac##kingme');
    var token2 = '$2y$10$weQPwu16AY/qh1UXJJxkQubT.s0dcVF9rHnwpwDH8URb2ZlaUruJ2';
    localStorage.setItem('55a5s1dfflo$fswe' + "lierac_global", '$234' + token2.split("").reverse().join("") + '2324234');
    localStorage.setItem('66a5s2dttlo$fsw' + "lierac_global", '$vr4' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(1, 8) + '3453455');
    localStorage.setItem('99a3s2dgflo$fsw' + "lierac_global", '$34f' + token2.substring(9, 20) + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'wer345f');
    localStorage.setItem('01a5s2dhglo$fsw' + "lierac_global", '$fwe' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(1, 20) + 'werweqe');
    localStorage.setItem('98a0s2ddelo$fsw' + "lierac_global", '$5fs' + token2.substring(3, 20) + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'fertfdw');
    localStorage.setItem('75a9s2dsslo$fsw' + "lierac_global", '$4ff' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(2, 37) + 'werfsfd');
    localStorage.setItem('22a5s2dfflo$fsw' + "lierac_global", token2 + auth_moment().format('YYYY-MM-DD HH:mm:ss'));
    localStorage.setItem('96a3s2djjlo$fsw' + "lierac_global", '$45f' + token2.substring(2, 40) + '435wefs');
    localStorage.setItem('81a4s2dyylo$fsw' + "lierac_global", '$4fe' + token2 + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(1, 20) + 'sdtrrdf');
    localStorage.setItem('72a5s2diilo$fsw' + "lierac_global", '$5fs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(4, 28) + 'dswe443');
    localStorage.setItem('97a6s2dkklo$fswe568', '$ng4' + token2.substring(7, 27) + auth_moment().format('YYYY-MM-DD HH:mm:ss') + 'cvrt433');
    localStorage.setItem('00a7s2dwdlo$fswe' + "lierac_global", '$1hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(7, 29) + 'gfdgerg');
    localStorage.setItem('11a7s2dwdlo$fswe' + "lierac_global", '$2hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(6, 30) + 'gfdgerg');
    localStorage.setItem('44a7s2dwdlo$fsw' + "lierac_global", '$5hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(4, 30) + 'gfdgerg');
    localStorage.setItem('55a7s2dwdlo$fswe' + "lierac_global", '$6hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(5, 40) + 'gfdgerg');
    localStorage.setItem('77a7s2dwdlo$fswe' + "lierac_global", '$8hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(4, 30) + 'gfdgerg');
    localStorage.setItem('88a7s2dwdlo$fswe' + "lierac_global", '$9hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(3, 20) + 'gfdgerg');
    localStorage.setItem('99a7s2dwdlo$fswe' + "lierac_global", '$0hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(2, 40) + 'gfdgerg');
    localStorage.setItem('10a7s2dwdlo$fswe' + "lierac_global", '$1hs' + auth_moment().format('YYYY-MM-DD HH:mm:ss') + token2.substring(1, 30) + 'gfdgerg');
    resolve();
  });
}), defineProperty_default()(_actions, AUTH_OK, function (_ref7) {
  var commit = _ref7.commit,
      dispatch = _ref7.dispatch;

  return new promise_default.a(function (resolve, reject) {
    resolve();
  });
}), defineProperty_default()(_actions, GET_PROMOTIONS, function (_ref8) {
  var commit = _ref8.commit,
      dispatch = _ref8.dispatch;


  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(GET_PROMOTIONS);
    axios_default()({
      url: "https://pharma.ubiqubit.it/" + 'fapi/getAllContest',
      data: {},
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + "a47a065bee221a88306bafcd0c9b866cefb738ec", 'Content-type': 'application/json' } }).then(function (resp) {
      commit(GET_PROMOTIONS_SUCCESS, resp.data);
      resolve(resp.data.data);
    }).catch(function (err) {
      commit(REGISTRATION_ERROR);
      reject(err);
    });
  });
}), defineProperty_default()(_actions, SET_PROMOTION, function (_ref9, promo) {
  var commit = _ref9.commit,
      dispatch = _ref9.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(SET_PROMOTION, promo);
    resolve(promo);
  });
}), defineProperty_default()(_actions, ACCEPT_REG, function (_ref10, promo) {
  var commit = _ref10.commit,
      dispatch = _ref10.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(ACCEPT_REG, promo);
    resolve(promo);
  });
}), _actions);

var mutations = (_mutations = {}, defineProperty_default()(_mutations, AUTH_REQUEST, function (state) {
  state.status = 'loading';
  state.login_error = false;
  state.loadingState = true;
}), defineProperty_default()(_mutations, GET_PROMOTIONS, function (state) {
  state.status = 'loading';
}), defineProperty_default()(_mutations, GET_PROMOTIONS_SUCCESS, function (state, resp) {
  state.promotions = resp;
}), defineProperty_default()(_mutations, AUTH_SOCIAL, function (state) {
  state.status = 'loading';
  state.login_error = false;
  state.loadingState = true;
}), defineProperty_default()(_mutations, AUTH_SUCCESS, function (state, resp) {
  state.status = 'success';
  state.token = resp;
  state.hasLoadedOnce = true;
  state.loadingState = false;
}), defineProperty_default()(_mutations, AUTH_ERROR, function (state, error) {
  state.status = error;
  state.login_error = true;
  state.hasLoadedOnce = true;
  state.loadingState = false;
}), defineProperty_default()(_mutations, AUTH_LOGOUT, function (state) {
  state.token = '';
  state.status = '';
}), defineProperty_default()(_mutations, AUTH_REGISTRATION, function (state) {
  state.status = 'loading';
  state.loadingState = true;
}), defineProperty_default()(_mutations, AUTH_COMPLATE_REGISTRATION, function (state) {
  state.status = 'loading';
  state.loadingState = true;
}), defineProperty_default()(_mutations, REGISTRATION_SUCCESS, function (state) {
  state.status = 'success';
  state.loadingState = false;
}), defineProperty_default()(_mutations, COMPLATE_REGISTRATION_SUCCESS, function (state) {
  state.status = 'success';
  state.loadingState = false;
}), defineProperty_default()(_mutations, REGISTRATION_ERROR, function (state) {
  state.status = 'error';
  state.loadingState = false;
}), defineProperty_default()(_mutations, SET_PROMOTION, function (state, value) {
  state.promo = value;
}), defineProperty_default()(_mutations, ACCEPT_REG, function (state, value) {
  state.regulations[value] = true;
  localStorage.setItem('accept_reg', stringify_default()(state.regulations)); // store the token in localstorage
}), defineProperty_default()(_mutations, DECRYPT, function (state, resp) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse("B%t$AD!YMfnCZnfD");
    var ciphertext = crypto_js_default.a.enc.Hex.parse(resp);
    var srcs = crypto_js_default.a.enc.Base64.stringify(ciphertext);
    var decrypt = crypto_js_default.a.AES.decrypt(srcs, ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    var decrypted = decrypt.toString(crypto_js_default.a.enc.Utf8);
    state.tempCrypt = JSON.parse(decrypted);
  } else {
    state.tempCrypt = resp;
  }
}), defineProperty_default()(_mutations, ENCRYPT, function (state, resp) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse("B%t$AD!YMfnCZnfD");
    var encrypted = crypto_js_default.a.AES.encrypt(stringify_default()(resp), ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    state.tempEncrypt = encrypted.ciphertext.toString();
  } else {
    state.tempEncrypt = resp;
  }
}), _mutations);

/* harmony default export */ var auth = ({
  state: auth_state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/store/modules/user.js


var user__actions, user__mutations;







var user_state = { status: '', profile: {}, defaultShipData: {}, checkAge: localStorage.getItem('checkAge') || false, acceptCookies: localStorage.getItem('acceptCookies') || false };

var user_getters = {
  getProfile: function getProfile(state) {
    return state.profile;
  },
  getDefaultShipData: function getDefaultShipData(state) {
    return state.defaultShipData;
  },
  isComplateAccount: function isComplateAccount(state) {
    return !!state.profile.support_id;
  },
  isProfileLoaded: function isProfileLoaded(state) {
    return !!state.profile.company;
  },
  checkAge: function checkAge(state) {
    return !!state.checkAge;
  },
  acceptCookies: function acceptCookies(state) {
    return !!state.acceptCookies;
  }
};

var user_actions = (user__actions = {}, defineProperty_default()(user__actions, USER_REQUEST, function (_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit(USER_REQUEST);
  var data = {
    token: localStorage.getItem("55H$yGS8e8$PSY" + "lierac_global"),
    id_platform: "DcJ7J1WfiwucqBl_lierac",
    unique_key_db: "d971ad4ed27c5e76c0ccf95a",
    vector_unique_key_db: "lierac_global"
  };
  commit(ENCRYPT, data);
  data = auth.state.tempEncrypt;
  axios_default()({
    url: "https://pharma.ubiqubit.it/" + 'api/getUser',
    data: {
      data: data
    },
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + "a47a065bee221a88306bafcd0c9b866cefb738ec",
      'Content-type': 'application/json'
    }
  }).then(function (resp) {
    commit(DECRYPT, resp.data);
    resp.data = auth.state.tempCrypt;
    commit(USER_SUCCESS, resp.data);
    dispatch(AUTH_OK);
  }).catch(function (resp) {
    commit(DECRYPT, resp.response.data);
    resp.response.data = auth.state.tempCrypt;
    commit(USER_ERROR, resp.response.data.message);
    dispatch(AUTH_LOGOUT, resp.response.data.message);
  });
}), defineProperty_default()(user__actions, USER_UPDATE_DATA, function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  commit(USER_UPDATE_DATA);
}), defineProperty_default()(user__actions, USER_SET_DEFAULT_SHIP_DATA, function (_ref3, shipData) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  commit(USER_SET_DEFAULT_SHIP_DATA, shipData);
}), defineProperty_default()(user__actions, USER_CHECK_AGE, function (_ref4) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  localStorage.setItem('checkAge', true); // store the token in localstorage  
  commit(USER_CHECK_AGE);
}), defineProperty_default()(user__actions, ACCEPT_COOKIES, function (_ref5) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  localStorage.setItem('acceptCookies', true); // store the token in localstorage  
  commit(ACCEPT_COOKIES);
}), user__actions);

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, USER_REQUEST, function (state) {
  state.status = 'loading';
}), defineProperty_default()(user__mutations, USER_SUCCESS, function (state, resp) {
  state.status = 'success';
  vue_esm["default"].set(state, 'profile', resp);
}), defineProperty_default()(user__mutations, USER_ERROR, function (state, resp) {
  state.status = resp;
}), defineProperty_default()(user__mutations, USER_UPDATE_DATA, function (state) {
  state.status = 'success';
  vue_esm["default"].set(state.profile, 'support_id', true);
}), defineProperty_default()(user__mutations, AUTH_LOGOUT, function (state) {
  state.profile = {};
}), defineProperty_default()(user__mutations, USER_SET_DEFAULT_SHIP_DATA, function (state, shipData) {
  vue_esm["default"].set(state, 'defaultShipData', shipData);
}), defineProperty_default()(user__mutations, USER_CHECK_AGE, function (state) {
  state.checkAge = true;
}), defineProperty_default()(user__mutations, ACCEPT_COOKIES, function (state) {
  state.acceptCookies = true;
}), user__mutations);

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  actions: user_actions,
  mutations: user_mutations
});
// CONCATENATED MODULE: ./src/store/index.js




vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    user: modules_user,
    auth: auth
  },
  strict: debug
}));
// CONCATENATED MODULE: ./src/router/index.js










// FAQ: The question: the answerimport Privacy from 'components/privacy'









vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router_ifNotAuthenticated = function ifNotAuthenticated(to, from, next) {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

var router_ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

var router_ifComplateAccount = function ifComplateAccount(to, from, next) {
  if (!store.getters.isProfileLoaded && store.getters.isAuthenticated) {
    store.watch(function (state, getters) {
      return getters.isProfileLoaded;
    }, function (value) {
      if (value === true) {
        proceed();
      }
    });
  } else {
    proceed();
  }

  function proceed() {
    if (store.getters.isAuthenticated) {
      if (store.getters.isComplateAccount) {
        next();
        return;
      } else {
        next();
      }
    } else {
      next();
      return;
    }
  }
};
var router_moment = __webpack_require__("PJh5");
var ifIsStart = function ifIsStart(to, from, next) {

  var queryString = '?';
  var i = 0;
  for (var x in to.query) {}

  if (router_moment() > router_moment("2021-07-01 00:00:00")) {
    next();
    return;
  }

  console.log('NOT ACTIVE YET');

  next('/not_active');
};
var ifIsStart_intermedio = function ifIsStart_intermedio(to, from, next) {

  if (router_moment() > router_moment("2021-09-01 00:00:00")) {
    next();
    return;
  }

  console.log('NOT ACTIVE YET');

  next('/');
};

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  //base: '/staging/pharma/',
  base: '/',
  routes: [{
    path: '/not_active',
    name: 'NotActive',
    component: src_components_not_active
  }, {
    path: '/',
    name: 'Home',
    component: src_components_home,
    beforeEnter: router_guards([ifIsStart, router_ifComplateAccount])

  }, {
    path: '/play/:id/:piva/:cod',
    name: 'Play',
    component: src_components_play,
    beforeEnter: router_guards([ifIsStart, ifIsStart_intermedio, router_ifComplateAccount, router_ifAuthenticated])
  }, {
    path: '/contest/:id/:piva/:cod',
    name: 'Contest',
    component: src_components_contest,
    beforeEnter: router_guards([ifIsStart, ifIsStart_intermedio, router_ifAuthenticated])
  }, {
    path: '/iban',
    name: 'Iban',
    component: src_components_iban,
    beforeEnter: router_guards([ifIsStart, router_ifComplateAccount])

  }, {
    path: '/phone/:id/:data',
    name: 'Phone',
    component: src_components_phone,
    beforeEnter: router_guards([ifIsStart, router_ifComplateAccount])

  }, {
    path: '/account',
    name: 'Account',
    component: src_components_account,
    beforeEnter: router_guards([ifIsStart, ifIsStart_intermedio, router_ifComplateAccount, router_ifAuthenticated])
  }, {
    path: '/login',
    name: 'Login',
    component: src_components_login,
    beforeEnter: router_guards([ifIsStart, router_ifNotAuthenticated])
  }, {
    path: '/confirm',
    name: 'Confirm',
    component: src_components_confirm,
    beforeEnter: router_guards([ifIsStart, ifIsStart_intermedio, router_ifAuthenticated])
  }, {
    path: '/forgot-password',
    name: 'Forgotpassword',
    component: src_components_forgotpassword,
    beforeEnter: router_guards([ifIsStart, router_ifNotAuthenticated])
  },
  /*{
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
  },*/
  {
    path: '/recovery-password',
    name: 'Recoverypassword',
    component: src_components_recoverypassword,
    beforeEnter: router_guards([ifIsStart, router_ifNotAuthenticated])

  }, {
    path: '/uploadPhone/:token',
    name: 'uploadPhone',
    component: src_components_uploadphone,
    beforeEnter: router_guards([ifIsStart, ifIsStart_intermedio])

  }, {
    path: '*',
    name: 'PageNotFound',
    component: src_components_page_not_found
  }]
}));

// allows using multiple guards for routes
function router_guards(guards) {
  var _this = this;

  return function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
      var changed, mNext, i;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              // a flag to discard remaining guards
              changed = false;

              // handle next for multiple guards

              mNext = function mNext(value) {
                // prevent calling next after it is already resolved with a value
                if (changed) return;

                // if we have 'value' reslove next with the value and set changed flag
                if (typeof value != 'undefined') {
                  changed = true;
                  next(value);
                }
              };

              // call guards


              i = 0;

            case 3:
              if (!(i < guards.length)) {
                _context.next = 11;
                break;
              }

              if (!changed) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('break', 11);

            case 6:
              _context.next = 8;
              return guards[i](to, from, mNext);

            case 8:
              i++;
              _context.next = 3;
              break;

            case 11:

              // move on if none of guards resolved next with a value
              if (!changed) next();

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/loading.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  props: {},
  components: {},
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6428c8d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/loading.vue
var loading_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var loading_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg_load" }, [
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            height: "0",
            "padding-bottom": "100%",
            position: "relative"
          }
        },
        [
          _c("img", {
            staticClass: "loadScreen imgLoad",
            attrs: { src: __webpack_require__("vp/L") }
          })
        ]
      )
    ])
  }
]
loading_render._withStripped = true
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var lib_loading = (loading_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6428c8d2", loading_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/lib/loading.vue
var loading_disposed = false
function loading_injectStyle (ssrContext) {
  if (loading_disposed) return
  __webpack_require__("8gwm")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = "data-v-6428c8d2"
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  lib_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)
loading_Component.options.__file = "src/components/lib/loading.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6428c8d2", loading_Component.options)
  } else {
    hotAPI.reload("data-v-6428c8d2", loading_Component.options)
  }
  module.hot.dispose(function (data) {
    loading_disposed = true
  })
})()}

/* harmony default export */ var components_lib_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/center-container.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var center_container = ({
  name: 'center-container'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-896ab43a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/center-container.vue
var center_container_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "center-container" }, [_vm._t("default")], 2)
}
var center_container_staticRenderFns = []
center_container_render._withStripped = true
var center_container_esExports = { render: center_container_render, staticRenderFns: center_container_staticRenderFns }
/* harmony default export */ var lib_center_container = (center_container_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-896ab43a", center_container_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/lib/center-container.vue
var center_container_disposed = false
function center_container_injectStyle (ssrContext) {
  if (center_container_disposed) return
  __webpack_require__("Ry4p")
}
var center_container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var center_container___vue_template_functional__ = false
/* styles */
var center_container___vue_styles__ = center_container_injectStyle
/* scopeId */
var center_container___vue_scopeId__ = "data-v-896ab43a"
/* moduleIdentifier (server only) */
var center_container___vue_module_identifier__ = null
var center_container_Component = center_container_normalizeComponent(
  center_container,
  lib_center_container,
  center_container___vue_template_functional__,
  center_container___vue_styles__,
  center_container___vue_scopeId__,
  center_container___vue_module_identifier__
)
center_container_Component.options.__file = "src/components/lib/center-container.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-896ab43a", center_container_Component.options)
  } else {
    hotAPI.reload("data-v-896ab43a", center_container_Component.options)
  }
  module.hot.dispose(function (data) {
    center_container_disposed = true
  })
})()}

/* harmony default export */ var components_lib_center_container = (center_container_Component.exports);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/js/bootstrap.js
var bootstrap = __webpack_require__("K3J8");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__("C/JF");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__("fhbW");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-free-brands/index.es.js
var fontawesome_free_brands_index_es = __webpack_require__("h17U");

// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var vue_fontawesome_index_es = __webpack_require__("1e6/");

// EXTERNAL MODULE: ./node_modules/vue-headful/dist/vue-headful.js
var vue_headful = __webpack_require__("WiKS");
var vue_headful_default = /*#__PURE__*/__webpack_require__.n(vue_headful);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/It.js
var It = __webpack_require__("vfoj");
var It_default = /*#__PURE__*/__webpack_require__.n(It);

// CONCATENATED MODULE: ./src/utils/vee-validate/index.js




// Merge the locales.
vee_validate_esm["a" /* Validator */].localize({ it: It_default.a });

// CUSTOM RULES:


// NEW VALIDATE RULE FOR PARTITA IVA
var partitaIva = {
	getMessage: function getMessage(field) {
		return 'Partita IVA non valida';
	},
	validate: function validate(value) {
		var pi = value;
		if (pi.length == 11) {

			var s = 0;
			for (i = 0; i <= 9; i += 2) {
				s += pi.charCodeAt(i) - '0'.charCodeAt(0);
			}for (var i = 1; i <= 9; i += 2) {
				var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
				if (c > 9) c = c - 9;
				s += c;
			}
			var atteso = (10 - s % 10) % 10;
			if (atteso != pi.charCodeAt(10) - '0'.charCodeAt(0)) {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}
};
vee_validate_esm["a" /* Validator */].extend('partitaIva', partitaIva);
It_default.a.messages = assign_default()({}, It_default.a.messages, { partitaIva: function partitaIva(field) {
		return 'Partita IVA non valida.';
	} });

// NOT USE TEMPORARY EMAIL
var emailTemporaryArray = ['10minutemail.com', '163.com', '1chuan.com', '1zhuan.com', '20minutemail.com', '21cn.com', '2prong.com', '30minutesmail.com', '4warding.com', '4warding.com', '4warding.net', '4warding.org', '675hosting.com', '675hosting.net', '675hosting.org', '6url.com', '75hosting.com', '75hosting.net', '75hosting.org', 'afrobacon.com', 'ajaxapp.net', 'amiri.net', 'amiriindustries.com', 'anonymail.dk', 'anonymbox.com', 'aol.com', 'bambooclub.cn', 'binkmail.com', 'blogmyway.org', 'bobmail.info', 'bofthew.com', 'bsnow.net', 'bugmenot.com', 'bumpymail.com', 'buyusedlibrarybooks.org', 'centermail.com', 'centermail.net', 'choicemail1.com', 'chongsoft.cn', 'chongsoft.com', 'chongsoft.org', 'cool.fr.nf', 'courriel.fr.nf', 'csoftmail.cn', 'deadspam.com', 'despam.it', 'despammed.com', 'discardmail.com', 'discardmail.de', 'dispose.it', 'disposeamail.com', 'dispostable.com', 'dodgeit.com', 'dodgit.com', 'dontreg.com', 'dontsendmespam.de', 'dotmsg.com', 'dumpandjunk.com', 'dumpmail.de', 'dunflimblag.mailexpire.com', 'e4ward.com', 'emaildienst.de', 'emailias.com', 'emailmiser.com', 'emailtemporanea.net', 'emailto.de', 'emailxfer.com', 'emz.net', 'enterto.com', 'etranquil.com', 'etranquil.net', 'etranquil.org', 'fakeinformation.com', 'fakemailz.com', 'fastacura.com', 'fastchevy.com', 'fastchrysler.com', 'fastkawasaki.com', 'fastmazda.com', 'fastmitsubishi.com', 'fastnissan.com', 'fastsubaru.com', 'fastsuzuki.com', 'fasttoyota.com', 'fastyamaha.com', 'filzmail.com', 'filzmail.com', 'footard.com', 'forgetmail.com', 'front14.org', 'fuckingduh.com', 'fux0ringduh.com', 'getonemail.com', 'ghosttexter.de', 'gishpuppy.com', 'gowikibooks.com', 'gowikicampus.com', 'gowikicars.com', 'gowikifilms.com', 'gowikigames.com', 'gowikimusic.com', 'gowikinetwork.com', 'gowikitravel.com', 'gowikitv.com', 'greensloth.com', 'guerrillamail.com', 'guerrillamail.net', 'guerrillamailblock.com', 'h8s.org', 'haltospam.com', 'hatespam.org', 'hidemail.de', 'hush.ai', 'i-b2c.com', 'iheartspam.org', 'imstations.com', 'incognitomail.net', 'ipoo.org', 'iwi.net', 'jetable.com', 'jetable.fr.nf', 'jetable.fr.nf', 'jetable.net', 'jetable.org', 'jnxjn.com', 'justonemail.net', 'kasmail.com', 'killmail.com', 'killmail.net', 'klassmaster.com', 'klassmaster.net', 'klzlk.com', 'legworld.cn', 'letmymail.com', 'lhsdv.com', 'link2mail.net', 'lortemail.dk', 'lovemeleaveme.com', 'lroid.com', 'mail.ru', 'mail2rss.org', 'mail333.com', 'mailblocks.com', 'mailcatch.com', 'maileater.com', 'mailexpire.com', 'mailfreeonline.com', 'mailin8r.com', 'mailinator.com', 'mailinator2.com', 'mailmetrash.com', 'mailmoat.com', 'mailnesia.com', 'mailnull.com', 'mailquack.com', 'mailshell.com', 'mailsiphon.com', 'mailslapping.com', 'mailtemp.net', 'mailzilla.com', 'mega.zik.dj', 'mega.zik.dj', 'meinspamschutz.de', 'meltmail.com', 'messagebeamer.de', 'mintemail.com', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'mt2009.com', 'myspaceinc.com', 'myspaceinc.net', 'myspaceinc.org', 'myspacepimpedup.com', 'myspamless.com', 'mytrashmail.com', 'neomailbox.com', 'nepwk.com', 'nervmich.net', 'nervtmich.net', 'netmails.com', 'netmails.net', 'netzidiot.de', 'nobulk.com', 'noclickemail.com', 'nomail.xl.cx', 'nospam.ze.tc', 'nospamfor.us', 'nurfuerspam.de', 'nwldx.com', 'onemoremail.net', 'oneoffemail.com', 'oneoffmail.com', 'oopi.org', 'ourklips.com', 'outlawspam.com', 'owlpic.com', 'pancakemail.com', 'pc1520.com', 'pimpedupmyspace.com', 'pjjkp.com', 'poofy.org', 'pookmail.com', 'privacy.net', 'prtnx.com', 'punkass.com', 'recyclemail.dk', 'rejectmail.com', 'rklips.com', 'safersignup.de', 'seorj.cn', 'sharklasers.com', 'shiftmail.com', 'shortmail.net', 'sibmail.com', 'sina.com', 'siteposter.net', 'slaskpost.se', 'slopsbox.com', 'sneakemail.com', 'sofimail.com', 'sofort-mail.de', 'sogetthis.com', 'sohu.com', 'spam.la', 'spam.su', 'spamavert.com', 'spambob.com', 'spambob.net', 'spambob.org', 'spambog.com', 'spambog.de', 'spambox.us', 'spamcon.org', 'spamcorptastic.com', 'spamday.com', 'spamex.com', 'spamexperts.com', 'spamfree24.com', 'spamfree24.net', 'spamfree24.org', 'spamgourmet.com', 'spamhole.com', 'spamhouse.com', 'spamify.com', 'spaminator.de', 'spaml.com', 'spammotel.com', 'spamoff.de', 'spamslicer.com', 'spamsphere.com', 'spamtrail.com', 'speed.1s.fr', 'teleworm.com', 'tempemail.net', 'tempinbox.com', 'tempmail.it', 'tempomail.fr', 'temporarily.de', 'temporaryforwarding.com', 'temporaryinbox.com', 'thankyou2010.com', 'tom.com', 'tracciabi.li', 'trash2009.com', 'trashdevil.com', 'trashdevil.de', 'trashmail.com', 'trashmail.de', 'trash-mail.de', 'trashmail.net', 'trashmail.org', 'trashymail.com', 'turual.com', 'twinmail.de', 'tyldd.com', 'uggsrock.com', 'upliftnow.com', 'uplipht.com', 'uymail.com', 'venompen.com', 'viditag.com', 'viewcastmedia.com', 'viewcastmedia.net', 'viewcastmedia.org', 'visit.onlatedotcom.info', 'walala.org', 'wegwerfadresse.de', 'wetrainbayarea.com', 'wetrainbayarea.org', 'wh4f.org', 'whopy.com', 'wilemail.com', 'willselfdestruct.com', 'wormseo.cn', 'wuzup.net', 'wwwnew.eu', 'xagloo.com', 'xemaps.com', 'xents.com', 'xmaily.com', 'yep.it', 'yopmail.com', 'yopmail.fr', 'yopmail.fr', 'yopmail.net', 'youumail.com', 'zoemail.org', 'MakeMeTheKing.com', 'tempemail.co.za', 'mail-temp.com', 'emailthrow.net ', 'rppkn.com', 'incognitomail.org', 'email60.com', 'rtrtr.com'];
var temporaryEmail = {
	getMessage: function getMessage(field) {
		return 'Le email temporanee non sono consentite';
	},
	validate: function validate(value) {
		var domain = value.split('@');
		var count = domain.length;
		domain = domain[count - 1];
		if (emailTemporaryArray.indexOf(domain) !== -1) {
			return false;
		} else {
			return true;
		}
	}
};
vee_validate_esm["a" /* Validator */].extend('temporaryEmail', temporaryEmail);
It_default.a.messages = assign_default()({}, It_default.a.messages, { temporaryEmail: function temporaryEmail(field) {
		return 'Le email temporanee non sono consentite';
	} });

// EMAIL CHECK PLUS + CHARACTER ( FOR GMAIL....+1@gmail.com )
var plusIssueEmail = {
	getMessage: function getMessage(field) {
		return 'L`indirizzo email contiene caratteri non consentiti';
	},
	validate: function validate(value) {
		var str = value;
		if (str.indexOf('+') == -1) {
			return true;
		} else {
			return false;
		}
	}
};
vee_validate_esm["a" /* Validator */].extend('plusIssueEmail', plusIssueEmail);
It_default.a.messages = assign_default()({}, It_default.a.messages, { plusIssueEmail: function plusIssueEmail(field) {
		return 'L`indirizzo email contiene caratteri non consentiti';
	} });

// PASSWORD SECURITY CHECK
var passwordCheck = {
	getMessage: function getMessage(field) {
		return 'La password deve essere composta da lettere e numeri.';
	},
	validate: function validate(value) {
		if (!/[a-z]/.test(value)) {
			console.log('letter missing');
			return false;
		} else if (!/[0-9]/.test(value)) {
			return false;
		}
		return true;
	}
};
vee_validate_esm["a" /* Validator */].extend('passwordCheck', passwordCheck);
It_default.a.messages = assign_default()({}, It_default.a.messages, { passwordCheck: function passwordCheck(field) {
		return 'La password deve essere composta da lettere e numeri.';
	} });

// PASSWORD SECURITY CHECK
var emptyTime = {
	getMessage: function getMessage(field) {
		return 'Il campo Ora è richiesto.';
	},
	validate: function validate(value) {
		if (value.HH == '' || value.mm == '') {
			return false;
		}
		return true;
	}
};
vee_validate_esm["a" /* Validator */].extend('emptyTime', emptyTime);
It_default.a.messages = assign_default()({}, It_default.a.messages, { emptyTime: function emptyTime(field) {
		return 'Il campo Ora è richiesto.';
	} });

// IBAN CHECK
var ibanControl = {
	getMessage: function getMessage(field) {
		return 'Il campo Iban non é corretto.';
	},
	validate: function validate(value) {

		// Remove spaces and to upper case
		var iban = value.replace(/ /g, "").toUpperCase(),
		    ibancheckdigits = "",
		    leadingZeroes = true,
		    cRest = "",
		    cOperator = "",
		    countrycode,
		    ibancheck,
		    charAt,
		    cChar,
		    bbanpattern,
		    bbancountrypatterns,
		    ibanregexp,
		    i,
		    p;

		// Check for IBAN code length.
		// It contains:
		// country code ISO 3166-1 - two letters,
		// two check digits,
		// Basic Bank Account Number (BBAN) - up to 30 chars
		var minimalIBANlength = 5;
		if (iban.length < minimalIBANlength) {
			return false;
		}

		// Check the country code and find the country specific format
		countrycode = iban.substring(0, 2);
		bbancountrypatterns = {
			"AL": "\\d{8}[\\dA-Z]{16}",
			"AD": "\\d{8}[\\dA-Z]{12}",
			"AT": "\\d{16}",
			"AZ": "[\\dA-Z]{4}\\d{20}",
			"BE": "\\d{12}",
			"BH": "[A-Z]{4}[\\dA-Z]{14}",
			"BA": "\\d{16}",
			"BR": "\\d{23}[A-Z][\\dA-Z]",
			"BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
			"CR": "\\d{17}",
			"HR": "\\d{17}",
			"CY": "\\d{8}[\\dA-Z]{16}",
			"CZ": "\\d{20}",
			"DK": "\\d{14}",
			"DO": "[A-Z]{4}\\d{20}",
			"EE": "\\d{16}",
			"FO": "\\d{14}",
			"FI": "\\d{14}",
			"FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
			"GE": "[\\dA-Z]{2}\\d{16}",
			"DE": "\\d{18}",
			"GI": "[A-Z]{4}[\\dA-Z]{15}",
			"GR": "\\d{7}[\\dA-Z]{16}",
			"GL": "\\d{14}",
			"GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
			"HU": "\\d{24}",
			"IS": "\\d{22}",
			"IE": "[\\dA-Z]{4}\\d{14}",
			"IL": "\\d{19}",
			"IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
			"KZ": "\\d{3}[\\dA-Z]{13}",
			"KW": "[A-Z]{4}[\\dA-Z]{22}",
			"LV": "[A-Z]{4}[\\dA-Z]{13}",
			"LB": "\\d{4}[\\dA-Z]{20}",
			"LI": "\\d{5}[\\dA-Z]{12}",
			"LT": "\\d{16}",
			"LU": "\\d{3}[\\dA-Z]{13}",
			"MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
			"MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
			"MR": "\\d{23}",
			"MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
			"MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
			"MD": "[\\dA-Z]{2}\\d{18}",
			"ME": "\\d{18}",
			"NL": "[A-Z]{4}\\d{10}",
			"NO": "\\d{11}",
			"PK": "[\\dA-Z]{4}\\d{16}",
			"PS": "[\\dA-Z]{4}\\d{21}",
			"PL": "\\d{24}",
			"PT": "\\d{21}",
			"RO": "[A-Z]{4}[\\dA-Z]{16}",
			"SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
			"SA": "\\d{2}[\\dA-Z]{18}",
			"RS": "\\d{18}",
			"SK": "\\d{20}",
			"SI": "\\d{15}",
			"ES": "\\d{20}",
			"SE": "\\d{20}",
			"CH": "\\d{5}[\\dA-Z]{12}",
			"TN": "\\d{20}",
			"TR": "\\d{5}[\\dA-Z]{17}",
			"AE": "\\d{3}\\d{16}",
			"GB": "[A-Z]{4}\\d{14}",
			"VG": "[\\dA-Z]{4}\\d{16}"
		};

		bbanpattern = bbancountrypatterns[countrycode];

		// As new countries will start using IBAN in the
		// future, we only check if the countrycode is known.
		// This prevents false negatives, while almost all
		// false positives introduced by this, will be caught
		// by the checksum validation below anyway.
		// Strict checking should return FALSE for unknown
		// countries.
		if (typeof bbanpattern !== "undefined") {
			ibanregexp = new RegExp("^[A-Z]{2}\\d{2}" + bbanpattern + "$", "");
			if (!ibanregexp.test(iban)) {
				return false; // Invalid country specific format
			}
		}

		// Now check the checksum, first convert to digits
		ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
		for (i = 0; i < ibancheck.length; i++) {
			charAt = ibancheck.charAt(i);
			if (charAt !== "0") {
				leadingZeroes = false;
			}
			if (!leadingZeroes) {
				ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(charAt);
			}
		}

		// Calculate the result of: ibancheckdigits % 97
		for (p = 0; p < ibancheckdigits.length; p++) {
			cChar = ibancheckdigits.charAt(p);
			cOperator = "" + cRest + "" + cChar;
			cRest = cOperator % 97;
		}
		return cRest === 1;
	}
};
vee_validate_esm["a" /* Validator */].extend('ibanControl', ibanControl);
It_default.a.messages = assign_default()({}, It_default.a.messages, { ibanControl: function ibanControl(field) {
		return 'Il campo Iban non é corretto.';
	} });

// IBAN ITALIAN
var ibanItalian = {
	getMessage: function getMessage(field) {
		return 'Non si tratta di un iban italiano.';
	},
	validate: function validate(value) {
		if (value == '') {
			return true;
		} else {
			if (value) {

				var lower = value.toLowerCase();

				if (lower.indexOf("it") == 0) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		}
	}
};
vee_validate_esm["a" /* Validator */].extend('ibanItalian', ibanItalian);
It_default.a.messages = assign_default()({}, It_default.a.messages, { ibanItalian: function ibanItalian(field) {
		return 'Non si tratta di un iban italiano.';
	} });

// VEE VALIDATE CONFIG
var vee_validate_config = {
	aria: true,
	classNames: {},
	classes: false,
	delay: 0,
	dictionary: {
		it: It_default.a
	},
	errorBagName: 'errors', // change if property conflicts
	events: 'input|blur',
	fieldsBagName: 'fields',
	i18n: null, // the vue-i18n plugin instance
	i18nRootKey: 'validations', // the nested key under which the validation messages will be located
	inject: true,
	locale: 'it',
	validity: false,
	useConstraintAttrs: true
};

/* harmony default export */ var vee_validate = ({
	config: vee_validate_config,
	core: vee_validate_esm["b" /* default */]
});
// EXTERNAL MODULE: ./node_modules/vue-sweetalert2/src/index.js
var src = __webpack_require__("oYt9");

// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__("bm7V");
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// EXTERNAL MODULE: ./node_modules/vue-moment/dist/vue-moment.js
var vue_moment = __webpack_require__("8AgW");
var vue_moment_default = /*#__PURE__*/__webpack_require__.n(vue_moment);

// EXTERNAL MODULE: ./node_modules/@chenfengyuan/vue-countdown/dist/vue-countdown.js
var vue_countdown = __webpack_require__("aCbg");
var vue_countdown_default = /*#__PURE__*/__webpack_require__.n(vue_countdown);

// EXTERNAL MODULE: ./node_modules/v-viewer/dist/v-viewer.js
var v_viewer = __webpack_require__("EAZf");
var v_viewer_default = /*#__PURE__*/__webpack_require__.n(v_viewer);

// EXTERNAL MODULE: ./node_modules/vue-observe-visibility/dist/vue-observe-visibility.esm.js
var vue_observe_visibility_esm = __webpack_require__("GBOZ");

// EXTERNAL MODULE: ./node_modules/vue-gtm/dist/vue-gtm.min.js
var vue_gtm_min = __webpack_require__("Sl4y");
var vue_gtm_min_default = /*#__PURE__*/__webpack_require__.n(vue_gtm_min);

// EXTERNAL MODULE: ./node_modules/vue-social-sharing/dist/vue-social-sharing.js
var vue_social_sharing = __webpack_require__("j9CP");
var vue_social_sharing_default = /*#__PURE__*/__webpack_require__.n(vue_social_sharing);

// EXTERNAL MODULE: ./node_modules/vue-recaptcha-v3/dist/ReCaptchaVuePlugin.js
var ReCaptchaVuePlugin = __webpack_require__("oHEs");
var ReCaptchaVuePlugin_default = /*#__PURE__*/__webpack_require__.n(ReCaptchaVuePlugin);

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vue-google-adsense/dist/VueGoogleAdsense.esm.min.js
var VueGoogleAdsense_esm_min = __webpack_require__("m60E");

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var dist_vue_select = __webpack_require__("T1ft");
var dist_vue_select_default = /*#__PURE__*/__webpack_require__.n(dist_vue_select);

// EXTERNAL MODULE: ./node_modules/vue-numeral-filter/dist/vue-numeral-filter.es.js
var vue_numeral_filter_es = __webpack_require__("gu9R");

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__("ViqS");
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// IE EXPLORER NEEDS
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////───────────────▄▄───▐█/////////////////////////////////////////////////////
///////////////////////////////////////───▄▄▄───▄██▄──█▀───█─▄////////////////////////////////////////////////////
///////////////////////////////////////─▄██▀█▌─██▄▄──▐█▀▄─▐█▀/////////////////////////////////////////////////////
///////////////////////////////////////▐█▀▀▌───▄▀▌─▌─█─▌──▌─▌/////////////////////////////////////////////////////
///////////////////////////////////////▌▀▄─▐──▀▄─▐▄─▐▄▐▄─▐▄─▐▄////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////



























//import VueGtag from 'vue-gtag-conversion'




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////CRYPT DATA///////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["default"].prototype.$encryptByAES = function (string, key) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse(key);
    var encrypted = crypto_js_default.a.AES.encrypt(string, ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(); // return ciphertext in hex format
  } else {
    return JSON.parse(string);
  }
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////DECRYPT DATA/////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["default"].prototype.$decryptByAES = function (string, key) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse(key);
    var ciphertext = crypto_js_default.a.enc.Hex.parse(string);
    var srcs = crypto_js_default.a.enc.Base64.stringify(ciphertext);
    var decrypt = crypto_js_default.a.AES.decrypt(srcs, ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    var decrypted = decrypt.toString(crypto_js_default.a.enc.Utf8);
    return JSON.parse(decrypted);
  } else {
    return string;
  }
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////LOG CALL DATA////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["default"].prototype.$callLog = function (string, data) {
  if (false) {
    console.log(string + '-> call', { data: data });
  }
  return true;
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////LOG RESP DATA////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["default"].prototype.$respLog = function (string, data) {
  if (false) {
    console.warn(string + '-> resp', { data: data });
  }
  return true;
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////LOG TRACK DATA///////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["default"].prototype.$track = function (string, data) {
  if (false) {
    console.log(string + ' -> ', data);
  }
  return true;
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////GOOGLE TAG MANAGER////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
if (false) {
  Vue.use(VueGtm, {
    id: process.env.GTM, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    vueRouter: router
  });
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////GOOGLE ADSENSE/////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/******************************************
if (process.env.GTAGAWSTATUS == 'on' && process.env.GTAGSTATUS == 'off') {
  
  Vue.use(Ads.AutoAdsense, { adClient: process.env.GTAGAW })
  Vue.use(VueGtag, {
    id: process.env.GTAGAW, // Your Adwords ID
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: process.env.NODE_ENV !== 'production' (optional)
    debug: true, // Whether or not display console log debugs (optional)
  });
}
/************************************************** */
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////VUE GTAG IF ADSENS IS ON GTAG == ADSENSE///////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
if (false) {

  Vue.use(VueGtagAll, {
    config: { id: process.env.GTAG }
  }, router);
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*****************************************************************/
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////GENERAL///////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["default"].component("v-select", dist_vue_select_default.a);
__webpack_require__("p3C9");
vue_esm["default"].use(vue_observe_visibility_esm["a" /* default */]);
vue_esm["default"].use(v_viewer_default.a);
vue_esm["default"].component(vue_countdown_default.a.name, vue_countdown_default.a);
vue_esm["default"].use(vue_carousel_3d_min_default.a);
vue_esm["default"].use(vue_moment_default.a);
vue_esm["default"].use(vue_scrollto_default.a);
vue_esm["default"].use(src["a" /* default */]);
vue_esm["default"].component('vue-headful', vue_headful_default.a);
vue_esm["default"].component('font-awesome-icon', vue_fontawesome_index_es["a" /* FontAwesomeIcon */]);
vue_esm["default"].component('loading', components_lib_loading);
vue_esm["default"].component('center-container', components_lib_center_container);
vue_esm["default"].config.productionTip = false;
index_es["c" /* library */].add(free_solid_svg_icons_index_es["p" /* faSpinner */], fontawesome_free_brands_index_es["a" /* faFacebookF */], free_solid_svg_icons_index_es["c" /* faCheck */], free_solid_svg_icons_index_es["f" /* faFileAlt */], free_solid_svg_icons_index_es["m" /* faSearchPlus */], free_solid_svg_icons_index_es["e" /* faEye */], free_solid_svg_icons_index_es["b" /* faCaretSquareDown */], free_solid_svg_icons_index_es["s" /* faUser */], free_solid_svg_icons_index_es["j" /* faLaptop */], fontawesome_free_brands_index_es["b" /* faInstagram */], fontawesome_free_brands_index_es["d" /* faYoutube */], fontawesome_free_brands_index_es["c" /* faTwitter */], free_solid_svg_icons_index_es["i" /* faInfoCircle */], free_solid_svg_icons_index_es["k" /* faPlusCircle */], free_solid_svg_icons_index_es["q" /* faTimesCircle */], free_solid_svg_icons_index_es["r" /* faTrashAlt */], free_solid_svg_icons_index_es["d" /* faCheckCircle */], free_solid_svg_icons_index_es["g" /* faFileInvoice */], free_solid_svg_icons_index_es["l" /* faReceipt */], free_solid_svg_icons_index_es["t" /* faWineBottle */], free_solid_svg_icons_index_es["a" /* faCamera */], free_solid_svg_icons_index_es["n" /* faShippingFast */], free_solid_svg_icons_index_es["h" /* faGlobe */], free_solid_svg_icons_index_es["o" /* faShoppingCart */]);
vue_esm["default"].use(vee_validate.core, vee_validate.config);
vue_esm["default"].use(vue_numeral_filter_es["a" /* default */], { locale: 'it' });
vue_esm["default"].filter("formatNumber", function (value) {
  var value = parseFloat(value);
  return numeral_default()(value).format("0.0,[00]"); // displaying other groupings/separators is possible, look at the docs
});
new vue_esm["default"]({
  el: '#app',
  router: src_router,
  store: store,
  Loading: components_lib_loading,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "PyBu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/soglie.f11f83e.png";

/***/ }),

/***/ "R870":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ry4p":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3Gu/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b7bbfb9c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-896ab43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./center-container.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-896ab43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./center-container.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UuNy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("pDSP"), "");

// module
exports.push([module.i, "\n", ""]);

// exports


/***/ }),

/***/ "YAyH":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjBAMAAADs965qAAAAIVBMVEUJBQlHcEwJBQkJBQkJBQkKBgoRDhEJBQkNCQ0JBQkJBQn6iUojAAAACnRSTlNAAL+A5Woeti6gUxXcJgAAAKtJREFUKM9jEBRMYIADRkFBQQEGQeFVCLCkESwkhSS0aiJEaKEgHFgpEiW0agkjhtAqR6iQmBIYJFopcC2EColC7Au0UpSCCQlCXCqILAS3kSQhMZivEULiMB8ibBRVgoJGEo2XhJnFiE8I6h0GDrxmCUDdoJ4IFxLCdKqYMQSYUh44CxBpYhZESAQ5ARiChQS8ECLLBcFCgoJCCxCm4RYSRzYNIoRs2ipDAQCTgJcMyViRRAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "aHDP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9fMG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5fb2516c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25a8184a\",\"scoped\":false,\"hasInlineConfig\":false}!../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./BadgerAccordionItem.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25a8184a\",\"scoped\":false,\"hasInlineConfig\":false}!../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./BadgerAccordionItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bNR/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.timeElement[data-v-375d5ff6] {\n  background: white;\n  color: green;\n  padding: 18px;\n  width: 64px;\n  height: 64px;\n  font-size: 20px;\n  border-radius: 7px;\n  font-family: Medium uppercase;\n}\n.headerLogo[data-v-375d5ff6] {\n  max-width: 115px;\n}\n@media screen and (max-width: 667px) {\n.headerLogo[data-v-375d5ff6] {\n      max-width: 70px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.headerLogo[data-v-375d5ff6] {\n      max-width: 100px;\n}\n}\n.coca-logo[data-v-375d5ff6] {\n  top: -5px;\n  height: 40px;\n  position: relative;\n}\n@media screen and (max-width: 667px) {\n.coca-logo[data-v-375d5ff6] {\n      height: 20px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.coca-logo[data-v-375d5ff6] {\n      height: 23px;\n}\n}\n.ce-logo[data-v-375d5ff6] {\n  top: -15px;\n  height: 65px;\n  position: relative;\n}\n@media screen and (max-width: 667px) {\n.ce-logo[data-v-375d5ff6] {\n      top: -7px;\n      height: 37px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.ce-logo[data-v-375d5ff6] {\n      top: -7px;\n      height: 37px;\n}\n}\n.mainFont[data-v-375d5ff6] {\n  font-size: 14px;\n}\n.big-red[data-v-375d5ff6] {\n  font-family: \"Gotham Rounded\", sans-serif;\n  font-weight: Medium uppercase;\n  font-size: 26px;\n  color: #e30613;\n}\n@media screen and (max-width: 667px) {\n.big-red[data-v-375d5ff6] {\n      font-size: 14px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.big-red[data-v-375d5ff6] {\n      font-size: 16px;\n}\n}\n.main[data-v-375d5ff6] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-position: 0% 50% !important;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n", ""]);

// exports


/***/ }),

/***/ "f/DI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABmBAMAAACtqwUGAAAAElBMVEVHcEwKlmAspHZkuplMsImQy7RYo86BAAAAAXRSTlMAQObYZgAAAJRJREFUSMfd07kNgDAMBVCHkJ6zhw3CBrAB7L8MSU1s6YMFJC5/4ycfROVX3YZK5CbEXSI/Qt4k8oXJZyaPbf01djHfnzMN09boMOkGcwA40jQnkEm/ZzqGU4HMeJsjwGwFJuXBBJZ+K1+BX5F+rmfmlvpdqwXdvoTuwCY5KHcpEhSeXDZQrwCVVj8AUPsGdFSAllQnc9ofHIlv5ywAAAAASUVORK5CYII="

/***/ }),

/***/ "gCMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ "hEAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/badger-accordion/dist/badger-accordion.esm.js
var badger_accordion_esm = __webpack_require__("pQNc");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordion.vue

//
//
//
//
//
//



// Helper-function to unwrap child-component-wrapper
function unwrap(wrapper) {
    // place childNodes in document fragment
    var docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        var child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }

    // replace wrapper with document fragment
    wrapper.parentNode.replaceChild(docFrag, wrapper);
}

/* harmony default export */ var BadgerAccordion = ({
    name: 'BadgerAccordion',
    props: {
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        icons: {
            default: function _default() {
                return { opened: '-', closed: '+' };
            }
        },
        iconComponent: {
            default: null
        }
    },
    data: function data() {
        return {
            accordion: null,
            itemsReady: false,
            show: true,
            rerendering: false,
            children: this.$children
        };
    },

    watch: {
        "accordion.states": {
            handler: function handler(states) {
                this.calculateAllPanelsHeight();
                this.$children.forEach(function (child, n) {
                    if (typeof_default()(states[n]) == 'object') {
                        child.changeState(states[n].state == 'open');
                    }
                });
            },

            deep: true
        }
    },
    created: function created() {
        var _this = this;

        // On child-item rendered initiate badger-accordion
        this.$on('item:ready', function () {
            // Unwrap child-wrapper due issues with badger-accordion
            unwrap(_this.$refs.badger.querySelector('.badger-accordion-item'));
            // Init badger-accordion if child-component is loaded
            _this.accordion = new badger_accordion_esm["a" /* default */](_this.$refs.badger, _this.options || {});
            _this.$forceUpdate();
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$watch(function () {
            return _this2.children.length;
        }, function (items) {
            _this2.rerender();
        });
    },


    methods: {
        init: function init() {
            this.accordion.init();
        },
        getState: function getState() {
            var headerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            return this.accordion.getState(headerIds);
        },
        open: function open(headerIndex) {
            this.accordion.open(headerIndex);
        },
        close: function close(headerIndex) {
            this.accordion.close(headerIndex);
        },
        togglePanel: function togglePanel(animationAction, headerIndex) {
            this.accordion.togglePanel(animationAction, headerIndex);
        },
        openAll: function openAll() {
            this.accordion.openAll();
        },
        closeAll: function closeAll() {
            this.accordion.closeAll();
        },
        calculateAllPanelsHeight: function calculateAllPanelsHeight() {
            this.accordion.calculateAllPanelsHeight();
        },
        calculatePanelHeight: function calculatePanelHeight(panel) {
            this.accordion.calculatePanelHeight(panel);
        },
        rerender: function rerender() {
            var _this3 = this;

            if (!this.rerendering) {
                this.rerendering = true;
                this.show = false;
                this.$nextTick(function () {
                    _this3.show = true;
                    _this3.$nextTick(function () {
                        _this3.rerendering = false;
                    });
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17205bd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordion.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "dl",
        { ref: "badger", staticClass: "component-badger-accordion" },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_BadgerAccordion = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17205bd2", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-badger-accordion/src/BadgerAccordion.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BadgerAccordion,
  src_BadgerAccordion,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-badger-accordion/src/BadgerAccordion.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17205bd2", Component.options)
  } else {
    hotAPI.reload("data-v-17205bd2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vue_badger_accordion_src_BadgerAccordion = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iQH9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ki2I":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.footerText[data-v-62fe346e] {\n  font-size: 16px;\n  margin-bottom: 0px;\n  color: #fffbde;\n}\n.footerBrownDesc[data-v-62fe346e] {\n  color: #000000;\n  font-family: museo-slab;\n  font-size: 16px;\n}\n.footerImageRight[data-v-62fe346e] {\n  text-align: right;\n}\n.support[data-v-62fe346e] {\n  color: #000000;\n  font-size: 16px;\n}\n.techImage[data-v-62fe346e] {\n  width: 90%;\n}\n.tech[data-v-62fe346e] {\n  position: absolute;\n  top: -80px;\n  left: -80px;\n  font-size: small;\n}\n.bottomBrand[data-v-62fe346e] {\n  padding: 28px;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.footerImageRight[data-v-62fe346e] {\n    text-align: left;\n}\n.footerText[data-v-62fe346e] {\n    font-size: 14px;\n    margin-top: 10px;\n}\n.tech[data-v-62fe346e] {\n    top: -100px;\n}\n.bottomBrand[data-v-62fe346e] {\n    width: 27vw;\n    padding-top: 10px;\n    padding: 10px;\n}\n.footer[data-v-62fe346e] {\n    /*margin-top: -200px!important;*/\n    height: 230px !important;\n}\n.alignBottomMobile[data-v-62fe346e] {\n    -ms-flex-item-align: end;\n        align-self: flex-end;\n}\n.techImage[data-v-62fe346e] {\n    width: 59%;\n}\n.tech[data-v-62fe346e] {\n    top: -60px;\n    left: -57px;\n    width: 172px;\n}\n.footerBrownDesc[data-v-62fe346e][data-v-62fe346e] {\n    color: #000000;\n    font-family: museo-slab;\n    font-size: 13px;\n}\n.support[data-v-62fe346e][data-v-62fe346e] {\n    color: #000000;\n    font-size: 11px;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "l+T2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "time-picker" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.displayTime,
          expression: "displayTime"
        }
      ],
      staticClass: "display-time",
      attrs: { id: _vm.id, type: "text", readonly: "" },
      domProps: { value: _vm.displayTime },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleDropdown.apply(null, arguments)
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.displayTime = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    !_vm.hideClearButton
      ? _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showDropdown && _vm.showClearBtn,
                expression: "!showDropdown && showClearBtn"
              }
            ],
            staticClass: "clear-btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.clearTime.apply(null, arguments)
              }
            }
          },
          [_vm._v("×")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showDropdown
      ? _c("div", {
          staticClass: "time-picker-overlay",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleDropdown.apply(null, arguments)
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDropdown,
            expression: "showDropdown"
          }
        ],
        staticClass: "dropdown"
      },
      [
        _c("div", { staticClass: "select-list" }, [
          _c(
            "ul",
            { staticClass: "hours" },
            [
              _c("li", {
                staticClass: "hint",
                domProps: { textContent: _vm._s(_vm.hourType) }
              }),
              _vm._v(" "),
              _vm._l(_vm.hours, function(hr) {
                return _c("li", {
                  class: { active: _vm.hour === hr },
                  domProps: { textContent: _vm._s(hr) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.select("hour", hr)
                    }
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "minutes" },
            [
              _c("li", {
                staticClass: "hint",
                domProps: { textContent: _vm._s(_vm.minuteType) }
              }),
              _vm._v(" "),
              _vm._l(_vm.minutes, function(m) {
                return _c("li", {
                  class: { active: _vm.minute === m },
                  domProps: { textContent: _vm._s(m) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.select("minute", m)
                    }
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.secondType
            ? _c(
                "ul",
                { staticClass: "seconds" },
                [
                  _c("li", {
                    staticClass: "hint",
                    domProps: { textContent: _vm._s(_vm.secondType) }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.seconds, function(s) {
                    return _c("li", {
                      class: { active: _vm.second === s },
                      domProps: { textContent: _vm._s(s) },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.select("second", s)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.apmType
            ? _c(
                "ul",
                { staticClass: "apms" },
                [
                  _c("li", {
                    staticClass: "hint",
                    domProps: { textContent: _vm._s(_vm.apmType) }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.apms, function(a) {
                    return _c("li", {
                      class: { active: _vm.apm === a },
                      domProps: { textContent: _vm._s(a) },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.select("apm", a)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4588f32", esExports)
  }
}

/***/ }),

/***/ "l+gf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UuNy");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3e50e643", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4588f32\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-timepicker.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4588f32\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-timepicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "liEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mNJB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAABjBAMAAADweOTyAAAAElBMVEVHcEwKlmBWtZAupXeUzrh2wqWY5978AAAAAXRSTlMAQObYZgAAAI9JREFUSMfdlE0SQDAMRqPY64993UBvwA24/2Xoul+MDpkJWb5F85o/oh9GY60NGLsSmxNb8MoFjiVOJx5wTgaPGPvbhl3Gi3rDxzXcBQ3pG4aLoOGgYw4ZwxXjCeOccsZ4K2iPv9NizFyPRs6Pqv0k60cv+DnsF2T8DO/nBfsbNfilGj9mgQ3fSH/72GmIAzcsHhiEZEhaAAAAAElFTkSuQmCC"

/***/ }),

/***/ "pDSP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".time-picker {\n  display: inline-block;\n  position: relative;\n  font-size: 1em;\n  width: 10em;\n  font-family: sans-serif;\n  vertical-align: middle;\n}\n\n.time-picker * {\n  box-sizing: border-box;\n}\n\n.time-picker input.display-time {\n  border: 1px solid #d2d2d2;\n  width: 10em;\n  height: 2.2em;\n  padding: 0.3em 0.5em;\n  font-size: 1em;\n}\n\n.time-picker .clear-btn {\n  position: absolute;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  margin-top: -0.15em;\n  z-index: 3;\n  font-size: 1.1em;\n  line-height: 1em;\n  vertical-align: middle;\n  width: 1.3em;\n  color: #d2d2d2;\n  background: rgba(255,255,255,0);\n  text-align: center;\n  font-style: normal;\n\n  -webkit-transition: color .2s;\n  transition: color .2s;\n}\n\n.time-picker .clear-btn:hover {\n  color: #797979;\n  cursor: pointer;\n}\n\n.time-picker .time-picker-overlay {\n  z-index: 2;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.time-picker .dropdown {\n  position: absolute;\n  z-index: 5;\n  top: calc(2.2em + 2px);\n  left: 0;\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.15);\n  width: 10em;\n  height: 10em;\n  font-weight: normal;\n}\n\n.time-picker .dropdown .select-list {\n  width: 10em;\n  height: 10em;\n  overflow: hidden;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  justify-content: space-between;\n}\n\n.time-picker .dropdown ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.time-picker .dropdown ul.minutes,\n.time-picker .dropdown ul.seconds,\n.time-picker .dropdown ul.apms{\n  border-left: 1px solid #fff;\n}\n\n.time-picker .dropdown ul li {\n  text-align: center;\n  padding: 0.3em 0;\n  color: #161616;\n}\n\n.time-picker .dropdown ul li:not(.hint):hover {\n  background: rgba(0,0,0,.08);\n  color: #161616;\n  cursor: pointer;\n}\n\n.time-picker .dropdown ul li.active,\n.time-picker .dropdown ul li.active:hover {\n  background: #41B883;\n  color: #fff;\n}\n\n.time-picker .dropdown .hint {\n  color: #a5a5a5;\n  cursor: default;\n  font-size: 0.8em;\n}\n", ""]);

// exports


/***/ }),

/***/ "pFZQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/premi.f236683.png";

/***/ }),

/***/ "q2xu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v4.6.0 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,::after,::before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article,aside,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([class]){color:inherit;text-decoration:none}a:not([href]):not([class]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg{overflow:hidden;vertical-align:middle}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit;text-align:-webkit-match-parent}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus:not(:focus-visible){outline:0}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300;line-height:1.2}.display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.display-4{font-size:3.5rem;font-weight:300;line-height:1.2}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer::before{content:\"\\2014\\A0\"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container,.container-fluid,.container-lg,.container-md,.container-sm,.container-xl{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}.row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-ms-flex-order:-1;order:-1}.order-last{-ms-flex-order:13;order:13}.order-0{-ms-flex-order:0;order:0}.order-1{-ms-flex-order:1;order:1}.order-2{-ms-flex-order:2;order:2}.order-3{-ms-flex-order:3;order:3}.order-4{-ms-flex-order:4;order:4}.order-5{-ms-flex-order:5;order:5}.order-6{-ms-flex-order:6;order:6}.order-7{-ms-flex-order:7;order:7}.order-8{-ms-flex-order:8;order:8}.order-9{-ms-flex-order:9;order:9}.order-10{-ms-flex-order:10;order:10}.order-11{-ms-flex-order:11;order:11}.order-12{-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-sm-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-sm-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-sm-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-sm-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-sm-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-sm-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-sm-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-ms-flex-order:-1;order:-1}.order-sm-last{-ms-flex-order:13;order:13}.order-sm-0{-ms-flex-order:0;order:0}.order-sm-1{-ms-flex-order:1;order:1}.order-sm-2{-ms-flex-order:2;order:2}.order-sm-3{-ms-flex-order:3;order:3}.order-sm-4{-ms-flex-order:4;order:4}.order-sm-5{-ms-flex-order:5;order:5}.order-sm-6{-ms-flex-order:6;order:6}.order-sm-7{-ms-flex-order:7;order:7}.order-sm-8{-ms-flex-order:8;order:8}.order-sm-9{-ms-flex-order:9;order:9}.order-sm-10{-ms-flex-order:10;order:10}.order-sm-11{-ms-flex-order:11;order:11}.order-sm-12{-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-md-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-md-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-md-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-md-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-md-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-md-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-md-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-ms-flex-order:-1;order:-1}.order-md-last{-ms-flex-order:13;order:13}.order-md-0{-ms-flex-order:0;order:0}.order-md-1{-ms-flex-order:1;order:1}.order-md-2{-ms-flex-order:2;order:2}.order-md-3{-ms-flex-order:3;order:3}.order-md-4{-ms-flex-order:4;order:4}.order-md-5{-ms-flex-order:5;order:5}.order-md-6{-ms-flex-order:6;order:6}.order-md-7{-ms-flex-order:7;order:7}.order-md-8{-ms-flex-order:8;order:8}.order-md-9{-ms-flex-order:9;order:9}.order-md-10{-ms-flex-order:10;order:10}.order-md-11{-ms-flex-order:11;order:11}.order-md-12{-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-lg-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-lg-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-lg-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-lg-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-lg-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-lg-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-lg-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-ms-flex-order:-1;order:-1}.order-lg-last{-ms-flex-order:13;order:13}.order-lg-0{-ms-flex-order:0;order:0}.order-lg-1{-ms-flex-order:1;order:1}.order-lg-2{-ms-flex-order:2;order:2}.order-lg-3{-ms-flex-order:3;order:3}.order-lg-4{-ms-flex-order:4;order:4}.order-lg-5{-ms-flex-order:5;order:5}.order-lg-6{-ms-flex-order:6;order:6}.order-lg-7{-ms-flex-order:7;order:7}.order-lg-8{-ms-flex-order:8;order:8}.order-lg-9{-ms-flex-order:9;order:9}.order-lg-10{-ms-flex-order:10;order:10}.order-lg-11{-ms-flex-order:11;order:11}.order-lg-12{-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-xl-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-xl-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-xl-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-xl-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-xl-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-xl-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-xl-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-ms-flex-order:-1;order:-1}.order-xl-last{-ms-flex-order:13;order:13}.order-xl-0{-ms-flex-order:0;order:0}.order-xl-1{-ms-flex-order:1;order:1}.order-xl-2{-ms-flex-order:2;order:2}.order-xl-3{-ms-flex-order:3;order:3}.order-xl-4{-ms-flex-order:4;order:4}.order-xl-5{-ms-flex-order:5;order:5}.order-xl-6{-ms-flex-order:6;order:6}.order-xl-7{-ms-flex-order:7;order:7}.order-xl-8{-ms-flex-order:8;order:8}.order-xl-9{-ms-flex-order:9;order:9}.order-xl-10{-ms-flex-order:10;order:10}.order-xl-11{-ms-flex-order:11;order:11}.order-xl-12{-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;margin-bottom:1rem;color:#212529}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm td,.table-sm th{padding:.3rem}.table-bordered{border:1px solid #dee2e6}.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-borderless tbody+tbody,.table-borderless td,.table-borderless th,.table-borderless thead th{border:0}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{color:#212529;background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-primary tbody+tbody,.table-primary td,.table-primary th,.table-primary thead th{border-color:#7abaff}.table-hover .table-primary:hover{background-color:#9fcdff}.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#d6d8db}.table-secondary tbody+tbody,.table-secondary td,.table-secondary th,.table-secondary thead th{border-color:#b3b7bb}.table-hover .table-secondary:hover{background-color:#c8cbcf}.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#c8cbcf}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-success tbody+tbody,.table-success td,.table-success th,.table-success thead th{border-color:#8fd19e}.table-hover .table-success:hover{background-color:#b1dfbb}.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-info tbody+tbody,.table-info td,.table-info th,.table-info thead th{border-color:#86cfda}.table-hover .table-info:hover{background-color:#abdde5}.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-warning tbody+tbody,.table-warning td,.table-warning th,.table-warning thead th{border-color:#ffdf7e}.table-hover .table-warning:hover{background-color:#ffe8a1}.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-danger tbody+tbody,.table-danger td,.table-danger th,.table-danger thead th{border-color:#ed969e}.table-hover .table-danger:hover{background-color:#f1b0b7}.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-light tbody+tbody,.table-light td,.table-light th,.table-light thead th{border-color:#fbfcfc}.table-hover .table-light:hover{background-color:#ececf6}.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#95999c}.table-hover .table-dark:hover{background-color:#b9bbbe}.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#343a40;border-color:#454d55}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#343a40}.table-dark td,.table-dark th,.table-dark thead th{border-color:#454d55}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.table-dark.table-hover tbody tr:hover{color:#fff;background-color:rgba(255,255,255,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.form-control::-moz-placeholder{color:#6c757d;opacity:1}.form-control:-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{-webkit-appearance:none;-moz-appearance:none;appearance:none}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm{padding-right:0;padding-left:0}.form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.form-control[multiple],select.form-control[size]{height:auto}textarea.form-control{height:auto}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,.9);border-radius:.25rem}.form-row>.col>.valid-tooltip,.form-row>[class*=col-]>.valid-tooltip{left:5px}.is-valid~.valid-feedback,.is-valid~.valid-tooltip,.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip{display:block}.form-control.is-valid,.was-validated .form-control:valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-valid,.was-validated .custom-select:valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.custom-select.is-valid:focus,.was-validated .custom-select:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label::before,.was-validated .custom-control-input:valid~.custom-control-label::before{border-color:#28a745}.custom-control-input.is-valid:checked~.custom-control-label::before,.was-validated .custom-control-input:valid:checked~.custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label::before,.was-validated .custom-control-input:valid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.form-row>.col>.invalid-tooltip,.form-row>[class*=col-]>.invalid-tooltip{left:5px}.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip,.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip{display:block}.form-control.is-invalid,.was-validated .form-control:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-invalid,.was-validated .custom-select:invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.custom-select.is-invalid:focus,.was-validated .custom-select:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label::before,.was-validated .custom-control-input:invalid~.custom-control-label::before{border-color:#dc3545}.custom-control-input.is-invalid:checked~.custom-control-label::before,.was-validated .custom-control-input:invalid:checked~.custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}.form-inline .form-group{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center;margin-bottom:0}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .custom-select,.form-inline .input-group{width:auto}.form-inline .form-check{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;-ms-flex-negative:0;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:#212529;text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not(:disabled):not(.disabled){cursor:pointer}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-secondary{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary.focus,.btn-secondary:focus{color:#fff;background-color:#5a6268;border-color:#545b62;box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#545b62;border-color:#4e555b}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-outline-primary{color:#007bff;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#6c757d;border-color:#6c757d}.btn-outline-secondary:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-success{color:#28a745;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;text-decoration:none}.btn-link:hover{color:#0056b3;text-decoration:underline}.btn-link.focus,.btn-link:focus{text-decoration:underline}.btn-link.disabled,.btn-link:disabled{color:#6c757d;pointer-events:none}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{position:relative;height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing{transition:none}}.dropdown,.dropleft,.dropright,.dropup{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left{right:auto;left:0}.dropdown-menu-right{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-left{right:auto;left:0}.dropdown-menu-sm-right{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-left{right:auto;left:0}.dropdown-menu-md-right{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-left{right:auto;left:0}.dropdown-menu-lg-right{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-left{right:auto;left:0}.dropdown-menu-xl-right{right:0;left:auto}}.dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-toggle::after{vertical-align:0}.dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropleft .dropdown-toggle::after{display:none}.dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty::after{margin-left:0}.dropleft .dropdown-toggle::before{vertical-align:0}.dropdown-menu[x-placement^=bottom],.dropdown-menu[x-placement^=left],.dropdown-menu[x-placement^=right],.dropdown-menu[x-placement^=top]{right:auto;bottom:auto}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#e9ecef}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.btn-group,.btn-group-vertical{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.btn-group-vertical>.btn:hover,.btn-group>.btn:hover{z-index:1}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus{z-index:1}.btn-toolbar{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn-group:not(:first-child),.btn-group>.btn:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropright .dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after{margin-left:0}.dropleft .dropdown-toggle-split::before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn-group:not(:first-child),.btn-group-vertical>.btn:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio],.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control,.input-group>.form-control-plaintext{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control,.input-group>.form-control-plaintext+.custom-file,.input-group>.form-control-plaintext+.custom-select,.input-group>.form-control-plaintext+.form-control{margin-left:-1px}.input-group>.custom-file .custom-file-input:focus~.custom-file-label,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file .custom-file-input:focus{z-index:4}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group>.custom-file:not(:first-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label::after,.input-group:not(.has-validation)>.custom-select:not(:last-child),.input-group:not(.has-validation)>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label::after,.input-group.has-validation>.custom-select:nth-last-child(n+3),.input-group.has-validation>.form-control:nth-last-child(n+3){border-top-right-radius:0;border-bottom-right-radius:0}.input-group-append,.input-group-prepend{display:-ms-flexbox;display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn:focus,.input-group-prepend .btn:focus{z-index:3}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group-lg>.custom-select,.input-group-lg>.form-control:not(textarea){height:calc(1.5em + 1rem + 2px)}.input-group-lg>.custom-select,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-sm>.custom-select,.input-group-sm>.form-control:not(textarea){height:calc(1.5em + .5rem + 2px)}.input-group-sm>.custom-select,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-lg>.custom-select,.input-group-sm>.custom-select{padding-right:1.75rem}.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.btn,.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.input-group-text,.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;z-index:1;display:block;min-height:1.5rem;padding-left:1.5rem;-webkit-print-color-adjust:exact;color-adjust:exact}.custom-control-inline{display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:focus:not(:checked)~.custom-control-label::before{border-color:#80bdff}.custom-control-input:not(:disabled):active~.custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label,.custom-control-input[disabled]~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label::before,.custom-control-input[disabled]~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background:50%/50% 50% no-repeat}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{border-color:#007bff;background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-switch{padding-left:2.25rem}.custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-switch .custom-control-label::after{transition:none}}.custom-switch .custom-control-input:checked~.custom-control-label::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{display:none}.custom-select:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.custom-select-sm{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.custom-file-input{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;overflow:hidden;opacity:0}.custom-file-input:focus~.custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:disabled~.custom-file-label,.custom-file-input[disabled]~.custom-file-label{background-color:#e9ecef}.custom-file-input:lang(en)~.custom-file-label::after{content:\"Browse\"}.custom-file-input~.custom-file-label[data-browse]::after{content:attr(data-browse)}.custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;overflow:hidden;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range{width:100%;height:1.4rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-range:focus{outline:0}.custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range::-moz-focus-outer{border:0}.custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-moz-range-thumb{-moz-transition:none;transition:none}}.custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;-ms-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-ms-thumb{-ms-transition:none;transition:none}}.custom-range::-ms-thumb:active{background-color:#b3d7ff}.custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range:disabled::-moz-range-track{cursor:default}.custom-range:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label::before,.custom-file-label,.custom-select{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label::before,.custom-file-label,.custom-select{transition:none}}.nav{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link{margin-bottom:-1px;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item,.nav-fill>.nav-link{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item,.nav-justified>.nav-link{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:.5rem 1rem}.navbar .container,.navbar .container-fluid,.navbar .container-lg,.navbar .container-md,.navbar .container-sm,.navbar .container-xl{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:50%/100% 100% no-repeat}.navbar-nav-scroll{max-height:75vh;overflow-y:auto}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-nav-scroll{overflow:visible}.navbar-expand-sm .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-nav-scroll{overflow:visible}.navbar-expand-md .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-nav-scroll{overflow:visible}.navbar-expand-lg .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-nav-scroll{overflow:visible}.navbar-expand-xl .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}}.navbar-expand{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-nav-scroll{overflow:visible}.navbar-expand .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-light .navbar-brand{color:rgba(0,0,0,.9)}.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a{color:rgba(0,0,0,.9)}.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand{color:#fff}.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:rgba(255,255,255,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-dark .navbar-text{color:rgba(255,255,255,.5)}.navbar-dark .navbar-text a{color:#fff}.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group{border-top:inherit;border-bottom:inherit}.card>.list-group:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group,.card>.list-group+.card-footer{border-top:0}.card-body{-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem;margin-bottom:0}.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem;border-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom,.card-img-top{-ms-flex-negative:0;flex-shrink:0;width:100%}.card-img,.card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{-ms-flex:1 0 0%;flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom{border-bottom-left-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.card-columns .card{display:inline-block;width:100%}}.accordion{overflow-anchor:none}.accordion>.card{overflow:hidden}.accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.breadcrumb{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item::before{float:left;padding-right:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:underline}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.badge{transition:none}}a.badge:focus,a.badge:hover{text-decoration:none}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}a.badge-primary:focus,a.badge-primary:hover{color:#fff;background-color:#0062cc}a.badge-primary.focus,a.badge-primary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.badge-secondary{color:#fff;background-color:#6c757d}a.badge-secondary:focus,a.badge-secondary:hover{color:#fff;background-color:#545b62}a.badge-secondary.focus,a.badge-secondary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.badge-success{color:#fff;background-color:#28a745}a.badge-success:focus,a.badge-success:hover{color:#fff;background-color:#1e7e34}a.badge-success.focus,a.badge-success:focus{outline:0;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.badge-info{color:#fff;background-color:#17a2b8}a.badge-info:focus,a.badge-info:hover{color:#fff;background-color:#117a8b}a.badge-info.focus,a.badge-info:focus{outline:0;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.badge-warning{color:#212529;background-color:#ffc107}a.badge-warning:focus,a.badge-warning:hover{color:#212529;background-color:#d39e00}a.badge-warning.focus,a.badge-warning:focus{outline:0;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.badge-danger{color:#fff;background-color:#dc3545}a.badge-danger:focus,a.badge-danger:hover{color:#fff;background-color:#bd2130}a.badge-danger.focus,a.badge-danger:focus{outline:0;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.badge-light{color:#212529;background-color:#f8f9fa}a.badge-light:focus,a.badge-light:hover{color:#212529;background-color:#dae0e5}a.badge-light.focus,a.badge-light:focus{outline:0;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.badge-dark{color:#fff;background-color:#343a40}a.badge-dark:focus,a.badge-dark:hover{color:#fff;background-color:#1d2124}a.badge-dark.focus,a.badge-dark:focus{outline:0;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;z-index:2;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary hr{border-top-color:#c8cbcf}.alert-secondary .alert-link{color:#202326}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.progress{display:-ms-flexbox;display:flex;height:1rem;overflow:hidden;line-height:0;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:1s linear infinite progress-bar-stripes;animation:1s linear infinite progress-bar-stripes}@media (prefers-reduced-motion:reduce){.progress-bar-animated{-webkit-animation:none;animation:none}}.media{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.media-body{-ms-flex:1;flex:1}.list-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:-1px;border-top-width:1px}.list-group-horizontal{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-sm>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-md>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-lg>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-xl>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.list-group-flush{border-radius:0}.list-group-flush>.list-group-item{border-width:0 0 1px}.list-group-flush>.list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:hover{color:#000;text-decoration:none}.close:not(:disabled):not(.disabled):focus,.close:not(:disabled):not(.disabled):hover{opacity:.75}button.close{padding:0;background-color:transparent;border:0}a.close.disabled{pointer-events:none}.toast{-ms-flex-preferred-size:350px;flex-basis:350px;max-width:350px;font-size:.875rem;background-color:rgba(255,255,255,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);opacity:0;border-radius:.25rem}.toast:not(:last-child){margin-bottom:.75rem}.toast.showing{opacity:1}.toast.show{display:block;opacity:1}.toast.hide{display:none}.toast-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:rgba(255,255,255,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-body{padding:.75rem}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translate(0,-50px);transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{-webkit-transform:none;transform:none}.modal.modal-static .modal-dialog{-webkit-transform:scale(1.02);transform:scale(1.02)}.modal-dialog-scrollable{display:-ms-flexbox;display:flex;max-height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.modal-dialog-scrollable .modal-footer,.modal-dialog-scrollable .modal-header{-ms-flex-negative:0;flex-shrink:0}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered::before{display:block;height:calc(100vh - 1rem);height:-webkit-min-content;height:-moz-min-content;height:min-content;content:\"\"}.modal-dialog-centered.modal-dialog-scrollable{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.modal-dialog-centered.modal-dialog-scrollable::before{content:none}.modal-content{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem 1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .close{padding:1rem 1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.modal-footer{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>*{margin:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-dialog-centered::before{height:calc(100vh - 3.5rem);height:-webkit-min-content;height:-moz-min-content;height:min-content}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{max-width:800px}}@media (min-width:1200px){.modal-xl{max-width:1140px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow::before,.bs-tooltip-top .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow::before,.bs-tooltip-right .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow::before,.bs-tooltip-bottom .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow::before,.bs-tooltip-left .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow::after,.popover .arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top]>.arrow,.bs-popover-top>.arrow{bottom:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=top]>.arrow::before,.bs-popover-top>.arrow::before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top]>.arrow::after,.bs-popover-top>.arrow::after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right]>.arrow,.bs-popover-right>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right]>.arrow::before,.bs-popover-right>.arrow::before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right]>.arrow::after,.bs-popover-right>.arrow::after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom]>.arrow,.bs-popover-bottom>.arrow{top:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=bottom]>.arrow::before,.bs-popover-bottom>.arrow::before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom]>.arrow::after,.bs-popover-bottom>.arrow::after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left]>.arrow,.bs-popover-left>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left]>.arrow::before,.bs-popover-left>.arrow::before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left]>.arrow::after,.bs-popover-left>.arrow::after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel.pointer-event{-ms-touch-action:pan-y;touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:\"\"}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item{transition:none}}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.active.carousel-item-right,.carousel-item-next:not(.carousel-item-left){-webkit-transform:translateX(100%);transform:translateX(100%)}.active.carousel-item-left,.carousel-item-prev:not(.carousel-item-right){-webkit-transform:translateX(-100%);transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;-webkit-transform:none;transform:none}.carousel-fade .carousel-item-next.carousel-item-left,.carousel-fade .carousel-item-prev.carousel-item-right,.carousel-fade .carousel-item.active{z-index:1;opacity:1}.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{transition:none}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next,.carousel-control-prev{transition:none}}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:50%/100% 100% no-repeat}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{box-sizing:content-box;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators li{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@-webkit-keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border;animation:.75s linear infinite spinner-border}.spinner-border-sm{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}@keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow;animation:.75s linear infinite spinner-grow}.spinner-grow-sm{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border,.spinner-grow{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#6c757d!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#545b62!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded-sm{border-radius:.2rem!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-lg{border-radius:.3rem!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:50rem!important}.rounded-0{border-radius:0!important}.clearfix::after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:-ms-flexbox!important;display:flex!important}.d-print-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive::before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9::before{padding-top:42.857143%}.embed-responsive-16by9::before{padding-top:56.25%}.embed-responsive-4by3::before{padding-top:75%}.embed-responsive-1by1::before{padding-top:100%}.flex-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-sm-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-sm-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-sm-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-sm-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-sm-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-sm-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-md-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-md-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-md-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-md-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-md-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-md-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-lg-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-lg-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-lg-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-lg-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-lg-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-lg-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-xl-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-xl-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-xl-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-xl-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-xl-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-xl-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;-ms-user-select:auto!important;user-select:auto!important}.user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.min-vw-100{min-width:100vw!important}.min-vh-100{min-height:100vh!important}.vw-100{width:100vw!important}.vh-100{height:100vh!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-n1{margin:-.25rem!important}.mt-n1,.my-n1{margin-top:-.25rem!important}.mr-n1,.mx-n1{margin-right:-.25rem!important}.mb-n1,.my-n1{margin-bottom:-.25rem!important}.ml-n1,.mx-n1{margin-left:-.25rem!important}.m-n2{margin:-.5rem!important}.mt-n2,.my-n2{margin-top:-.5rem!important}.mr-n2,.mx-n2{margin-right:-.5rem!important}.mb-n2,.my-n2{margin-bottom:-.5rem!important}.ml-n2,.mx-n2{margin-left:-.5rem!important}.m-n3{margin:-1rem!important}.mt-n3,.my-n3{margin-top:-1rem!important}.mr-n3,.mx-n3{margin-right:-1rem!important}.mb-n3,.my-n3{margin-bottom:-1rem!important}.ml-n3,.mx-n3{margin-left:-1rem!important}.m-n4{margin:-1.5rem!important}.mt-n4,.my-n4{margin-top:-1.5rem!important}.mr-n4,.mx-n4{margin-right:-1.5rem!important}.mb-n4,.my-n4{margin-bottom:-1.5rem!important}.ml-n4,.mx-n4{margin-left:-1.5rem!important}.m-n5{margin:-3rem!important}.mt-n5,.my-n5{margin-top:-3rem!important}.mr-n5,.mx-n5{margin-right:-3rem!important}.mb-n5,.my-n5{margin-bottom:-3rem!important}.ml-n5,.mx-n5{margin-left:-3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-n1{margin:-.25rem!important}.mt-sm-n1,.my-sm-n1{margin-top:-.25rem!important}.mr-sm-n1,.mx-sm-n1{margin-right:-.25rem!important}.mb-sm-n1,.my-sm-n1{margin-bottom:-.25rem!important}.ml-sm-n1,.mx-sm-n1{margin-left:-.25rem!important}.m-sm-n2{margin:-.5rem!important}.mt-sm-n2,.my-sm-n2{margin-top:-.5rem!important}.mr-sm-n2,.mx-sm-n2{margin-right:-.5rem!important}.mb-sm-n2,.my-sm-n2{margin-bottom:-.5rem!important}.ml-sm-n2,.mx-sm-n2{margin-left:-.5rem!important}.m-sm-n3{margin:-1rem!important}.mt-sm-n3,.my-sm-n3{margin-top:-1rem!important}.mr-sm-n3,.mx-sm-n3{margin-right:-1rem!important}.mb-sm-n3,.my-sm-n3{margin-bottom:-1rem!important}.ml-sm-n3,.mx-sm-n3{margin-left:-1rem!important}.m-sm-n4{margin:-1.5rem!important}.mt-sm-n4,.my-sm-n4{margin-top:-1.5rem!important}.mr-sm-n4,.mx-sm-n4{margin-right:-1.5rem!important}.mb-sm-n4,.my-sm-n4{margin-bottom:-1.5rem!important}.ml-sm-n4,.mx-sm-n4{margin-left:-1.5rem!important}.m-sm-n5{margin:-3rem!important}.mt-sm-n5,.my-sm-n5{margin-top:-3rem!important}.mr-sm-n5,.mx-sm-n5{margin-right:-3rem!important}.mb-sm-n5,.my-sm-n5{margin-bottom:-3rem!important}.ml-sm-n5,.mx-sm-n5{margin-left:-3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-n1{margin:-.25rem!important}.mt-md-n1,.my-md-n1{margin-top:-.25rem!important}.mr-md-n1,.mx-md-n1{margin-right:-.25rem!important}.mb-md-n1,.my-md-n1{margin-bottom:-.25rem!important}.ml-md-n1,.mx-md-n1{margin-left:-.25rem!important}.m-md-n2{margin:-.5rem!important}.mt-md-n2,.my-md-n2{margin-top:-.5rem!important}.mr-md-n2,.mx-md-n2{margin-right:-.5rem!important}.mb-md-n2,.my-md-n2{margin-bottom:-.5rem!important}.ml-md-n2,.mx-md-n2{margin-left:-.5rem!important}.m-md-n3{margin:-1rem!important}.mt-md-n3,.my-md-n3{margin-top:-1rem!important}.mr-md-n3,.mx-md-n3{margin-right:-1rem!important}.mb-md-n3,.my-md-n3{margin-bottom:-1rem!important}.ml-md-n3,.mx-md-n3{margin-left:-1rem!important}.m-md-n4{margin:-1.5rem!important}.mt-md-n4,.my-md-n4{margin-top:-1.5rem!important}.mr-md-n4,.mx-md-n4{margin-right:-1.5rem!important}.mb-md-n4,.my-md-n4{margin-bottom:-1.5rem!important}.ml-md-n4,.mx-md-n4{margin-left:-1.5rem!important}.m-md-n5{margin:-3rem!important}.mt-md-n5,.my-md-n5{margin-top:-3rem!important}.mr-md-n5,.mx-md-n5{margin-right:-3rem!important}.mb-md-n5,.my-md-n5{margin-bottom:-3rem!important}.ml-md-n5,.mx-md-n5{margin-left:-3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-n1{margin:-.25rem!important}.mt-lg-n1,.my-lg-n1{margin-top:-.25rem!important}.mr-lg-n1,.mx-lg-n1{margin-right:-.25rem!important}.mb-lg-n1,.my-lg-n1{margin-bottom:-.25rem!important}.ml-lg-n1,.mx-lg-n1{margin-left:-.25rem!important}.m-lg-n2{margin:-.5rem!important}.mt-lg-n2,.my-lg-n2{margin-top:-.5rem!important}.mr-lg-n2,.mx-lg-n2{margin-right:-.5rem!important}.mb-lg-n2,.my-lg-n2{margin-bottom:-.5rem!important}.ml-lg-n2,.mx-lg-n2{margin-left:-.5rem!important}.m-lg-n3{margin:-1rem!important}.mt-lg-n3,.my-lg-n3{margin-top:-1rem!important}.mr-lg-n3,.mx-lg-n3{margin-right:-1rem!important}.mb-lg-n3,.my-lg-n3{margin-bottom:-1rem!important}.ml-lg-n3,.mx-lg-n3{margin-left:-1rem!important}.m-lg-n4{margin:-1.5rem!important}.mt-lg-n4,.my-lg-n4{margin-top:-1.5rem!important}.mr-lg-n4,.mx-lg-n4{margin-right:-1.5rem!important}.mb-lg-n4,.my-lg-n4{margin-bottom:-1.5rem!important}.ml-lg-n4,.mx-lg-n4{margin-left:-1.5rem!important}.m-lg-n5{margin:-3rem!important}.mt-lg-n5,.my-lg-n5{margin-top:-3rem!important}.mr-lg-n5,.mx-lg-n5{margin-right:-3rem!important}.mb-lg-n5,.my-lg-n5{margin-bottom:-3rem!important}.ml-lg-n5,.mx-lg-n5{margin-left:-3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-n1{margin:-.25rem!important}.mt-xl-n1,.my-xl-n1{margin-top:-.25rem!important}.mr-xl-n1,.mx-xl-n1{margin-right:-.25rem!important}.mb-xl-n1,.my-xl-n1{margin-bottom:-.25rem!important}.ml-xl-n1,.mx-xl-n1{margin-left:-.25rem!important}.m-xl-n2{margin:-.5rem!important}.mt-xl-n2,.my-xl-n2{margin-top:-.5rem!important}.mr-xl-n2,.mx-xl-n2{margin-right:-.5rem!important}.mb-xl-n2,.my-xl-n2{margin-bottom:-.5rem!important}.ml-xl-n2,.mx-xl-n2{margin-left:-.5rem!important}.m-xl-n3{margin:-1rem!important}.mt-xl-n3,.my-xl-n3{margin-top:-1rem!important}.mr-xl-n3,.mx-xl-n3{margin-right:-1rem!important}.mb-xl-n3,.my-xl-n3{margin-bottom:-1rem!important}.ml-xl-n3,.mx-xl-n3{margin-left:-1rem!important}.m-xl-n4{margin:-1.5rem!important}.mt-xl-n4,.my-xl-n4{margin-top:-1.5rem!important}.mr-xl-n4,.mx-xl-n4{margin-right:-1.5rem!important}.mb-xl-n4,.my-xl-n4{margin-bottom:-1.5rem!important}.ml-xl-n4,.mx-xl-n4{margin-left:-1.5rem!important}.m-xl-n5{margin:-3rem!important}.mt-xl-n5,.my-xl-n5{margin-top:-3rem!important}.mr-xl-n5,.mx-xl-n5{margin-right:-3rem!important}.mb-xl-n5,.my-xl-n5{margin-bottom:-3rem!important}.ml-xl-n5,.mx-xl-n5{margin-left:-3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:rgba(0,0,0,0)}.text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.text-justify{text-align:justify!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-lighter{font-weight:lighter!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-weight-bolder{font-weight:bolder!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0056b3!important}.text-secondary{color:#6c757d!important}a.text-secondary:focus,a.text-secondary:hover{color:#494f54!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#19692c!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#0f6674!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#ba8b00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#a71d2a!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#cbd3da!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#121416!important}.text-body{color:#212529!important}.text-muted{color:#6c757d!important}.text-black-50{color:rgba(0,0,0,.5)!important}.text-white-50{color:rgba(255,255,255,.5)!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.text-decoration-none{text-decoration:none!important}.text-break{word-break:break-word!important;word-wrap:break-word!important}.text-reset{color:inherit!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,::after,::before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]::after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #adb5bd;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}body{min-width:992px!important}.container{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #dee2e6!important}.table-dark{color:inherit}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#dee2e6}.table .thead-dark th{color:inherit;border-color:#dee2e6}}", ""]);

// exports


/***/ }),

/***/ "u2z1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bNR/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1249665c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-375d5ff6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-375d5ff6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vdnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BadgerAccordionItem = ({
    name: 'BadgerAccordionItem',
    mounted: function mounted() {
        // If item rendered emit readyness to parent
        this.$parent.$emit('item:ready');
    },
    data: function data() {
        return {
            opened: false
        };
    },

    methods: {
        changeState: function changeState(state) {
            this.opened = state;
        },
        getIcon: function getIcon() {
            return this.icon;
        }
    },
    computed: {
        iconComponent: function iconComponent() {
            if (this.$parent.iconComponent) {
                return this.$parent.iconComponent;
            }

            return this.iconLoaded;
        },
        iconOpened: function iconOpened() {
            return this.$parent.icons ? this.$parent.icons.opened : '';
        },
        iconClosed: function iconClosed() {
            return this.$parent.icons ? this.$parent.icons.closed : '';
        },
        icon: function icon() {
            return this.opened ? this.iconOpened : this.iconClosed;
        },
        iconLoaded: function iconLoaded() {
            return {
                template: '<span>' + this.icon + '</span>'
            };
        }
    },
    watch: {
        opened: function opened(newValue) {
            this.$emit(newValue ? 'open' : 'close');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a8184a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "badger-accordion-item" }, [
    _c("dt", { staticClass: "badger-accordion__header" }, [
      _c("div", { staticClass: "js-badger-accordion-header" }, [
        _c(
          "button",
          { staticClass: "badger-accordion-toggle" },
          [
            _c(
              "span",
              { staticClass: "badger-accordion-title" },
              [
                _vm._t("header", function() {
                  return [_vm._v("Collapse-Title")]
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.icon !== "" && _vm.iconComponent
              ? _c(_vm.iconComponent, {
                  tag: "component",
                  staticClass: "badger-toggle-indicator",
                  attrs: { opened: _vm.opened }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "dd",
      { staticClass: "badger-accordion__panel js-badger-accordion-panel" },
      [
        _c(
          "div",
          { staticClass: "js-badger-accordion-panel-inner" },
          [_vm._t("content")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_BadgerAccordionItem = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a8184a", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("aHDP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BadgerAccordionItem,
  src_BadgerAccordionItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25a8184a", Component.options)
  } else {
    hotAPI.reload("data-v-25a8184a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vue_badger_accordion_src_BadgerAccordionItem = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vp/L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/load.bf322df.gif";

/***/ }),

/***/ "x3vu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HJqQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e56d5352", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app-43c45ce4ede47700163f1.js